export const translations = {
  ro: {
    nav: {
      home: 'Acasă',
      services: 'Servicii',
      portfolio: 'Portofoliu',
      articles: 'Articole',
      about: 'Despre',
      contact: 'Contact',
      getConsultation: 'Solicită o ofertă',
      getConsultationShort: 'Ofertă',
      bookCall: 'Programează un apel',
      openMenu: 'Meniu',
      closeMenu: 'Închide'
    },
    cookies: {
      banner: {
        title: 'Preferințe cookie-uri',
        description: 'Folosim cookie-uri pentru a îmbunătăți experiența ta și a analiza traficul site-ului. Poți accepta toate cookie-urile, respinge cele non-esențiale sau gestiona preferințele tale. Pentru mai multe detalii, vezi',
        cookiePolicy: 'Politica cookie-urilor',
        acceptAll: 'Acceptă toate',
        rejectAll: 'Respinge toate',
        managePreferences: 'Gestionează preferințele'
      },
      preferences: {
        title: 'Preferințe cookie-uri',
        description: 'Gestionează preferințele tale de cookie-uri. Poți activa sau dezactiva diferite tipuri de cookie-uri mai jos. Cookie-urile strict necesare sunt întotdeauna activate deoarece sunt necesare pentru funcționarea corectă a site-ului.',
        strictlyNecessary: {
          title: 'Cookie-uri strict necesare',
          description: 'Aceste cookie-uri sunt esențiale pentru funcționarea corectă a site-ului. Ele permit funcționalități de bază precum securitatea, gestionarea rețelei și accesibilitatea. Nu poți dezactiva aceste cookie-uri.',
          examplesTitle: 'Exemple:',
          examples: [
            'Gestionarea sesiunii',
            'Funcții de securitate',
            'Echilibrarea încărcării',
            'Preferințe de consimțământ pentru cookie-uri'
          ]
        },
        analytics: {
          title: 'Cookie-uri de analiză',
          description: 'Aceste cookie-uri ne ajută să înțelegem cum interacționează vizitatorii cu site-ul nostru prin colectarea și raportarea informațiilor în mod anonim. Aceasta ne ajută să îmbunătățim site-ul și experiența utilizatorului.',
          examplesTitle: 'Exemple:',
          examples: [
            'Google Analytics 4 (GA4) – când este activat',
            'Urmărirea vizualizărilor de pagină',
            'Analiza comportamentului utilizatorilor',
            'Metrici de performanță',
            'Cookie-uri Google securizate (__Secure-3PAPISID, __Secure-3PSID etc.)'
          ],
          disabledNote: 'Notă: Cookie-urile de analiză sunt momentan dezactivate. Niciun script de urmărire nu va fi încărcat până când activezi această opțiune.',
          viewDetails: 'Vezi detaliile cookie-urilor Google',
          googleCookiesInfo: 'Când analiza este activată, Google poate seta următoarele cookie-uri securizate:',
          googleCookies: [
            '__Secure-3PAPISID - Autentificare API Google',
            '__Secure-3PSID - ID sesiune Google',
            '__Secure-3PSIDCC - Sesiune Google cu consimțământ',
            '__Secure-1PAPISID - API Google (first-party)',
            '__Secure-1PSID - Sesiune Google (first-party)',
            '_ga, _gid - Google Analytics'
          ],
          googleCookiesNote: 'Aceste cookie-uri sunt setate de domeniile Google și sunt supuse setărilor browserului tău privind cookie-urile terțe. Ele ajută la furnizarea de experiențe personalizate și la măsurarea performanței site-ului.'
        },
        privacySection: {
          title: 'Despre confidențialitatea ta',
          description: 'Respectăm confidențialitatea ta și ne conformăm cerințelor GDPR și ale Directivei ePrivacy a UE. Preferințele tale de consimțământ sunt stocate local în browserul tău și pot fi schimbate oricând. Pentru mai multe informații, te rugăm să citești',
          cookiePolicy: 'Politica cookie-urilor',
          and: 'și',
          privacyPolicy: 'Politica de confidențialitate'
        },
        buttons: {
          clearAll: 'Șterge toate datele',
          rejectAll: 'Respinge toate',
          acceptAll: 'Acceptă toate',
          savePreferences: 'Salvează preferințele'
        }
      }
    },
    seo: {
      home: {
        title: 'Creare site web și aplicații web în Moldova | Byteet',
        description: 'Byteet creează site-uri, magazine online și aplicații web pentru afaceri din Chișinău și Moldova și administrează IT-ul din spate: cloud, securitate și suport.'
      },
      about: {
        title: 'Despre Byteet – servicii IT în Moldova | Byteet',
        description: 'Află despre Byteet, un partener IT de încredere în Moldova, specializat în dezvoltare web, soluții cloud, administrarea dispozitivelor, gestionarea identităților și a accesului și servicii IT complete.'
      },
      contact: {
        title: 'Contact Byteet – consultanță IT în Moldova | Byteet',
        description: 'Contactează Byteet pentru consultanță IT de specialitate în Moldova. Servicii de dezvoltare web, soluții cloud, administrarea dispozitivelor și suport IT. Oferim suport rapid și de încredere.'
      },
      services: {
        title: 'Servicii IT în Moldova: suport, cloud, securitate, web | Byteet',
        description: 'Servicii IT complete în Chișinău și Republica Moldova: externalizare IT și suport 24/7, cloud și Microsoft 365, securitate cibernetică, baze de date, automatizare AI și creare site web.'
      },
      portfolio: {
        title: 'Portofoliu – soluții IT și studii de caz în Moldova | Byteet',
        description: 'Descoperă portofoliul Byteet, cu implementări IT de succes și studii de caz din Moldova. Explorează exemple reale de soluții cloud, proiecte de dezvoltare web, implementări de administrare a dispozitivelor și soluții de automatizare livrate pentru afaceri.'
      },
      privacy: {
        title: 'Politica de confidențialitate – Byteet | Conformitate GDPR în Moldova',
        description: 'Politica de confidențialitate Byteet explică modul în care colectăm, folosim și protejăm datele tale personale în conformitate cu GDPR și reglementările privind protecția datelor din Moldova.'
      },
      terms: {
        title: 'Termeni și condiții – Byteet | Termeni legali',
        description: 'Citește termenii și condițiile Byteet pentru a înțelege condițiile legale care guvernează utilizarea site-ului nostru și a serviciilor IT în Moldova.'
      },
      book: {
        title: 'Programează o consultație IT gratuită | Byteet',
        description: 'Programează o consultație IT gratuită de {minutes} de minute cu Byteet pe Google Meet. Alege ora potrivită, iar invitația vine pe e-mail. Fără obligații.'
      },
      notFound: {
        title: 'Pagina nu a fost găsită – Byteet',
        description: 'Pagina pe care o cauți nu a putut fi găsită. Revino la pagina principală Byteet pentru a explora serviciile noastre IT.'
      }
    },
    serviceSeo: {
      'managed-it-support': {
        title: 'Externalizare IT și suport tehnic 24/7 în Moldova | Byteet',
        description: 'Externalizare IT și suport tehnic 24/7 în Chișinău și Republica Moldova: helpdesk, administrare dispozitive, servere și rețele, abonament de mentenanță IT cu SLA.'
      },
      'cloud-infrastructure': {
        title: 'Servicii cloud și migrare la Microsoft 365 în Moldova | Byteet',
        description: 'Servicii cloud în Chișinău și Moldova: Microsoft 365 și Google Workspace, migrare în cloud fără întreruperi, servere, virtualizare, cloud privat și backup.'
      },
      'cybersecurity-identity': {
        title: 'Securitate cibernetică pentru companii din Moldova | Byteet',
        description: 'Securitate cibernetică pentru companii în Chișinău și Moldova: audit de securitate, MFA/IAM, protecție endpoint (EDR) și conformitate cu Legea 195/2024 (GDPR).'
      },
      'data-databases': {
        title: 'Baze de date, backup și recuperarea datelor în Moldova | Byteet',
        description: 'Servicii de baze de date în Chișinău și Moldova: administrare și optimizare PostgreSQL, MySQL, SQL Server, migrare, backup automat, recuperarea datelor și business intelligence.'
      },
      'ai-automation': {
        title: 'Automatizare AI și agenți AI pentru afaceri din Moldova | Byteet',
        description: 'Automatizarea proceselor de afaceri cu AI în Moldova: agenți și chatboți AI în română și rusă, integrare CRM/1C, procesare documente și fluxuri (n8n, Make).'
      },
      'web-software-development': {
        title: 'Creare site web și magazine online în Moldova | Byteet',
        description: 'Creare site web, magazine online și software la comandă în Chișinău și Moldova: React și Next.js, design UX, integrare plăți (maib, mPay), SEO și mentenanță.'
      },
      'mobile-app-development': {
        title: 'Dezvoltare aplicații mobile iOS și Android în Moldova | Byteet',
        description: 'Aplicații mobile iOS și Android pentru afaceri din Moldova: React Native, Flutter sau nativ, backend și API, publicare în App Store și Google Play, mentenanță.'
      },
      'crm-development': {
        title: 'Sisteme CRM la comandă și integrare CRM în Moldova | Byteet',
        description: 'Sisteme CRM în Chișinău și Moldova: CRM la comandă sau configurare amoCRM, Bitrix24, HubSpot, Odoo, integrare cu e-mail, facturare și site, migrare din Excel.'
      },
      'erp-systems': {
        title: 'Integrare ERP și 1C, module la comandă în Moldova | Byteet',
        description: 'Integrare și extindere ERP în Moldova: 1C, Odoo, Business Central, module la comandă, legături cu magazinul online, CRM-ul și contabilitatea, migrare de date.'
      },
      'automation-devops': {
        title: 'Automatizare și DevOps | CI/CD și Infrastructure as Code | Byteet Moldova',
        description: 'Servicii de automatizare și DevOps în Moldova. Pipeline-uri CI/CD, Infrastructure as Code (IaC), automatizarea proceselor și optimizarea eficienței. Transformă operațiunile IT cu practici DevOps moderne.'
      },
      'cloud-workspace': {
        title: 'Spații de lucru în cloud | Microsoft 365 și Google Workspace | Byteet Moldova',
        description: 'Soluții profesionale de lucru în cloud în Moldova. Configurare și administrare Microsoft 365, Azure, AWS și Google Workspace. Soluții moderne pentru echipe la distanță și hibride.'
      },
      'device-management': {
        title: 'Administrare dispozitive | Intune și MDM | Byteet Moldova',
        description: 'Servicii de administrare a dispozitivelor (MDM) în Moldova. Microsoft Intune, Mobile Device Management, securitate endpoint și conformitate. Securizează și administrează eficient toate dispozitivele.'
      },
      'identity-access': {
        title: 'Managementul identităților și al accesului | IAM și SSO | Byteet Moldova',
        description: 'Servicii profesionale de management al identităților și al accesului (IAM) în Moldova. SSO, Zero Trust, Active Directory, Okta și implementare CyberArk. Gestionare securizată a accesului pentru organizația ta.'
      },
      'infrastructure-management': {
        title: 'Managementul infrastructurii | Cloud hibrid și servere | Byteet Moldova',
        description: 'Servicii de management al infrastructurii în Moldova. Soluții de cloud hibrid, administrare servere, virtualizare și optimizarea infrastructurii. Operațiuni de infrastructură de încredere.'
      },
      'database-management': {
        title: 'Managementul bazelor de date | SQL și optimizarea datelor | Byteet Moldova',
        description: 'Servicii profesionale de management al bazelor de date în Moldova. Optimizare SQL, administrarea bazelor de date, integritatea datelor, migrare și suport 24/7. Asigură funcționarea fiabilă a bazelor de date.'
      },
      'service-desk': {
        title: 'Service desk | Suport IT și helpdesk | Byteet Moldova',
        description: 'Implementare profesională de service desk în Moldova. Suport IT, configurare helpdesk, management SLA, sisteme de ticketing și optimizarea suportului IT. Eficientizează operațiunile de suport IT.'
      },
      'knowledge-management': {
        title: 'Managementul bazei de cunoștințe | Documentație și knowledge base | Byteet Moldova',
        description: 'Servicii profesionale de management al bazei de cunoștințe în Moldova. Sisteme de documentație, implementare knowledge base, configurare Confluence și managementul informațiilor. Îmbunătățește partajarea cunoștințelor.'
      },
      'web-development': {
        title: 'Dezvoltare web | Full-stack și React/Next.js | Byteet Moldova',
        description: 'Servicii de dezvoltare web în Moldova. Dezvoltare full-stack, React, Next.js, aplicații web personalizate și soluții web moderne. Construiește aplicații web performante pentru afacerea ta.'
      },
      'it-support': {
        title: 'Suport IT | Suport 24/7 | Byteet Moldova',
        description: 'Servicii profesionale de suport IT în Moldova. Suport tehnic 24/7, servicii de helpdesk și depanare IT. Suport IT de încredere atunci când ai nevoie.'
      },
      'data-engineering': {
        title: 'Ingineria datelor | Pipeline-uri și ETL | Byteet Moldova',
        description: 'Servicii de inginerie a datelor în Moldova. Pipeline-uri de date, procese ETL, soluții Big Data, infrastructură de date și analiză. Transformă datele în informații utile pentru decizii.'
      }
    },
    hero: {
      titleLead: 'Creare site-uri',
      titleTail: 'și aplicații web în Moldova',
      title: 'Creare site-uri și aplicații web în Moldova',
      subtitle: 'Proiectăm și construim site-uri, magazine online și aplicații web, iar aceeași echipă poate administra și IT-ul din spatele lor: suport, cloud, securitate, date și AI.',
      cta: {
        title: 'Ai nevoie de un site web nou sau de ajutor cu IT-ul?',
        consultation: 'Solicită un audit IT gratuit',
        call: 'Sună acum'
      }
    },
    home: {
      scroll: 'Derulează',
      statementLabel: 'Ce facem',
      statement: 'Byteet proiectează și construiește site-uri, magazine online și aplicații web pentru afaceri din Moldova, de la primul design până la lansare și mentenanță. Pe lângă asta, dezvoltăm aplicații mobile, CRM și ERP și administrăm IT-ul din spate: suport, cloud, securitate, date și AI.',
      servicesLabel: 'Servicii',
      servicesLead: 'Construim.',
      servicesTail: 'Administrăm.',
      servicesIntro: 'Nouă servicii de la o singură echipă, în frunte cu designul și dezvoltarea web: construim ce ai nevoie online și ținem în funcțiune sistemele din spate.',
      explore: 'Detalii',
      allServices: 'Toate serviciile',
      workLabel: 'Proiecte selectate',
      workLead: 'Lansate',
      workTail: 'și în funcțiune',
      workIntro: 'Site-uri și platforme pe care le-am proiectat și construit, online astăzi.',
      visit: 'Vezi site-ul',
      allCases: 'Toate proiectele',
      engagementsLabel: 'Proiecte IT',
      engagementsTitle: 'În spatele ecranului',
      engagementsIntro: 'Proiecte de infrastructură, identitate și dispozitive care nu încap într-o captură de ecran.',
      toolsLabel: 'Instrumente cu care lucrăm',
      ctaLabel: 'Contact',
      ctaLead: 'Hai să vorbim',
      ctaTail: 'despre proiectul tău',
      email: 'E-mail',
      phone: 'Telefon'
    },
    work: {
      label: 'Portofoliu',
      lead: 'Proiecte',
      tail: 'care funcționează',
      intro: 'Site-uri și platforme construite pentru clienți și proiectele IT din culise, de la flote de dispozitive la identitate și migrări în cloud.',
      sitesLabel: 'Site-uri și platforme',
      stack: 'Tehnologii',
      delivered: 'Ce am livrat',
      challenge: 'Provocare',
      approach: 'Abordare',
      outcome: 'Rezultat',
      all: 'Toate'
    },
    cookieBanner: {
      title: 'Cookie-uri',
      text: 'Folosim cookie-uri pentru a îmbunătăți site-ul și a analiza traficul. Poți accepta toate cookie-urile, respinge cele non-esențiale sau alege pe categorii. Pentru mai multe detalii, vezi',
      policy: 'Politica Cookie-urilor',
      reject: 'Respinge toate',
      accept: 'Acceptă toate',
      rejectLabel: 'Respinge toate cookie-urile non-esențiale',
      acceptLabel: 'Acceptă toate cookie-urile',
      manage: 'Gestionează preferințele'
    },
    stats: {
      clients: 'Clienți serviți',
      uptime: 'Rata SLA',
      support: 'Suport'
    },
    products: {
      title: 'CÂTEVA DINTRE SOLUȚIILE NOASTRE',
      subtitle: 'Servicii IT pentru afacerile mici și mijlocii.',
      viewAll: 'Vezi toate serviciile'
    },
    partners: {
      title: 'CÂTEVA DINTRE INSTRUMENTELE PE CARE LE FOLOSIM',
      subtitle: 'Platformele și instrumentele cu care lucrăm zilnic.'
    },
    services: {
      title: 'SERVICIILE NOASTRE',
      subtitle: 'Servicii IT complete pentru afaceri în Chișinău și Republica Moldova, de la suport și cloud la securitate, date și AI, plus web, aplicații mobile, CRM și ERP.',
      learnMore: 'Află mai multe',
      managedItSupport: {
        title: 'Externalizare IT și suport',
        subtitle: 'Helpdesk, mentenanță și monitorizare',
        description: 'Externalizarea IT, helpdesk și suport tehnic, administrarea dispozitivelor, service desk și monitorizare, cu abonament de mentenanță și SLA clar.',
        features: ['Helpdesk și suport tehnic', 'Administrare dispozitive (Intune, Jamf)', 'Configurare service desk', 'Monitorizare și alertare', 'Bază de cunoștințe întreținută']
      },
      cloudInfrastructure: {
        title: 'Servicii cloud și infrastructură',
        subtitle: 'Microsoft 365, servere și migrare',
        description: 'Servicii cloud și infrastructură în Moldova: administrare Microsoft 365 și Google Workspace, servere și virtualizare, migrare în cloud fără întreruperi și optimizarea costurilor.',
        features: ['Administrare Microsoft 365 și Google Workspace', 'Gestionare servere și VM', 'Migrare în cloud (Azure, AWS)', 'Monitorizare și optimizare costuri', 'Backup și recuperare']
      },
      cybersecurityIdentity: {
        title: 'Securitate cibernetică și identitate',
        subtitle: 'IAM, protecție endpoint și conformitate 195/2024',
        description: 'Securitate cibernetică pentru companii: management identitate și acces (MFA/PAM), protecție endpoint, audit de securitate și conformitate cu Legea 195/2024.',
        features: ['Single sign-on și MFA', 'Management acces privilegiat (PAM)', 'Detectare și răspuns endpoint (EDR)', 'Arhitectură Zero Trust', 'Conformitate și audit']
      },
      dataDatabases: {
        title: 'Baze de date și date',
        subtitle: 'Administrare, backup și analiză',
        description: 'Administrare și optimizare baze de date (PostgreSQL, MySQL, SQL Server), migrare, backup automat și recuperare, plus pipeline-uri și business intelligence.',
        features: ['Administrare baze de date (PostgreSQL, MySQL, SQL Server)', 'Migrare și optimizare', 'Pipeline-uri ETL/ELT', 'Data warehouse și data lake', 'Calitatea și guvernanța datelor']
      },
      aiAutomation: {
        title: 'AI și automatizare',
        subtitle: 'Agenți AI, chatboți și fluxuri',
        description: 'Automatizarea proceselor de afaceri, agenți și chatboți AI în română și rusă cu integrare CRM/1C, procesarea documentelor și analiză AI.',
        features: ['Automatizare fluxuri (n8n, Make, Zapier)', 'Agenți AI și chatboți (RAG)', 'Procesare documente', 'Analiză și raportare AI', 'Integrări și CI/CD']
      },
      webSoftwareDevelopment: {
        title: 'Creare site web și software',
        subtitle: 'Site-uri, magazine online și aplicații',
        description: 'Creare site web, magazine online și software la comandă cu React și Next.js, cu design UX, performanță, integrare plăți și mentenanță.',
        features: ['Aplicații web personalizate (React, Next.js)', 'Design UX/UI', 'Performanță și Core Web Vitals', 'Securitate și SEO', 'Întreținere și suport']
      },
      mobileAppDevelopment: {
        title: 'Dezvoltare aplicații mobile',
        subtitle: 'iOS și Android, backend și publicare',
        description: 'Aplicații iOS și Android pentru clienți sau pentru echipa ta, cross-platform cu React Native sau Flutter ori native, cu backend, publicare în App Store și Google Play și mentenanță.',
        features: [
          'Aplicații iOS și Android',
          'React Native, Flutter, Swift și Kotlin',
          'Backend, API și panou de administrare',
          'Publicare în App Store și Google Play',
          'Mentenanță și actualizări'
        ]
      },
      crmDevelopment: {
        title: 'Sisteme CRM',
        subtitle: 'CRM la comandă, configurare și integrări',
        description: 'Un CRM la comandă sau amoCRM, Bitrix24, HubSpot ori Odoo configurate și extinse, conectate la e-mail, facturare și site, cu datele mutate din tabele Excel.',
        features: [
          'CRM la comandă',
          'Configurare amoCRM, Bitrix24, HubSpot, Odoo',
          'Integrări cu e-mail, facturare și site',
          'Migrare din tabele Excel',
          'Automatizări și mementouri'
        ]
      },
      erpSystems: {
        title: 'Sisteme ERP',
        subtitle: 'Integrări, module la comandă și migrare',
        description: 'Integrări între 1C, Odoo sau Microsoft Dynamics 365 Business Central și magazinul online, CRM-ul și contabilitatea, plus module la comandă și migrarea datelor.',
        features: [
          'Integrări cu 1C, Odoo și Business Central',
          'Module și extensii la comandă',
          'Sincronizare comenzi, stocuri și prețuri',
          'Migrare de date cu reconciliere',
          'Monitorizare și suport'
        ]
      },
      deviceManagement: {
        title: 'Administrare Dispozitive',
        subtitle: 'Windows, macOS, Linux, ChromeOS, iOS, Android',
        description: 'Management complet al ciclului de viață al dispozitivelor pentru Windows și macOS folosind Microsoft Intune și SCCM pentru Windows, și Jamf Pro pentru macOS.',
        features: [
          'Windows: Microsoft Intune',
          'Windows: SCCM/ConfigMgr',
          'macOS: Jamf Pro',
          'Conformitate și aplicarea politicilor',
          'Împachetare software și implementare'
        ]
      },
      infrastructureManagement: {
        title: 'Managementul infrastructurii',
        subtitle: 'Administrare servere, dispozitive și VM',
        description: 'Management complet al infrastructurii, inclusiv administrarea serverelor, managementul dispozitivelor și optimizarea mașinilor virtuale.',
        features: ['Administrare servere', 'Gestionarea dispozitivelor', 'Optimizare VM', 'Monitorizarea performanței', 'Backup și recuperare']
      },
      databaseManagement: {
        title: 'Managementul bazelor de date',
        subtitle: 'Configurare, migrare și administrare',
        description: 'Servicii profesionale de management al bazelor de date, inclusiv configurare, migrare, optimizare și administrare continuă.',
        features: ['Configurarea bazelor de date', 'Migrarea datelor', 'Optimizarea performanței', 'Administrare 24/7', 'Backup și recuperare']
      },
      cloudWorkspace: {
        title: 'Spații de lucru în cloud',
        subtitle: 'Microsoft 365 și Google Workspace',
        description: 'Configurare și administrare completă pentru medii Microsoft 365 și Google Workspace.',
        features: ['Configurare M365', 'Administrare Google Workspace', 'Gestionarea utilizatorilor', 'Configurarea securității', 'Suport la migrare']
      },
      identityAccess: {
        title: 'Managementul identității și al accesului',
        subtitle: 'Active Directory, Okta și CyberArk',
        description: 'Managementul identității și al accesului cu Active Directory, Okta și CyberArk.',
        features: ['Active Directory', 'Integrare Okta', 'CyberArk PAM', 'Implementare SSO', 'Controlul accesului']
      },
      automationDevops: {
        title: 'Automatizare IT și DevOps',
        subtitle: 'Scripting, CI/CD și automatizarea proceselor',
        description: 'Automatizează procesele IT și implementează practici DevOps pentru mai multă eficiență.',
        features: ['Automatizarea proceselor', 'Pipeline-uri CI/CD', 'Soluții de scripting', 'Optimizarea fluxurilor de lucru', 'Instrumente de monitorizare']
      },
      serviceDesk: {
        title: 'Implementare service desk',
        subtitle: 'Configurare Jira, YouTrack și Zammad',
        description: 'Instalare și configurare profesională a service desk-ului pentru operațiuni eficiente de suport IT.',
        features: ['Jira Service Desk', 'Jira Service Management', 'Configurare ServiceNow', 'Configurare YouTrack', 'Configurare Zammad', 'Proiectarea fluxurilor de lucru', 'Suport pentru integrare']
      },
      knowledgeManagement: {
        title: 'Managementul bazei de cunoștințe',
        subtitle: 'Confluence și sisteme de tip knowledge base',
        description: 'Soluții complete de management al bazei de cunoștințe, pentru o documentație mai bună și o partajare mai eficientă a informațiilor.',
        features: ['Configurare Confluence', 'Proiectarea bazei de cunoștințe', 'Standarde de documentare', 'Optimizarea căutării', 'Gestionarea conținutului']
      },
      webDevelopment: {
        title: 'Dezvoltare web',
        subtitle: 'Aplicații web personalizate și site-uri',
        description: 'Servicii profesionale de dezvoltare web, întreținere și optimizare. Soluții de dezvoltare web adaptate afacerilor.',
        features: ['Aplicații web personalizate', 'Dezvoltare de site-uri', 'Întreținere și actualizări', 'Optimizarea performanței', 'Implementarea securității']
      },
      itSupport: {
        title: 'Suport IT',
        subtitle: 'Helpdesk și suport tehnic',
        description: 'Servicii complete de helpdesk IT și suport tehnic care asigură rezolvarea rapidă a problemelor și performanța optimă a sistemului.',
        features: ['Suport tehnic 24/7', 'Servicii de helpdesk', 'Răspuns la incidente', 'Monitorizarea sistemelor', 'Depanare și remediere']
      },
      dataEngineering: {
        title: 'Ingineria datelor',
        subtitle: 'Pipeline-uri de date și infrastructură de analiză',
        description: 'Construiește pipeline-uri de date robuste, procese ETL și infrastructură de analiză care transformă datele brute în informații utile pentru decizii bazate pe date.',
        features: ['Dezvoltarea pipeline-urilor de date', 'Procese ETL/ELT', 'Data warehouse și data lake', 'Procesare în timp real', 'Calitatea și guvernanța datelor']
      }
    },
    serviceOptions: {
      managedItSupport: 'Administrare IT și suport',
      cloudInfrastructure: 'Cloud și infrastructură',
      cybersecurityIdentity: 'Securitate cibernetică și identitate',
      dataDatabases: 'Date și baze de date',
      aiAutomation: 'AI și automatizare',
      webSoftwareDevelopment: 'Creare site web și software',
      mobileAppDevelopment: 'Dezvoltare aplicații mobile',
      crmDevelopment: 'Sisteme CRM',
      erpSystems: 'Sisteme ERP',
      other: 'Altele',
      otherLabel: 'De ce altceva ai nevoie?',
      otherPlaceholder: 'Spune-ne pe scurt de ce ai nevoie…',
      otherRequired: 'Descrie pe scurt de ce ai nevoie',
      otherRequiredDesc: 'Ai selectat „Altele”. Adaugă o scurtă descriere ca să te putem ajuta.'
    },
    about: {
      title: 'DESPRE BYTEET – SERVICII IT ÎN MOLDOVA',
      subtitle: 'Suntem o companie de servicii IT care administrează și modernizează IT-ul afacerilor mici și mijlocii.',
      description: 'Cu peste un deceniu de experiență, echipa noastră de profesioniști certificați se specializează în dezvoltare web, administrarea dispozitivelor, administrare cloud și automatizare.',
      yearsExperience: 'Ani de experiență',
      yearsExperienceSubtitle: 'Ingineri experți care rămân la curent cu cele mai recente tehnologii',
      projectsCompleted: 'Proiecte finalizate',
      excellence: {
        title: 'Calitate',
        description: 'Documentăm, testăm și predăm tot ce construim.'
      },
      partnership: {
        title: 'Parteneriat',
        description: 'Construim relații pe termen lung prin încredere și colaborare.'
      },
      efficiency: {
        title: 'Eficiență',
        description: 'Automatizăm munca repetitivă și păstrăm procesele simple.'
      },
      security: {
        title: 'Securitate',
        description: 'Măsuri de securitate potrivite dimensiunii afacerii tale.'
      }
    },
    contact: {
      title: 'CONTACTEAZĂ-NE – SERVICII IT ÎN MOLDOVA',
      subtitle: 'Spune-ne de ce ai nevoie și revenim cu o ofertă.',
      form: {
        name: 'Nume complet',
        email: 'Adresă de e-mail',
        company: 'Numele companiei',
        phone: 'Număr de telefon',
        services: 'Servicii necesare',
        budget: 'Interval de buget',
        timeline: 'Termen de realizare',
        teamSize: 'Dimensiunea echipei',
        message: 'Detalii despre proiect',
        submit: 'Trimite mesajul',
        submitting: 'Se trimite...',
        success: 'Mesaj trimis cu succes!',
        error: 'Te rugăm să completezi toate câmpurile obligatorii.'
      },
      budgetRanges: {
        under5k: 'Sub €5K',
        '5k-10k': '€5K - €10K',
        '10k-20k': '€10K - €20K',
        '20k-30k': '€20K - €30K',
        '30k+': '€30K+'
      },
      timelines: {
        asap: 'Cât mai curând (în 1 lună)',
        '1-3months': '1-3 luni',
        '3-6months': '3-6 luni',
        '6months+': '6+ luni'
      },
      teamSizes: {
        '1-5': '1-5 persoane',
        '6-20': '6-20 persoane',
        '21-50': '21-50 persoane',
        '50+': '50+ persoane'
      },
      contactInfo: {
        email: 'E-mail',
        phone: 'Telefon',
        location: 'Locație'
      }
    },
    footer: {
      description: 'Servicii IT profesionale pentru afaceri moderne în Moldova. Ne specializăm în administrarea dispozitivelor, administrare cloud și soluții de automatizare.',
      services: 'SERVICII',
      pages: 'PAGINI',
      company: 'COMPANIE',
      copyright: 'Toate drepturile rezervate.',
      privacyPolicy: 'Politica de confidențialitate',
      termsOfService: 'Termeni și Condiții',
      backToTop: 'Sus'
    },
    forms: {
      alerts: {
        selectService: 'Te rugăm să selectezi cel puțin un serviciu',
        selectServiceDesc: 'Trebuie să selectezi cel puțin un serviciu pentru a continua.',
        selectBudget: 'Te rugăm să selectezi un interval de buget',
        selectBudgetDesc: 'Trebuie să selectezi un interval de buget pentru a continua.',
        success: 'Ai trimis cererea cu succes!',
        successDesc: 'Vom analiza cerințele tale și te vom contacta în 24 de ore cu o soluție personalizată și o ofertă.',
        errorDesc: 'A apărut o eroare. Te rugăm să încerci din nou sau să ne scrii la info@byteet.md.'
      },
      serviceInquiry: {
        send: "Trimite",
        sending: "Se trimite…",
        steps: {
          need: {
            rail: "Ce îți trebuie",
            title: "De ce ai nevoie?",
            desc: "Alege tot ce se potrivește.",
          },
          project: {
            rail: "Proiectul",
            title: "Proiectul tău",
            desc: "O idee aproximativă este suficientă. Restul te întrebăm noi.",
          },
          contact: {
            rail: "Contact",
            title: "Cum te putem contacta?",
            desc: "Răspundem prin e-mail. Numărul de telefon este opțional.",
          },
          call: {
            rail: "Un apel",
            title: "Discutăm pe scurt?",
            desc: "{minutes} minute pe Google Meet, gratuit și fără obligații.",
          },
        },
        projectLabel: "În câteva propoziții",
        projectPlaceholder: "Ce vrei să construiești, să repari sau să îmbunătățești și de ce.",
        aiHint: "Nu știi cum să formulezi? Lasă asistentul AI să scrie descrierea.",
        aiSteps: "Lipește textul în asistentul AI, răspunde la cele trei întrebări și lipește rezultatul în câmpul de mai sus.",
        showPrompt: "Arată promptul",
        hidePrompt: "Ascunde promptul",
        copyPrompt: "Copiază promptul",
        copied: "Copiat",
        copySelected: "Selectat. Apasă Ctrl+C (sau Cmd+C) pentru a copia.",
        budget: "Buget",
        timeline: "Termen",
        callYes: "Da, programez un apel",
        callNo: "Nu, doar trimite",
        callUnavailable: "Programarea online nu este disponibilă acum; îți scriem pe e-mail pentru a stabili o oră.",
        pickTime: "Alege o oră pentru apel sau „Nu, doar trimite”.",
        alreadySent: "Am primit deja mesajul tău.",
        bookingFailed: "Am primit mesajul, dar apelul nu a putut fi programat. Încearcă din nou sau alege „Nu, doar trimite” și îți scriem pe e-mail pentru a stabili o oră.",
        nameRequired: "Introdu numele.",
        emailInvalid: "Introdu o adresă de e-mail validă.",
        servicesLabel: "Servicii",
        sendFailed: "Cererea nu a putut fi trimisă. Încearcă din nou sau scrie-ne la {email}.",
        received: "Primit.",
        receivedNext: "Citim cererea și răspundem la {email}.",
        receivedNextCall: "Citim cererea înainte de apel.",
        aiPrompt: "Vreau să contactez o companie IT despre un proiect. Pune-mi aceste trei întrebări, pe rând, și așteaptă fiecare răspuns:\n1) Ce vrei să construiești, să repari sau să îmbunătățești?\n2) Ce folosești acum și ce nu funcționează?\n3) Cum ar arăta un rezultat bun pentru tine?\nApoi scrie o descriere clară a proiectului, de cel mult 120 de cuvinte, la persoana întâi și într-un limbaj simplu, fără să adaugi nimic din ce nu am spus.",
        title: 'Solicită o ofertă',
        subtitle: 'Obține o ofertă personalizată pentru proiectul tău',
        thankYou: 'Mulțumim!',
        thankYouSubtitle: 'Te vom contacta în curând!',
        submit: 'Trimite cererea',
        submitting: 'Se trimite...',
        previous: 'Anterior',
        next: 'Următor',
        nextSteps: 'Pașii următori:',
        nextStepsDesc: 'Echipa noastră va analiza detaliile proiectului tău și va programa un apel de consultație pentru a discuta nevoile tale specifice.',
        insertOutline: 'Inserează structura',
        outlineTemplate: 'De ce ai nevoie?\n- \n\nCe folosești în prezent?\n- \n\nCe ar trebui să se schimbe pentru tine?\n- \n\nCe altceva ar trebui să știm (sisteme de conectat, termene, constrângeri)?\n- ',
        formLabels: {
          fullName: 'Nume complet',
          emailAddress: 'Adresă de e-mail',
          company: 'Companie',
          phoneNumber: 'Număr de telefon',
          servicesOfInterest: 'Servicii de interes',
          servicesOfInterestDesc: '(Selectează toate opțiunile potrivite)',
          budgetRange: 'Interval de buget',
          projectTimeline: 'Termen de realizare',
          teamSize: 'Dimensiunea echipei',
          projectDetails: 'Detaliile și cerințele proiectului'
        },
        placeholders: {
          enterFullName: 'Introdu numele tău complet',
          enterEmail: 'Introdu adresa ta de e-mail',
          enterCompany: 'Introdu numele companiei',
          enterPhone: 'Introdu numărul de telefon',
          selectTimeline: 'Selectează termenul',
          selectTeamSize: 'Selectează dimensiunea echipei',
          projectDetailsPlaceholder: 'Spune-ne despre proiectul tău, cerințele specifice, provocările și orice alte detalii care ne-ar ajuta să-ți facem o ofertă mai bună…'
        },
        stepLabels: {
          step1: 'Informațiile tale',
          step2: 'Selectează serviciile',
          step3: 'Buget și termen',
          step4: 'Detaliile proiectului'
        },
        stepDescriptions: {
          step1Title: 'Spune-ne despre tine',
          step1Desc: 'Vom folosi aceste informații pentru a te contacta despre proiectul tău.',
          step2Title: 'De ce servicii ai nevoie?',
          step2Desc: 'Selectează toate serviciile relevante pentru proiectul tău.',
          step3Title: 'Buget și termen',
          step3Desc: 'Ajută-ne să înțelegem amploarea și termenul proiectului tău.',
          step4Title: 'Spune-ne despre proiectul tău',
          step4Desc: 'Împărtășește orice detalii suplimentare care ne vor ajuta să-ți facem o ofertă mai bună.'
        }
      }
    },
    contactPage: {
      serviceInquiryForm: 'Ofertă personalizată',
      serviceInquirySubtitle: 'Obține o ofertă personalizată pentru proiectul tău IT',
      contactInformation: 'Informații de contact',
      followUs: 'Urmărește-ne',
      quickContact: 'Contact rapid',
      quickContactDesc: 'Ai nevoie de asistență imediată? Contactează-ne direct.',
      sendEmail: 'Trimite un e-mail',
      selectTimeline: 'Selectează termenul',
      selectTeamSize: 'Selectează dimensiunea echipei',
      projectDetailsPlaceholder: 'Spune-ne despre proiectul tău, cerințele specifice, provocările și orice alte detalii care ne-ar ajuta să-ți facem o ofertă mai bună…',
      privacyConsent: 'Prin trimiterea acestui formular, ești de acord cu politica noastră de confidențialitate și consimți să fii contactat în legătură cu cererea ta.',
      servicesSelectAll: '(Selectează toate opțiunile potrivite)'
    },
    booking: {
      label: 'Programare',
      lead: 'Programează',
      tail: 'o discuție',
      intro: '{minutes} de minute pe Google Meet despre IT-ul tău sau software-ul de care ai nevoie. Alege o oră mai jos, iar invitația vine direct din calendarul nostru.',
      expectLabel: 'Ce te așteaptă',
      lengthTerm: 'Durată',
      lengthValue: '{minutes} de minute',
      whereTerm: 'Unde',
      whereValue: 'Google Meet. Linkul se află în invitația din calendar.',
      costTerm: 'Cost',
      costValue: 'Gratuit, fără nicio obligație.',
      aboutTerm: 'Ce discutăm',
      aboutValue: 'Configurația actuală, ce vrei să schimbi și dacă suntem echipa potrivită pentru asta.',
      languageTerm: 'Limba',
      languageValue: 'Română sau rusă.',
      preferContact: 'Preferi e-mailul sau telefonul?',
      schedulerLabel: 'Alegerea orei',
      pickDay: 'Alege o zi',
      pickTime: 'Alege o oră',
      timezoneNote: 'Orele sunt afișate în ora Chișinăului',
      timezoneShort: 'ora Chișinăului',
      loading: 'Se încarcă orele libere…',
      dayFull: 'Ocupat',
      noSlotsDay: 'Nu sunt ore libere în această zi. Încearcă altă zi.',
      noSlotsAll: 'Nu sunt ore libere în săptămânile următoare.',
      yourDetails: 'Datele tale',
      selected: 'Ora aleasă',
      changeTime: 'Schimbă ora',
      name: 'Nume',
      email: 'E-mail',
      company: 'Companie',
      topic: 'Ce vrei să discutăm?',
      optional: 'opțional',
      honeypot: 'Lasă acest câmp gol',
      confirm: 'Confirmă programarea',
      submitting: 'Se programează…',
      privacyBefore: 'Datele tale sunt incluse în invitația din calendar pentru această discuție. Consultă ',
      privacyLink: 'politica de confidențialitate',
      privacyAfter: '.',
      errors: {
        load: 'Calendarul nu a putut fi încărcat.',
        retry: 'Încearcă din nou',
        taken: 'Această oră tocmai a fost rezervată. Alege alta.',
        invalid: 'Verifică numele și adresa de e-mail și nu include linkuri în câmpurile companie și subiect.',
        unavailable: 'Programarea online nu este disponibilă momentan.',
        rateLimited: 'Prea multe încercări de pe această conexiune.',
        generic: 'Programarea nu a reușit.',
        fallbackBefore: 'Scrie-ne la ',
        fallbackAfter: ' și găsim împreună o oră potrivită.'
      },
      success: {
        label: 'Confirmat',
        title: 'Gata.',
        when: 'Când',
        meet: 'Google Meet',
        meetPending: 'Linkul Meet se află în invitație.',
        invite: 'Am trimis o invitație în calendar la {email}, cu linkul Meet inclus.',
        back: 'Înapoi la pagina principală'
      }
    },
    floatingHelp: {
      needHelp: 'Ai nevoie de ajutor?',
      weAreHere: 'Suntem aici să te ajutăm!',
      getServiceQuote: 'Obține o ofertă',
      backToTop: 'Înapoi sus',
      close: 'Închide',
      tooltip: 'Ai nevoie de ajutor? Apasă aici!'
    },
    portfolio: {
      title: 'LUCRĂRI SELECTATE',
      subtitle: 'Proiecte IT și web realizate pentru clienții noștri.',
      jsonLd: {
        name: 'Portofoliu',
        description: 'Descoperă portofoliul Byteet, cu implementări IT de succes și studii de caz. Explorează exemple reale de soluții cloud, proiecte de dezvoltare web, implementări de administrare a dispozitivelor și soluții de automatizare.'
      },
      all: 'Toate',
      viewAll: 'Vezi toate proiectele',
      technologiesUsed: 'Tehnologii folosite:',
      keyResults: 'Rezultate-cheie:',
      viewProject: 'Vezi detalii',
      openWebsite: 'Deschide site-ul',
      viewDetails: 'Vezi detalii',
      recentWork: 'LUCRĂRI RECENTE',
      recentWorkSubtitle: 'O prezentare a proiectelor noastre recente și a implementărilor de succes din diverse industrii și tehnologii.',
      categories: {
        infrastructure: 'Infrastructură',
        deviceManagement: 'Administrare dispozitive',
        security: 'Securitate',
        automation: 'Automatizare',
        cloudInfrastructure: 'Infrastructură cloud',
        devopsAutomation: 'Automatizare DevOps',
        securityIAM: 'Securitate și IAM',
        itOperations: 'Operațiuni IT',
        documentation: 'Documentație',
        webDevelopment: 'Dezvoltare web',
        serviceDesk: 'Service Desk'
      },
      projects: {
        mundusCrasWebsite: {
          title: 'Mundus Cras – consultanță pentru management superior',
          description: 'Site bilingv și platformă de conținut pentru Mundus Cras, o firmă de consultanță pentru management superior care activează în Țările de Jos și în Emiratele Arabe Unite. Treisprezece pagini în engleză și neerlandeză, un headless CMS cu panou de administrare pentru articolele firmei, un flux structurat pentru solicitări și un sistem de consimțământ pentru analiză.',
          results: [
            'Treisprezece pagini în engleză și neerlandeză',
            'Headless CMS cu panou de administrare',
            'Flux structurat pentru solicitări',
            'Gestionarea consimțământului pentru analiză'
          ]
        },
        deHorecaBrigadeWebsite: {
          title: 'De Horeca Brigade – servicii juridice pentru HoReCa',
          description: 'Identitate de brand și site bilingv pentru De Horeca Brigade, o firmă olandeză care se ocupă de chestiuni juridice și de reglementare pentru antreprenorii din HoReCa, de la autorizații la conformitate. Echipa gestionează articolele din baza de cunoștințe, prețurile și cererile de ofertă dintr-un panou de administrare propriu, iar vizitatorii pot programa un apel direct pe site.',
          results: ['Identitate de brand și ghid de stil', 'Site bilingv (NL/EN) cu URL-uri localizate', 'Ghid interactiv care îndrumă vizitatorul spre serviciul potrivit', 'Panou de administrare pentru articole, prețuri și cereri']
        },
        ironLadyWebsite: {
          title: 'The Iron Lady – site pentru steakhouse, Rotterdam',
          description: 'Site bilingv pentru The Iron Lady, un steakhouse și cocktail bar în centrul orașului Rotterdam. Meniul complet de mâncare și băuturi este conținut structurat pe care proprietarii îl editează singuri, cu rezervări online integrate.',
          results: ['Site bilingv (NL/EN)', 'Panou de administrare pentru meniu, fotografii și conținut', 'Meniu complet de mâncare și băuturi', 'Rezervări online']
        },
        fatFoxWebsite: {
          title: 'The Fat Fox – site pentru pub și steakhouse, Rotterdam',
          description: 'Site bilingv pentru The Fat Fox, un pub englezesc și steakhouse cu grătar pe cărbuni din zona Witte de With din Rotterdam. Proprietarii gestionează meniul, inclusiv peste 150 de băuturi, din propriul panou de administrare, iar oaspeții rezervă o masă online.',
          results: ['Site bilingv (NL/EN)', 'Panou de administrare pentru meniu și conținut', 'Meniu cu peste 150 de băuturi', 'Rezervări online']
        },
        morenaWebsite: {
          title: 'Morena – restaurant latino și cocktail bar, Rotterdam',
          description: 'Reconstrucție completă a site-ului pentru Morena, un restaurant pan-latino-american și cocktail bar din cartierul MaHo din Rotterdam. Proprietarii editează singuri meniul și aleg preparatele evidențiate pe pagina principală.',
          results: ['Reconstrucție completă a morenarotterdam.nl', 'Site bilingv (NL/EN)', 'Panou de administrare pentru meniu și preparate evidențiate', 'Rezervări online']
        },
        nouraWebsite: {
          title: 'Noura – restaurant levantin, Rotterdam',
          description: 'Site bilingv pentru Noura, un restaurant levantin din Rotterdam, proiectat în jurul identității de brand a restaurantului. Proprietarii gestionează programul, meniul și conținutul paginilor dintr-o consolă pe un subdomeniu de administrare separat.',
          results: ['Site bilingv (NL/EN)', 'Design construit pe identitatea de brand Noura', 'Consolă de administrare pentru program, meniu și pagini', 'Meniu cu denumiri arabe și etichete dietetice']
        },
        sportaMdWebsite: {
          title: 'Sporta MD – site pentru platforma de rezervări sportive',
          description: 'Site pentru Sporta MD, o aplicație mobilă pentru rezervarea meciurilor amicale de fotbal, baschet, volei, tenis și padel în Chișinău. Site-ul trilingv (RO/RU/EN) cuprinde pagini pentru fiecare sport, un catalog de stadioane cu hartă, documentele juridice și documentația API publică, plus deep link-urile și confirmarea prin e-mail care trimit utilizatorii în aplicație.',
          results: ['Site trilingv (RO/RU/EN)', 'Catalog de stadioane cu Google Maps', 'Documentație API pe docs.sporta.md', 'Deep link-uri și redirecționare către magazinele de aplicații']
        },
        jamfDeviceManagement: {
          title: 'Managementul dispozitivelor enterprise',
          description: 'Am înscris și configurat cu succes peste 150 de dispozitive prin soluția Jamf Pro MDM și am pus în funcțiune managementul complet al dispozitivelor și politicile de securitate pentru o implementare la scară enterprise.',
          problem: {
            title: 'Provocarea',
            description: 'Organizația s-a confruntat cu dificultăți în gestionarea unei flote în creștere de dispozitive macOS în mai multe locații:',
            challenges: [
              'Configurarea manuală a dispozitivelor, care ducea la inconsecvențe',
              'Lipsa unei modalități centralizate de aplicare a politicilor de securitate',
              'Procese de înscriere și configurare a dispozitivelor care consumă timp',
              'Dificultate în urmărirea și gestionarea inventarului dispozitivelor',
              'Lipsa capabilităților de implementare automată a software-ului'
            ]
          },
          solution: {
            title: 'Soluția noastră',
            description: 'Am implementat Jamf Pro MDM pentru a centraliza managementul dispozitivelor și a automatiza procesele de implementare.',
            process: [
              { step: 'Evaluare', icon: 'clipboard', description: 'Am evaluat inventarul dispozitivelor și cerințele' },
              { step: 'Configurare Jamf', icon: 'server', description: 'Am configurat serverul Jamf Pro și politicile' },
              { step: 'Înscriere', icon: 'users', description: 'Înscriere automată a peste 150 de dispozitive' },
              { step: 'Implementarea politicilor', icon: 'shield', description: 'Am aplicat politicile de securitate și management' }
            ]
          },
          results: ['Peste 150 de dispozitive înscrise', 'Management centralizat', 'Politici de securitate aplicate', 'Soluție de nivel enterprise']
        },
        activeDirectoryManagement: {
          title: 'Infrastructură Active Directory',
          description: 'Am implementat managementul complet al Active Directory, inclusiv configurarea politicilor de grup, gestionarea ciclului de viață al utilizatorilor, procese automate de onboarding și scripturi PowerShell personalizate de automatizare.',
          problem: {
            title: 'Provocarea',
            description: 'Organizația s-a confruntat cu ineficiențe în managementul utilizatorilor și al dispozitivelor:',
            challenges: [
              'Provizionarea manuală a utilizatorilor, care dura ore pentru fiecare angajat',
              'Politici de securitate neunitare între departamente',
              'Lipsa unei modalități automate de gestionare a ciclului de viață al utilizatorilor',
              'Configurarea politicilor de grup, care consuma mult timp',
              'Lipsa unui management centralizat al identităților'
            ]
          },
          solution: {
            title: 'Soluția noastră',
            description: 'Am proiectat și implementat o infrastructură Active Directory completă cu automatizare.',
            process: [
              { step: 'Proiectarea arhitecturii', icon: 'layout', description: 'Am proiectat structura AD și ierarhia OU' },
              { step: 'Configurarea politicilor de grup', icon: 'settings', description: 'Am configurat politicile de securitate și management' },
              { step: 'Scripturi de automatizare', icon: 'terminal', description: 'Am dezvoltat fluxuri de automatizare în PowerShell' },
              { step: 'Ciclul de viață al utilizatorilor', icon: 'refresh-cw', description: 'Procese automate de onboarding/offboarding' }
            ]
          },
          results: ['Implementarea politicilor de grup', 'Onboarding automatizat al utilizatorilor', 'Automatizare PowerShell', 'Optimizarea infrastructurii']
        },
        googleWorkspaceSetup: {
          title: 'Configurare și management Google Workspace',
          description: 'Implementare completă Google Workspace pentru peste 150 de angajați, inclusiv unități organizaționale, politici de securitate, configurarea Google Groups și gestionarea ciclului de viață al utilizatorilor cu provizionare automată.',
          problem: {
            title: 'Provocarea',
            description: 'Organizația trebuia să migreze la Google Workspace, dar s-a confruntat cu mai multe obstacole:',
            challenges: [
              'Migrare complexă de la sisteme vechi de e-mail',
              'Nevoia de aliniere a structurii organizaționale',
              'Cerințe de securitate și conformitate',
              'Preocupări privind formarea și adoptarea utilizatorilor',
              'Integrare cu sistemele existente'
            ]
          },
          solution: {
            title: 'Soluția noastră',
            description: 'Am livrat o implementare completă Google Workspace cu provizionare automată și securitate.',
            process: [
              { step: 'Planificare', icon: 'map', description: 'Am proiectat structura OU și planul de migrare' },
              { step: 'Configurare', icon: 'cog', description: 'Am configurat politicile de securitate și grupurile' },
              { step: 'Migrare', icon: 'arrow-right', description: 'Am migrat peste 150 de utilizatori fără probleme' },
              { step: 'Automatizare', icon: 'zap', description: 'Am implementat fluxuri de provizionare automată' }
            ]
          },
          results: ['Peste 150 de angajați configurați', 'Structură OU proiectată', 'Politici de securitate aplicate', 'Implementare Google Groups', 'Provizionare automată']
        },
        jiraServiceManagement: {
          title: 'Implementare Jira Service Management',
          description: 'Am implementat un serviciu de helpdesk complet folosind Atlassian JSM, cu fluxuri de lucru avansate de automatizare, rutare personalizată a tichetelor, management SLA și dashboard-uri de raportare integrate, pentru operațiuni de suport IT optimizate.',
          problem: {
            title: 'Provocarea',
            description: 'Organizația avea nevoie de o soluție unificată de service desk, dar s-a confruntat cu provocări operaționale:',
            challenges: [
              'Canale de suport fragmentate, care duceau la pierderea tichetelor și la întârzieri',
              'Lipsa unui proces standardizat pentru gestionarea cererilor IT',
              'Dificultăți în urmărirea conformității cu SLA și a metricilor de performanță',
              'Lipsa opțiunilor de self-service, care creștea volumul de muncă al echipei de suport',
              'Rutarea manuală a tichetelor, care ducea la ineficiențe'
            ]
          },
          solution: {
            title: 'Soluția noastră',
            description: 'Am implementat Jira Service Management cu automatizare, un portal de self-service și raportare completă.',
            process: [
              { step: 'Analiza cerințelor', icon: 'clipboard', description: 'Am analizat fluxurile de lucru ale suportului și cerințele' },
              { step: 'Configurare JSM', icon: 'settings', description: 'Am configurat o instanță JSM multiregională și fluxurile de lucru' },
              { step: 'Configurarea automatizării', icon: 'zap', description: 'Am configurat rutarea automată și fluxurile de lucru' },
              { step: 'Portal și instruire', icon: 'users', description: 'Am lansat portalul de self-service și am instruit agenții' }
            ]
          },
          results: ['10 agenți de suport IT', 'Configurare multiregională', 'Portal de self-service', 'Fluxuri de lucru automatizate', 'Management SLA', 'Dashboard-uri de raportare']
        },
        zammadServiceDesk: {
          title: 'Zammad Service Desk cu integrare LDAP',
          description: 'Am creat o soluție robustă de service desk folosind Zammad, cu integrare LDAP fără probleme, provizionare automată a utilizatorilor, control al accesului bazat pe roluri și automatizare personalizată a fluxurilor de lucru, pentru un suport mai eficient.',
          problem: {
            title: 'Provocarea',
            description: 'Organizația avea nevoie de un service desk open-source integrat cu serviciul de director:',
            challenges: [
              'Nevoia unei soluții de service desk rentabile',
              'Cerința de integrare LDAP/Active Directory',
              'Gestionarea manuală a utilizatorilor, care consuma resurse IT',
              'Lipsa controalelor de acces bazate pe roluri',
              'Lipsa fluxurilor de lucru automatizate'
            ]
          },
          solution: {
            title: 'Soluția noastră',
            description: 'Am implementat Zammad cu integrare LDAP și fluxuri de provizionare automată a utilizatorilor.',
            process: [
              { step: 'Implementare Zammad', icon: 'server', description: 'Am instalat și configurat platforma Zammad' },
              { step: 'Integrare LDAP', icon: 'link', description: 'Am conectat platforma la Active Directory prin LDAP' },
              { step: 'Configurare RBAC', icon: 'shield', description: 'Am configurat controale de acces bazate pe roluri' },
              { step: 'Automatizare', icon: 'zap', description: 'Am implementat provizionarea automată a utilizatorilor' }
            ]
          },
          results: ['Integrare LDAP', 'Provizionare automată a utilizatorilor', 'Control al accesului bazat pe roluri', 'Automatizare personalizată a fluxurilor de lucru', 'Eficiență sporită a suportului']
        },
        gravlDocumentation: {
          title: 'Site web de documentație Gravl',
          description: 'Am dezvoltat un site web de documentație modern și responsiv folosind Gravl CMS, cu capabilități avansate de căutare, controlul versiunilor, suport multilingv și navigare intuitivă pentru documentație tehnică completă.',
          problem: {
            title: 'Provocarea',
            description: 'Organizația avea nevoie de o platformă modernă de documentație, dar s-a confruntat cu mai multe provocări:',
            challenges: [
              'Documentație împrăștiată în mai multe locații',
              'Sistem învechit de management al conținutului',
              'Funcție de căutare slabă, care făcea informațiile greu de găsit',
              'Lipsa controlului versiunilor pentru modificările documentației',
              'Suport multilingv limitat'
            ]
          },
          solution: {
            title: 'Soluția noastră',
            description: 'Am construit un site web modern de documentație folosind Gravl CMS, cu funcții avansate.',
            process: [
              { step: 'Auditul conținutului', icon: 'search', description: 'Am analizat structura documentației existente' },
              { step: 'Configurare Gravl', icon: 'code', description: 'Am configurat platforma Gravl CMS' },
              { step: 'Migrare', icon: 'arrow-right', description: 'Am migrat conținutul cu controlul versiunilor' },
              { step: 'Îmbunătățiri', icon: 'rocket', description: 'Am adăugat căutare și suport multilingv' }
            ]
          },
          results: ['Platformă modernă de documentație', 'Capabilități avansate de căutare', 'Controlul versiunilor', 'Suport multilingv', 'Navigare intuitivă']
        },
        activeDirectoryEnrollment: {
          title: 'Înscrierea dispozitivelor enterprise prin Active Directory',
          description: 'Am înscris și configurat cu succes peste 80 de dispozitive ale companiei prin alăturarea la domeniul Active Directory și am implementat politici de grup complete, configurații de securitate și management centralizat, pentru o guvernanță IT mai bună.',
          problem: {
            title: 'Provocarea',
            description: 'Organizația trebuia să înscrie dispozitivele în Active Directory, dar s-a confruntat cu dificultăți la înscriere:',
            challenges: [
              'Proces manual de înscriere a dispozitivelor, care dura prea mult',
              'Configurații de securitate neunitare între dispozitive',
              'Lipsa unei modalități centralizate de gestionare a politicilor pentru dispozitive',
              'Dificultate în aplicarea standardelor de conformitate',
              'Lipsa provizionării automate a dispozitivelor'
            ]
          },
          solution: {
            title: 'Soluția noastră',
            description: 'Înscrierea automată a dispozitivelor prin Active Directory, cu management complet al politicilor.',
            process: [
              { step: 'Pregătire AD', icon: 'server', description: 'Am pregătit Active Directory pentru înscrierea dispozitivelor' },
              { step: 'Proiectarea politicilor', icon: 'settings', description: 'Am proiectat politici de grup și configurații de securitate' },
              { step: 'Înscriere', icon: 'users', description: 'Am înscris peste 80 de dispozitive în domeniu' },
              { step: 'Guvernanță', icon: 'shield', description: 'Am aplicat politicile de management centralizat' }
            ]
          },
          results: ['Peste 80 de dispozitive înscrise', 'Politici de grup complete', 'Configurații de securitate aplicate', 'Management centralizat', 'Guvernanță IT îmbunătățită']
        },
        windowsInstallationAutomation: {
          title: 'Proces automatizat de instalare Windows',
          description: 'Am proiectat un sistem automatizat de instalare Windows folosind unități USB bootabile, cu scripturi personalizate de implementare, integrarea driverelor, preinstalarea software-ului și configurare nesupravegheată, pentru provizionarea rapidă a dispozitivelor.',
          problem: {
            title: 'Provocarea',
            description: 'Organizația trebuia să optimizeze instalările Windows, dar s-a confruntat cu provocări de implementare:',
            challenges: [
              'Instalarea manuală a Windows, care dura ore pentru fiecare dispozitiv',
              'Instalări de software neunitare între dispozitive',
              'Instalarea și configurarea driverelor, care consumau mult timp',
              'Lipsa unui proces standardizat de implementare',
              'Dificultăți în gestionarea preinstalării software-ului'
            ]
          },
          solution: {
            title: 'Soluția noastră',
            description: 'Am creat un sistem automatizat de instalare Windows cu scripturi personalizate de implementare.',
            process: [
              { step: 'Dezvoltarea scripturilor', icon: 'terminal', description: 'Am dezvoltat scripturi personalizate de implementare' },
              { step: 'Creare USB', icon: 'server', description: 'Am creat un stick USB bootabil cu drivere și software' },
              { step: 'Testare', icon: 'settings', description: 'Am testat procesul de instalare fără supraveghere' },
              { step: 'Implementare', icon: 'rocket', description: 'Am implementat sistemul de provizionare rapidă a dispozitivelor' }
            ]
          },
          results: ['Instalare automatizată', 'Scripturi de implementare personalizate', 'Integrarea driverelor', 'Preinstalare software', 'Provizionare rapidă a dispozitivelor']
        },
        googleWorkspaceManagement: {
          title: 'Configurare și management Google Workspace',
          description: 'Implementare completă Google Workspace, inclusiv provizionarea utilizatorilor, configurarea politicilor de securitate, migrarea datelor, integrarea aplicațiilor și administrare continuă, pentru productivitate și colaborare optime.',
          problem: {
            title: 'Provocarea',
            description: 'Organizația avea nevoie de management complet pentru Google Workspace, dar s-a confruntat cu provocări operaționale:',
            challenges: [
              'Provizionarea complexă a utilizatorilor și gestionarea ciclului de viață',
              'Nevoia de a configura politici de securitate și conformitate',
              'Migrarea datelor din sisteme vechi',
              'Cerințe de integrare a aplicațiilor',
              'Nevoia de administrare și optimizare continuă'
            ]
          },
          solution: {
            title: 'Soluția noastră',
            description: 'Am livrat o implementare completă Google Workspace, cu provizionare automată și management continuu.',
            process: [
              { step: 'Planificare', icon: 'map', description: 'Am proiectat strategia de implementare și migrare' },
              { step: 'Configurare', icon: 'cog', description: 'Am configurat politicile de securitate și integrările' },
              { step: 'Migrare', icon: 'arrow-right', description: 'Am migrat datele și utilizatorii fără probleme' },
              { step: 'Management', icon: 'refresh-cw', description: 'Am stabilit procese de administrare continuă' }
            ]
          },
          results: ['Provizionarea utilizatorilor', 'Politici de securitate configurate', 'Migrarea datelor finalizată', 'Integrarea aplicațiilor', 'Administrare continuă']
        },
        wordpressPlatform: {
          title: 'Platformă WordPress',
          description: 'Implementarea unei rețele WordPress multisite de înaltă performanță.',
          problem: {
            title: 'Provocarea',
            description: 'Organizația avea nevoie de o platformă WordPress scalabilă, dar s-a confruntat cu provocări de infrastructură:',
            challenges: [
              'Nevoia unei rețele multisite',
              'Cerințe de performanță și scalabilitate',
              'Management centralizat al mai multor site-uri',
              'Optimizarea resurselor și eficiența costurilor',
              'Preocupări legate de securitate și întreținere'
            ]
          },
          solution: {
            title: 'Soluția noastră',
            description: 'Am implementat o rețea WordPress multisite de înaltă performanță, cu infrastructură optimizată.',
            process: [
              { step: 'Proiectarea arhitecturii', icon: 'layout', description: 'Am proiectat arhitectura rețelei multisite' },
              { step: 'Configurarea infrastructurii', icon: 'server', description: 'Am configurat hosting de înaltă performanță' },
              { step: 'Optimizare', icon: 'zap', description: 'Am optimizat performanța și resursele' },
              { step: 'Implementare', icon: 'rocket', description: 'Am implementat platforma de rețea multisite' }
            ]
          },
          results: ['Rețea multisite', 'Performanță înaltă', 'Infrastructură scalabilă', 'Management centralizat', 'Resurse optimizate']
        },
        caseCloudWorkspace: {
        title: 'Spații de lucru în cloud',
          description: 'Am modernizat colaborarea prin migrarea la Microsoft 365, cu partajare securizată a fișierelor, Teams pentru comunicare și controale granulare ale accesului. Am implementat politici MFA și DLP pentru siguranța datelor și șabloane standardizate de onboarding pentru utilizatorii noi.',
          problem: {
            title: 'Provocarea',
            description: 'Organizația trebuia să modernizeze colaborarea, dar s-a confruntat cu provocări legate de spațiul de lucru:',
            challenges: [
              'Sisteme vechi de e-mail și de partajare a fișierelor, care limitau colaborarea',
              'Preocupări de securitate privind partajarea datelor și controalele de acces',
              'Lipsa unei platforme unificate de comunicare',
              'Structuri de fișiere și permisiuni neunitare',
              'Lipsa unui proces standardizat de onboarding pentru utilizatorii noi'
            ]
          },
          solution: {
            title: 'Soluția noastră',
            description: 'Am migrat la Microsoft 365 cu funcții complete de securitate și colaborare.',
            process: [
              { step: 'Planificarea migrării', icon: 'map', description: 'Am proiectat strategia de migrare fără întreruperi' },
              { step: 'Configurare M365', icon: 'server', description: 'Am configurat M365 cu Teams și SharePoint' },
              { step: 'Implementarea securității', icon: 'shield', description: 'Am implementat politici MFA și DLP' },
              { step: 'Standardizare', icon: 'settings', description: 'Am creat șabloane și procese standardizate' }
            ]
          },
          results: ['Migrare M365 fără întreruperi', '2FA/MFA aplicat pentru toți utilizatorii', 'Structură de fișiere și permisiuni standardizate', 'Reducerea atașamentelor de e-mail cu 80%']
        },
        caseDatabaseManagement: {
          title: 'Modernizarea managementului bazelor de date',
          description: 'Am consolidat datele operaționale fragmentate într-o instanță Oracle gestionată, cu backup-uri programate, monitorizare și acces bazat pe roluri. Am construit dashboard-uri simple pentru raportare aproape în timp real.',
          problem: {
            title: 'Provocarea',
            description: 'Organizația s-a confruntat cu dificultăți în managementul bazelor de date și fragmentarea datelor:',
            challenges: [
              'Date fragmentate în mai multe sisteme și locații',
              'Interogări lente, care afectau operațiunile',
              'Lipsa proceselor automate de backup și recuperare',
              'Lipsa controalelor de acces bazate pe roluri',
              'Dificultăți în generarea rapoartelor și a dashboard-urilor în timp real'
            ]
          },
          solution: {
            title: 'Soluția noastră',
            description: 'Am consolidat datele într-o instanță Oracle gestionată, cu automatizare și monitorizare.',
            process: [
              { step: 'Evaluarea datelor', icon: 'clipboard', description: 'Am analizat sursele de date fragmentate' },
              { step: 'Configurare Oracle', icon: 'server', description: 'Am implementat instanța Oracle gestionată' },
              { step: 'Migrare și optimizare', icon: 'arrow-right', description: 'Am migrat și optimizat datele' },
              { step: 'Monitorizare și dashboard-uri', icon: 'settings', description: 'Am configurat monitorizarea și dashboard-uri de raportare' }
            ]
          },
          results: ['Oracle în cloud cu backup-uri automate', 'RBAC pentru manageri/ops', 'Timpul interogărilor redus de la minute la secunde', 'Dashboard-uri operaționale pentru KPI-uri']
        },
        caseDeviceManagement: {
          title: 'Management centralizat al dispozitivelor',
          description: 'Am implementat Microsoft Intune cu politici de securitate de bază, criptarea dispozitivelor și cataloage de aplicații. Am introdus înscrierea automată pentru a accelera provizionarea și ștergerea la distanță pentru dispozitivele pierdute.',
          problem: {
            title: 'Provocarea',
            description: 'Organizația avea nevoie de management centralizat al dispozitivelor, dar s-a confruntat cu mai multe provocări:',
            challenges: [
              'Lipsa unei modalități centralizate de gestionare a dispozitivelor companiei',
              'Politici de securitate neunitare între dispozitive',
              'Proces de provizionare a dispozitivelor care consuma mult timp',
              'Lipsa criptării dispozitivelor și a controalelor de securitate',
              'Dificultăți în gestionarea software-ului și a aplicațiilor aprobate'
            ]
          },
          solution: {
            title: 'Soluția noastră',
            description: 'Am implementat Microsoft Intune pentru managementul centralizat și securitatea dispozitivelor.',
            process: [
              { step: 'Planificare Intune', icon: 'map', description: 'Am proiectat strategia de implementare Intune' },
              { step: 'Configurarea politicilor', icon: 'settings', description: 'Am configurat politicile de securitate și criptare' },
              { step: 'Automatizarea înscrierii', icon: 'zap', description: 'Am configurat înscrierea automată a dispozitivelor' },
              { step: 'Configurarea catalogului de aplicații', icon: 'server', description: 'Am creat catalogul de software aprobat' }
            ]
          },
          results: ['Înscriere Intune în întreaga companie', 'Criptare completă a discului aplicată', 'Catalog de aplicații cu software aprobat', 'Timpul de onboarding redus cu 60%']
        },
        caseWindowsAutomatedDeployment: {
          title: 'Implementarea automatizată a dispozitivelor Windows',
          description: 'Am creat o soluție USB bootabilă care instalează automat Windows, alătură dispozitivele la domeniul Active Directory și instalează instrumentele și driverele necesare, pentru o companie de contabilitate cu peste 30 de dispozitive.',
          problem: {
            title: 'Provocarea',
            description: 'O companie de contabilitate avea nevoie de cel mai simplu și mai ieftin mod de a gestiona peste 30 de dispozitive Windows livrate fără sistem de operare instalat:',
            challenges: [
              'Dispozitivele au sosit fără sistem de operare Windows instalat',
              'Instalarea manuală pe peste 30 de dispozitive ar fi durat mult',
              'Nevoia de alăturare automată a dispozitivelor la domeniul Active Directory',
              'Instalarea instrumentelor și driverelor necesare pe fiecare dispozitiv',
              'Era necesară o soluție rentabilă pentru o companie mică de contabilitate'
            ]
          },
          solution: {
            title: 'Soluția noastră',
            description: 'Am dezvoltat un stick USB bootabil care automatizează întregul proces de instalare și configurare a Windows.',
            process: [
              { step: 'Creare USB', icon: 'server', description: 'Am creat un stick USB bootabil cu mediul de instalare Windows' },
              { step: 'Scripturi de automatizare', icon: 'code', description: 'Am dezvoltat scripturi pentru instalarea automată a Windows' },
              { step: 'Integrarea în domeniu', icon: 'link', description: 'Am configurat alăturarea automată la domeniul Active Directory' },
              { step: 'Configurare drivere și instrumente', icon: 'settings', description: 'Instalarea automată a driverelor și instrumentelor necesare' }
            ]
          },
          results: ['Instalare automată a Windows pe peste 30 de dispozitive', 'Alăturare automată la domeniul Active Directory', 'Drivere și instrumente preconfigurate', 'Economii semnificative de timp și costuri']
        },
        caseIdentityAccess: {
          title: 'Consolidarea identităților și a accesului',
          description: 'Am implementat SSO și MFA prin Okta, cu sincronizarea directorului cu Azure AD. Am standardizat cererile de acces folosind grupuri și politici de ciclu de viață în principalele aplicații SaaS.',
          problem: {
            title: 'Provocarea',
            description: 'Organizația trebuia să consolideze managementul identităților și al accesului:',
            challenges: [
              'Mai multe sisteme de autentificare, care frustrau utilizatorii',
              'Lipsa single sign-on în aplicațiile de afaceri',
              'Procese neunitare de gestionare a accesului',
              'Gestionarea manuală a ciclului de viață al utilizatorilor',
              'Dificultăți în menținerea conformității pentru audit'
            ]
          },
          solution: {
            title: 'Soluția noastră',
            description: 'Am implementat Okta cu SSO, MFA și management automatizat al ciclului de viață.',
            process: [
              { step: 'Planificare Okta', icon: 'map', description: 'Am proiectat strategia de consolidare a identităților' },
              { step: 'Integrarea directorului', icon: 'link', description: 'Am integrat Okta cu Azure AD' },
              { step: 'Configurare SSO și MFA', icon: 'shield', description: 'Am configurat politicile SSO și MFA' },
              { step: 'Automatizarea ciclului de viață', icon: 'zap', description: 'Fluxuri automate pentru ciclul de viață al utilizatorilor' }
            ]
          },
          results: ['SSO pentru peste 12 aplicații de afaceri', 'MFA în funcție de rol și risc', 'Fluxuri automate joiner/mover/leaver', 'Revizuiri ale accesului pregătite pentru audit']
        },
        caseInfrastructure: {
          title: 'Migrarea infrastructurii în cloud',
          description: 'Am mutat serviciile de fișiere și sarcinile de lucru selectate în AWS, folosind EC2 și S3. Am definit infrastructura cu Terraform pentru reproductibilitate și am configurat alerte CloudWatch pentru monitorizare proactivă.',
          problem: {
            title: 'Provocarea',
            description: 'Organizația trebuia să migreze infrastructura în cloud, dar s-a confruntat cu mai multe provocări:',
            challenges: [
              'Costuri ridicate de infrastructură cu sistemele on-premises',
              'Lipsa infrastructurii ca cod pentru reproductibilitate',
              'Lipsa monitorizării și a alertelor automate',
              'Dificultăți în scalarea resurselor în funcție de nevoi',
              'Procese complexe de recuperare în caz de dezastru și backup'
            ]
          },
          solution: {
            title: 'Soluția noastră',
            description: 'Am migrat infrastructura la AWS cu Terraform IaC și monitorizare completă.',
            process: [
              { step: 'Planificarea migrării', icon: 'map', description: 'Am proiectat strategia de migrare în cloud' },
              { step: 'Configurare Terraform', icon: 'code', description: 'Am creat infrastructura ca cod cu Terraform' },
              { step: 'Migrare în AWS', icon: 'arrow-right', description: 'Am migrat sarcinile de lucru la EC2 și S3' },
              { step: 'Configurarea monitorizării', icon: 'settings', description: 'Am configurat alerte CloudWatch și monitorizare' }
            ]
          },
          results: ['Costuri de infrastructură reduse cu 50%', 'Fundamente IaC cu Terraform', 'Politici de ciclu de viață S3 pentru controlul costurilor', 'Fiabilitate și recuperare (RTO/RPO) îmbunătățite']
        },
        caseDevOpsAutomation: {
          title: 'CI/CD și automatizare',
          description: 'Am construit un pipeline GitLab CI cu build-uri bazate pe Docker, testare automatizată și promovare între medii. Am adăugat notificări în chat și etichete de release pentru urmărire.',
          problem: {
            title: 'Provocarea',
            description: 'Organizația trebuia să automatizeze procesele de dezvoltare și implementare:',
            challenges: [
              'Implementări manuale, care cauzau întârzieri și erori',
              'Lipsa testelor automate în fluxul de dezvoltare',
              'Cicluri de build și implementare care consumau mult timp',
              'Lipsa posibilității de rollback în timpul implementărilor',
              'Lipsa vizibilității asupra stării implementărilor și a notificărilor'
            ]
          },
          solution: {
            title: 'Soluția noastră',
            description: 'Am implementat un pipeline GitLab CI/CD cu Docker, teste automate și notificări.',
            process: [
              { step: 'Proiectarea pipeline-ului', icon: 'layout', description: 'Am proiectat arhitectura pipeline-ului CI/CD' },
              { step: 'Configurare GitLab CI', icon: 'code', description: 'Am configurat GitLab CI cu build-uri Docker' },
              { step: 'Automatizarea testelor', icon: 'zap', description: 'Am integrat teste automate pentru fiecare PR' },
              { step: 'Implementare și monitorizare', icon: 'rocket', description: 'Am configurat implementarea automată și notificările' }
            ]
          },
          results: ['Timpul de implementare redus la 10 minute', 'Teste automate pentru fiecare PR', 'Release-uri pregătite pentru rollback', 'Mai puține întreruperi în timpul implementărilor']
        },
        caseKnowledgeManagement: {
          title: 'Platformă de management al bazei de cunoștințe',
          description: 'Am lansat o bază de cunoștințe în Confluence, cu șabloane de pagini, fluxuri de aprobare și etichete structurate. Am integrat SSO și am instruit echipele să mențină conținutul actualizat.',
          problem: {
            title: 'Provocarea',
            description: 'Organizația avea nevoie de un sistem centralizat de management al cunoștințelor, dar s-a confruntat cu provocări legate de informații:',
            challenges: [
              'Cunoștințe împrăștiate în mai multe locații și formate',
              'Lipsa șabloanelor standardizate pentru documentație',
              'Lipsa fluxurilor de aprobare pentru calitatea conținutului',
              'Dificultăți în găsirea informațiilor din cauza organizării slabe',
              'Lipsa unui sistem structurat de etichete sau de categorisire'
            ]
          },
          solution: {
            title: 'Soluția noastră',
            description: 'Am implementat baza de cunoștințe în Confluence, cu șabloane, fluxuri de aprobare și organizare structurată.',
            process: [
              { step: 'Configurare Confluence', icon: 'server', description: 'Am configurat platforma Confluence cu SSO' },
              { step: 'Crearea șabloanelor', icon: 'layout', description: 'Am creat șabloane standardizate de pagini' },
              { step: 'Proiectarea fluxurilor', icon: 'settings', description: 'Am configurat fluxuri de aprobare și etichete' },
              { step: 'Instruire și lansare', icon: 'users', description: 'Am instruit echipele și am lansat baza de cunoștințe' }
            ]
          },
          results: ['Politici și SOP-uri centralizate', 'Conținut bazat pe șabloane', 'Etichete și categorii ușor de căutat', 'Timpul de onboarding redus semnificativ']
        },
        caseServiceDesk: {
        title: 'Implementare service desk',
          description: 'Am introdus un helpdesk unificat cu categorii de tichete, SLA-uri, bază de cunoștințe self-service și reguli automate de rutare. Am adăugat sondaje CSAT pentru măsurarea satisfacției utilizatorilor.',
          problem: {
            title: 'Provocarea',
            description: 'Organizația avea nevoie de un service desk unificat, dar s-a confruntat cu provocări de suport:',
            challenges: [
              'Mai multe canale de suport, care creau confuzie și întârzieri',
              'Lipsa unei urmăriri și a unui management standardizat al SLA-urilor',
              'Lipsa opțiunilor de self-service, care creștea volumul de tichete',
              'Rutarea manuală a tichetelor, care ducea la ineficiențe',
              'Lipsa unei modalități de a măsura și îmbunătăți satisfacția utilizatorilor'
            ]
          },
          solution: {
            title: 'Soluția noastră',
            description: 'Am implementat un service desk unificat, cu automatizare, self-service și urmărirea satisfacției.',
            process: [
              { step: 'Configurare service desk', icon: 'server', description: 'Am configurat platforma de helpdesk unificată' },
              { step: 'Configurare SLA', icon: 'settings', description: 'Am configurat urmărirea SLA și categoriile' },
              { step: 'Automatizare și self-service', icon: 'zap', description: 'Am implementat rutarea automată și baza de cunoștințe' },
              { step: 'Integrare CSAT', icon: 'users', description: 'Am adăugat sondaje de satisfacție și urmărirea lor' }
            ]
          },
          results: ['Conformitate SLA îmbunătățită', 'Self-service-ul a preluat tichetele frecvente', 'Rutarea automată a redus backlogul', 'CSAT urmărit și îmbunătățit de la un trimestru la altul']
        }
      }
    },
    homepageFeaturedWork: {
      title: 'SOLUȚII SELECTATE',
      subtitle: 'O selecție de proiecte IT recente.',
      technologiesUsed: 'Tehnologii folosite:',
      keyResults: 'Rezultate-cheie:',
      learnMore: 'Află mai multe',
      viewAllProjects: 'Vezi toate proiectele',
      categories: {
        cloudSolutions: 'Soluții cloud',
        securityIAM: 'Securitate și IAM',
        infrastructure: 'Infrastructură'
      },
      projects: {
        microsoft365Migration: {
          title: 'Migrare enterprise la Microsoft 365',
          description: 'Am condus o migrare completă la Microsoft 365 pentru o organizație cu peste 200 de angajați, inclusiv migrarea e-mailului, configurarea SharePoint, implementarea Teams și configurarea securității, ceea ce a îmbunătățit colaborarea și productivitatea.',
          problem: {
            title: 'Provocarea',
            description: 'Organizația trebuia să migreze la Microsoft 365, dar s-a confruntat cu provocări de migrare:',
            challenges: [
              'Sisteme vechi de e-mail, care limitau colaborarea',
              'Nevoia unei migrări fără întreruperi pentru peste 200 de utilizatori',
              'Migrarea complexă a datelor din mai multe surse',
              'Cerințe de securitate și conformitate',
              'Preocupări privind formarea și adoptarea utilizatorilor'
            ]
          },
          solution: {
            title: 'Soluția noastră',
            description: 'Am realizat o migrare completă la M365, fără întreruperi și cu securitate îmbunătățită.',
            process: [
              { step: 'Planificarea migrării', icon: 'map', description: 'Am proiectat strategia de migrare fără întreruperi' },
              { step: 'Migrarea e-mailului', icon: 'arrow-right', description: 'Am migrat peste 200 de utilizatori fără probleme' },
              { step: 'Configurarea platformei', icon: 'server', description: 'Am configurat SharePoint, Teams și securitatea' },
              { step: 'Instruire și suport', icon: 'users', description: 'Am oferit instruire și suport continuu' }
            ]
          },
          results: ['Peste 200 de utilizatori migrați', 'Migrare fără întreruperi', 'Politici de securitate îmbunătățite', 'Instrumente de colaborare îmbunătățite']
        },
        oktaImplementation: {
          title: 'Implementarea managementului identităților cu Okta',
          description: 'Am implementat Okta ca furnizor principal de identitate pentru o organizație multi-tenant, cu single sign-on fără probleme în peste 15 aplicații, și am consolidat securitatea prin autentificare multifactor.',
          problem: {
            title: 'Provocarea',
            description: 'Organizația avea nevoie de management unificat al identităților, dar s-a confruntat cu provocări de autentificare:',
            challenges: [
              'Mai multe sisteme de autentificare, care frustrau utilizatorii',
              'Lipsa single sign-on în peste 15 aplicații de afaceri',
              'Preocupări de securitate legate de autentificarea pe bază de parolă',
              'Cerințe complexe de identitate multi-tenant',
              'Dificultăți în gestionarea accesului utilizatorilor la aplicații'
            ]
          },
          solution: {
            title: 'Soluția noastră',
            description: 'Am implementat Okta ca furnizor principal de identitate, cu SSO și MFA în toate aplicațiile.',
            process: [
              { step: 'Planificare Okta', icon: 'map', description: 'Am proiectat strategia de management al identităților' },
              { step: 'Integrarea aplicațiilor', icon: 'link', description: 'Am integrat peste 15 aplicații cu SSO' },
              { step: 'Configurare MFA', icon: 'shield', description: 'Am configurat autentificarea multifactor' },
              { step: 'Configurare multi-tenant', icon: 'users', description: 'Am configurat arhitectura multi-tenant' }
            ]
          },
          results: ['Peste 15 aplicații integrate', 'Implementare SSO', 'Aplicarea MFA', 'Conformitate de securitate']
        },
        serverInfrastructure: {
          title: 'Configurarea infrastructurii de servere enterprise',
          description: 'Am proiectat și implementat o infrastructură completă de servere enterprise, inclusiv implementarea Windows Server, virtualizare VMware, configurarea Active Directory, soluții automate de backup și sisteme complete de monitorizare pentru o organizație în creștere.',
          problem: {
            title: 'Provocarea',
            description: 'Organizația avea nevoie de o infrastructură de servere enterprise, dar s-a confruntat cu mai multe provocări:',
            challenges: [
              'Lipsa unei infrastructuri centralizate de servere pentru o organizație în creștere',
              'Lipsa virtualizării, care limita eficiența',
              'Lipsa Active Directory pentru managementul identităților',
              'Procese manuale de backup, cu risc de pierdere a datelor',
              'Lipsa unui sistem de monitorizare a stării infrastructurii'
            ]
          },
          solution: {
            title: 'Soluția noastră',
            description: 'Am proiectat și implementat o infrastructură enterprise completă, cu virtualizare și automatizare.',
            process: [
              { step: 'Proiectarea infrastructurii', icon: 'layout', description: 'Am proiectat arhitectura și topologia serverelor' },
              { step: 'Implementare VMware', icon: 'server', description: 'Am implementat platforma de virtualizare VMware' },
              { step: 'Configurare AD și servicii', icon: 'settings', description: 'Am configurat Active Directory și serviciile' },
              { step: 'Automatizare și monitorizare', icon: 'zap', description: 'Am implementat backup-uri și monitorizare 24/7' }
            ]
          },
          results: ['Infrastructură completă de servere', 'Virtualizare VMware', 'Configurare Active Directory', 'Soluții automate de backup', 'Sistem de monitorizare 24/7']
        }
      }
    },
    solutions: {
      title: 'SOLUȚIILE NOASTRE',
      subtitle: 'Suport IT, cloud, securitate, date, AI, dezvoltare web și mobilă, CRM și ERP pentru afaceri din Moldova.',
      exploreAllSolutions: 'Explorează toate soluțiile',
      exploreSolution: 'Explorează soluția',
      technologies: 'Tehnologii',
      keyBenefits: 'Beneficii-cheie',
      managedItSupport: {
        title: 'Externalizare IT și suport',
        subtitle: 'Helpdesk, mentenanță și service desk',
        description: 'Externalizarea IT, helpdesk-ul, mentenanța și monitorizarea funcționează ca o singură operațiune, cu SLA clar și o bază de cunoștințe în spatele fiecărei rezolvări.',
        benefits: ['Helpdesk cu SLA', 'Externalizare IT completă', 'Mentenanță lunară', 'Rezolvare la primul contact']
      },
      cloudInfrastructure: {
        title: 'Cloud și infrastructură',
        subtitle: 'Microsoft 365, servere și migrare',
        description: 'Administrare Microsoft 365 și Google Workspace, servere și virtualizare, cu migrare în cloud fără întreruperi, monitorizare și optimizarea costurilor.',
        benefits: ['Administrare Microsoft 365', 'Migrare fără întreruperi', 'Servere și virtualizare', 'Costuri cloud optimizate']
      },
      cybersecurityIdentity: {
        title: 'Securitate cibernetică și identitate',
        subtitle: 'IAM, protecție endpoint și Zero Trust',
        description: 'Securitate cibernetică pentru companii: identitate și acces (MFA/PAM), protecție endpoint și conformitate, inclusiv pregătirea pentru Legea 195/2024.',
        benefits: ['MFA și SSO', 'Acces privilegiat (PAM)', 'Protecție endpoint (EDR)', 'Conformitate cu Legea 195/2024']
      },
      dataDatabases: {
        title: 'Date și baze de date',
        subtitle: 'Administrare, backup și analiză',
        description: 'Administrarea și optimizarea bazelor de date, backup și recuperare, migrare, pipeline-uri și business intelligence care transformă datele în decizii.',
        benefits: ['Baze de date optimizate', 'Backup automat', 'Recuperare după avarie', 'Business intelligence']
      },
      aiAutomation: {
        title: 'AI și automatizare',
        subtitle: 'Agenți AI, chatboți și fluxuri',
        description: 'Automatizarea proceselor de afaceri, agenți și chatboți AI în română și rusă, cu integrare CRM/1C, implementate cu inginerie reală de integrare.',
        benefits: ['Chatboți în română și rusă', 'Integrare CRM/1C', 'Automatizarea fluxurilor', 'Agenți AI non-stop']
      },
      webSoftwareDevelopment: {
        title: 'Creare site web și software',
        subtitle: 'Site-uri, magazine online și aplicații',
        description: 'Creare site web, magazine online și software la comandă cu React și Next.js, cu design UX, performanță, integrare plăți (maib, mPay) și mentenanță.',
        benefits: ['Site-uri și magazine online', 'Integrare plăți (maib, mPay)', 'Performanță și SEO', 'Mentenanță continuă']
      },
      mobileAppDevelopment: {
        title: 'Dezvoltare aplicații mobile',
        subtitle: 'iOS și Android, backend și publicare',
        description: 'Aplicații iOS și Android construite cu React Native, Flutter sau cod nativ, cu backend, publicare în App Store și Google Play și mentenanță incluse.',
        benefits: ['iOS și Android de la o singură echipă', 'Backend și API incluse', 'Publicare în magazine', 'Actualizări pentru versiuni noi de sistem']
      },
      crmDevelopment: {
        title: 'Sisteme CRM',
        subtitle: 'CRM la comandă, configurare și integrări',
        description: 'Un CRM la comandă sau amoCRM, Bitrix24, HubSpot ori Odoo configurate pe procesul tău de vânzări, conectate la e-mail, facturare și site.',
        benefits: ['Pipeline adaptat procesului tău', 'Lead-uri direct de pe site', 'Legătură cu facturarea', 'Migrare din Excel']
      },
      erpSystems: {
        title: 'Sisteme ERP',
        subtitle: 'Integrări, module la comandă și migrare',
        description: 'ERP-ul tău, fie 1C, Odoo sau Business Central, conectat la magazinul online, CRM-ul și contabilitatea, cu module la comandă și migrare de date verificată.',
        benefits: ['Integrare cu 1C și Odoo', 'Comenzi și stocuri sincronizate', 'Module la comandă', 'Migrare cu reconciliere']
      },
      infrastructureManagement: {
        title: 'Managementul infrastructurii',
        subtitle: 'Administrare servere, dispozitive și VM',
        description: 'Management complet al endpoint-urilor, serverelor și VM-urilor, cu monitorizare și suport 24/7.',
        benefits: ['Monitorizare 24/7', 'Actualizări automate', 'Optimizarea performanței', 'Backup și recuperare']
      },
      cloudSolutions: {
        title: 'Soluții cloud',
        subtitle: 'Microsoft 365 și Google Workspace',
        description: 'Administrare specializată a mediilor Microsoft 365 și Google Workspace.',
        benefits: ['Gestionarea utilizatorilor', 'Configurarea securității', 'Servicii de migrare', 'Instruire și suport']
      },
      securityIdentity: {
        title: 'Securitate și identitate',
        subtitle: 'Active Directory, Okta și CyberArk',
        description: 'Management enterprise al identităților și al accesului cu AD, Okta și CyberArk.',
        benefits: ['Single sign-on', 'Autentificare multifactor', 'Acces privilegiat', 'Raportare de conformitate']
      },
      webDevelopment: {
        title: 'Dezvoltare web',
        subtitle: 'Aplicații web personalizate și site-uri',
        description: 'Aplicații web și site-uri la comandă, plus întreținere.',
        benefits: ['Dezvoltare personalizată', 'Optimizarea performanței', 'Implementarea securității', 'Întreținere și actualizări']
      }
    },
    articles: {
      detail: {
        backToArticles: 'Înapoi la articole',
        articleNotFound: 'Articolul nu a fost găsit',
        articleNotFoundDescription: 'Articolul pe care îl cauți nu există.',
        relatedArticles: 'Articole asemănătoare',
        readMore: 'Citește mai mult',
        needHelp: 'Ai nevoie de ajutor cu infrastructura IT?',
        needHelpDescription: 'Hai să discutăm despre IT-ul tău.',
        getStarted: 'Începe acum'
      },
      page: {
        seo: {
          title: 'Articole și note de teren | Byteet',
          description: 'Explorează biblioteca completă de articole IT, playbook-uri tehnice și note strategice de teren Byteet despre soluții cloud, dezvoltare web, managementul dispozitivelor, automatizare, managementul identităților și cele mai bune practici de infrastructură IT modernă.',
          keywords: 'Articole Byteet, playbook-uri IT, automatizare, strategie de infrastructură, ghiduri de management al identităților și accesului, dezvoltare web Moldova',
          schemaName: 'Articole și analize',
          schemaDescription: 'Articole, planuri și note de teren de la Byteet despre soluții cloud, dezvoltare web, managementul dispozitivelor, automatizare, identitate și infrastructură IT modernă.'
        },
        hero: {
          eyebrow: 'Articole Byteet',
          title: 'Articole, playbook-uri și',
          highlight: 'note de teren',
          description: 'Articole despre automatizare, endpoint-uri, infrastructură și dezvoltare web.',
          cta: 'Explorează articolele'
        },
        stats: {
          averageReadTime: {
            label: 'Timp mediu de lectură',
            value: '8 min',
            detail: 'Scrise pentru cei care administrează IT-ul'
          },
          articlesPublished: {
            label: 'Articole publicate',
            detail: 'Ghiduri și liste de verificare practice'
          },
          categoriesCovered: {
            label: 'Categorii acoperite',
            detail: 'De la managementul dispozitivelor la ingineria datelor'
          }
        },
        latest: {
          eyebrow: 'Publicate recent',
          title: 'Cele mai noi articole',
          description: 'Ghiduri și note noi despre administrarea IT pentru afacerile mici și mijlocii.'
        },
        cards: {
          continueReading: 'Continuă lectura'
        },
        series: {
          eyebrow: 'Serii',
          title: 'Alege formatul',
          description: 'Note scurte de strategie sau ghiduri pas cu pas, în funcție de nevoile tale.',
          cards: {
            fieldNotes: {
              title: 'Note de teren',
              summary: 'Note scurte din proiecte: ce am încercat și ce am învățat.'
            },
            playbooks: {
              title: 'Playbook-uri',
              summary: 'Ghiduri pas cu pas pentru onboarding, guvernanță și implementare.'
            },
            strategyCapsules: {
              title: 'Capsule strategice',
              summary: 'Explicații scurte despre când merită o anumită alegere de infrastructură, automatizare sau UX.'
            }
          }
        }
      }
    },
    servicePageCommon: {
      backToServices: 'Înapoi la servicii',
      backToAllServices: 'Înapoi la toate serviciile',
      relatedArticles: 'Ghiduri despre acest serviciu',
      serviceNotFound: 'Serviciul nu a fost găsit',
      serviceNotFoundDescription: 'Serviciul pe care îl cauți nu există.',
      coreCapabilities: 'Capabilități principale',
      deliverables: 'Livrabile',
      businessImpact: 'Impact asupra afacerii',
      coreCapabilitiesDescription: 'Ce include acest serviciu.',
      projectInformation: 'Informații despre proiect',
      projectInformationDescription: 'Această pagină oferă informații detaliate despre ofertele noastre de servicii. Pentru întrebări despre proiecte sau soluții personalizate, te rugăm să ne contactezi prin formularul nostru de consultanță.'
    },
    servicePages: {
      managedItSupport: {
        title: 'Externalizare IT și suport',
        subtitle: 'Helpdesk, dispozitive, service desk și monitorizare',
        description: 'Externalizează-ți IT-ul cu o singură echipă: helpdesk și suport tehnic, administrarea dispozitivelor (Intune, Jamf), service desk (Jira, Zammad) și monitorizare, cu abonament de mentenanță și SLA.',
        heroContent: {
          mainTitle: 'Externalizare IT și suport',
          subtitle: 'O singură echipă pentru helpdesk-ul, dispozitivele, service desk-ul și monitorizarea ta',
          keyPoints: [
            'Helpdesk pe niveluri cu SLA-uri definite și căi de escaladare',
            'Administrarea dispozitivelor și endpoint-urilor prin Microsoft Intune și Jamf Pro',
            'Configurare service desk în Jira Service Desk, Zammad sau ServiceNow',
            'Monitorizare proactivă susținută de o bază de cunoștințe întreținută'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Suport și dispozitive fragmentate',
            description: 'Tichetele, laptopurile și documentația se află în instrumente separate, așa că timpii de răspuns cresc, nivelul de patch-uri variază, iar aceleași întrebări primesc răspuns de la zero în fiecare săptămână.',
            challenges: [
              'Timpi de răspuns lenți care afectează productivitatea',
              'Dispozitive neadministrate, cu stare inconsecventă de patch și conformitate',
              'Lipsa unui flux standard de tichete sau a unei căi de escaladare',
              'Cunoștințe care rămân la anumite persoane în loc să fie documentate'
            ]
          },
          solution: {
            title: 'Un singur serviciu de suport, administrat de noi',
            description: 'Combinăm helpdesk-ul, administrarea endpoint-urilor și service desk-ul într-un singur flux, cu monitorizare și documentație care scurtează fiecare rezolvare viitoare.',
            benefits: [
              'Răspuns rapid la incidente cu escaladare clară',
              'Dispozitive administrate central și conforme pe Windows, macOS și mobil',
              'Rutare standardizată a tichetelor, SLA-uri și raportare',
              'Rezolvări documentate care cresc rezolvarea la primul contact'
            ]
          }
        },
        features: [
          {
            title: 'Helpdesk și suport tehnic',
            description: 'Suport de prima și a doua linie pentru problemele utilizatorilor, cu urmărirea tichetelor, asistență la distanță și depanare de specialitate pentru probleme complexe.',
            capabilities: [
              'Gestionarea și urmărirea tichetelor',
              'Suport de prima și a doua linie',
              'Asistență la distanță și diagnosticare',
              'Escaladare și rutare către specialiști'
            ]
          },
          {
            title: 'Administrare dispozitive și endpoint-uri',
            description: 'Ciclu de viață complet al dispozitivelor pe Windows, macOS, iOS și Android folosind Microsoft Intune și Jamf Pro, de la înrolare la patch și conformitate.',
            capabilities: [
              'Înrolare și provizionare zero-touch',
              'Configurarea și aplicarea politicilor',
              'Distribuire software și managementul patch-urilor',
              'Inventar de active și raportare de conformitate'
            ]
          },
          {
            title: 'Implementare service desk',
            description: 'Configurăm Jira Service Desk, Zammad sau ServiceNow cu fluxuri, SLA-uri și automatizări adaptate echipei tale.',
            capabilities: [
              'Configurarea platformei și proiectarea fluxurilor',
              'Rutare automată a tichetelor și management SLA',
              'Integrare cu directorul și sistemele existente',
              'Dashboard-uri și raportare de performanță'
            ]
          },
          {
            title: 'Monitorizare și bază de cunoștințe',
            description: 'Monitorizare continuă pentru a depista problemele înainte ca utilizatorii să le raporteze, împreună cu o bază de cunoștințe întreținută pentru rezolvări consecvente și mai rapide.',
            capabilities: [
              'Monitorizare și alertare 24/7 pentru sisteme',
              'Detectarea și prevenirea proactivă a problemelor',
              'Dezvoltarea și întreținerea bazei de cunoștințe',
              'Proceduri și runbook-uri documentate'
            ]
          }
        ],
        technologies: {
          title: 'Instrumente și platforme de suport',
          description: 'Expertiză în platformele de administrare endpoint, ticketing și documentație pe care se bazează operațiunile IT moderne.',
          platforms: [
            { name: 'Microsoft Intune', category: 'Administrare dispozitive' },
            { name: 'Jamf Pro', category: 'Administrare macOS' },
            { name: 'Jira Service Desk', category: 'Platformă ITSM' },
            { name: 'Zammad', category: 'Helpdesk open source' },
            { name: 'ServiceNow', category: 'ITSM enterprise' },
            { name: 'Confluence', category: 'Bază de cunoștințe' }
          ]
        },
        implementation: {
          title: 'Procesul de configurare a suportului',
          description: 'O implementare structurată care pune la punct suportul, dispozitivele și documentația împreună.',
          phases: [
            {
              phase: 'Evaluare și planificare',
              duration: '1-2 săptămâni',
              description: 'Analizăm volumul actual de suport, parcul de dispozitive și instrumentele pentru a defini modelul operațional.',
              deliverables: ['Evaluare suport și dispozitive', 'Model operațional și SLA-uri', 'Selecția instrumentelor', 'Foaie de parcurs pentru implementare']
            },
            {
              phase: 'Configurare și punere în funcțiune',
              duration: '2-3 săptămâni',
              description: 'Configurăm service desk-ul, înrolăm dispozitivele și construim baza de cunoștințe inițială.',
              deliverables: ['Configurare service desk', 'Înrolarea dispozitivelor și politici', 'Structura bazei de cunoștințe', 'Configurarea monitorizării și alertării']
            },
            {
              phase: 'Instruire și lansare',
              duration: '1-2 săptămâni',
              description: 'Instruim personalul, documentăm procedurile și lansăm suportul.',
              deliverables: ['Instruirea echipei de suport', 'Documentație pentru utilizatori', 'Suport la lansare', 'Configurarea raportării']
            },
            {
              phase: 'Suport continuu',
              duration: 'Continuu',
              description: 'Oferim suport zilnic și rafinăm procesele și documentația.',
              deliverables: ['Suport 24/7', 'Managementul patch-urilor și conformitate', 'Optimizarea proceselor', 'Întreținerea bazei de cunoștințe']
            }
          ]
        },
        benefits: {
          title: 'Impactul suportului',
          description: 'Câștiguri măsurabile în viteza de rezolvare, conformitatea dispozitivelor și satisfacția utilizatorilor.',
          outcomes: [
            {
              label: 'Timpi de rezolvare mai scurți',
              description: 'Fluxurile standard și suportul specializat reduc timpul de rezolvare a problemelor.'
            },
            {
              label: 'Rezolvare la primul contact',
              description: 'O bază de cunoștințe întreținută ajută agenții să rezolve problemele din prima.'
            },
            {
              label: 'Monitorizare și suport',
              description: 'Monitorizarea continuă depistează problemele înainte să ajungă la utilizatori.'
            },
            {
              label: 'Conformitatea dispozitivelor',
              description: 'Politicile administrate central mențin endpoint-urile actualizate și conforme.'
            }
          ]
        }
      },
      cloudInfrastructure: {
        title: 'Servicii cloud și infrastructură',
        subtitle: 'Microsoft 365, Google Workspace, servere și virtualizare',
        description: 'Modernizează-ți infrastructura cloud: administrare Microsoft 365 și Google Workspace, servere, virtualizare și cloud hibrid, cu migrare fără întreruperi, monitorizare și control al costurilor.',
        heroContent: {
          mainTitle: 'Cloud și infrastructură',
          subtitle: 'Spații de lucru, servere, virtualizare și migrare în cloud, sub același acoperiș',
          keyPoints: [
            'Administrarea și securitatea Microsoft 365 și Google Workspace',
            'Gestionarea serverelor și a mașinilor virtuale pe VMware și Hyper-V',
            'Migrare și integrare în cloud pe Azure și AWS',
            'Monitorizare, planificarea capacității și optimizarea costurilor'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Cloud și infrastructură dispersate',
            description: 'Spațiile de lucru, serverele on-prem și conturile cloud sunt administrate izolat, ceea ce lasă goluri de vizibilitate, securitate inconsecventă și costuri imprevizibile.',
            challenges: [
              'Instrumente și echipe separate pentru spațiile de lucru și infrastructură',
              'Securitate și conformitate inconsecvente între platforme',
              'Operațiuni manuale pe servere și VM, care creează riscul de întreruperi',
              'Costuri de licențe și cloud greu de prezis sau controlat'
            ]
          },
          solution: {
            title: 'Operațiuni unificate de cloud și infrastructură',
            description: 'Administrăm spațiile de lucru și infrastructura ta ca un singur ansamblu, cu monitorizare comună, configurații de securitate de bază și planificarea capacității în medii hibride.',
            benefits: [
              'Administrare centralizată pentru Microsoft 365 și Google Workspace',
              'Operațiuni fiabile de servere și virtualizare',
              'Migrări planificate, cu întreruperi minime',
              'Licențiere și cheltuieli cloud dimensionate corect'
            ]
          }
        },
        features: [
          {
            title: 'Microsoft 365 și Google Workspace',
            description: 'Administrarea tenanților, ciclul de viață al utilizatorilor și configurarea securității pe Microsoft 365 și Google Workspace.',
            capabilities: [
              'Configurarea și optimizarea tenantului',
              'Gestionarea ciclului de viață al utilizatorilor',
              'Politici DLP și acces condiționat',
              'Managementul licențelor și optimizarea costurilor'
            ]
          },
          {
            title: 'Gestionare servere și virtualizare',
            description: 'Provizionare, patch-uri și optimizare pentru servere Windows și Linux și mașini virtuale VMware sau Hyper-V.',
            capabilities: [
              'Provizionarea și configurarea serverelor',
              'Managementul patch-urilor și actualizări de securitate',
              'Provizionare VM și optimizarea resurselor',
              'Backup și recuperare după avarie'
            ]
          },
          {
            title: 'Migrare și integrare în cloud',
            description: 'Migrare planificată a e-mailurilor, fișierelor și sarcinilor de lucru în cloud, cu sincronizarea directorului și integrare cu sistemele existente.',
            capabilities: [
              'Migrarea e-mailurilor și a datelor',
              'Sincronizarea directorului',
              'Migrarea sarcinilor de lucru în Azure și AWS',
              'Integrarea aplicațiilor'
            ]
          },
          {
            title: 'Monitorizare și optimizare',
            description: 'Monitorizare continuă și planificarea capacității în cloud și on-premises, cu ajustări pentru performanță și costuri.',
            capabilities: [
              'Monitorizarea infrastructurii în timp real',
              'Planificarea și prognoza capacității',
              'Ajustarea performanței',
              'Optimizarea costurilor și licențelor'
            ]
          }
        ],
        technologies: {
          title: 'Expertiză în platforme',
          description: 'Experiență aprofundată în platformele de workspace, virtualizare și cloud public.',
          platforms: [
            { name: 'Microsoft 365', category: 'Suită de productivitate' },
            { name: 'Google Workspace', category: 'Platformă de colaborare' },
            { name: 'Microsoft Azure', category: 'Cloud public' },
            { name: 'AWS', category: 'Cloud public' },
            { name: 'VMware vSphere', category: 'Platformă de virtualizare' },
            { name: 'Hyper-V', category: 'Hipervizor' }
          ]
        },
        implementation: {
          title: 'Procesul de implementare',
          description: 'O abordare structurată a implementării de cloud și infrastructură, pentru operațiuni fiabile și optimizate.',
          phases: [
            {
              phase: 'Evaluare și strategie',
              duration: '1-2 săptămâni',
              description: 'Evaluăm spațiile de lucru, serverele și resursele cloud actuale și definim ansamblul țintă.',
              deliverables: ['Analiza stării actuale', 'Strategie cloud și infrastructură', 'Foaie de parcurs pentru migrare', 'Configurație de securitate de bază']
            },
            {
              phase: 'Proiectare și configurare',
              duration: '2-3 săptămâni',
              description: 'Proiectăm arhitectura și configurăm spațiile de lucru, serverele și virtualizarea.',
              deliverables: ['Proiectarea arhitecturii', 'Configurări de securitate', 'Specificații de integrare', 'Planuri de testare']
            },
            {
              phase: 'Migrare și implementare',
              duration: '3-4 săptămâni',
              description: 'Migrare și implementare în etape, cu validare și suport la trecerea finală (cutover).',
              deliverables: ['Migrare pilot', 'Implementare completă', 'Instruirea utilizatorilor', 'Suport la lansare']
            },
            {
              phase: 'Optimizare și suport',
              duration: 'Continuu',
              description: 'Monitorizare continuă, ajustare și optimizarea costurilor în întregul ansamblu.',
              deliverables: ['Optimizarea performanței', 'Planificarea capacității', 'Suport 24/7', 'Revizuiri ale costurilor']
            }
          ]
        },
        benefits: {
          title: 'Impact operațional',
          description: 'Îmbunătățiri măsurabile în cost, fiabilitate și performanță, în cloud și on-premises.',
          outcomes: [
            {
              label: 'Reducerea costurilor IT',
              description: 'Licențierea optimizată și dimensionarea resurselor scad cheltuielile pentru spațiile de lucru și infrastructură.'
            },
            {
              label: 'Disponibilitatea infrastructurii',
              description: 'Monitorizarea și mentenanța proactive mențin sistemele disponibile și afacerea în funcțiune.'
            },
            {
              label: 'Rezolvare mai rapidă a problemelor',
              description: 'Monitorizarea și alertarea centralizate accelerează detectarea și rezolvarea.'
            },
            {
              label: 'Optimizarea costurilor cloud',
              description: 'Planificarea capacității și dimensionarea corectă reduc costurile cloud și de infrastructură.'
            }
          ]
        }
      },
      cybersecurityIdentity: {
        title: 'Securitate cibernetică și identitate',
        subtitle: 'Identitate, acces privilegiat, protecție endpoint și Zero Trust',
        description: 'Securitate cibernetică pentru companii mici și mijlocii din Moldova: SSO și MFA, managementul accesului privilegiat (PAM), protecție endpoint (EDR) și pregătire pentru conformitatea cu Legea 195/2024 privind protecția datelor.',
        heroContent: {
          mainTitle: 'Securitate cibernetică și identitate',
          subtitle: 'Identitate, acces și protecție endpoint construite în jurul modelului Zero Trust',
          keyPoints: [
            'Single sign-on și MFA în cloud și on-premises',
            'Managementul accesului privilegiat, cu control al sesiunilor',
            'Detectare și răspuns pe endpoint-uri în întregul parc',
            'Arhitectură Zero Trust și raportare de conformitate'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Riscuri legate de identitate și endpoint-uri',
            description: 'Furtul de credențiale și endpoint-urile neadministrate sunt principalii vectori de atac, în timp ce proliferarea accesului și cerințele de audit suprasolicită echipele de securitate.',
            challenges: [
              'Atacuri bazate pe identitate și furt de credențiale',
              'Acces privilegiat permanent, fără control de sesiune',
              'Endpoint-uri fără detectare și răspuns consecvente',
              'Cerințe de conformitate și audit conform mai multor cadre de reglementare'
            ]
          },
          solution: {
            title: 'Securitate centrată pe identitate',
            description: 'Combinăm identitatea, accesul privilegiat și protecția endpoint într-un model Zero Trust cu verificare continuă și raportare pregătită pentru audit.',
            benefits: [
              'Identitate unificată cu autentificare puternică',
              'Acces privilegiat just-in-time cu înregistrare',
              'Detectare și răspuns automatizate pe endpoint-uri',
              'Monitorizare și raportare continuă a conformității'
            ]
          }
        },
        features: [
          {
            title: 'Managementul identității și al accesului',
            description: 'SSO, MFA și acces bazat pe roluri în Microsoft Entra ID, Active Directory și Okta, cu fluxuri automate pentru angajare, transfer și plecare.',
            capabilities: [
              'Implementare single sign-on (SSO)',
              'Autentificare multifactor (MFA)',
              'Control al accesului bazat pe roluri (RBAC)',
              'Provizionare și deprovizionare automate'
            ]
          },
          {
            title: 'Managementul accesului privilegiat',
            description: 'Controlăm și monitorizăm accesul privilegiat cu CyberArk, folosind seifuri de credențiale (vaulting), ridicarea privilegiilor just-in-time și înregistrarea sesiunilor.',
            capabilities: [
              'Descoperirea conturilor privilegiate și păstrarea lor în seif (vaulting)',
              'Acordarea accesului just-in-time',
              'Monitorizarea și înregistrarea sesiunilor',
              'Rotația automată a credențialelor'
            ]
          },
          {
            title: 'Protecție endpoint',
            description: 'Detectare și răspuns pe fiecare endpoint cu CrowdStrike Falcon și Microsoft Defender, inclusiv analiză comportamentală și remediere automată.',
            capabilities: [
              'Detectare și răspuns endpoint (EDR)',
              'Analiză comportamentală și detectarea anomaliilor',
              'Răspuns automat la incidente',
              'Integrarea informațiilor despre amenințări'
            ]
          },
          {
            title: 'Zero Trust și conformitate',
            description: 'Acces cu privilegiu minim și verificare continuă, plus piste de audit și raportare aliniate cadrelor de reglementare.',
            capabilities: [
              'Acces condiționat și bazat pe risc',
              'Privilegiu minim și microsegmentare',
              'Jurnalizare și piste de audit',
              'Raportare de conformitate și dashboard-uri'
            ]
          }
        ],
        technologies: {
          title: 'Platforme tehnologice',
          description: 'Platformele pe care le folosim pentru identitate, acces privilegiat și securitatea endpoint-urilor.',
          platforms: [
            { name: 'Microsoft Entra ID', category: 'Identitate în cloud' },
            { name: 'Active Directory', category: 'Servicii de director' },
            { name: 'Okta', category: 'Furnizor de identitate' },
            { name: 'CyberArk', category: 'Managementul accesului privilegiat' },
            { name: 'CrowdStrike Falcon', category: 'Platformă EDR' },
            { name: 'Microsoft Defender', category: 'Protecție endpoint' }
          ]
        },
        implementation: {
          title: 'Abordarea de implementare',
          description: 'Metodologie structurată pentru implementarea identității, a accesului privilegiat și a protecției endpoint.',
          phases: [
            {
              phase: 'Descoperire și evaluare',
              duration: '1-2 săptămâni',
              description: 'Evaluăm infrastructura de identitate actuală, conturile privilegiate și starea de securitate a endpoint-urilor.',
              deliverables: ['Auditul identităților și al accesului', 'Evaluarea riscurilor', 'Analiza lacunelor', 'Strategie de implementare']
            },
            {
              phase: 'Proiectare și arhitectură',
              duration: '2-3 săptămâni',
              description: 'Proiectăm arhitectura Zero Trust, politicile de acces și controalele endpoint.',
              deliverables: ['Proiectarea arhitecturii', 'Politici de acces și securitate', 'Specificații de integrare', 'Protocoale de testare']
            },
            {
              phase: 'Implementare și integrare',
              duration: '3-4 săptămâni',
              description: 'Lansare în etape a soluțiilor de identitate, PAM și protecție endpoint, cu validare.',
              deliverables: ['Implementare pilot', 'Testarea integrării', 'Validare de securitate', 'Instruirea utilizatorilor']
            },
            {
              phase: 'Optimizare și suport',
              duration: 'Continuu',
              description: 'Monitorizare continuă, ajustare și suport pentru menținerea nivelului de securitate.',
              deliverables: ['Monitorizare de securitate', 'Ajustarea politicilor', 'Suport 24/7', 'Raportare de conformitate']
            }
          ]
        },
        benefits: {
          title: 'Impact asupra securității',
          description: 'Îmbunătățește semnificativ nivelul de securitate și menține accesul eficient și auditabil.',
          outcomes: [
            {
              label: 'Reducerea riscurilor de identitate',
              description: 'Autentificarea puternică și controlul accesului reduc expunerea la atacuri bazate pe identitate.'
            },
            {
              label: 'Mai puține incidente de securitate',
              description: 'Detectarea pe endpoint-uri și accesul cu privilegiu minim reduc incidentele.'
            },
            {
              label: 'Răspuns mai rapid la incidente',
              description: 'Răspunsul automat și vizibilitatea sesiunilor accelerează izolarea.'
            },
            {
              label: 'Acoperire de conformitate',
              description: 'Pistele de audit și raportarea mențin accesul aliniat cadrelor de reglementare.'
            }
          ]
        }
      },
      dataDatabases: {
        title: 'Baze de date și date',
        subtitle: 'Administrare, migrare, backup, pipeline-uri și analiză',
        description: 'Administrare și optimizare pentru PostgreSQL, MySQL și SQL Server, migrări cu întreruperi minime, backup automat și recuperare după avarie (inclusiv ransomware), plus pipeline-uri ETL, data warehousing și business intelligence.',
        heroContent: {
          mainTitle: 'Baze de date și date',
          subtitle: 'Administrarea bazelor de date și ingineria datelor ca un singur serviciu',
          keyPoints: [
            'Configurare, migrare și optimizarea performanței bazelor de date',
            'Pipeline-uri ETL și ELT cu Apache Airflow',
            'Data warehouse-uri și data lake-uri pentru analiză centralizată',
            'Calitatea datelor, guvernanță și raportare'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Baze de date lente și date în silozuri',
            description: 'Bazele de date se degradează sub sarcină, în timp ce datele stau fragmentate între sisteme, ceea ce face dificilă livrarea unor analize și raportări fiabile.',
            challenges: [
              'Performanță slabă a bazelor de date care afectează aplicațiile',
              'Migrări riscante, care provoacă întreruperi',
              'Surse de date fragmentate și silozuri',
              'Lipsa guvernanței și a încrederii în cifrele raportate'
            ]
          },
          solution: {
            title: 'Date fiabile, de la cap la coadă',
            description: 'Administrăm și optimizăm bazele tale de date și construim pipeline-urile și warehousing-ul care fac datele disponibile, exacte și pregătite pentru analiză.',
            benefits: [
              'Baze de date optimizate și fiabile, cu backup și monitorizare',
              'Migrări cu întreruperi reduse și validare',
              'Date consolidate prin pipeline-uri administrate',
              'Date guvernate și de încredere pentru analiză'
            ]
          }
        },
        features: [
          {
            title: 'Configurare, migrare și administrare de baze de date',
            description: 'Instalare, optimizare și administrare continuă pentru PostgreSQL, MySQL, SQL Server și MongoDB, inclusiv migrări cu întreruperi reduse.',
            capabilities: [
              'Instalare, configurare și hardening',
              'Optimizarea performanței și a interogărilor',
              'Strategii de migrare cu întreruperi reduse',
              'Backup, recuperare și monitorizare automate'
            ]
          },
          {
            title: 'Pipeline-uri de date și ETL',
            description: 'Proiectăm și operăm pipeline-uri ETL și ELT care ingerează, transformă și mută datele fiabil cu Apache Airflow.',
            capabilities: [
              'Arhitectura și orchestrarea pipeline-urilor',
              'Implementarea proceselor ETL și ELT',
              'Ingestia și integrarea datelor',
              'Monitorizarea și alertarea pipeline-urilor'
            ]
          },
          {
            title: 'Data warehouse și data lake-uri',
            description: 'Construim și modelăm data warehouse-uri și data lake-uri pentru stocare centralizată și interogări analitice rapide.',
            capabilities: [
              'Arhitectura data warehouse și data lake',
              'Modelarea datelor și proiectarea schemelor',
              'Optimizarea stocării și partiționarea',
              'Încărcare incrementală și în loturi'
            ]
          },
          {
            title: 'Analiză și guvernanță',
            description: 'Transformăm datele stocate în rapoarte și dashboard-uri, cu verificări ale calității datelor, trasabilitate (lineage) și guvernanță.',
            capabilities: [
              'Dezvoltarea raportării și a dashboard-urilor',
              'Cadre pentru calitatea și validarea datelor',
              'Trasabilitatea (lineage) și catalogarea datelor',
              'Guvernanță și control al accesului'
            ]
          }
        ],
        technologies: {
          title: 'Expertiză în date și baze de date',
          description: 'Expertiză în baze de date relaționale și NoSQL, warehousing și instrumente de pipeline.',
          platforms: [
            { name: 'PostgreSQL', category: 'Bază de date relațională' },
            { name: 'MySQL', category: 'Bază de date relațională' },
            { name: 'Microsoft SQL Server', category: 'Bază de date enterprise' },
            { name: 'MongoDB', category: 'Bază de date NoSQL' },
            { name: 'Snowflake', category: 'Data Warehouse' },
            { name: 'Apache Airflow', category: 'Orchestrarea fluxurilor' }
          ]
        },
        implementation: {
          title: 'Metodologia de implementare',
          description: 'O abordare structurată a administrării bazelor de date și a ingineriei datelor, pentru date fiabile și pregătite pentru analiză.',
          phases: [
            {
              phase: 'Evaluare și proiectare',
              duration: '2-3 săptămâni',
              description: 'Audităm bazele de date și sursele de date, apoi proiectăm schema țintă și arhitectura pipeline-urilor.',
              deliverables: ['Auditul bazelor de date și al datelor', 'Bază de referință a performanței', 'Proiectarea arhitecturii', 'Foaie de parcurs pentru implementare']
            },
            {
              phase: 'Configurare și punere în funcțiune',
              duration: '2-3 săptămâni',
              description: 'Configurăm și optimizăm bazele de date și punem la punct pipeline-urile și warehousing-ul inițial.',
              deliverables: ['Instalarea și optimizarea bazelor de date', 'Strategie de backup', 'Pipeline-uri inițiale', 'Configurare de securitate']
            },
            {
              phase: 'Migrare și construirea pipeline-urilor',
              duration: '3-6 săptămâni',
              description: 'Migrăm datele și dezvoltăm procesele ETL și modelele de warehouse, cu validare.',
              deliverables: ['Migrarea datelor', 'Procese ETL', 'Cadre de calitate a datelor', 'Configurarea monitorizării']
            },
            {
              phase: 'Optimizare și suport',
              duration: 'Continuu',
              description: 'Optimizare, monitorizare și suport continue pentru baze de date și pipeline-uri.',
              deliverables: ['Optimizarea performanței', 'Monitorizare și alertare', 'Suport 24/7', 'Îmbunătățire continuă']
            }
          ]
        },
        benefits: {
          title: 'Impact asupra performanței',
          description: 'Îmbunătățiri măsurabile în performanța bazelor de date, livrarea datelor și fiabilitate.',
          outcomes: [
            {
              label: 'Îmbunătățirea performanței',
              description: 'Optimizarea interogărilor și a indexurilor reduce timpii de răspuns pentru sarcinile de lucru critice.'
            },
            {
              label: 'Procesare mai rapidă a datelor',
              description: 'Pipeline-urile orchestrate scurtează drumul de la sursă la warehouse.'
            },
            {
              label: 'Raportare mai rapidă',
              description: 'Warehouse-urile modelate transformă interogările lente în rapoarte rapide și reutilizabile.'
            },
            {
              label: 'Acoperire pentru backup și recuperare',
              description: 'Backup-urile automate și recuperarea testată protejează datele critice.'
            }
          ]
        }
      },
      aiAutomation: {
        title: 'AI și automatizare',
        subtitle: 'Agenți AI, automatizarea fluxurilor și Document AI',
        description: 'Automatizarea proceselor de afaceri cu AI: agenți și chatboți AI care vorbesc română și rusă, caută răspunsuri în documentele tale și se integrează cu CRM, amoCRM și 1C. Automatizarea fluxurilor cu n8n, Make și Zapier și procesarea documentelor.',
        heroContent: {
          mainTitle: 'AI și automatizare',
          subtitle: 'Agenți, automatizarea fluxurilor și Document AI conectate la instrumentele tale existente',
          keyPoints: [
            'Automatizarea fluxurilor între instrumentele tale, cu n8n, Make și Zapier',
            'Agenți AI și chatboți care caută răspunsuri în documentele companiei',
            'Procesarea, extragerea și clasificarea automată a documentelor',
            'Inginerie CI/CD și de integrare în spatele fiecărei implementări'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Muncă manuală și instrumente deconectate',
            description: 'Echipele copiază date între sisteme, răspund la aceleași întrebări în mod repetat și procesează documente manual, în timp ce proiectele-pilot AI promițătoare nu ajung niciodată în producție.',
            challenges: [
              'Muncă manuală repetitivă între instrumente deconectate',
              'Întrebări de suport și interne la care se răspunde de la zero',
              'Documente procesate și reintroduse manual',
              'Experimente AI care se blochează înainte de producție'
            ]
          },
          solution: {
            title: 'AI care ajunge în producție',
            description: 'Construim automatizări, agenți și fluxuri de documente pe platforme dovedite, apoi le implementăm și le întreținem cu inginerie reală de integrare și CI/CD.',
            benefits: [
              'Fluxuri automatizate care conectează instrumentele tale existente',
              'Agenți care se bazează pe propriile tale documente și date',
              'Procesare de documente și introducere de date fără intervenție manuală',
              'Integrări implementate, monitorizate și întreținute'
            ]
          }
        },
        features: [
          {
            title: 'Automatizarea fluxurilor cu AI',
            description: 'Automatizăm procesele de afaceri din instrumentele tale folosind n8n, Make, Zapier și integrări API personalizate, de la rutarea lead-urilor la procesarea facturilor.',
            capabilities: [
              'Cartografierea proceselor și proiectarea automatizării',
              'Fluxuri n8n, Make și Zapier',
              'Integrări API și webhook-uri personalizate',
              'Gestionarea erorilor și monitorizare'
            ]
          },
          {
            title: 'Agenți AI și chatboți',
            description: 'Asistenți de suport pentru clienți și interni construiți pe Claude și OpenAI, folosind generare augmentată prin regăsire (RAG) pe baza documentelor tale.',
            capabilities: [
              'Asistenți de suport pentru clienți și asistenți interni',
              'Generare augmentată prin regăsire pe baza documentelor companiei',
              'Integrare LLM și API (Claude, OpenAI)',
              'Guardrail-uri, evaluare și monitorizare'
            ]
          },
          {
            title: 'AI pentru documente și date',
            description: 'Automatizăm procesarea documentelor (extragere, clasificare și introducere de date) astfel încât informația să curgă în sistemele tale fără introducere manuală.',
            capabilities: [
              'Extragerea și parsarea documentelor',
              'Clasificare și rutare',
              'Introducerea automată a datelor în sisteme',
              'Verificare umană inclusă în flux'
            ]
          },
          {
            title: 'Analiză și insight-uri AI',
            description: 'Raportare, prognoză și suport decizional asistate de AI, care transformă datele tale în răspunsuri clare și la timp.',
            capabilities: [
              'Raportare și sumarizare bazate pe AI',
              'Prognoză și detectarea tendințelor',
              'Suport decizional și recomandări',
              'Dashboard-uri și alertare'
            ]
          }
        ],
        technologies: {
          title: 'Stack-ul de AI și automatizare',
          description: 'Modelele, platformele de automatizare și instrumentele cu care construim și livrăm.',
          platforms: [
            { name: 'Claude (Anthropic) API', category: 'Furnizor LLM' },
            { name: 'OpenAI API', category: 'Furnizor LLM' },
            { name: 'n8n', category: 'Automatizarea fluxurilor' },
            { name: 'Make / Zapier', category: 'Platforme de automatizare' },
            { name: 'LangChain', category: 'Framework de agenți' },
            { name: 'GitHub Actions', category: 'Platformă CI/CD' }
          ]
        },
        implementation: {
          title: 'Abordarea de livrare',
          description: 'De la un caz de utilizare bine definit la o automatizare implementată și monitorizată.',
          phases: [
            {
              phase: 'Descoperire și definirea cazului de utilizare',
              duration: '1-2 săptămâni',
              description: 'Identificăm procesele cu valoare mare, analizăm sursele de date și definim metricile de succes.',
              deliverables: ['Evaluare procese și date', 'Cazuri de utilizare prioritizate', 'Metrici de succes', 'Proiectarea soluției']
            },
            {
              phase: 'Prototip și validare',
              duration: '2-3 săptămâni',
              description: 'Construim un prototip funcțional și validăm acuratețea și potrivirea pe date reale.',
              deliverables: ['Prototip funcțional', 'Rezultate de acuratețe și evaluare', 'Plan de integrare', 'Definirea guardrail-urilor']
            },
            {
              phase: 'Integrare și implementare',
              duration: '2-4 săptămâni',
              description: 'Integrăm soluția cu sistemele tale și o implementăm cu CI/CD, testare și monitorizare.',
              deliverables: ['Integrări de sistem', 'Pipeline CI/CD', 'Testare automată', 'Monitorizare și alertare']
            },
            {
              phase: 'Optimizare și suport',
              duration: 'Continuu',
              description: 'Monitorizăm rezultatele, rafinăm prompturile și fluxurile și extindem acoperirea.',
              deliverables: ['Monitorizarea rezultatelor', 'Ajustarea prompturilor și fluxurilor', 'Lansarea de noi automatizări', 'Suport continuu']
            }
          ]
        },
        benefits: {
          title: 'Impact operațional',
          description: 'Economii concrete de timp și răspunsuri mai rapide datorită automatizării și AI-ului.',
          outcomes: [
            {
              label: 'Mai puțină muncă manuală',
              description: 'Fluxurile automatizate elimină copierea, rutarea și introducerea repetitivă de date.'
            },
            {
              label: 'Agenți mereu activi',
              description: 'Asistenții gestionează întrebările de rutină non-stop.'
            },
            {
              label: 'Procesare mai rapidă a documentelor',
              description: 'Extragerea și clasificarea înlocuiesc introducerea manuală.'
            },
            {
              label: 'Timpi de răspuns mai scurți',
              description: 'Agenții și automatizările rezolvă imediat cererile frecvente.'
            }
          ]
        }
      },
      webSoftwareDevelopment: {
        title: 'Creare site web și software',
        subtitle: 'Site-uri, magazine online, aplicații web și mobile',
        description: 'Creare site web, magazine online și software la comandă cu React, Next.js și TypeScript, de la design UX și performanță (Core Web Vitals) la integrarea plăților (maib, mPay), securitate, SEO și mentenanță.',
        heroContent: {
          mainTitle: 'Creare site web și software',
          subtitle: 'Aplicații web și site-uri la comandă, construite și întreținute',
          keyPoints: [
            'Dezvoltarea de aplicații web personalizate',
            'Design de interfață și experiență utilizator',
            'Performanță, accesibilitate și securitate',
            'Mentenanță și suport continue'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Proiecte web care nu se ridică la înălțimea așteptărilor',
            description: 'Stack-urile învechite, paginile lente și interfețele incomode reduc engagement-ul și conversiile, în timp ce securitatea și mentenanța sunt amânate.',
            challenges: [
              'Tehnologii învechite care limitează capabilitățile',
              'Experiență utilizator slabă care afectează engagement-ul',
              'Încărcare lentă a paginilor și Core Web Vitals slabe',
              'Securitate și mentenanță neglijate'
            ]
          },
          solution: {
            title: 'Software web bine construit',
            description: 'Construim aplicații web responsive și accesibile pe un stack modern, optimizate pentru performanță și securitate și susținute după lansare.',
            benefits: [
              'Aplicații și site-uri moderne și responsive',
              'Interfețe proiectate în jurul sarcinilor reale ale utilizatorilor',
              'Încărcare rapidă a paginilor și scoruri Core Web Vitals bune',
              'Întreținute, sigure și la zi'
            ]
          }
        },
        features: [
          {
            title: 'Aplicații web personalizate',
            description: 'Aplicații construite cu React, Next.js și Node.js, cu API-uri și baze de date bine proiectate.',
            capabilities: [
              'Aplicații React și Next.js',
              'Dezvoltare backend Node.js',
              'Dezvoltarea și integrarea API-urilor',
              'Proiectarea și optimizarea bazelor de date'
            ]
          },
          {
            title: 'Design UX și de interfață',
            description: 'Interfețe responsive și accesibile, proiectate în jurul sarcinilor reale ale utilizatorilor și testate pe toate dispozitivele.',
            capabilities: [
              'Design de interfață',
              'Design responsive pe toate dispozitivele',
              'Optimizarea experienței utilizator',
              'Conformitate cu standardele de accesibilitate (WCAG)'
            ]
          },
          {
            title: 'Performanță și securitate',
            description: 'Optimizarea Core Web Vitals și hardening de securitate pentru aplicații fiabile și rapide.',
            capabilities: [
              'Optimizarea Core Web Vitals',
              'Hardening de securitate și bune practici',
              'Fundamente SEO',
              'Suport pentru conformitate și audit'
            ]
          },
          {
            title: 'Mentenanță și suport',
            description: 'Actualizări, monitorizare și suport continue pentru a menține aplicațiile actuale și sigure.',
            capabilities: [
              'Actualizări și mentenanță regulate',
              'Monitorizarea performanței și a disponibilității',
              'Patch-uri de securitate',
              'Suport tehnic prompt'
            ]
          }
        ],
        technologies: {
          title: 'Expertiză tehnologică',
          description: 'Competență într-un stack modern de dezvoltare web.',
          platforms: [
            { name: 'React', category: 'Framework frontend' },
            { name: 'Next.js', category: 'Framework full-stack' },
            { name: 'Node.js', category: 'Runtime backend' },
            { name: 'TypeScript', category: 'Limbaj de programare' },
            { name: 'Tailwind CSS', category: 'Framework de stilizare' },
            { name: 'PostgreSQL', category: 'Bază de date' }
          ]
        },
        implementation: {
          title: 'Procesul de dezvoltare',
          description: 'Abordare structurată a dezvoltării web, care asigură calitatea și livrarea la timp.',
          phases: [
            {
              phase: 'Planificare și design',
              duration: '1-2 săptămâni',
              description: 'Analiza cerințelor, cercetarea utilizatorilor și proiectarea soluției.',
              deliverables: ['Specificația cerințelor', 'Designul experienței utilizatorului', 'Arhitectură tehnică', 'Calendarul proiectului']
            },
            {
              phase: 'Dezvoltare și testare',
              duration: '4-8 săptămâni',
              description: 'Dezvoltarea aplicației cu testare continuă și asigurarea calității.',
              deliverables: ['Dezvoltare frontend', 'Dezvoltare backend', 'Testare de integrare', 'Asigurarea calității']
            },
            {
              phase: 'Implementare și lansare',
              duration: '1-2 săptămâni',
              description: 'Implementare în producție, optimizarea performanței și suport la lansare.',
              deliverables: ['Implementare în producție', 'Optimizarea performanței', 'Instruirea utilizatorilor', 'Suport la lansare']
            },
            {
              phase: 'Mentenanță și suport',
              duration: 'Continuu',
              description: 'Mentenanță, actualizări și suport continue pentru performanță fiabilă.',
              deliverables: ['Mentenanță regulată', 'Actualizări de funcționalități', 'Monitorizarea performanței', 'Suport tehnic']
            }
          ]
        },
        benefits: {
          title: 'Impact asupra afacerii',
          description: 'Rezultate măsurabile obținute cu software web bine construit și bine întreținut.',
          outcomes: [
            {
              label: 'Engagement-ul utilizatorilor',
              description: 'Designul responsive și interfețele mai clare cresc engagement-ul și conversiile.'
            },
            {
              label: 'Încărcare mai rapidă a paginilor',
              description: 'Optimizarea performanței reduce timpii de încărcare și îmbunătățește Core Web Vitals.'
            },
            {
              label: 'Bugete de performanță',
              description: 'Build-urile sunt verificate cu Lighthouse și Core Web Vitals înainte de lansare.'
            },
            {
              label: 'Acoperire responsive',
              description: 'Aplicațiile funcționează pe mobil, tabletă și desktop.'
            }
          ]
        }
      },
      mobileAppDevelopment: {
        title: 'Dezvoltare aplicații mobile',
        subtitle: 'Aplicații iOS și Android, backend și publicare în magazine',
        description: 'Proiectăm și construim aplicații iOS și Android pentru clienții tăi sau pentru propria echipă, native sau cross-platform cu React Native ori Flutter, împreună cu backend-ul și API-ul, publicarea în App Store și Google Play și mentenanța după lansare.',
        heroContent: {
          mainTitle: 'Dezvoltare aplicații mobile',
          subtitle: 'Aplicații pentru iOS și Android, de la primul prototip la lansarea în magazine și mai departe',
          keyPoints: [
            'Aplicații care se simt native pe iOS și Android',
            'Dezvoltare cross-platform cu React Native sau Flutter, ori nativă în Swift și Kotlin acolo unde e nevoie',
            'Backend, API și panou de administrare construite odată cu aplicația',
            'Publicare în App Store și Google Play și actualizări continue'
          ]
        },
        problemSolution: {
          problem: {
            title: 'O idee de aplicație fără un drum clar spre magazine',
            description: 'O aplicație pentru clienți sau pentru angajații de pe teren se blochează adesea între idee și lansare: două platforme de susținut, un backend pe care nu l-a planificat nimeni, verificarea din magazine și nimeni care să o țină funcțională după următoarea actualizare de iOS sau Android.',
            challenges: [
              'Nu e clar dacă aplicația trebuie construită nativ sau cross-platform',
              'Niciun backend sau API cu care aplicația să comunice',
              'Publicarea, semnarea și declarațiile de confidențialitate lăsate pe ultimul moment',
              'Aplicații care nu mai funcționează după actualizări de sistem, pentru că nu le întreține nimeni'
            ]
          },
          solution: {
            title: 'O singură echipă de la prototip la magazine și actualizări',
            description: 'Definim aplicația în jurul sarcinilor pe care utilizatorii tăi le fac efectiv, alegem abordarea de platformă potrivită, construim aplicația și backend-ul împreună, o trecem prin verificarea magazinelor și o menținem la zi după lansare.',
            benefits: [
              'Alegerea platformei explicată și agreată înainte de începerea dezvoltării',
              'Aplicația și backend-ul proiectate ca un singur sistem',
              'Lansarea în magazine pregătită din primul sprint, nu în ultima săptămână',
              'Un plan de mentenanță pentru actualizări de sistem, biblioteci și erori'
            ]
          }
        },
        features: [
          {
            title: 'Aplicații iOS și Android',
            description: 'Aplicații care arată și se comportă așa cum se așteaptă utilizatorii pe fiecare platformă, construite cross-platform cu React Native sau Flutter, ori nativ în Swift și Kotlin când aplicația are nevoie de acces profund la dispozitiv.',
            capabilities: [
              'Dezvoltare cross-platform cu React Native sau Flutter',
              'Dezvoltare nativă iOS (Swift) și Android (Kotlin)',
              'Funcționare offline, cameră, localizare și notificări push',
              'Interfețe accesibile în română și rusă, pentru telefoane și tablete'
            ]
          },
          {
            title: 'Backend și API',
            description: 'Partea de server de care depinde aplicația: API-uri, conturi de utilizator, baze de date și un panou de administrare pentru echipa ta, sau conectarea la sistemele pe care le folosești deja. Datele personale sunt gestionate ținând cont de protecția lor.',
            capabilities: [
              'Dezvoltare API REST sau GraphQL',
              'Autentificare și gestionarea utilizatorilor',
              'Panou de administrare pentru conținut și utilizatori',
              'Integrare cu sistemele existente ale afacerii'
            ]
          },
          {
            title: 'Publicare în App Store și Google Play',
            description: 'Pregătim și trimitem versiunea: conturi de dezvoltator, semnare, paginile din magazine și informațiile despre confidențialitate și permisiuni pe care le cer ambele magazine.',
            capabilities: [
              'Configurarea conturilor de dezvoltator și a semnării',
              'Pagini în magazine, capturi de ecran și descrieri',
              'Declarații de confidențialitate și permisiuni',
              'Versiuni de test prin TestFlight și canalele de testare Google Play'
            ]
          },
          {
            title: 'Mentenanță și actualizări',
            description: 'Aplicațiile au nevoie de lucru regulat ca să funcționeze pe versiunile noi de iOS și Android. Ne ocupăm de actualizări, monitorizare și funcționalități noi după lansare.',
            capabilities: [
              'Actualizări pentru versiuni noi de sistem de operare',
              'Actualizări de dependențe și de securitate',
              'Raportarea erorilor și monitorizare',
              'Lansări planificate de funcționalități'
            ]
          }
        ],
        technologies: {
          title: 'Tehnologii mobile',
          description: 'Framework-urile și limbajele cu care construim și întreținem aplicații mobile.',
          platforms: [
            { name: 'React Native', category: 'Framework cross-platform' },
            { name: 'Flutter', category: 'Framework cross-platform' },
            { name: 'Swift', category: 'iOS nativ' },
            { name: 'Kotlin', category: 'Android nativ' },
            { name: 'Node.js', category: 'Backend și API' },
            { name: 'Firebase', category: 'Notificări push și autentificare' }
          ]
        },
        implementation: {
          title: 'Procesul de dezvoltare a aplicației',
          description: 'De la o idee bine definită la o aplicație publicată, în iterații scurte, cu versiuni de test pe care le poți instala pe propriul telefon.',
          phases: [
            {
              phase: 'Descoperire și prototip',
              duration: '2-3 săptămâni',
              description: 'Definim utilizatorii, sarcinile principale și abordarea de platformă și testăm fluxurile principale într-un prototip interactiv.',
              deliverables: ['Funcționalități și fluxuri de utilizare', 'Recomandare: nativ sau cross-platform', 'Prototip interactiv', 'Arhitectură tehnică']
            },
            {
              phase: 'Dezvoltare și testare',
              duration: '6-12 săptămâni',
              description: 'Construim aplicația și backend-ul în iterații scurte, cu o versiune de test pe dispozitive reale după fiecare.',
              deliverables: ['Versiuni iOS și Android', 'Backend și API', 'Versiuni de test prin TestFlight și Google Play', 'Testare automată și pe dispozitive']
            },
            {
              phase: 'Lansare în magazine',
              duration: '1-2 săptămâni',
              description: 'Pregătim paginile din magazine, informațiile de confidențialitate și versiunile finale și trecem aplicația prin verificarea App Store și Google Play.',
              deliverables: [
                'Pagini în magazine și capturi de ecran',
                'Declarații de confidențialitate și permisiuni',
                'Versiuni finale semnate',
                'Configurarea raportării erorilor'
              ]
            },
            {
              phase: 'Mentenanță și actualizări',
              duration: 'Continuu',
              description: 'Menținem aplicația funcțională pe versiunile noi de sistem și livrăm îmbunătățiri în lansări planificate.',
              deliverables: [
                'Actualizări de sistem și dependențe',
                'Remedieri și monitorizare',
                'Lansări de funcționalități',
                'Actualizarea paginilor din magazine'
              ]
            }
          ]
        },
        benefits: {
          title: 'Impact asupra afacerii',
          description: 'Ce îi aduce afacerii tale o aplicație bine construită și întreținută.',
          outcomes: [
            {
              label: 'O singură bază de cod, două platforme',
              description: 'Cu o abordare cross-platform, iOS și Android împart cea mai mare parte a codului, așa că funcționalitățile noi ajung pe ambele în același timp.'
            },
            {
              label: 'Cod sursă care îți aparține',
              description: 'Primești codul sursă al aplicației și al backend-ului, deci nu depinzi de un singur furnizor.'
            },
            {
              label: 'Mai puține surprize la lansare',
              description: 'Cerințele magazinelor sunt tratate în timpul dezvoltării, așa că problemele de verificare apar devreme.'
            },
            {
              label: 'Mereu la zi',
              description: 'Mentenanța regulată ține aplicația funcțională pe măsură ce iOS și Android se schimbă.'
            }
          ]
        }
      },
      crmDevelopment: {
        title: 'Sisteme CRM',
        subtitle: 'CRM la comandă, configurare CRM și integrări',
        description: 'Un CRM care urmează felul în care echipa ta vinde și deservește clienții: un CRM construit la comandă sau amoCRM, Bitrix24, HubSpot ori Odoo configurate și extinse, conectate la e-mail, facturare și site, cu datele mutate din tabelele Excel.',
        heroContent: {
          mainTitle: 'Sisteme CRM',
          subtitle: 'Datele clienților, pipeline-ul și follow-up-ul într-un singur sistem, potrivit procesului tău',
          keyPoints: [
            'CRM la comandă, construit în jurul procesului tău de vânzări și deservire',
            'Configurarea și extinderea unui CRM existent',
            'Integrări cu e-mail, facturare și site',
            'Migrare din tabele Excel și instrumente vechi'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Datele clienților împrăștiate în tabele și inbox-uri',
            description: 'Lead-urile vin pe e-mail, din formularul de pe site, pe telefon sau prin aplicații de mesagerie, ofertele sunt urmărite într-un tabel, iar facturile sunt în alt sistem. Follow-up-urile se pierd și nimeni nu are imaginea completă a unui client.',
            challenges: [
              'Lead-uri și tranzacții urmărite în tabele sau în inbox-uri personale',
              'O licență CRM pe care echipa nu o folosește, pentru că nu se potrivește procesului',
              'Introducerea dublă a datelor între CRM, facturare și site',
              'Nicio imagine de încredere asupra pipeline-ului și a follow-up-urilor deschise'
            ]
          },
          solution: {
            title: 'Un CRM construit în jurul procesului tău',
            description: 'Cartografiem drumul clienților prin afacerea ta, apoi fie construim un CRM pentru acel proces, fie îl configurăm și extindem pe cel pe care îl ai, și îl conectăm la instrumentele pe care echipa le folosește deja.',
            benefits: [
              'Pipeline-uri, câmpuri și etape care urmează procesul tău de vânzări',
              'Formularele de pe site și e-mailurile ajung direct în CRM',
              'Datele despre clienți și facturi rămân sincronizate',
              'Datele existente curățate și importate, nu reintroduse manual'
            ]
          }
        },
        features: [
          {
            title: 'CRM la comandă',
            description: 'Un CRM construit pentru procesul tău atunci când soluțiile gata făcute nu se potrivesc, cu ecranele, câmpurile și permisiunile de care are nevoie echipa și nimic în plus.',
            capabilities: [
              'Model de date propriu pentru clienți, tranzacții și proiecte',
              'Acces pe bază de roluri și reguli de păstrare a datelor',
              'Dashboard-uri și rapoarte de pipeline',
              'Interfață în română și rusă, în browser și pe mobil'
            ]
          },
          {
            title: 'Configurare și extindere CRM',
            description: 'Configurarea și extinderea amoCRM, Bitrix24, HubSpot sau Odoo: pipeline-uri, câmpuri personalizate, automatizări și extensii acolo unde configurația standard nu ajunge.',
            capabilities: [
              'Proiectarea pipeline-ului și a etapelor',
              'Câmpuri, obiecte și vizualizări personalizate',
              'Automatizări și mementouri',
              'Extensii prin API-ul platformei'
            ]
          },
          {
            title: 'Integrări',
            description: 'Conexiuni între CRM și restul instrumentelor tale, ca datele să fie introduse o singură dată și să apară acolo unde e nevoie de ele.',
            capabilities: [
              'Integrare cu e-mail și calendar',
              'Legături cu facturarea și contabilitatea, inclusiv 1C',
              'Preluarea lead-urilor de pe site și din formulare web',
              'Sincronizare bidirecțională cu alte sisteme ale afacerii'
            ]
          },
          {
            title: 'Migrare din tabele',
            description: 'Datele existente despre clienți mutate în CRM: curățate, fără duplicate, mapate pe noua structură și verificate înainte de lansare.',
            capabilities: [
              'Inventarul tabelelor și instrumentelor',
              'Curățare și eliminarea duplicatelor',
              'Maparea câmpurilor și importuri de probă',
              'Verificare cu echipa ta înainte de lansare'
            ]
          }
        ],
        technologies: {
          title: 'Platforme și instrumente CRM',
          description: 'Platformele pe care le configurăm și extindem și instrumentele pe care le folosim pentru dezvoltări la comandă și integrări.',
          platforms: [
            { name: 'amoCRM', category: 'Platformă CRM' },
            { name: 'Bitrix24', category: 'CRM și colaborare' },
            { name: 'HubSpot', category: 'Platformă CRM' },
            { name: 'Odoo', category: 'CRM și ERP open-source' },
            { name: 'PostgreSQL', category: 'Bază de date pentru CRM la comandă' },
            { name: 'n8n', category: 'Fluxuri de integrare' }
          ]
        },
        implementation: {
          title: 'Procesul de implementare CRM',
          description: 'Un drum pas cu pas de la date împrăștiate despre clienți la un CRM pe care echipa îl folosește.',
          phases: [
            {
              phase: 'Cartografierea procesului',
              duration: '1-2 săptămâni',
              description: 'Cartografiem cum circulă azi lead-urile, tranzacțiile și clienții prin afacerea ta și decidem dacă construim sau configurăm.',
              deliverables: [
                'Harta procesului de vânzări și deservire',
                'Inventarul datelor și instrumentelor actuale',
                'Recomandare: construire sau configurare',
                'Sfera proiectului și planul'
              ]
            },
            {
              phase: 'Construire și configurare',
              duration: '3-8 săptămâni',
              description: 'Configurăm sau construim CRM-ul, apoi îl conectăm la e-mail, facturare și site.',
              deliverables: ['Pipeline-uri, câmpuri și roluri', 'Ecrane sau extensii la comandă', 'Integrări', 'Automatizări și mementouri']
            },
            {
              phase: 'Migrare și instruire',
              duration: '1-3 săptămâni',
              description: 'Importăm datele curățate, le verificăm împreună cu echipa ta și instruim fiecare rol pentru utilizarea zilnică.',
              deliverables: ['Import de date curățate și fără duplicate', 'Migrare de probă și aprobare', 'Instruire pentru fiecare rol', 'Suport la lansare']
            },
            {
              phase: 'Suport și îmbunătățiri',
              duration: 'Continuu',
              description: 'Ajustăm pipeline-urile, rapoartele și integrările pe măsură ce procesul tău se schimbă.',
              deliverables: ['Suport pentru utilizatori', 'Modificări de câmpuri și fluxuri', 'Monitorizarea integrărilor', 'Rapoarte și automatizări noi']
            }
          ]
        },
        benefits: {
          title: 'Impact asupra afacerii',
          description: 'Ce îi aduce echipei tale un CRM care se potrivește procesului.',
          outcomes: [
            {
              label: 'Imaginea completă a fiecărui client',
              description: 'Contactele, tranzacțiile, e-mailurile și facturile unui client sunt într-un singur loc.'
            },
            {
              label: 'Mai puține follow-up-uri pierdute',
              description: 'Mementourile și etapele din pipeline fac vizibile acțiunile deschise.'
            },
            {
              label: 'Mai puține date introduse de două ori',
              description: 'Integrările mută datele între sisteme, în loc ca oamenii să le reintroducă.'
            },
            {
              label: 'Construit pentru utilizarea zilnică',
              description: 'Ecranele și câmpurile urmează procesul tău, ceea ce face CRM-ul mai ușor de ținut la zi.'
            }
          ]
        }
      },
      erpSystems: {
        title: 'Sisteme ERP',
        subtitle: 'Integrări ERP, module la comandă și migrare de date',
        description: 'Conectăm și extindem ERP-ul pe care rulează afacerea ta, precum 1C, Odoo sau Microsoft Dynamics 365 Business Central: module la comandă, integrări cu magazinul online, CRM-ul și contabilitatea și migrare de date testată și verificată pas cu pas.',
        heroContent: {
          mainTitle: 'Sisteme ERP',
          subtitle: 'ERP-ul tău conectat la restul afacerii, extins acolo unde varianta standard nu ajunge',
          keyPoints: [
            'Integrări între ERP și magazinul online, CRM și contabilitate',
            'Module și extensii la comandă pentru procesele pe care standardul nu le acoperă',
            'Migrare de date din sisteme vechi, cu verificări de reconciliere',
            'Suport când se schimbă versiunile ERP și API-urile'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Un ERP care funcționează izolat',
            description: 'Comenzile sunt copiate manual din magazinul online, stocurile diferă între sisteme, iar procesele care îți fac afacerea diferită sunt gestionate în tabele Excel, lângă ERP.',
            challenges: [
              'Copierea manuală a comenzilor, clienților și facturilor între sisteme',
              'Diferențe de stoc și preț între ERP și magazinul online',
              'Procese pe care ERP-ul standard nu le acoperă, ținute în tabele',
              'O trecere planificată pe alt ERP, cu ani de date de mutat'
            ]
          },
          solution: {
            title: 'Un ERP conectat la restul afacerii',
            description: 'Cartografiem cum circulă datele între sistemele tale, construim integrările și modulele care închid golurile și mutăm datele cu rulări de probă și verificări înainte ca ceva să intre în producție.',
            benefits: [
              'Comenzi, clienți și stocuri sincronizate automat',
              'Module la comandă care urmează procesele tale',
              'Integrări cu jurnalizare și alerte de eroare, ca problemele să fie observate',
              'Migrare de date testată înainte de trecere'
            ]
          }
        },
        features: [
          {
            title: 'Conectare și extindere ERP',
            description: 'Lucrăm cu ERP-ul pe care îl folosești deja, precum 1C, Odoo sau Business Central, prin API-urile, mecanismele de schimb de date și opțiunile de extindere ale acestuia.',
            capabilities: [
              'Analiza configurației ERP actuale',
              'Folosirea API-urilor și conectorilor standard',
              'Configurarea modulelor existente',
              'Documentarea fiecărei modificări'
            ]
          },
          {
            title: 'Module la comandă',
            description: 'Module sau aplicații însoțitoare pentru procesele pe care ERP-ul tău nu le acoperă, precum planificare, etape de producție, vizite de service sau portaluri pentru clienți, care lucrează cu aceleași date.',
            capabilities: [
              'Module la comandă pentru Odoo sau Business Central',
              'Aplicații web însoțitoare bazate pe datele din ERP, inclusiv 1C',
              'Portaluri pentru clienți și furnizori',
              'Rapoarte și dashboard-uri din datele ERP'
            ]
          },
          {
            title: 'Integrări',
            description: 'Legături între ERP și magazinul online, CRM, contabilitate și instrumentele de logistică, cu jurnalizare și alerte, ca o sincronizare eșuată să nu treacă neobservată.',
            capabilities: [
              'Integrare cu magazinul online pentru comenzi, stocuri și prețuri',
              'Sincronizare de clienți și comenzi între CRM și ERP',
              'Legături cu contabilitatea și facturarea',
              'Monitorizare, jurnalizare și alerte de eroare'
            ]
          },
          {
            title: 'Migrare de date',
            description: 'Clienți, articole, solduri deschise și istoric mutate dintr-un sistem vechi în noul ERP, cu migrări de probă și reconciliere înainte de lansare.',
            capabilities: [
              'Inventarul datelor și evaluarea calității',
              'Mapare și scripturi de conversie',
              'Migrări de probă într-un mediu de test',
              'Reconcilierea totalurilor cu sistemul vechi'
            ]
          }
        ],
        technologies: {
          title: 'Platforme ERP și instrumente de integrare',
          description: 'Sistemele ERP pe care le conectăm și extindem și instrumentele cu care le integrăm.',
          platforms: [
            { name: '1C:Enterprise', category: 'Contabilitate și ERP' },
            { name: 'Odoo', category: 'ERP modular' },
            { name: 'Microsoft Dynamics 365 Business Central', category: 'ERP' },
            { name: 'n8n', category: 'Fluxuri de integrare' },
            { name: 'API-uri REST și OData', category: 'Interfețe de integrare' },
            { name: 'PostgreSQL', category: 'Bază de date intermediară și raportare' }
          ]
        },
        implementation: {
          title: 'Procesul de integrare ERP',
          description: 'O succesiune atentă de pași pentru a modifica sistemul de care depind finanțele și operațiunile tale.',
          phases: [
            {
              phase: 'Analiză',
              duration: '2-3 săptămâni',
              description: 'Cartografiem sistemele, fluxurile de date și procesele pe care ERP-ul nu le acoperă astăzi.',
              deliverables: [
                'Harta sistemelor și a fluxurilor de date',
                'Cerințe pentru integrări și module',
                'Evaluarea calității datelor',
                'Plan de implementare'
              ]
            },
            {
              phase: 'Construire și integrare',
              duration: '4-10 săptămâni',
              description: 'Dezvoltăm integrările și modulele la comandă și le testăm într-un mediu de test, nu în baza de date de producție.',
              deliverables: ['Integrări prin API', 'Module sau extensii la comandă', 'Jurnalizare și gestionarea erorilor', 'Rulări de test cu scenarii reale']
            },
            {
              phase: 'Migrare și lansare',
              duration: '2-4 săptămâni',
              description: 'Rulăm migrări de probă, reconciliem rezultatele cu sistemul vechi și planificăm trecerea împreună cu echipa ta.',
              deliverables: ['Scripturi de migrare și rulări de probă', 'Rapoarte de reconciliere', 'Plan de trecere', 'Suport la lansare']
            },
            {
              phase: 'Suport și mentenanță',
              duration: 'Continuu',
              description: 'Monitorizăm integrările și le actualizăm când se schimbă ERP-ul sau sistemele conectate.',
              deliverables: ['Monitorizarea integrărilor', 'Actualizări la schimbări de ERP și API', 'Remedieri și extinderi', 'Documentație la zi']
            }
          ]
        },
        benefits: {
          title: 'Impact asupra afacerii',
          description: 'Ce îi aduce afacerii tale un ERP conectat, potrivit proceselor tale.',
          outcomes: [
            {
              label: 'Mai puțină introducere manuală',
              description: 'Comenzile, clienții și facturile circulă automat între sisteme.'
            },
            {
              label: 'Stocuri și prețuri concordante',
              description: 'Magazinul online și ERP-ul lucrează cu aceleași cifre.'
            },
            {
              label: 'Procese care se potrivesc',
              description: 'Modulele la comandă acoperă pașii care îți fac afacerea diferită.'
            },
            {
              label: 'Migrare controlată',
              description: 'Rulările de probă și reconcilierea prind problemele de date înainte de lansare.'
            }
          ]
        }
      },
      itSupport: {
        title: 'Suport IT',
        subtitle: 'Helpdesk și suport tehnic',
        description: 'Servicii complete de helpdesk IT și suport tehnic, care asigură rezolvarea rapidă a problemelor și performanța optimă a sistemului.',
        heroContent: {
          mainTitle: 'Suport IT',
          subtitle: 'Servicii profesionale de helpdesk IT și suport tehnic pentru operațiuni fără probleme și rezolvarea rapidă a incidentelor',
          keyPoints: [
            'Servicii de suport tehnic și helpdesk 24/7',
            'Răspuns și rezolvare rapidă a incidentelor',
            'Monitorizarea și întreținerea proactivă a sistemului',
            'Diagnosticare de specialitate și rezolvarea problemelor'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Provocări în suportul IT',
            description: 'Organizațiile se confruntă cu probleme IT care cauzează downtime, pierderi de productivitate și frustrarea utilizatorilor, din cauza timpilor de răspuns mari și a lipsei de suport specializat.',
            challenges: [
              'Timpi de răspuns mari care afectează productivitatea',
              'Lipsa resurselor de suport tehnic specializat',
              'Procese neuniforme de rezolvare a problemelor',
              'Vizibilitate limitată asupra stării sistemului IT'
            ]
          },
          solution: {
            title: 'Soluții complete de suport IT',
            description: 'Oferim servicii profesionale de suport IT care asigură rezolvarea rapidă a problemelor, monitorizare proactivă și asistență tehnică de specialitate.',
            benefits: [
              'Răspuns și rezolvare rapidă a incidentelor',
              'Suport tehnic expert și troubleshooting',
              'Monitorizarea și întreținerea proactivă a sistemului',
              'Documentație de suport completă și bază de cunoștințe'
            ]
          }
        },
        features: [
          {
            title: 'Servicii de helpdesk',
            description: 'Servicii profesionale de helpdesk, care oferă suport de primă linie pentru probleme IT, întrebările utilizatorilor și asistență tehnică.',
            capabilities: [
              'Gestionarea și urmărirea tichetelor',
              'Suport tehnic de primă linie',
              'Asistență și îndrumare pentru utilizatori',
              'Escaladarea și direcționarea problemelor'
            ]
          },
          {
            title: 'Suport tehnic',
            description: 'Suport tehnic specializat pentru probleme IT complexe, diagnosticarea sistemelor și rezolvarea problemelor.',
            capabilities: [
              'Troubleshooting și diagnosticare avansate',
              'Configurarea și optimizarea sistemului',
              'Suport hardware și software',
              'Asistență și suport la distanță'
            ]
          },
          {
            title: 'Monitorizare proactivă',
            description: 'Monitorizare continuă a sistemului și întreținere proactivă, pentru a preveni problemele înainte ca acestea să afecteze utilizatorii.',
            capabilities: [
              'Monitorizare și alerte de sistem 24/7',
              'Detectarea și prevenirea proactivă a problemelor',
              'Monitorizarea și optimizarea performanței',
              'Verificări ale stării sistemului și întreținere'
            ]
          },
          {
            title: 'Gestionarea bazei de cunoștințe',
            description: 'Bază de cunoștințe și documentație completă, care asigură o calitate constantă a suportului și timpi de rezolvare mai scurți.',
            capabilities: [
              'Dezvoltarea și întreținerea bazei de cunoștințe',
              'Documentație și proceduri de suport',
              'Instruire și transfer de cunoștințe',
              'Bune practici și ghiduri'
            ]
          }
        ],
        technologies: {
          title: 'Instrumente și platforme de suport',
          description: 'Expertiză în platforme și instrumente de suport IT.',
          platforms: [
            { name: 'Zammad', category: 'Platformă de helpdesk' },
            { name: 'Jira Service Desk', category: 'Platformă ITSM' },
            { name: 'ServiceNow', category: 'ITSM enterprise' },
            { name: 'Freshservice', category: 'Helpdesk în cloud' },
            { name: 'ManageEngine', category: 'Management IT' },
            { name: 'TeamViewer', category: 'Suport la distanță' }
          ]
        },
        implementation: {
          title: 'Procesul de configurare a suportului',
          description: 'Abordare structurată pentru implementarea unor servicii complete de suport IT.',
          phases: [
            {
              phase: 'Evaluare și planificare',
              duration: '1-2 săptămâni',
              description: 'Evaluarea completă a nevoilor actuale de suport IT și elaborarea strategiei de suport.',
              deliverables: ['Analiza cerințelor de suport', 'Documentul strategiei de suport', 'Selectarea instrumentelor și planificare', 'Roadmap de implementare']
            },
            {
              phase: 'Configurare și instalare',
              duration: '2-3 săptămâni',
              description: 'Configurarea platformei de helpdesk și a fluxurilor de lucru și implementarea proceselor de suport.',
              deliverables: ['Configurarea platformei', 'Configurarea fluxurilor de lucru', 'Structura bazei de cunoștințe', 'Proceduri de suport']
            },
            {
              phase: 'Instruire și lansare',
              duration: '1-2 săptămâni',
              description: 'Instruirea personalului, documentarea proceselor și suport la lansare pentru serviciile de suport IT.',
              deliverables: ['Instruirea echipei de suport', 'Documentație pentru utilizatori', 'Suport la lansare', 'Configurarea monitorizării performanței']
            },
            {
              phase: 'Suport continuu',
              duration: 'Continuu',
              description: 'Suport continuu, optimizarea proceselor și îmbunătățirea serviciilor.',
              deliverables: ['Suport 24/7', 'Monitorizarea performanței', 'Optimizarea proceselor', 'Îmbunătățire continuă']
            }
          ]
        },
        benefits: {
          title: 'Impactul suportului',
          description: 'Aducem îmbunătățiri măsurabile ale calității suportului și ale satisfacției utilizatorilor.',
          outcomes: [
            {
              label: 'Timpi de rezolvare mai scurți',
              description: 'Suportul specializat și procesele eficiente reduc semnificativ timpii de rezolvare a problemelor.'
            },
            {
              label: 'Satisfacția utilizatorilor',
              description: 'Serviciile profesionale de suport și timpii de răspuns scurți cresc satisfacția utilizatorilor.'
            },
            {
              label: 'Reducerea downtime-ului',
              description: 'Monitorizarea proactivă și răspunsul rapid reduc downtime-ul sistemului și pierderile de productivitate.'
            },
            {
              label: 'Rezolvare la primul contact',
              description: 'Suportul specializat și o bază de cunoștințe completă permit rate ridicate de rezolvare la primul contact.'
            }
          ]
        }
      },
      dataEngineering: {
        title: 'Data Engineering',
        subtitle: 'Pipeline-uri de date și infrastructură de analytics',
        description: 'Construim pipeline-uri de date robuste, procese ETL și infrastructură de analytics care transformă datele brute în informații utile pentru decizii bazate pe date.',
        heroContent: {
          mainTitle: 'Data Engineering',
          subtitle: 'Servicii complete de data engineering pentru construirea de pipeline-uri de date scalabile, procese ETL și infrastructură de analytics',
          keyPoints: [
            'Dezvoltarea de pipeline-uri de date scalabile',
            'Proiectarea și implementarea proceselor ETL/ELT',
            'Arhitectură de data warehouse și data lake',
            'Procesarea datelor și analytics în timp real'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Provocări ale infrastructurii de date',
            description: 'Organizațiile se confruntă cu surse de date fragmentate, procesarea ineficientă a datelor și lipsa unei infrastructuri scalabile care să susțină analytics și business intelligence.',
            challenges: [
              'Surse de date fragmentate și silozuri',
              'Procesarea și transformarea ineficientă a datelor',
              'Lipsa unei infrastructuri de date scalabile',
              'Capacitate limitată de procesare a datelor în timp real'
            ]
          },
          solution: {
            title: 'Soluții complete de data engineering',
            description: 'Livrăm soluții scalabile de data engineering pentru procesarea și transformarea eficientă a datelor și pentru infrastructura de analytics.',
            benefits: [
              'Arhitectură scalabilă de pipeline-uri de date',
              'Procese ETL/ELT eficiente',
              'Infrastructură de date unificată',
              'Procesarea datelor în timp real'
            ]
          }
        },
        features: [
          {
            title: 'Dezvoltare de pipeline-uri de date',
            description: 'Proiectăm și implementăm pipeline-uri de date scalabile pentru ingestia, transformarea și procesarea eficientă a datelor.',
            capabilities: [
              'Proiectarea arhitecturii pipeline-urilor de date',
              'Implementarea proceselor ETL/ELT',
              'Ingestia și integrarea datelor',
              'Monitorizarea și optimizarea pipeline-urilor'
            ]
          },
          {
            title: 'Data warehouse și data lake',
            description: 'Construim și optimizăm data warehouse-uri și data lake-uri pentru stocarea centralizată a datelor și analytics.',
            capabilities: [
              'Proiectarea arhitecturii de data warehouse',
              'Implementarea și optimizarea data lake-ului',
              'Modelarea datelor și proiectarea schemei',
              'Optimizarea stocării și partiționare'
            ]
          },
          {
            title: 'Procesare în timp real',
            description: 'Implementăm procesarea datelor în timp real și analytics pe fluxuri de date (streaming), pentru insight-uri imediate și luarea deciziilor.',
            capabilities: [
              'Arhitectură de procesare streaming',
              'Transformarea datelor în timp real',
              'Procesarea datelor bazată pe evenimente',
              'Analytics și monitorizare streaming'
            ]
          },
          {
            title: 'Calitatea și guvernanța datelor',
            description: 'Implementăm framework-uri de calitate a datelor, politici de guvernanță și monitorizare, pentru date de încredere și sigure.',
            capabilities: [
              'Framework-uri de calitate și validare a datelor',
              'Guvernanța datelor și conformitate',
              'Trasabilitatea datelor (data lineage) și catalogare',
              'Monitorizarea și raportarea calității datelor'
            ]
          }
        ],
        technologies: {
          title: 'Stack tehnologic',
          description: 'Expertiză în platforme și instrumente de data engineering.',
          platforms: [
            { name: 'Apache Airflow', category: 'Orchestrarea fluxurilor de lucru' },
            { name: 'Apache Spark', category: 'Procesarea datelor' },
            { name: 'Snowflake', category: 'Data warehouse' },
            { name: 'AWS Glue', category: 'Serviciu ETL' },
            { name: 'Apache Kafka', category: 'Procesare streaming' },
            { name: 'dbt', category: 'Transformarea datelor' }
          ]
        },
        implementation: {
          title: 'Metodologia de implementare',
          description: 'Abordare structurată a proiectelor de data engineering, care asigură o infrastructură de date scalabilă și de încredere.',
          phases: [
            {
              phase: 'Evaluare și proiectare',
              duration: '2-3 săptămâni',
              description: 'Evaluarea completă a datelor, proiectarea arhitecturii și planificarea implementării.',
              deliverables: ['Raport de evaluare a datelor', 'Proiectarea arhitecturii', 'Recomandări tehnologice', 'Roadmap de implementare']
            },
            {
              phase: 'Configurarea infrastructurii',
              duration: '2-4 săptămâni',
              description: 'Configurarea infrastructurii de date și a platformei și dezvoltarea pipeline-urilor inițiale.',
              deliverables: ['Implementarea infrastructurii', 'Configurarea platformei', 'Pipeline-uri inițiale', 'Configurarea securității']
            },
            {
              phase: 'Dezvoltarea pipeline-urilor',
              duration: '3-6 săptămâni',
              description: 'Dezvoltarea pipeline-urilor de date și a proceselor ETL și implementarea transformărilor de date.',
              deliverables: ['Pipeline-uri de date', 'Procese ETL', 'Framework-uri de calitate a datelor', 'Configurarea monitorizării']
            },
            {
              phase: 'Optimizare și suport',
              duration: 'Continuu',
              description: 'Optimizare continuă, ajustarea performanței și suport permanent pentru infrastructura de date.',
              deliverables: ['Optimizarea performanței', 'Monitorizare și alerte', 'Suport 24/7', 'Îmbunătățire continuă']
            }
          ]
        },
        benefits: {
          title: 'Impact asupra afacerii',
          description: 'Aducem îmbunătățiri măsurabile ale eficienței procesării datelor și ale capacităților de analytics.',
          outcomes: [
            {
              label: 'Procesare mai rapidă a datelor',
              description: 'Pipeline-urile și infrastructura optimizate reduc semnificativ timpii de procesare a datelor.'
            },
            {
              label: 'Reducerea costurilor',
              description: 'O infrastructură de date eficientă și optimizarea ei reduc costurile de procesare și stocare a datelor.'
            },
            {
              label: 'Calitate mai bună a datelor',
              description: 'Framework-urile complete de calitate a datelor asigură date de încredere și sigure pentru analytics.'
            },
            {
              label: 'Insight-uri obținute mai repede',
              description: 'Pipeline-urile de date optimizate și procesarea în timp real scurtează timpul până la obținerea de insight-uri aplicabile.'
            }
          ]
        }
      },
      deviceManagement: {
        title: 'Administrarea dispozitivelor',
        subtitle: 'Windows, macOS, Linux, ChromeOS, iOS, Android',
        description: 'Protejăm fiecare endpoint Windows, macOS, Linux și mobil cu Intune, Jamf și verificarea automată a conformității, astfel încât inventarul, politicile și patch-urile să rămână sincronizate.',
        heroContent: {
          mainTitle: 'Administrarea dispozitivelor',
          subtitle: 'Management complet (end-to-end) al dispozitivelor Windows și macOS: Microsoft Intune și SCCM pentru Windows, Jamf Pro pentru macOS',
          keyPoints: [
            'Protecție avansată împotriva amenințărilor pe toate endpoint-urile',
            'Administrarea unificată a dispozitivelor și a conformității',
            'Implementarea unei arhitecturi de securitate Zero Trust',
            'Răspuns automatizat la incidente și remediere'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Provocări în securitatea endpoint-urilor',
            description: 'Întreprinderile moderne se confruntă cu provocări de securitate fără precedent: angajați care lucrează din locații diferite, politici BYOD și amenințări cibernetice avansate care vizează endpoint-urile ca principal vector de atac.',
            challenges: [
              'Instrumente de securitate fragmentate, care creează lacune de vizibilitate',
              'Cerințe complexe de conformitate în jurisdicții diferite',
              'Amenințări care evoluează mai repede decât măsurile de protecție',
              'Resurse limitate care reduc eficiența echipei de securitate'
            ]
          },
          solution: {
            title: 'Abordarea noastră completă',
            description: 'Oferim soluții integrate de securitate endpoint care asigură vizibilitate, control și protecție complete în întregul tău ecosistem de dispozitive.',
            benefits: [
              'Platformă unificată de securitate, care reduce complexitatea',
              'Detectarea automată a amenințărilor și răspuns',
              'Gestionarea și aplicarea centralizată a politicilor',
              'Monitorizarea continuă a conformității și raportare'
            ]
          }
        },
        features: [
          {
            title: 'Protecție avansată împotriva amenințărilor',
            description: 'Securitate pe mai multe niveluri, inclusiv EDR, analiză comportamentală și detectarea amenințărilor bazată pe AI, pentru identificarea și neutralizarea atacurilor avansate înainte ca acestea să afecteze afacerea ta.',
            capabilities: [
              'Detectarea și analiza amenințărilor în timp real',
              'Analiză comportamentală și detectarea anomaliilor',
              'Fluxuri automatizate de răspuns la incidente',
              'Integrarea informațiilor despre amenințări (threat intelligence)'
            ]
          },
          {
            title: 'Administrarea unificată a dispozitivelor',
            description: 'Control și administrare centralizate pentru toate endpoint-urile Windows, macOS, Linux, iOS și Android, dintr-o singură consolă.',
            capabilities: [
              'Înregistrarea și configurarea inițială (provisioning) a dispozitivelor pe toate platformele',
              'Configurarea și aplicarea politicilor',
              'Distribuirea software-ului și gestionarea patch-urilor',
              'Inventarul activelor și gestionarea ciclului de viață'
            ]
          },
          {
            title: 'Arhitectură Zero Trust',
            description: 'Implementăm principiile de securitate Zero Trust, cu verificare continuă, acces cu privilegii minime și microsegmentare în infrastructura ta de endpoint-uri.',
            capabilities: [
              'Controlul accesului pe bază de identitate',
              'Segmentarea și izolarea rețelei',
              'Autentificare și autorizare continuă',
              'Soluții de acces bazate pe risc'
            ]
          },
          {
            title: 'Conformitate și raportare',
            description: 'Menținem conformitatea cu cerințele de reglementare prin raportare automatizată, piste de audit și aplicarea politicilor pentru mai multe framework-uri și standarde.',
            capabilities: [
              'Monitorizarea automată a conformității',
              'Raportare și dashboard-uri personalizate',
              'Păstrarea pistelor de audit',
              'Alinierea la framework-urile de reglementare'
            ]
          }
        ],
        technologies: {
          title: 'Stack tehnologic',
          description: 'Platformele și instrumentele pe care le folosim pentru securitatea endpoint-urilor.',
          platforms: [
            { name: 'Microsoft Intune', category: 'Administrarea dispozitivelor' },
            { name: 'Microsoft Defender', category: 'Protecția endpoint-urilor' },
            { name: 'Jamf Pro', category: 'Administrare macOS' },
            { name: 'CrowdStrike Falcon', category: 'Platformă EDR' },
            { name: 'SentinelOne', category: 'Răspuns autonom' },
            { name: 'VMware Workspace ONE', category: 'Administrare unificată a endpoint-urilor' }
          ]
        },
        implementation: {
          title: 'Metodologia de implementare',
          description: 'Abordarea noastră, testată în practică, asigură implementarea și adoptarea cu succes a soluțiilor de securitate endpoint.',
          phases: [
            {
              phase: 'Evaluare și planificare',
              duration: '1-2 săptămâni',
              description: 'Evaluare completă de securitate, analiza lacunelor și planificare strategică pentru implementarea securității endpoint-urilor.',
              deliverables: ['Evaluarea nivelului de securitate', 'Raport de analiză a riscurilor', 'Roadmap de implementare', 'Recomandări tehnologice']
            },
            {
              phase: 'Proiectare și configurare',
              duration: '2-3 săptămâni',
              description: 'Proiectarea arhitecturii soluției, configurarea politicilor și implementarea framework-urilor de securitate.',
              deliverables: ['Proiectarea arhitecturii de securitate', 'Configurațiile politicilor', 'Specificații de integrare', 'Protocoale de testare']
            },
            {
              phase: 'Implementare și testare',
              duration: '2-4 săptămâni',
              description: 'Implementare etapizată în fiecare mediu, cu proceduri complete de testare și validare.',
              deliverables: ['Implementare pilot', 'Teste de performanță', 'Validarea securității', 'Testarea de acceptanță de către utilizatori']
            },
            {
              phase: 'Instruire și optimizare',
              duration: '1-2 săptămâni',
              description: 'Instruirea personalului, furnizarea documentației și recomandări pentru optimizare continuă.',
              deliverables: ['Materiale de formare', 'Documentație', 'Plan de optimizare', 'Proceduri de suport']
            }
          ]
        },
        benefits: {
          title: 'Impact asupra afacerii',
          description: 'Îți transformăm nivelul de securitate, îmbunătățind în același timp eficiența operațională și reducând riscurile.',
          outcomes: [
            {
              label: 'Precizia detectării amenințărilor',
              description: 'Detectarea avansată bazată pe AI reduce rezultatele fals pozitive, menținând în același timp o acoperire completă a amenințărilor.'
            },
            {
              label: 'Reducerea incidentelor de securitate',
              description: 'Prevenirea proactivă a amenințărilor și răspunsul automatizat reduc semnificativ incidentele de securitate.'
            },
            {
              label: 'Răspuns mai rapid la incidente',
              description: 'Workflow-urile automatizate și managementul centralizat accelerează detectarea și rezolvarea incidentelor.'
            },
            {
              label: 'Acoperirea cerințelor de conformitate',
              description: 'Monitorizarea și raportarea completă asigură conformitatea continuă cu toate framework-urile de reglementare.'
            }
          ]
        }
      },
      infrastructureManagement: {
        title: 'Managementul infrastructurii',
        subtitle: 'Administrarea serverelor, dispozitivelor și VM-urilor',
        description: 'Centralizăm administrarea serverelor, a rețelei și a VM-urilor, cu monitorizare, planificarea capacității și recuperare automată, astfel încât mediile hibride să fie rapide, conforme și reziliente.',
        heroContent: {
          mainTitle: 'Managementul infrastructurii',
          subtitle: 'Management complet al infrastructurii: administrarea serverelor, gestionarea dispozitivelor și optimizarea mașinilor virtuale',
          keyPoints: [
            'Administrarea și monitorizarea completă a serverelor',
            'Optimizarea și administrarea mașinilor virtuale',
            'Backup automatizat și recuperare în caz de dezastru',
            'Monitorizarea performanței și planificarea capacității'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Provocările unei infrastructuri complexe',
            description: 'Întreprinderile moderne se confruntă cu o infrastructură complexă și distribuită, care necesită monitorizare, întreținere și optimizare constante pentru a asigura continuitatea afacerii și performanța.',
            challenges: [
              'Instrumente de monitorizare fragmentate, care creează lacune de vizibilitate',
              'Procese manuale care cauzează ineficiență operațională',
              'Dificultăți în planificarea capacității și optimizarea resurselor',
              'Complexitatea backupului și a recuperării în caz de dezastru'
            ]
          },
          solution: {
            title: 'Management unificat al infrastructurii',
            description: 'Oferim soluții complete de management al infrastructurii, care centralizează controlul, automatizează procesele și asigură performanță optimă în întregul tău mediu IT.',
            benefits: [
              'Platformă centralizată de monitorizare și management',
              'Procese automatizate de backup și recuperare',
              'Optimizarea proactivă a performanței',
              'Planificarea capacității și scalare completă'
            ]
          }
        },
        features: [
          {
            title: 'Administrarea serverelor',
            description: 'Gestionarea completă a ciclului de viață al serverelor, inclusiv provisioning, configurare, monitorizare și întreținere, în medii Windows și Linux.',
            capabilities: [
              'Provisioningul și configurarea serverelor',
              'Monitorizarea și optimizarea performanței',
              'Gestionarea patch-urilor și a actualizărilor de securitate',
              'Planificarea capacității și optimizarea resurselor'
            ]
          },
          {
            title: 'Administrarea bazelor de date',
            description: 'Administrarea și optimizarea specializată a bazelor de date, pentru disponibilitate ridicată, performanță și securitate în sistemele tale critice de date.',
            capabilities: [
              'Instalarea și configurarea bazelor de date',
              'Tuningul și optimizarea performanței',
              'Strategii de backup și recuperare',
              'Consolidarea securității (hardening) și conformitate'
            ]
          },
          {
            title: 'Optimizarea mașinilor virtuale',
            description: 'Administrarea virtualizării VMware și Hyper-V, cu optimizarea utilizării resurselor, a performanței și a costurilor.',
            capabilities: [
              'Provisioningul și administrarea mașinilor virtuale',
              'Alocarea și optimizarea resurselor',
              'Migrarea și consolidarea VM-urilor',
              'Monitorizarea și tuningul performanței'
            ]
          },
          {
            title: 'Monitorizare și analitică',
            description: 'Monitorizarea completă a infrastructurii, cu analitică avansată, alerte și raportare, pentru detectarea și rezolvarea proactivă a problemelor.',
            capabilities: [
              'Monitorizarea infrastructurii în timp real',
              'Analitică predictivă și alerte',
              'Dashboard-uri și raportare personalizate',
              'Planificarea capacității și prognoză'
            ]
          }
        ],
        technologies: {
          title: 'Expertiză tehnologică',
          description: 'Expertiză profundă în platforme și instrumente de management al infrastructurii.',
          platforms: [
            { name: 'VMware vSphere', category: 'Platformă de virtualizare' },
            { name: 'Microsoft Hyper-V', category: 'Hypervisor' },
            { name: 'Microsoft System Center', category: 'Suită de management' },
            { name: 'Nagios', category: 'Soluție de monitorizare' },
            { name: 'Veeam', category: 'Backup și recuperare' },
            { name: 'SolarWinds', category: 'Monitorizarea infrastructurii' }
          ]
        },
        implementation: {
          title: 'Metodologia de implementare',
          description: 'Abordare structurată a implementării managementului infrastructurii, care asigură performanță și fiabilitate optime.',
          phases: [
            {
              phase: 'Evaluare și descoperire',
              duration: '1-2 săptămâni',
              description: 'Evaluarea completă a infrastructurii și analiza stării actuale.',
              deliverables: ['Raport de audit al infrastructurii', 'Nivelul de referință al performanței', 'Analiza capacității', 'Evaluarea riscurilor']
            },
            {
              phase: 'Proiectare și planificare',
              duration: '2-3 săptămâni',
              description: 'Proiectarea arhitecturii soluției și planificarea implementării.',
              deliverables: ['Proiectarea arhitecturii', 'Roadmap de implementare', 'Strategie de migrare', 'Protocoale de testare']
            },
            {
              phase: 'Implementare și migrare',
              duration: '3-4 săptămâni',
              description: 'Implementare etapizată, cu testare și validare completă.',
              deliverables: ['Implementarea infrastructurii', 'Migrarea datelor', 'Teste de performanță', 'Instruirea utilizatorilor']
            },
            {
              phase: 'Optimizare și suport',
              duration: 'Continuu',
              description: 'Optimizare și suport continue pentru performanță optimă.',
              deliverables: ['Optimizarea performanței', 'Monitorizare regulată', 'Suport 24/7', 'Îmbunătățire continuă']
            }
          ]
        },
        benefits: {
          title: 'Impact operațional',
          description: 'Aducem îmbunătățiri măsurabile ale performanței, fiabilității și eficienței operaționale.',
          outcomes: [
            {
              label: 'SLA respectat',
              description: 'Monitorizarea și întreținerea proactive asigură disponibilitatea maximă a sistemului și continuitatea afacerii.'
            },
            {
              label: 'Reducerea downtime-ului',
              description: 'Monitorizarea automatizată și răspunsul rapid reduc semnificativ întreruperile neplanificate.'
            },
            {
              label: 'Rezolvarea mai rapidă a problemelor',
              description: 'Monitorizarea centralizată și alertele automatizate accelerează detectarea și rezolvarea problemelor.'
            },
            {
              label: 'Optimizarea costurilor',
              description: 'Optimizarea resurselor și planificarea capacității reduc costurile de infrastructură și îmbunătățesc, în același timp, performanța.'
            }
          ]
        }
      },
      databaseManagement: {
        title: 'Administrarea bazelor de date',
        subtitle: 'Configurare, migrare și administrare',
        description: 'Stabilizăm bazele de date critice pentru afacere prin migrare, tuning, backup-uri automatizate și monitorizare 24/7, care urmăresc performanța, uptime-ul și conformitatea.',
        heroContent: {
          mainTitle: 'Administrarea bazelor de date',
          subtitle: 'Servicii specializate de administrare, migrare și optimizare a bazelor de date, pentru performanță și fiabilitate optime',
          keyPoints: [
            'Instalarea și configurarea bazelor de date',
            'Servicii sigure de migrare a datelor',
            'Optimizarea și tuningul performanței',
            'Monitorizare și suport 24/7'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Provocări în administrarea bazelor de date',
            description: 'Organizațiile se confruntă cu probleme de performanță ale bazelor de date, migrări complexe, vulnerabilități de securitate și lipsa specialiștilor în administrarea bazelor de date.',
            challenges: [
              'Performanța slabă a bazelor de date, care afectează aplicațiile',
              'Proiecte de migrare complexe, care cauzează downtime',
              'Vulnerabilități de securitate și probleme de conformitate',
              'Lipsa administratorilor de baze de date specializați'
            ]
          },
          solution: {
            title: 'Soluții complete pentru baze de date',
            description: 'Oferim servicii specializate de administrare a bazelor de date, care optimizează performanța, asigură migrări sigure și mențin funcționarea fiabilă a bazelor de date.',
            benefits: [
              'Performanță și fiabilitate optimizate ale bazelor de date',
              'Migrări de date sigure și fără întreruperi',
              'Securitate și conformitate îmbunătățite',
              'Administrare expertă și suport 24/7'
            ]
          }
        },
        features: [
          {
            title: 'Instalarea și configurarea bazelor de date',
            description: 'Instalarea, configurarea și tuningul profesional al bazelor de date, pentru performanță și securitate optime.',
            capabilities: [
              'Instalarea și configurarea serverelor de baze de date',
              'Tuningul și optimizarea performanței',
              'Consolidarea securității (hardening) și configurare',
              'Implementarea soluțiilor de disponibilitate ridicată'
            ]
          },
          {
            title: 'Servicii de migrare a bazelor de date',
            description: 'Migrarea sigură și fiabilă a bazelor de date, cu downtime minim și testare completă.',
            capabilities: [
              'Planificarea și execuția migrării bazelor de date',
              'Validarea integrității datelor și testare',
              'Strategii de migrare fără downtime',
              'Optimizare și suport post-migrare'
            ]
          },
          {
            title: 'Optimizarea performanței',
            description: 'Tuningul și optimizarea performanței bazelor de date, pentru execuția rapidă a interogărilor și utilizarea eficientă a resurselor.',
            capabilities: [
              'Optimizarea și tuningul interogărilor',
              'Gestionarea și optimizarea indexurilor',
              'Monitorizarea și analiza bazelor de date',
              'Planificarea capacității și scalare'
            ]
          },
          {
            title: 'Administrare continuă',
            description: 'Administrarea completă a bazelor de date, inclusiv monitorizare, backup, securitate și întreținere.',
            capabilities: [
              'Monitorizare și suport 24/7 pentru bazele de date',
              'Backup automatizat și recuperare',
              'Actualizări de securitate și gestionarea patch-urilor',
              'Monitorizarea performanței și raportare'
            ]
          }
        ],
        technologies: {
          title: 'Expertiză în baze de date',
          description: 'Expertiză în platforme și instrumente de administrare a bazelor de date.',
          platforms: [
            { name: 'PostgreSQL', category: 'Bază de date open-source' },
            { name: 'MySQL', category: 'Bază de date relațională' },
            { name: 'Microsoft SQL Server', category: 'Bază de date enterprise' },
            { name: 'Oracle Database', category: 'Bază de date enterprise' },
            { name: 'MongoDB', category: 'Bază de date NoSQL' },
            { name: 'Redis', category: 'Bază de date in-memory' }
          ]
        },
        implementation: {
          title: 'Procesul de implementare',
          description: 'Abordare structurată a administrării bazelor de date, care asigură performanță și fiabilitate optime.',
          phases: [
            {
              phase: 'Evaluare și planificare',
              duration: '1-2 săptămâni',
              description: 'Evaluarea completă a bazelor de date și elaborarea strategiei de administrare.',
              deliverables: ['Raport de audit al bazelor de date', 'Nivelul de referință al performanței', 'Strategie de administrare', 'Evaluarea securității']
            },
            {
              phase: 'Instalare și configurare',
              duration: '2-3 săptămâni',
              description: 'Instalarea, configurarea și optimizarea bazelor de date pentru punerea în producție.',
              deliverables: ['Instalarea bazelor de date', 'Tuningul performanței', 'Configurarea securității', 'Strategie de backup']
            },
            {
              phase: 'Migrare și implementare',
              duration: '2-4 săptămâni',
              description: 'Migrarea și implementarea sigură a bazelor de date, cu testare completă.',
              deliverables: ['Migrarea datelor', 'Teste de performanță', 'Validarea securității', 'Acceptarea de către utilizatori']
            },
            {
              phase: 'Suport continuu',
              duration: 'Continuu',
              description: 'Monitorizare continuă, optimizare și suport 24/7 pentru operarea bazelor de date.',
              deliverables: ['Monitorizare 24/7', 'Optimizarea performanței', 'Actualizări de securitate', 'Suport continuu']
            }
          ]
        },
        benefits: {
          title: 'Impact asupra performanței',
          description: 'Aducem îmbunătățiri măsurabile ale performanței, fiabilității și securității bazelor de date.',
          outcomes: [
            {
              label: 'Performanță îmbunătățită',
              description: 'Optimizarea îmbunătățește semnificativ performanța interogărilor și timpul de răspuns.'
            },
            {
              label: 'Garanție SLA',
              description: 'Operarea fiabilă a bazelor de date, cu monitorizare și suport complet, asigură disponibilitate maximă.'
            },
            {
              label: 'Execuție mai rapidă a interogărilor',
              description: 'Tuningul și optimizarea performanței reduc semnificativ timpul de execuție a interogărilor.'
            },
            {
              label: 'Securitatea și conformitatea datelor',
              description: 'Măsurile îmbunătățite de securitate și conformitate asigură protecția datelor și respectarea cerințelor de reglementare.'
            }
          ]
        }
      },
      serviceDesk: {
        title: 'Implementare service desk',
        subtitle: 'Configurare Jira, YouTrack și Zammad',
        description: 'Lansăm service desk-uri pe Jira, ServiceNow sau YouTrack, cu fluxuri de lucru, SLA și automatizări care reduc timpul de rezolvare și le oferă agenților context complet pentru tichete.',
        heroContent: {
          mainTitle: 'Implementare service desk',
          subtitle: 'Instalarea și configurarea profesională a unui service desk pentru operațiuni eficiente de suport IT',
          keyPoints: [
            'Implementarea unei platforme profesionale de service desk',
            'Rutarea automată și escaladarea tichetelor',
            'Raportare și analitică completă',
            'Integrare cu sistemele IT existente'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Provocări în operațiunile de suport IT',
            description: 'Organizațiile se confruntă cu procese de suport ineficiente, gestionarea slabă a tichetelor și lipsa de vizibilitate asupra performanței serviciilor IT.',
            challenges: [
              'Rutarea manuală a tichetelor, care cauzează întârzieri',
              'Lipsa unor procese de suport standardizate',
              'Vizibilitate slabă asupra metricilor de suport',
              'Dificultăți de integrare cu sistemele existente'
            ]
          },
          solution: {
            title: 'Soluții complete de service desk',
            description: 'Implementăm platforme profesionale de service desk care automatizează procesele, îmbunătățesc eficiența și asigură vizibilitate completă asupra operațiunilor de suport IT.',
            benefits: [
              'Rutarea automată și escaladarea tichetelor',
              'Procese și fluxuri de lucru de suport standardizate',
              'Raportare și analitică completă',
              'Integrare perfectă cu sistemele existente'
            ]
          }
        },
        features: [
          {
            title: 'Implementarea platformei',
            description: 'Instalarea și configurarea completă a platformei de service desk cu Jira Service Desk, YouTrack sau Zammad, în funcție de cerințele tale.',
            capabilities: [
              'Selectarea și configurarea platformei',
              'Proiectarea și implementarea fluxurilor de lucru personalizate',
              'Configurarea interfeței pentru utilizatori',
              'Integrare cu sistemele existente'
            ]
          },
          {
            title: 'Automatizarea proceselor',
            description: 'Rutarea automată a tichetelor, escaladare și procese de rezolvare care îmbunătățesc eficiența și reduc timpul de răspuns.',
            capabilities: [
              'Reguli de rutare automată a tichetelor',
              'Escaladare și gestionarea SLA-urilor',
              'Fluxuri automatizate de rezolvare',
              'Notificări și alerte automate'
            ]
          },
          {
            title: 'Raportare și analitică',
            description: 'Dashboard-uri și raportare completă pentru urmărirea metricilor de suport și a performanței SLA și pentru identificarea tendințelor.',
            capabilities: [
              'Dashboard-uri personalizate și vizualizări',
              'Raportarea metricilor de suport și SLA',
              'Analiza tendințelor și a tiparelor',
              'Exportul rapoartelor și al datelor'
            ]
          },
          {
            title: 'Integrare și extensibilitate',
            description: 'Integrare cu sistemele IT existente, aplicații terțe și API-uri, pentru fluxuri de lucru unificate.',
            capabilities: [
              'Integrare cu sistemele IT existente',
              'Conectare prin API-uri și webhook-uri',
              'Integrarea aplicațiilor terțe',
              'Extensibilitate și personalizare'
            ]
          }
        ],
        technologies: {
          title: 'Platforme și instrumente',
          description: 'Expertiză în platforme și instrumente de service desk și ITSM.',
          platforms: [
            { name: 'Jira Service Desk', category: 'Platformă de service desk' },
            { name: 'Jira Service Management', category: 'Platformă ITSM' },
            { name: 'ServiceNow', category: 'Platformă ITSM enterprise' },
            { name: 'YouTrack', category: 'Gestionarea sarcinilor și a proiectelor' },
            { name: 'Zammad', category: 'Platformă de helpdesk' },
            { name: 'Freshservice', category: 'ITSM în cloud' }
          ]
        },
        implementation: {
          title: 'Procesul de configurare',
          description: 'Abordare structurată pentru implementarea unor platforme profesionale de service desk.',
          phases: [
            {
              phase: 'Evaluare și planificare',
              duration: '1-2 săptămâni',
              description: 'Evaluarea completă a nevoilor de suport IT și elaborarea strategiei de service desk.',
              deliverables: ['Analiza cerințelor de suport', 'Documentul strategiei de service desk', 'Selectarea platformei și planificare', 'Roadmap de implementare']
            },
            {
              phase: 'Configurare și instalare',
              duration: '2-3 săptămâni',
              description: 'Configurarea platformei de service desk și a fluxurilor de lucru și implementarea proceselor de suport.',
              deliverables: ['Configurarea platformei', 'Configurarea fluxurilor de lucru', 'Configurarea SLA-urilor și a politicilor', 'Proceduri de suport']
            },
            {
              phase: 'Integrare și testare',
              duration: '1-2 săptămâni',
              description: 'Integrare cu sistemele existente, testare completă și validarea configurației.',
              deliverables: ['Integrarea sistemelor', 'Testare funcțională', 'Validarea fluxurilor de lucru', 'Testarea performanței']
            },
            {
              phase: 'Instruire și lansare',
              duration: '1-2 săptămâni',
              description: 'Instruirea echipei, documentarea proceselor și suport la lansarea platformei de service desk.',
              deliverables: ['Instruirea echipei de suport', 'Documentație pentru utilizatori', 'Suport la lansare', 'Configurarea monitorizării performanței']
            }
          ]
        },
        benefits: {
          title: 'Impactul suportului',
          description: 'Aducem îmbunătățiri măsurabile ale eficienței suportului și ale satisfacției utilizatorilor.',
          outcomes: [
            {
              label: 'Timp de rezolvare redus',
              description: 'Rutarea automată și procesele eficiente reduc semnificativ timpul de rezolvare a tichetelor.'
            },
            {
              label: 'Respectarea mai bună a SLA-urilor',
              description: 'Gestionarea automatizată a SLA-urilor și procesele standardizate îmbunătățesc respectarea acestora.'
            },
            {
              label: 'Eficiență operațională',
              description: 'Automatizarea și fluxurile de lucru optimizate îmbunătățesc eficiența operațiunilor de suport.'
            },
            {
              label: 'Satisfacția utilizatorilor',
              description: 'Răspunsul rapid și rezolvarea eficientă a problemelor cresc satisfacția utilizatorilor.'
            }
          ]
        }
      },
      knowledgeManagement: {
        title: 'Gestionarea bazei de cunoștințe',
        subtitle: 'Confluence și sisteme de baze de cunoștințe',
        description: 'Creăm portaluri Confluence și baze de cunoștințe, cu reguli de administrare, șabloane și cicluri de revizuire, astfel încât cunoștințele informale ale echipei să devină documentație fiabilă și reutilizabilă.',
        heroContent: {
          mainTitle: 'Gestionarea bazei de cunoștințe',
          subtitle: 'Soluții complete de gestionare a cunoștințelor, pentru o documentare mai bună și o partajare mai eficientă a informațiilor',
          keyPoints: [
            'Implementarea unui depozit centralizat de cunoștințe',
            'Funcții avansate de căutare și descoperire',
            'Fluxuri colaborative de documentare',
            'Procese de păstrare și transfer al cunoștințelor'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Provocări în gestionarea cunoștințelor',
            description: 'Organizațiile se confruntă cu informații fragmentate, o partajare slabă a cunoștințelor și dificultăți în găsirea informațiilor relevante atunci când este nevoie de ele.',
            challenges: [
              'Informații împrăștiate în mai multe sisteme',
              'Partajarea slabă a cunoștințelor și colaborare redusă',
              'Dificultăți în găsirea informațiilor relevante',
              'Pierderea cunoștințelor din cauza fluctuației personalului'
            ]
          },
          solution: {
            title: 'Soluții complete pentru baze de cunoștințe',
            description: 'Implementăm sisteme centralizate de gestionare a cunoștințelor, care organizează informațiile, încurajează colaborarea și asigură păstrarea cunoștințelor.',
            benefits: [
              'Depozit centralizat de cunoștințe',
              'Funcții avansate de căutare și descoperire',
              'Fluxuri colaborative de documentare',
              'Procese de păstrare și transfer al cunoștințelor'
            ]
          }
        },
        features: [
          {
            title: 'Implementarea platformei',
            description: 'Configurarea completă a platformei de gestionare a cunoștințelor cu Confluence, SharePoint sau soluții similare.',
            capabilities: [
              'Selectarea și configurarea platformei',
              'Structura și organizarea site-ului',
              'Crearea și configurarea șabloanelor',
              'Configurarea accesului utilizatorilor și a permisiunilor'
            ]
          },
          {
            title: 'Gestionarea conținutului',
            description: 'Procese structurate de gestionare a conținutului, care asigură informații corecte și relevante, ușor de găsit.',
            capabilities: [
              'Flux de creare a conținutului',
              'Procese de revizuire și aprobare',
              'Versionarea și gestionarea documentelor',
              'Organizarea și clasificarea conținutului'
            ]
          },
          {
            title: 'Căutare și descoperire',
            description: 'Funcții avansate de căutare și descoperire, pentru găsirea rapidă și precisă a informațiilor relevante.',
            capabilities: [
              'Căutare full-text și indexare',
              'Filtrare și sortare avansată',
              'Recomandări inteligente de conținut',
              'Etichetare și gestionarea metadatelor'
            ]
          },
          {
            title: 'Colaborare și fluxuri de lucru',
            description: 'Workflow-uri colaborative și procese care promovează crearea și partajarea cunoștințelor în organizație.',
            capabilities: [
              'Editare colaborativă și comentarii',
              'Fluxuri de revizuire și aprobare',
              'Notificări și alerte',
              'Integrare cu instrumentele de colaborare'
            ]
          }
        ],
        technologies: {
          title: 'Platforme și instrumente',
          description: 'Expertiză în platforme și instrumente de gestionare a cunoștințelor.',
          platforms: [
            { name: 'Confluence', category: 'Platformă de documentare' },
            { name: 'SharePoint', category: 'Platformă de colaborare' },
            { name: 'Notion', category: 'Spațiu de lucru all-in-one' },
            { name: 'GitBook', category: 'Documentație modernă' },
            { name: 'Document360', category: 'Bază de cunoștințe' },
            { name: 'Gravl', category: 'CMS pentru documentație' }
          ]
        },
        implementation: {
          title: 'Procesul de implementare',
          description: 'Abordare structurată pentru implementarea sistemelor de gestionare a cunoștințelor.',
          phases: [
            {
              phase: 'Evaluare și planificare',
              duration: '1-2 săptămâni',
              description: 'Evaluarea completă a nevoilor de gestionare a cunoștințelor și elaborarea strategiei de implementare.',
              deliverables: ['Analiza nevoilor de cunoștințe', 'Documentul de strategie', 'Selectarea platformei și planificare', 'Roadmap de implementare']
            },
            {
              phase: 'Configurare și instalare',
              duration: '2-3 săptămâni',
              description: 'Configurarea platformei, structurarea conținutului și pregătirea șabloanelor.',
              deliverables: ['Configurarea platformei', 'Structura site-ului', 'Șabloane de documentație', 'Configurarea permisiunilor']
            },
            {
              phase: 'Migrare și populare',
              duration: '2-4 săptămâni',
              description: 'Migrarea conținutului existent și popularea bazei de cunoștințe cu informații relevante.',
              deliverables: ['Migrarea conținutului', 'Organizarea documentelor', 'Indexare și etichetare', 'Validarea conținutului']
            },
            {
              phase: 'Instruire și adoptare',
              duration: '1-2 săptămâni',
              description: 'Instruirea utilizatorilor, încurajarea adoptării și suport continuu.',
              deliverables: ['Instruirea utilizatorilor', 'Documentație pentru utilizatori', 'Suport pentru adoptare', 'Monitorizarea utilizării']
            }
          ]
        },
        benefits: {
          title: 'Impactul gestionării cunoștințelor',
          description: 'Aducem îmbunătățiri măsurabile în partajarea cunoștințelor și în eficiența organizațională.',
          outcomes: [
            {
              label: 'Timp redus de căutare a informațiilor',
              description: 'O bază de cunoștințe centralizată și căutarea avansată reduc semnificativ timpul petrecut cu căutarea informațiilor.'
            },
            {
              label: 'Colaborare îmbunătățită',
              description: 'Fluxurile colaborative și partajarea cunoștințelor îmbunătățesc colaborarea în organizație.'
            },
            {
              label: 'Păstrarea cunoștințelor',
              description: 'Documentația centralizată și procesele de transfer al cunoștințelor asigură păstrarea cunoștințelor organizației.'
            },
            {
              label: 'Mai puțină muncă duplicată',
              description: 'Accesul ușor la documentația și cunoștințele existente reduce munca duplicată.'
            }
          ]
        }
      },
      cloudWorkspace: {
        title: 'Soluții de cloud workspace',
        subtitle: 'Microsoft 365 și Google Workspace',
        description: 'Modernizăm M365 și Google Workspace cu provisioning automatizat, onboarding, politici DLP și fluxuri de lucru care mențin colaborarea sigură, conformă și rapidă.',
        heroContent: {
          mainTitle: 'Soluții de cloud workspace',
          subtitle: 'Configurarea și administrarea completă a spațiilor de lucru în cloud, pentru medii Microsoft 365 și Google Workspace',
          keyPoints: [
            'Administrare completă pentru Microsoft 365 și Google Workspace',
            'Configurații avansate de securitate și conformitate',
            'Servicii de migrare și integrare fără întreruperi',
            'Optimizare continuă și suport'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Complexitatea spațiului de lucru în cloud',
            description: 'Organizațiile trebuie să gestioneze medii cloud complexe și configurații de securitate și să asigure performanța optimă pentru echipe care lucrează din locații diferite.',
            challenges: [
              'Cerințe complexe de securitate și conformitate',
              'Dificultăți de integrare între platforme',
              'Adoptarea de către utilizatori și managementul schimbării',
              'Optimizarea costurilor și gestionarea licențelor'
            ]
          },
          solution: {
            title: 'Management complet al mediului cloud',
            description: 'Oferim soluții complete (end-to-end) pentru spațiul de lucru în cloud, care reduc complexitatea și maximizează, în același timp, securitatea și productivitatea.',
            benefits: [
              'Administrare unificată pentru toate platformele',
              'Securitate și conformitate automatizate',
              'Gestionare optimizată a utilizatorilor',
              'Optimizarea licențelor pentru costuri mai mici'
            ]
          }
        },
        features: [
          {
            title: 'Administrarea platformei',
            description: 'Administrarea completă a mediilor Microsoft 365 și Google Workspace, cu configurare și optimizare avansate.',
            capabilities: [
              'Configurarea și optimizarea tenantului',
              'Gestionarea ciclului de viață al conturilor de utilizator',
              'Implementarea politicilor de securitate',
              'Monitorizarea și tuningul performanței'
            ]
          },
          {
            title: 'Securitate și conformitate',
            description: 'Configurații de securitate de nivel enterprise, care asigură protecția datelor și conformitatea cu cerințele de reglementare în toate serviciile cloud.',
            capabilities: [
              'Politici de prevenire a pierderii datelor (DLP)',
              'Controale de acces condiționat',
              'Configurarea autentificării multifactor (MFA)',
              'Monitorizarea și raportarea conformității'
            ]
          },
          {
            title: 'Migrare și integrare',
            description: 'Servicii de migrare și integrare pentru o tranziție fără probleme în cloud și conectarea cu sistemele existente.',
            capabilities: [
              'Planificarea și execuția migrării',
              'Migrarea datelor și a conținutului',
              'Integrare cu sistemele existente',
              'Validare și testare post-migrare'
            ]
          },
          {
            title: 'Optimizare și suport',
            description: 'Optimizare continuă și suport pentru performanță maximă și utilizarea eficientă a resurselor cloud.',
            capabilities: [
              'Optimizarea configurației și a performanței',
              'Gestionarea licențelor și a costurilor',
              'Monitorizarea utilizării și recomandări',
              'Suport continuu și întreținere'
            ]
          }
        ],
        technologies: {
          title: 'Expertiză pe platforme',
          description: 'Expertiză în platforme și instrumente pentru spațiul de lucru în cloud.',
          platforms: [
            { name: 'Microsoft 365', category: 'Suită de productivitate' },
            { name: 'Google Workspace', category: 'Suită de colaborare' },
            { name: 'Microsoft Azure AD', category: 'Gestionarea identităților' },
            { name: 'Okta', category: 'Platformă IAM' },
            { name: 'Microsoft Teams', category: 'Colaborare' },
            { name: 'Google Meet', category: 'Comunicare' }
          ]
        },
        implementation: {
          title: 'Procesul de implementare',
          description: 'Abordare structurată pentru implementarea soluțiilor de cloud workspace.',
          phases: [
            {
              phase: 'Evaluare și planificare',
              duration: '1-2 săptămâni',
              description: 'Evaluarea completă a nevoilor legate de spațiul de lucru în cloud și elaborarea strategiei de implementare.',
              deliverables: ['Analiza cerințelor pentru spațiul de lucru', 'Documentul de strategie', 'Selectarea platformei și planificare', 'Roadmap de implementare']
            },
            {
              phase: 'Configurare și instalare',
              duration: '2-3 săptămâni',
              description: 'Configurarea platformei, a securității și a serviciilor.',
              deliverables: ['Configurarea tenantului', 'Configurarea securității', 'Configurarea serviciilor', 'Configurarea integrărilor']
            },
            {
              phase: 'Migrare și tranziție',
              duration: '2-4 săptămâni',
              description: 'Migrarea datelor și a conținutului și tranziția utilizatorilor la noua platformă cloud.',
              deliverables: ['Migrarea datelor', 'Migrarea conținutului', 'Tranziția utilizatorilor', 'Validarea migrării']
            },
            {
              phase: 'Optimizare și suport',
              duration: 'Continuu',
              description: 'Optimizare continuă și suport pentru performanță și utilizare optime.',
              deliverables: ['Optimizarea performanței', 'Monitorizarea utilizării', 'Suport continuu', 'Îmbunătățire continuă']
            }
          ]
        },
        benefits: {
          title: 'Impact asupra productivității',
          description: 'Aducem îmbunătățiri măsurabile ale productivității, colaborării și eficienței operaționale.',
          outcomes: [
            {
              label: 'Colaborare îmbunătățită',
              description: 'Platformele cloud optimizate și instrumentele de colaborare îmbunătățesc colaborarea în echipă.'
            },
            {
              label: 'Costuri IT reduse',
              description: 'Optimizarea licențelor și utilizarea eficientă a resurselor cloud reduc costurile IT.'
            },
            {
              label: 'Adoptare de către utilizatori',
              description: 'Onboardingul eficient și suportul pentru utilizatori îmbunătățesc adoptarea platformelor cloud.'
            },
            {
              label: 'Securitate și conformitate',
              description: 'Configurațiile de securitate și conformitate asigură protecția datelor și respectarea cerințelor de reglementare.'
            }
          ]
        }
      },
      identityAccess: {
        title: 'Managementul identităților și al accesului',
        subtitle: 'Active Directory, Okta și CyberArk',
        description: 'Implementăm Azure AD, Okta și CyberArk cu SSO, MFA, automatizarea ciclului de viață al conturilor și politici PAM, pentru a opri deriva credențialelor și a trece auditurile.',
        heroContent: {
          mainTitle: 'Managementul identităților și al accesului',
          subtitle: 'Soluții sigure de gestionare a identităților și a accesului',
          keyPoints: [
            'Autentificare și autorizare avansate',
            'Gestionarea accesului privilegiat (PAM)',
            'Implementarea single sign-on (SSO)',
            'Audit și conformitate complete'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Provocări în securitatea identităților',
            description: 'Organizațiile se confruntă cu riscuri de securitate tot mai mari din cauza atacurilor bazate pe identitate, cu cerințe complexe de acces și cu cerințe de conformitate impuse de reglementări.',
            challenges: [
              'Atacuri bazate pe identitate și furtul credențialelor',
              'Gestionarea complexă a accesului în mai multe sisteme',
              'Lacune de securitate în accesul privilegiat',
              'Cerințe de conformitate și audit'
            ]
          },
          solution: {
            title: 'Securitate completă a identităților',
            description: 'Oferim soluții integrate de gestionare a identităților și a accesului, care asigură un control al accesului sigur, eficient și conform.',
            benefits: [
              'Platformă unificată de gestionare a identităților',
              'Mecanisme avansate de autentificare',
              'Acordarea automată a accesului (provisioning)',
              'Audit și conformitate complete'
            ]
          }
        },
        features: [
          {
            title: 'Autentificare și autorizare',
            description: 'Autentificare multifactor și control al accesului bazat pe roluri, pentru acces sigur la sistemele și datele critice.',
            capabilities: [
              'Autentificare multifactor (MFA)',
              'Implementarea single sign-on (SSO)',
              'Controlul accesului bazat pe roluri (RBAC)',
              'Politici de acces condiționat'
            ]
          },
          {
            title: 'Gestionarea accesului privilegiat',
            description: 'Gestionarea sigură a conturilor privilegiate și a accesului cu drepturi ridicate, cu monitorizare și control complete.',
            capabilities: [
              'Identificarea conturilor privilegiate',
              'Acordarea accesului just-in-time',
              'Monitorizarea și înregistrarea sesiunilor',
              'Rotația automată a parolelor'
            ]
          },
          {
            title: 'Gestionarea ciclului de viață al identităților',
            description: 'Provisioning automatizat al conturilor de utilizator, revocarea accesului și gestionarea acestuia pe parcursul ciclului de viață al angajatului.',
            capabilities: [
              'Provisioning automatizat al conturilor de utilizator',
              'Flux pentru cererile de acces',
              'Gestionarea identităților și conformitate',
              'Administrare delegată'
            ]
          },
          {
            title: 'Audit și conformitate',
            description: 'Piste de audit complete, raportarea conformității și evaluarea riscurilor pentru activitățile de gestionare a identităților și a accesului.',
            capabilities: [
              'Jurnalizare completă pentru audit',
              'Raportarea conformității și dashboard-uri',
              'Evaluarea riscurilor și analitică',
              'Alinierea la framework-urile de reglementare'
            ]
          }
        ],
        technologies: {
          title: 'Platforme tehnologice',
          description: 'Expertiză în platforme de gestionare a identităților și a accesului (IAM).',
          platforms: [
            { name: 'Microsoft Active Directory', category: 'Servicii de director' },
            { name: 'Azure Active Directory', category: 'Identitate în cloud' },
            { name: 'Okta', category: 'Furnizor de identitate' },
            { name: 'CyberArk', category: 'Gestionarea accesului privilegiat' },
            { name: 'BeyondTrust', category: 'Platformă PAM' },
            { name: 'SailPoint', category: 'Gestionarea identităților' }
          ]
        },
        implementation: {
          title: 'Abordarea implementării',
          description: 'Metodologie structurată pentru implementarea cu succes a gestionării identităților și a accesului.',
          phases: [
            {
              phase: 'Descoperire și evaluare',
              duration: '1-2 săptămâni',
              description: 'Evaluarea completă a infrastructurii actuale de identitate și a nivelului de securitate.',
              deliverables: ['Raport de audit al identităților', 'Evaluarea riscurilor', 'Analiza lacunelor', 'Strategie de implementare']
            },
            {
              phase: 'Proiectare și arhitectură',
              duration: '2-3 săptămâni',
              description: 'Proiectarea arhitecturii soluției și implementarea framework-urilor de securitate.',
              deliverables: ['Proiectarea arhitecturii', 'Politici de securitate', 'Specificații de integrare', 'Protocoale de testare']
            },
            {
              phase: 'Implementare și integrare',
              duration: '3-4 săptămâni',
              description: 'Implementare etapizată, cu testarea și validarea completă a integrării.',
              deliverables: ['Implementare pilot', 'Teste de integrare', 'Validarea securității', 'Instruirea utilizatorilor']
            },
            {
              phase: 'Optimizare și suport',
              duration: 'Continuu',
              description: 'Optimizare și suport continue pentru un nivel optim de securitate.',
              deliverables: ['Optimizarea performanței', 'Monitorizarea securității', 'Suport 24/7', 'Îmbunătățire continuă']
            }
          ]
        },
        benefits: {
          title: 'Impact asupra securității',
          description: 'Îți îmbunătățim semnificativ nivelul de securitate și, în același timp, eficiența operațională.',
          outcomes: [
            {
              label: 'Riscuri de identitate reduse',
              description: 'Securitatea completă a identităților reduce riscul atacurilor bazate pe identitate și al breșelor de date.'
            },
            {
              label: 'Acordare mai rapidă a accesului',
              description: 'Fluxurile automatizate accelerează onboardingul utilizatorilor și gestionarea accesului.'
            },
            {
              label: 'Acoperirea cerințelor de conformitate',
              description: 'Auditul și raportarea complete asigură conformitatea continuă cu cerințele de reglementare.'
            },
            {
              label: 'Sarcină administrativă redusă',
              description: 'Gestionarea automatizată a identităților reduce sarcina administrativă și costurile operaționale.'
            }
          ]
        }
      },
      automationDevops: {
        title: 'Automatizare IT și DevOps',
        subtitle: 'Scripting, CI/CD și automatizarea proceselor',
        description: 'Proiectăm pipeline-uri CI/CD, infrastructure as code și runbook-uri de autorecuperare, pentru a accelera lansările, a reduce munca manuală și a menține vizibilitatea completă asupra tuturor mediilor.',
        heroContent: {
          mainTitle: 'Automatizare IT și DevOps',
          subtitle: 'Automatizăm procesele IT și implementăm practici DevOps pentru o eficiență mai mare',
          keyPoints: [
            'Integrare continuă și deployment continuu (CI/CD)',
            'Implementarea infrastructure as code (IaC)',
            'Testare automatizată și asigurarea calității',
            'Soluții de monitorizare și observabilitate'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Provocări în operațiunile IT',
            description: 'Organizațiile se confruntă cu procese manuale, deployment-uri lente și medii neuniforme, care afectează productivitatea și fiabilitatea.',
            challenges: [
              'Procese manuale de deployment, care cauzează întârzieri',
              'Medii și configurații neuniforme',
              'Vizibilitate limitată asupra performanței sistemului',
              'Resurse limitate care frânează inovația'
            ]
          },
          solution: {
            title: 'Excelență operațională prin automatizare',
            description: 'Implementăm automatizare completă și practici DevOps care accelerează livrarea și îmbunătățesc, în același timp, calitatea și fiabilitatea.',
            benefits: [
              'Pipeline-uri de deployment automatizate',
              'Gestionarea uniformă a mediilor',
              'Monitorizare și alertare complete',
              'Costuri operaționale reduse'
            ]
          }
        },
        features: [
          {
            title: 'Implementare pipeline CI/CD',
            description: 'Pipeline-uri automatizate de integrare continuă și deployment, pentru o livrare rapidă și fiabilă a software-ului.',
            capabilities: [
              'Procese automatizate de build și testare',
              'Automatizarea deploymentului și a rollbackului',
              'Flux de promovare între medii',
              'Puncte de control pentru calitate și aprobare'
            ]
          },
          {
            title: 'Infrastructure as Code',
            description: 'Automatizarea infrastructurii prin abordări bazate pe cod, pentru deployment-uri uniforme și repetabile.',
            capabilities: [
              'Automatizarea provisioningului infrastructurii',
              'Gestionarea configurației',
              'Versionarea infrastructurii',
              'Deployment și scalare automatizate'
            ]
          },
          {
            title: 'Automatizarea testării și a controlului calității',
            description: 'Framework-uri de testare automatizată și procese de asigurare a calității, pentru livrarea unui software de înaltă calitate.',
            capabilities: [
              'Teste automatizate unitare, de integrare și end-to-end',
              'Testare în cadrul integrării continue',
              'Analiza statică a codului și code review',
              'Raportarea calității și metrici'
            ]
          },
          {
            title: 'Monitorizare și observabilitate',
            description: 'Soluții de monitorizare și observabilitate pentru vizibilitate completă asupra performanței și stării sistemelor.',
            capabilities: [
              'Monitorizarea performanței și a stării sistemelor',
              'Jurnalizare centralizată și analiză',
              'Alerte și notificări automate',
              'Dashboard-uri și vizualizări'
            ]
          }
        ],
        technologies: {
          title: 'Stack tehnologic',
          description: 'Expertiză în platforme și instrumente de automatizare și DevOps.',
          platforms: [
            { name: 'Jenkins', category: 'Server de automatizare' },
            { name: 'GitLab CI/CD', category: 'Platformă CI/CD' },
            { name: 'GitHub Actions', category: 'Automatizarea fluxurilor de lucru' },
            { name: 'Terraform', category: 'Infrastructure as Code' },
            { name: 'Ansible', category: 'Automatizarea configurației' },
            { name: 'Docker', category: 'Containerizare' }
          ]
        },
        implementation: {
          title: 'Procesul de implementare',
          description: 'Abordare structurată pentru implementarea automatizării și a practicilor DevOps.',
          phases: [
            {
              phase: 'Evaluare și planificare',
              duration: '1-2 săptămâni',
              description: 'Evaluarea completă a proceselor IT actuale și elaborarea strategiei de automatizare.',
              deliverables: ['Analiza proceselor actuale', 'Documentul strategiei de automatizare', 'Selectarea instrumentelor și planificare', 'Roadmap de implementare']
            },
            {
              phase: 'Proiectare și configurare',
              duration: '2-3 săptămâni',
              description: 'Proiectarea pipeline-urilor, configurarea instrumentelor și pregătirea mediilor.',
              deliverables: ['Proiectarea pipeline-urilor', 'Configurarea instrumentelor', 'Pregătirea mediilor', 'Configurarea integrărilor']
            },
            {
              phase: 'Implementare și testare',
              duration: '2-4 săptămâni',
              description: 'Implementarea pipeline-urilor, testarea și validarea automatizării.',
              deliverables: ['Implementarea pipeline-urilor', 'Testarea automatizării', 'Validarea proceselor', 'Instruirea echipei']
            },
            {
              phase: 'Optimizare și suport',
              duration: 'Continuu',
              description: 'Optimizare continuă și suport pentru performanță și eficiență optime.',
              deliverables: ['Optimizarea performanței', 'Monitorizarea proceselor', 'Suport continuu', 'Îmbunătățire continuă']
            }
          ]
        },
        benefits: {
          title: 'Impact operațional',
          description: 'Aducem îmbunătățiri măsurabile ale eficienței operaționale și ale calității livrării.',
          outcomes: [
            {
              label: 'Timp de deployment redus',
              description: 'Pipeline-urile automatizate și procesele eficiente reduc semnificativ timpul de deployment.'
            },
            {
              label: 'Mai puține erori',
              description: 'Automatizarea și testarea reduc erorile umane și îmbunătățesc calitatea livrării.'
            },
            {
              label: 'Productivitate mai mare',
              description: 'Automatizarea proceselor manuale eliberează timp pentru activități cu valoare mai mare.'
            },
            {
              label: 'Medii uniforme',
              description: 'Infrastructure as code și automatizarea asigură uniformitatea tuturor mediilor.'
            }
          ]
        }
      },
      webDevelopment: {
        title: 'Dezvoltare web',
        subtitle: 'Aplicații web personalizate și site-uri',
        description: 'Livrăm site-uri și aplicații web ultrarapide, cu sisteme de design, integrare CMS și optimizare Core Web Vitals, care transformă vizitatorii în potențiali clienți calificați.',
        heroContent: {
          mainTitle: 'Dezvoltare web',
          subtitle: 'Servicii profesionale de dezvoltare, întreținere și optimizare web',
          keyPoints: [
            'Dezvoltarea de aplicații web personalizate',
            'Framework-uri și tehnologii moderne',
            'Design responsiv și experiența utilizatorului',
            'Optimizarea performanței și a securității'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Provocările transformării digitale',
            description: 'Organizațiile au nevoie de soluții web moderne pentru a concura pe piața digitală, dar se confruntă cu complexitate tehnică și resurse limitate.',
            challenges: [
              'Tehnologii web învechite, care limitează posibilitățile',
              'Experiență slabă a utilizatorilor, care afectează implicarea acestora',
              'Vulnerabilități de securitate și probleme de conformitate',
              'Limitări de scalabilitate și performanță'
            ]
          },
          solution: {
            title: 'Soluții web complete',
            description: 'Creăm aplicații web moderne care oferă o experiență excepțională utilizatorilor și asigură, în același timp, securitate, performanță și scalabilitate.',
            benefits: [
              'Aplicații web moderne, responsive',
              'Experiență îmbunătățită și implicare mai mare a utilizatorilor',
              'Securitate și conformitate robuste',
              'Arhitectură scalabilă și performanță'
            ]
          }
        },
        features: [
          {
            title: 'Dezvoltare personalizată',
            description: 'Aplicații web personalizate, construite cu framework-uri moderne și după bune practici, pentru performanță optimă și întreținere ușoară.',
            capabilities: [
              'Aplicații React și Next.js',
              'Dezvoltare backend Node.js',
              'Dezvoltare și integrare API',
              'Proiectare și optimizare baze de date'
            ]
          },
          {
            title: 'Designul experienței utilizatorului',
            description: 'Design intuitiv și responsive, care oferă o experiență excepțională pe toate dispozitivele și platformele.',
            capabilities: [
              'Design de interfață',
              'Web design responsive',
              'Optimizarea conversiilor',
              'Accesibilitate și conformitate'
            ]
          },
          {
            title: 'Optimizarea performanței',
            description: 'Optimizarea performanței și a vitezei, pentru o experiență rapidă și poziții mai bune în motoarele de căutare.',
            capabilities: [
              'Optimizarea vitezei de încărcare',
              'Optimizarea imaginilor și a resurselor',
              'Optimizare Core Web Vitals',
              'Optimizare SEO și indexare'
            ]
          },
          {
            title: 'Securitate și conformitate',
            description: 'Măsuri de securitate robuste și conformitate, pentru protecția datelor și respectarea cerințelor de reglementare.',
            capabilities: [
              'Securizarea aplicației',
              'Protecție date și confidențialitate',
              'Conformitate cu GDPR și reglementările aplicabile',
              'Monitorizarea securității și audit'
            ]
          }
        ],
        technologies: {
          title: 'Stack tehnologic',
          description: 'Expertiză în framework-uri și tehnologii web moderne.',
          platforms: [
            { name: 'React', category: 'Framework frontend' },
            { name: 'Next.js', category: 'Framework full-stack' },
            { name: 'Node.js', category: 'Runtime backend' },
            { name: 'TypeScript', category: 'Limbaj tipizat' },
            { name: 'Tailwind CSS', category: 'Framework CSS' },
            { name: 'Vite', category: 'Instrument de build' }
          ]
        },
        implementation: {
          title: 'Procesul de dezvoltare',
          description: 'Abordare structurată pentru dezvoltarea de aplicații web de înaltă calitate.',
          phases: [
            {
              phase: 'Planificare și proiectare',
              duration: '1-2 săptămâni',
              description: 'Planificarea proiectului, proiectarea arhitecturii și elaborarea strategiei.',
              deliverables: ['Documentul cerințelor', 'Proiectarea arhitecturii', 'Mockup-uri de design', 'Planul proiectului']
            },
            {
              phase: 'Dezvoltare și implementare',
              duration: '4-8 săptămâni',
              description: 'Dezvoltarea aplicației, implementarea funcționalităților și integrare.',
              deliverables: ['Dezvoltare frontend', 'Dezvoltare backend', 'Integrare API', 'Testare funcțională']
            },
            {
              phase: 'Testare și optimizare',
              duration: '1-2 săptămâni',
              description: 'Testare completă, optimizarea performanței și remedierea problemelor.',
              deliverables: ['Testare cu utilizatori', 'Optimizarea performanței', 'Remedierea problemelor', 'Validarea calității']
            },
            {
              phase: 'Lansare și suport',
              duration: 'Continuu',
              description: 'Lansarea aplicației, monitorizare și suport continuu.',
              deliverables: ['Lansare în producție', 'Monitorizarea performanței', 'Suport continuu', 'Îmbunătățiri continue']
            }
          ]
        },
        benefits: {
          title: 'Impact asupra afacerii',
          description: 'Aducem îmbunătățiri măsurabile ale experienței utilizatorilor și ale rezultatelor afacerii.',
          outcomes: [
            {
              label: 'Site mai rapid',
              description: 'Optimizarea performanței îmbunătățește semnificativ viteza site-ului și experiența utilizatorilor.'
            },
            {
              label: 'Rată de conversie mai bună',
              description: 'Designul modern și experiența optimizată a utilizatorilor cresc ratele de conversie.'
            },
            {
              label: 'Securitate și conformitate',
              description: 'Măsurile de securitate robuste și conformitatea asigură protecția datelor și respectarea cerințelor de reglementare.'
            },
            {
              label: 'Costuri de mentenanță reduse',
              description: 'Arhitectura modernă și codul de calitate reduc costurile de mentenanță pe termen lung.'
            }
          ]
        }
      }
    },
    legal: {
      label: 'Informații juridice'
    },
    privacyPolicy: {
      title: 'Politica de confidențialitate',
      lastUpdated: 'Ultima actualizare',
      sections: {
        introduction: {
          title: '1. Introducere',
          paragraph1: 'Byteet („noi”, „ne” sau „al nostru”) este dedicat protejării confidențialității și datelor tale personale. Această Politică de Confidențialitate explică modul în care colectăm, folosim, dezvăluim și protejăm informațiile tale când vizitezi site-ul nostru <a href="https://byteet.md" className="text-blue-600 hover:underline">https://byteet.md</a> sau folosești serviciile noastre.',
          paragraph2: 'Această Politică de Confidențialitate este în conformitate cu Regulamentul general privind protecția datelor (UE) 2016/679 (GDPR) și cu reglementările privind protecția datelor aplicabile în Moldova. Prin utilizarea site-ului și a serviciilor noastre, consimți la practicile privind datele descrise în această politică.'
        },
        dataController: {
          title: '2. Operatorul de date',
          paragraph: 'Byteet este operatorul de date responsabil pentru datele tale personale. Informațiile noastre de contact sunt:',
          companyName: 'Denumirea companiei',
          address: 'Adresă',
          email: 'E-mail',
          phone: 'Telefon'
        },
        informationWeCollect: {
          title: '3. Informațiile pe care le colectăm',
          personalDataTitle: '3.1 Date personale pe care ni le furnizezi',
          paragraph: 'Putem colecta următoarele date personale când:',
          contactUs: 'Ne contactezi:',
          contactUsItems: 'Numele, adresa de e-mail, numărul de telefon, denumirea companiei și orice informație pe care o furnizezi în mesajul tău',
          requestQuote: 'Soliciți o ofertă:',
          requestQuoteItems: 'Numele, adresa de e-mail, numărul de telefon, denumirea companiei, serviciile de care ești interesat și detaliile proiectului',
          subscribeNewsletter: 'Te abonezi la newsletterul nostru:',
          subscribeNewsletterItems: 'Adresa de e-mail și numele (dacă este furnizat)',
          automaticallyCollectedTitle: '3.2 Informații colectate automat',
          automaticallyCollectedParagraph: 'Când vizitezi site-ul nostru, colectăm automat anumite informații, inclusiv:',
          technicalData: 'Date tehnice:',
          technicalDataItems: 'Adresa IP, tipul și versiunea browserului, tipul dispozitivului, sistemul de operare, fusul orar și datele de localizare',
          usageData: 'Date de utilizare:',
          usageDataItems: 'Paginile vizitate, timpul petrecut pe pagini, tiparele de clic, sursele de trimitere și traseele de navigare',
          cookiesTracking: 'Cookie-uri și tehnologii de urmărire:',
          cookiesTrackingItems: 'Folosim cookie-uri și tehnologii similare de urmărire. Pentru informații detaliate, te rugăm să consulți secțiunea despre politica privind cookie-urile, de mai jos.'
        },
        legalBasis: {
          title: '4. Baza legală pentru prelucrare',
          paragraph: 'Prelucrăm datele tale personale pe baza următoarelor temeiuri legale conform GDPR:',
          consent: 'Consimțământ:',
          consentItems: 'Când îți dai consimțământul explicit pentru activități specifice de prelucrare (de exemplu, comunicări de marketing)',
          contractualNecessity: 'Necesitate contractuală:',
          contractualNecessityItems: 'Pentru a presta serviciile noastre și a îndeplini obligațiile contractuale',
          legitimateInterests: 'Interese legitime:',
          legitimateInterestsItems: 'Pentru analiza site-ului, securitate, prevenirea fraudelor și operațiuni de afaceri (cu excepția cazului în care interesele sau drepturile și libertățile tale fundamentale prevalează asupra acestor interese)',
          legalObligations: 'Obligații legale:',
          legalObligationsItems: 'Pentru a respecta legile și reglementările aplicabile'
        },
        howWeUse: {
          title: '5. Cum folosim informațiile tale',
          paragraph: 'Folosim informațiile colectate în următoarele scopuri:',
          items: [
            'Pentru a răspunde la întrebările tale și a oferi suport pentru clienți',
            'Pentru a procesa și gestiona cereri de servicii și oferte',
            'Pentru a livra serviciile noastre IT (administrarea dispozitivelor, soluții cloud, dezvoltare web etc.)',
            'Pentru a-ți trimite comunicări de marketing (cu consimțământul tău)',
            'Pentru a îmbunătăți site-ul nostru, serviciile și experiența utilizatorului',
            'Pentru a analiza utilizarea site-ului și tendințele',
            'Pentru a asigura securitatea site-ului și a preveni fraudele',
            'Pentru a respecta obligațiile legale și a aplica termenii noștri'
          ]
        },
        cookies: {
          title: '6. Cookie-uri și tehnologii de urmărire',
          paragraph1: 'Folosim cookie-uri și tehnologii similare de urmărire pentru a-ți îmbunătăți experiența de navigare, a analiza traficul site-ului și a personaliza conținutul. Îți poți controla preferințele privind cookie-urile prin bannerul nostru de consimțământ sau din setările browserului tău.',
          typesTitle: 'Tipuri de cookie-uri pe care le folosim:',
          essentialCookies: 'Cookie-uri esențiale:',
          essentialCookiesItems: 'Sunt necesare pentru funcționarea site-ului și nu pot fi dezactivate',
          analyticsCookies: 'Cookie-uri de analiză:',
          analyticsCookiesItems: 'Ne ajută să înțelegem cum interacționează vizitatorii cu site-ul nostru (de exemplu, Google Analytics)',
          marketingCookies: 'Cookie-uri de marketing:',
          marketingCookiesItems: 'Folosite pentru a livra reclame relevante și a urmări eficacitatea campaniilor',
          paragraph2: 'Pentru mai multe informații despre practicile noastre privind cookie-urile, te rugăm să consulți setările de preferințe pentru cookie-uri, accesibile pe site-ul nostru.'
        },
        dataSharing: {
          title: '7. Partajarea și dezvăluirea datelor',
          paragraph1: 'Putem partaja datele tale personale cu:',
          serviceProviders: 'Furnizori de servicii:',
          serviceProvidersItems: 'Furnizori terți care ne ajută în operarea site-ului, desfășurarea afacerii sau deservirea utilizatorilor (de exemplu, furnizori de hosting, servicii de analiză, servicii de e-mail)',
          businessPartners: 'Parteneri de afaceri:',
          businessPartnersItems: 'Parteneri de încredere care ne ajută să livrăm servicii (doar când este necesar și cu garanții adecvate)',
          legalRequirements: 'Cerințe legale:',
          legalRequirementsItems: 'Când este cerut de lege, ordin judecătoresc sau reglementare guvernamentală',
          businessTransfers: 'Transferuri de afaceri:',
          businessTransfersItems: 'În legătură cu o fuziune, achiziție sau vânzare de active (cu notificare către utilizatorii afectați)',
          paragraph2: 'Nu vindem datele tale personale către terți. Toți terții sunt obligați contractual să-ți protejeze datele și să le folosească doar în scopuri specificate.'
        },
        internationalTransfers: {
          title: '8. Transferuri internaționale de date',
          paragraph: 'Datele tale personale pot fi transferate și prelucrate în țări din afara Spațiului Economic European (SEE). Când transferăm date în afara SEE, ne asigurăm că există garanții adecvate, cum ar fi:',
          items: [
            'Clauze contractuale standard aprobate de Comisia Europeană',
            'Decizii privind caracterul adecvat adoptate de Comisia Europeană',
            'Alte mecanisme de transfer recunoscute legal'
          ]
        },
        dataRetention: {
          title: '9. Păstrarea datelor',
          paragraph1: 'Păstrăm datele tale personale doar atât timp cât este necesar pentru a îndeplini scopurile prezentate în această Politică de Confidențialitate, cu excepția cazului în care o perioadă de păstrare mai lungă este cerută sau permisă de lege. Perioadele de păstrare variază în funcție de:',
          items: [
            'Natura datelor și scopul prelucrării',
            'Cerințele legale și de reglementare',
            'Obligațiile contractuale',
            'Interesele legitime de afaceri'
          ],
          paragraph2: 'Când datele personale nu mai sunt necesare, le ștergem în siguranță sau le anonimizăm în conformitate cu politicile noastre de păstrare a datelor.'
        },
        yourRights: {
          title: '10. Drepturile tale conform GDPR',
          paragraph: 'Ca persoană vizată, ai următoarele drepturi:',
          rightOfAccess: 'Dreptul de acces:',
          rightOfAccessItems: 'Solicită o copie a datelor tale personale pe care le deținem',
          rightToRectification: 'Dreptul la rectificare:',
          rightToRectificationItems: 'Solicită corectarea datelor inexacte sau incomplete',
          rightToErasure: 'Dreptul la ștergere („dreptul de a fi uitat”):',
          rightToErasureItems: 'Solicită ștergerea datelor tale personale în anumite circumstanțe',
          rightToRestrict: 'Dreptul la restricționarea prelucrării:',
          rightToRestrictItems: 'Solicită limitarea modului în care prelucrăm datele tale',
          rightToPortability: 'Dreptul la portabilitatea datelor:',
          rightToPortabilityItems: 'Primește datele tale într-un format structurat, utilizat în mod obișnuit',
          rightToObject: 'Dreptul de opoziție:',
          rightToObjectItems: 'Opune-te prelucrării bazate pe interese legitime sau în scop de marketing direct',
          rightToWithdraw: 'Dreptul de a retrage consimțământul:',
          rightToWithdrawItems: 'Retrage-ți consimțământul în orice moment, atunci când prelucrarea se bazează pe consimțământ',
          paragraph2: 'Pentru a exercita aceste drepturi, te rugăm să ne contactezi la <a href="mailto:info@byteet.md" className="text-blue-600 hover:underline">info@byteet.md</a>. Vom răspunde la cererea ta în termen de o lună (poate fi prelungit cu două luni pentru cereri complexe).'
        },
        dataSecurity: {
          title: '11. Securitatea datelor',
          paragraph1: 'Implementăm măsuri tehnice și organizaționale adecvate pentru a-ți proteja datele personale împotriva accesului neautorizat, alterării, dezvăluirii sau distrugerii. Aceste măsuri includ:',
          items: [
            'Criptarea datelor în tranzit și în repaus',
            'Evaluări și actualizări de securitate regulate',
            'Controale de acces și mecanisme de autentificare',
            'Proceduri sigure de stocare a datelor și de backup',
            'Instruirea angajaților privind protecția datelor'
          ],
          paragraph2: 'Cu toate acestea, nicio metodă de transmitere prin internet sau de stocare electronică nu este 100% sigură. Deși ne străduim să-ți protejăm datele, nu putem garanta securitatea absolută.'
        },
        childrenPrivacy: {
          title: '12. Confidențialitatea copiilor',
          paragraph: 'Serviciile noastre nu sunt destinate persoanelor sub vârsta de 16 ani. Nu colectăm în mod conștient date personale de la copii. Dacă crezi că am colectat date de la un copil, te rugăm să ne contactezi imediat și vom lua măsuri pentru a șterge astfel de informații.'
        },
        changes: {
          title: '13. Modificări ale acestei politici de confidențialitate',
          paragraph1: 'Putem actualiza această Politică de Confidențialitate din când în când pentru a reflecta modificările practicilor noastre sau ale cerințelor legale. Te vom notifica despre orice modificări esențiale prin:',
          items: [
            'Postarea politicii actualizate pe această pagină, cu o nouă dată la „Ultima actualizare”',
            'Trimiterea unei notificări prin e-mail (pentru modificări semnificative)',
            'Afișarea unui anunț pe site-ul nostru'
          ],
          paragraph2: 'Utilizarea continuă a site-ului nostru după intrarea în vigoare a modificărilor constituie acceptarea Politicii de Confidențialitate actualizate.'
        },
        complaints: {
          title: '14. Plângeri',
          paragraph1: 'Dacă ai nemulțumiri privind modul în care gestionăm datele tale personale, ai dreptul de a depune o plângere la Centrul Național pentru Protecția Datelor cu Caracter Personal al Republicii Moldova:',
          website: 'Site web:',
          phone: 'Telefon:',
          paragraph2: 'Te încurajăm să ne contactezi mai întâi la <a href="mailto:info@byteet.md" className="text-blue-600 hover:underline">info@byteet.md</a> pentru a lămuri orice nemulțumire.'
        },
        contactUs: {
          title: '15. Contactează-ne',
          paragraph: 'Dacă ai întrebări, nelămuriri sau cereri privind această Politică de Confidențialitate sau practicile noastre privind datele, te rugăm să ne contactezi:',
          email: 'E-mail:',
          phone: 'Telefon:',
          address: 'Adresă:'
        }
      }
    },
    termsOfService: {
      title: 'Termeni și Condiții',
      lastUpdated: 'Ultima actualizare',
      sections: {
        acceptance: {
          title: '1. Acceptarea Termenilor',
          paragraph1: 'Prin accesarea și utilizarea site-ului <a href="https://byteet.md" className="text-blue-600 hover:underline">https://byteet.md</a> („Site-ul”) și a serviciilor furnizate de Byteet („noi”, „ne” sau „al nostru”), ești de acord să respecți acești Termeni și Condiții („Termenii”). Dacă nu ești de acord cu acești Termeni, te rugăm să nu folosești Site-ul sau serviciile noastre.',
          paragraph2: 'Acești Termeni constituie un acord legal obligatoriu între tine și Byteet. Ne rezervăm dreptul de a modifica acești Termeni în orice moment. Utilizarea continuă a Site-ului sau a serviciilor noastre după intrarea în vigoare a modificărilor constituie acceptarea Termenilor actualizați.'
        },
        companyInfo: {
          title: '2. Informații despre companie',
          paragraph: 'Byteet operează ca furnizor de servicii IT. Informațiile noastre de contact sunt:',
          companyName: 'Denumirea companiei',
          address: 'Adresă',
          email: 'E-mail',
          phone: 'Telefon',
          website: 'Site web'
        },
        servicesDescription: {
          title: '3. Descrierea serviciilor',
          paragraph1: 'Byteet oferă servicii IT profesionale, inclusiv, dar fără a se limita la:',
          items: [
            'Administrarea dispozitivelor (Microsoft Intune, SCCM, Jamf Pro, Active Directory)',
            'Soluții cloud și administrare (Microsoft 365, Google Workspace)',
            'Managementul identităților și al accesului (Okta, CyberArk, Active Directory)',
            'Automatizare IT și DevOps',
            'Dezvoltare web și aplicații web personalizate',
            'Administrarea bazelor de date',
            'Data Engineering',
            'Suport IT și service desk',
            'Managementul infrastructurii',
            'Gestionarea bazei de cunoștințe'
          ],
          paragraph2: 'Descrierile serviciilor, prețurile și disponibilitatea pot fi modificate fără notificare prealabilă. Ne rezervăm dreptul de a modifica, suspenda sau întrerupe orice serviciu în orice moment.'
        },
        useOfWebsite: {
          title: '4. Utilizarea Site-ului',
          permittedUseTitle: '4.1 Utilizare permisă',
          permittedUseParagraph: 'Poți folosi Site-ul nostru doar în scopuri legale. Ești de acord să:',
          permittedUseItems: [
            'Furnizezi informații exacte și complete când ne contactezi sau soliciți servicii',
            'Folosești Site-ul în conformitate cu toate legile și reglementările aplicabile',
            'Respecți drepturile de proprietate intelectuală',
            'Nu interferezi cu funcționarea Site-ului și nu o întrerupi'
          ],
          prohibitedTitle: '4.2 Activități interzise',
          prohibitedParagraph: 'Ești de acord să nu:',
          prohibitedItems: [
            'Folosești Site-ul în orice scop ilegal sau neautorizat',
            'Încerci să obții acces neautorizat la sistemele sau rețelele noastre',
            'Transmiți viruși, malware sau orice cod dăunător',
            'Faci scraping sau crawling ori folosești instrumente automate pentru a accesa Site-ul fără permisiune',
            'Te dai drept altă persoană sau entitate',
            'Încalci legile sau reglementările aplicabile'
          ]
        },
        serviceAgreements: {
          title: '5. Acorduri de servicii',
          paragraph1: 'Când angajezi Byteet pentru servicii IT, se va încheia un acord de servicii sau un contract separat. Termenii acelui acord vor reglementa serviciile specifice furnizate. În caz de conflict între acești Termeni și un acord de servicii, acordul de servicii va avea prioritate pentru acele servicii specifice.',
          paragraph2: 'Acordurile de servicii vor include, dar fără a se limita la:',
          items: [
            'Domeniul de aplicare al serviciilor',
            'Prețurile și termenii de plată',
            'Acordurile de nivel de serviciu (SLA)',
            'Cronogramele proiectului și livrabilele',
            'Drepturile de proprietate intelectuală',
            'Obligațiile de confidențialitate',
            'Condițiile de reziliere'
          ]
        },
        pricing: {
          title: '6. Prețuri și plată',
          paragraph1: 'Prețurile pentru serviciile noastre vor fi furnizate în oferte sau acorduri de servicii. Toate prețurile sunt exprimate în euro (EUR), dacă nu se specifică altfel, și nu includ TVA, acolo unde aceasta se aplică.',
          paragraph2: 'Termenii de plată vor fi specificați în acordurile de servicii individuale. În general:',
          items: [
            'Plata este datorată conform termenilor specificați în acordul de servicii',
            'Plățile întârziate pot genera dobânzi, în limitele permise de lege',
            'Ne rezervăm dreptul de a suspenda serviciile pentru neplată',
            'Toate tarifele achitate sunt nerambursabile, dacă nu se specifică altfel sau dacă legea nu prevede altfel'
          ]
        },
        rightOfWithdrawal: {
          title: '7. Dreptul de retragere (drepturile consumatorilor din UE)',
          paragraph1: 'Dacă ești un consumator (nu acționezi în scopuri comerciale) în Uniunea Europeană, ai dreptul de a te retrage dintr-un contract de servicii în termen de 14 zile de la încheierea contractului, cu excepția cazului în care:',
          items: [
            'Serviciul a fost complet executat cu consimțământul tău explicit și recunoașterea că vei pierde dreptul de retragere odată ce serviciul este finalizat',
            'Serviciul este personalizat sau adaptat specificațiilor tale',
            'Serviciul constă într-o lucrare urgentă de reparație sau întreținere'
          ],
          paragraph2: 'Pentru a exercita dreptul de retragere, te rugăm să ne contactezi la <a href="mailto:info@byteet.md" className="text-blue-600 hover:underline">info@byteet.md</a> în perioada de retragere. Dacă ai primit deja servicii, poate fi necesar să plătești pentru serviciile furnizate până la momentul retragerii.'
        },
        intellectualProperty: {
          title: '8. Proprietate intelectuală',
          websiteContentTitle: '8.1 Conținutul Site-ului',
          websiteContentParagraph: 'Tot conținutul de pe acest Site, inclusiv text, grafică, logouri, imagini, software și design, este proprietatea Byteet sau a licențiatorilor săi și este protejat de legile privind drepturile de autor și mărcile comerciale și de alte legi privind proprietatea intelectuală.',
          deliverablesTitle: '8.2 Livrabilele serviciilor',
          deliverablesParagraph: 'Drepturile de proprietate intelectuală asupra livrabilelor serviciilor vor fi specificate în acordurile de servicii individuale. În general:',
          deliverablesItems: [
            'Proprietatea intelectuală preexistentă rămâne în posesia proprietarului inițial',
            'Soluțiile dezvoltate la comandă pot fi cedate clientului, conform prevederilor acordului',
            'Byteet își poate păstra dreptul de a folosi metodologii generale, instrumente și know-how'
          ]
        },
        confidentiality: {
          title: '9. Confidențialitate',
          paragraph1: 'Înțelegem natura sensibilă a serviciilor IT și a informațiilor despre clienți. Ne angajăm să:',
          items: [
            'Păstrăm strict confidențialitatea informațiilor și datelor clienților',
            'Nu dezvăluim informații confidențiale către terți fără autorizație',
            'Implementăm măsuri de securitate adecvate pentru a proteja informațiile confidențiale',
            'Respectăm legile aplicabile de protecție a datelor (vezi Politica noastră de Confidențialitate)'
          ],
          paragraph2: 'Obligațiile detaliate de confidențialitate vor fi specificate în acordurile de servicii individuale.'
        },
        warranties: {
          title: '10. Garanții și excluderi de răspundere',
          serviceWarrantiesTitle: '10.1 Garanții privind serviciile',
          serviceWarrantiesParagraph: 'Garantăm că serviciile vor fi executate cu pricepere și grijă rezonabilă în conformitate cu standardele industriei. Garanțiile specifice, dacă există, vor fi detaliate în acordurile de servicii individuale.',
          disclaimersTitle: '10.2 Excluderi de răspundere privind Site-ul',
          disclaimersParagraph: 'SITE-UL ȘI CONȚINUTUL SĂU SUNT FURNIZATE „CA ATARE” ȘI „ÎN MĂSURA DISPONIBILITĂȚII”, FĂRĂ GARANȚII DE NICIUN FEL, EXPRESE SAU IMPLICITE, INCLUSIV, DAR FĂRĂ A SE LIMITA LA:',
          disclaimersItems: [
            'Garanții de vandabilitate sau de adecvare la un anumit scop',
            'Garanții că Site-ul va fi neîntrerupt, sigur sau fără erori',
            'Garanții privind exactitatea, completitudinea sau fiabilitatea conținutului'
          ]
        },
        limitationOfLiability: {
          title: '11. Limitarea răspunderii',
          paragraph1: 'În măsura maximă permisă de legea aplicabilă:',
          items: [
            'Răspunderea totală a Byteet pentru orice pretenții care decurg din acești Termeni sau din serviciile noastre nu va depăși suma totală a tarifelor plătite de tine, în cele 12 luni anterioare pretenției, pentru serviciile specifice care au generat-o',
            'Nu vom fi răspunzători pentru daune indirecte, incidentale, speciale, subsecvente sau punitive, inclusiv pierderea de profit, de date sau de oportunități de afaceri',
            'Nu vom fi răspunzători pentru daune rezultate din servicii, software sau platforme ale terților, folosite în legătură cu serviciile noastre'
          ],
          paragraph2: 'Nimic în acești Termeni nu exclude sau limitează răspunderea noastră pentru:',
          exceptions: [
            'Decesul sau vătămarea corporală cauzate de neglijența noastră',
            'Frauda sau declarațiile frauduloase',
            'Orice răspundere care nu poate fi exclusă sau limitată conform legii aplicabile'
          ]
        },
        indemnification: {
          title: '12. Despăgubire',
          paragraph: 'Ești de acord să despăgubești, să aperi și să exonerezi de răspundere Byteet, precum și persoanele cu funcții de conducere, administratorii, angajații și agenții săi, pentru orice pretenții, daune, pierderi, răspunderi, costuri și cheltuieli (inclusiv onorarii rezonabile de avocat) care rezultă din:',
          items: [
            'Utilizarea de către tine a Site-ului sau a serviciilor',
            'Încălcarea de către tine a acestor Termeni',
            'Încălcarea de către tine a oricăror drepturi ale terților',
            'Orice conținut sau informație pe care o furnizezi'
          ]
        },
        termination: {
          title: '13. Reziliere',
          paragraph1: 'Ne rezervăm dreptul de a rezilia sau suspenda accesul tău la Site sau la servicii imediat, fără notificare prealabilă, pentru:',
          items: [
            'Încălcarea acestor Termeni',
            'Activitate frauduloasă sau ilegală',
            'Neplata tarifelor',
            'Orice alt motiv pe care îl considerăm necesar pentru a ne proteja interesele'
          ],
          paragraph2: 'Rezilierea acordurilor de servicii va fi reglementată de termenii specificați în acele acorduri.'
        },
        disputeResolution: {
          title: '14. Soluționarea litigiilor',
          odrTitle: '14.1 Soluționarea online a litigiilor în UE',
          odrParagraph: 'Dacă ești un consumator în Uniunea Europeană, poți folosi platforma de soluționare online a litigiilor a Comisiei Europene la <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">https://ec.europa.eu/consumers/odr</a> pentru a soluționa litigii.',
          governingLawTitle: '14.2 Legea aplicabilă și jurisdicția',
          governingLawParagraph: 'Acești Termeni sunt guvernați de legislația Republicii Moldova. Orice litigii care decurg din acești Termeni sau din serviciile noastre vor fi supuse jurisdicției exclusive a instanțelor judecătorești din Chișinău, Moldova, cu excepția cazului în care dispozițiile imperative privind protecția consumatorilor prevăd altfel.'
        },
        forceMajeure: {
          title: '15. Forța majoră',
          paragraph: 'Nu vom fi răspunzători pentru neexecutarea sau întârzierea executării obligațiilor prevăzute de acești Termeni din cauza unor circumstanțe aflate în afara controlului nostru rezonabil, inclusiv, dar fără a se limita la:',
          items: [
            'Dezastre naturale',
            'Război, terorism sau tulburări civile',
            'Pandemii sau urgențe de sănătate publică',
            'Acțiuni sau reglementări guvernamentale',
            'Defecțiuni ale internetului sau ale telecomunicațiilor',
            'Defecțiuni ale furnizorilor terți de servicii'
          ]
        },
        severability: {
          title: '16. Separabilitate',
          paragraph: 'Dacă oricare dispoziție a acestor Termeni este considerată invalidă, ilegală sau inaplicabilă, celelalte dispoziții rămân pe deplin în vigoare. Dispoziția invalidă va fi înlocuită cu o dispoziție validă care reflectă cât mai fidel intenția dispoziției inițiale.'
        },
        entireAgreement: {
          title: '17. Acordul integral',
          paragraph: 'Acești Termeni, împreună cu Politica noastră de Confidențialitate și orice acorduri de servicii aplicabile, constituie acordul complet între tine și Byteet privind utilizarea Site-ului și a serviciilor noastre, înlocuind toate acordurile și înțelegerile anterioare.'
        },
        changesToTerms: {
          title: '18. Modificări ale Termenilor',
          paragraph1: 'Ne rezervăm dreptul de a modifica acești Termeni în orice moment. Modificările esențiale vor fi comunicate prin:',
          items: [
            'Postarea Termenilor actualizați pe această pagină, cu o nouă dată la „Ultima actualizare”',
            'Trimiterea unei notificări prin e-mail (pentru modificări semnificative)',
            'Afișarea unui anunț pe Site-ul nostru'
          ],
          paragraph2: 'Utilizarea continuă a Site-ului sau a serviciilor noastre după intrarea în vigoare a modificărilor constituie acceptarea Termenilor actualizați.'
        },
        contactInfo: {
          title: '19. Informații de contact',
          paragraph: 'Dacă ai întrebări despre acești Termeni, te rugăm să ne contactezi:',
          email: 'E-mail:',
          phone: 'Telefon:',
          address: 'Adresă:'
        }
      }
    }
  },
  ru: {
    nav: {
      home: 'Главная',
      services: 'Услуги',
      portfolio: 'Портфолио',
      about: 'О нас',
      articles: 'Статьи',
      contact: 'Контакты',
      getConsultation: 'Запросить предложение',
      getConsultationShort: 'Заявка',
      bookCall: 'Записаться на звонок',
      openMenu: 'Меню',
      closeMenu: 'Закрыть'
    },
    cookies: {
      banner: {
        title: 'Настройки cookie',
        description: 'Мы используем cookie, чтобы сделать сайт удобнее и анализировать трафик. Вы можете принять все cookie, отклонить необязательные или управлять своими настройками. Подробнее см.',
        cookiePolicy: 'Политику cookie',
        acceptAll: 'Принять все',
        rejectAll: 'Отклонить все',
        managePreferences: 'Управление настройками'
      },
      preferences: {
        title: 'Настройки cookie',
        description: 'Управляйте настройками cookie. Вы можете включать или отключать различные типы cookie ниже. Строго необходимые cookie всегда включены, поскольку они необходимы для правильной работы сайта.',
        strictlyNecessary: {
          title: 'Строго необходимые cookie',
          description: 'Эти cookie необходимы для правильной работы сайта. Они обеспечивают базовые функции, такие как безопасность, управление сетью и доступность. Вы не можете отключить эти cookie.',
          examplesTitle: 'Примеры:',
          examples: [
            'Управление сеансом',
            'Функции безопасности',
            'Балансировка нагрузки',
            'Настройки согласия на cookie'
          ]
        },
        analytics: {
          title: 'Аналитические cookie',
          description: 'Эти cookie помогают нам понять, как посетители взаимодействуют с сайтом, собирая и передавая информацию в анонимном виде. Это помогает нам улучшать сайт и делать его удобнее.',
          examplesTitle: 'Примеры:',
          examples: [
            'Google Analytics 4 (GA4) — если включено',
            'Отслеживание просмотров страниц',
            'Анализ поведения пользователей',
            'Метрики производительности',
            'Защищённые cookie Google (__Secure-3PAPISID, __Secure-3PSID и т. д.)'
          ],
          disabledNote: 'Примечание: Аналитические cookie в настоящее время отключены. Никакие скрипты отслеживания не будут загружены, пока вы не включите эту опцию.',
          viewDetails: 'Подробнее о cookie Google',
          googleCookiesInfo: 'Когда аналитика включена, Google может установить следующие защищённые cookie:',
          googleCookies: [
            '__Secure-3PAPISID — аутентификация в API Google',
            '__Secure-3PSID — идентификатор сеанса Google',
            '__Secure-3PSIDCC — сеанс Google с согласием',
            '__Secure-1PAPISID — API Google (first-party)',
            '__Secure-1PSID — сеанс Google (first-party)',
            '_ga, _gid — Google Analytics'
          ],
          googleCookiesNote: 'Эти cookie устанавливаются доменами Google и подчиняются настройкам сторонних cookie вашего браузера. Они помогают персонализировать сервисы и измерять производительность сайта.'
        },
        privacySection: {
          title: 'О вашей конфиденциальности',
          description: 'Мы уважаем вашу конфиденциальность и соблюдаем требования GDPR и Директивы ЕС об электронной конфиденциальности. Ваши настройки согласия хранятся локально в вашем браузере и могут быть изменены в любое время. Для получения дополнительной информации, пожалуйста, прочитайте',
          cookiePolicy: 'Политику cookie',
          and: 'и',
          privacyPolicy: 'Политику конфиденциальности'
        },
        buttons: {
          clearAll: 'Очистить все данные',
          rejectAll: 'Отклонить все',
          acceptAll: 'Принять все',
          savePreferences: 'Сохранить настройки'
        }
      }
    },
    seo: {
      home: {
        title: 'Создание сайтов и веб-сервисов в Молдове | Byteet',
        description: 'Byteet создаёт сайты, интернет-магазины и веб-приложения для бизнеса в Кишинёве и Молдове и обслуживает ИТ за ними: облако, безопасность и поддержка.'
      },
      about: {
        title: 'О Byteet — ИТ-услуги в Молдове | Byteet',
        description: 'Узнайте о Byteet — надёжном ИТ-партнёре в Молдове, который специализируется на разработке сайтов, облачных решениях, управлении устройствами, идентификацией и доступом, а также на комплексных ИТ-услугах.'
      },
      contact: {
        title: 'Связаться с Byteet — ИТ-консультации в Молдове | Byteet',
        description: 'Свяжитесь с Byteet, чтобы получить экспертную ИТ-консультацию в Молдове. Разработка сайтов, облачные решения, управление устройствами и ИТ-поддержка. Быстрая и надёжная поддержка.'
      },
      services: {
        title: 'ИТ-услуги в Молдове: аутсорсинг, облако, сайты | Byteet',
        description: 'Полный спектр ИТ-услуг в Кишинёве и Молдове: ИТ-аутсорсинг и поддержка 24/7, облако и Microsoft 365, кибербезопасность, базы данных, ИИ-автоматизация и создание сайтов.'
      },
      portfolio: {
        title: 'Портфолио — ИТ-решения и кейсы в Молдове | Byteet',
        description: 'Портфолио Byteet: успешные ИТ-внедрения и кейсы в Молдове. Реальные примеры облачных решений, разработки сайтов, внедрения управления устройствами и автоматизации, которые мы реализовали для бизнеса.'
      },
      privacy: {
        title: 'Политика конфиденциальности — Byteet | Соответствие GDPR в Молдове',
        description: 'Политика конфиденциальности Byteet объясняет, как мы собираем, используем и защищаем ваши персональные данные в соответствии с GDPR и правилами защиты данных в Молдове.'
      },
      terms: {
        title: 'Условия использования — Byteet | Юридические условия',
        description: 'Прочитайте Условия использования Byteet, чтобы понять юридические условия, регулирующие использование нашего сайта и ИТ-услуг в Молдове.'
      },
      book: {
        title: 'Бесплатная ИТ-консультация онлайн | Byteet',
        description: 'Запишитесь на бесплатную {minutes}-минутную ИТ-консультацию с Byteet в Google Meet. Выберите удобное время — приглашение придёт на почту. Без обязательств.'
      },
      notFound: {
        title: 'Страница не найдена — Byteet',
        description: 'Страница, которую вы ищете, не найдена. Вернитесь на главную страницу Byteet, чтобы познакомиться с нашими ИТ-услугами.'
      }
    },
    serviceSeo: {
      'managed-it-support': {
        title: 'ИТ-аутсорсинг и техподдержка 24/7 в Молдове | Byteet',
        description: 'ИТ-аутсорсинг и техподдержка 24/7 в Кишинёве и Молдове: helpdesk, обслуживание устройств, серверы и сети, абонентское обслуживание с SLA.'
      },
      'cloud-infrastructure': {
        title: 'Облачные услуги и миграция в облако в Молдове | Byteet',
        description: 'Облачные услуги в Кишинёве и Молдове: Microsoft 365 и Google Workspace, миграция в облако без остановки, серверы, виртуализация, частное облако и бэкап.'
      },
      'cybersecurity-identity': {
        title: 'Кибербезопасность для бизнеса в Молдове | Byteet',
        description: 'Кибербезопасность для бизнеса в Кишинёве и Молдове: аудит ИБ, MFA/IAM, защита конечных точек (EDR) и соответствие Закону 195/2024 (GDPR).'
      },
      'data-databases': {
        title: 'Базы данных, бэкап и восстановление в Молдове | Byteet',
        description: 'Услуги баз данных в Кишинёве и Молдове: администрирование и оптимизация PostgreSQL, MySQL, SQL Server, миграция, автоматический бэкап, восстановление данных и бизнес-аналитика.'
      },
      'ai-automation': {
        title: 'Автоматизация с ИИ и чат-боты для бизнеса в Молдове | Byteet',
        description: 'Автоматизация бизнес-процессов с ИИ в Молдове: ИИ-агенты и чат-боты на русском и румынском, интеграция CRM/1С, обработка документов и процессы (n8n, Make).'
      },
      'web-software-development': {
        title: 'Создание сайтов в Молдове | Заказать сайт в Кишинёве',
        description: 'Создание сайтов, интернет-магазинов и ПО на заказ в Кишинёве и Молдове: React и Next.js, UX-дизайн, интеграция оплат (maib, PayNet), SEO и поддержка.'
      },
      'mobile-app-development': {
        title: 'Разработка мобильных приложений в Молдове | Byteet',
        description: 'Мобильные приложения iOS и Android в Кишинёве и Молдове: React Native, Flutter или нативная разработка, бэкенд и API, публикация в App Store и Google Play, поддержка.'
      },
      'crm-development': {
        title: 'CRM-системы на заказ и интеграция CRM в Молдове | Byteet',
        description: 'CRM-системы в Кишинёве и Молдове: CRM на заказ или настройка amoCRM, Bitrix24, HubSpot, Odoo, интеграция с почтой, счетами и сайтом, перенос данных из Excel.'
      },
      'erp-systems': {
        title: 'Интеграция ERP и 1С, модули на заказ в Молдове | Byteet',
        description: 'Интеграция и доработка ERP в Кишинёве и Молдове: 1С, Odoo, Business Central, модули на заказ, связь с интернет-магазином, CRM и бухгалтерией, миграция данных.'
      },
      'automation-devops': {
        title: 'Автоматизация и DevOps | CI/CD и Infrastructure as Code | Byteet',
        description: 'Экспертные услуги по автоматизации и DevOps в Молдове. CI/CD-пайплайны, Infrastructure as Code (IaC), автоматизация процессов и повышение эффективности. Модернизируйте ИТ-процессы с помощью современных практик DevOps.'
      },
      'cloud-workspace': {
        title: 'Облачные решения | Современное рабочее место и удалённая работа | Byteet',
        description: 'Профессиональные облачные решения в Молдове. Microsoft 365, Azure, AWS, настройка и управление Google Workspace. Современные инструменты для удалённых и гибридных команд.'
      },
      'device-management': {
        title: 'Управление устройствами | Intune и MDM-решения | Byteet',
        description: 'Экспертные услуги по управлению устройствами (MDM) в Молдове. Microsoft Intune, Mobile Device Management, безопасность конечных точек и соответствие требованиям. Безопасное и эффективное управление всеми устройствами.'
      },
      'identity-access': {
        title: 'Управление идентификацией и доступом | IAM и SSO | Byteet',
        description: 'Профессиональные услуги по управлению идентификацией и доступом (IAM) в Молдове. SSO, Zero Trust, Active Directory, внедрение Okta и CyberArk. Безопасное управление доступом для вашей организации.'
      },
      'infrastructure-management': {
        title: 'Управление инфраструктурой | Гибридное облако и управление серверами | Byteet',
        description: 'Экспертные услуги по управлению инфраструктурой в Молдове. Гибридные облачные решения, управление серверами, виртуализация и оптимизация инфраструктуры. Надёжная работа инфраструктуры.'
      },
      'database-management': {
        title: 'Управление базами данных | SQL и оптимизация данных | Byteet',
        description: 'Профессиональные услуги по управлению базами данных в Молдове. Оптимизация SQL, администрирование баз данных, целостность данных, миграция и поддержка 24/7. Надёжная работа баз данных.'
      },
      'service-desk': {
        title: 'Внедрение Service Desk | ИТ-поддержка и helpdesk | Byteet',
        description: 'Экспертное внедрение Service Desk в Молдове. ИТ-поддержка, настройка helpdesk, управление SLA, системы тикетов и оптимизация ИТ-поддержки. Сделайте ИТ-поддержку эффективнее.'
      },
      'knowledge-management': {
        title: 'Управление знаниями | Документация и база знаний | Byteet',
        description: 'Профессиональные услуги по управлению знаниями в Молдове. Системы документации, внедрение базы знаний, настройка Confluence и управление информацией. Улучшите обмен знаниями.'
      },
      'web-development': {
        title: 'Разработка сайтов | Full-stack и React/Next.js | Byteet',
        description: 'Экспертные услуги по разработке сайтов в Молдове. Full-stack-разработка, React, Next.js, веб-приложения на заказ и современные веб-решения. Создавайте мощные веб-приложения для вашего бизнеса.'
      },
      'it-support': {
        title: 'ИТ-поддержка | Поддержка 24/7 | Byteet',
        description: 'Профессиональные услуги ИТ-поддержки в Молдове. Техническая поддержка 24/7, услуги helpdesk и устранение ИТ-неполадок. Надёжная ИТ-поддержка, когда она вам нужна.'
      },
      'data-engineering': {
        title: 'Data Engineering | Пайплайны и ETL-решения | Byteet',
        description: 'Экспертные услуги Data Engineering в Молдове. Пайплайны данных, процессы ETL, решения Big Data, инфраструктура данных и аналитика. Превращайте данные в полезные выводы.'
      }
    },
    articles: {
      detail: {
        backToArticles: 'Вернуться к статьям',
        articleNotFound: 'Статья не найдена',
        articleNotFoundDescription: 'Статья, которую вы ищете, не существует.',
        relatedArticles: 'Похожие статьи',
        readMore: 'Читать далее',
        needHelp: 'Нужна помощь с ИТ-инфраструктурой?',
        needHelpDescription: 'Давайте обсудим вашу ИТ-инфраструктуру.',
        getStarted: 'Начать'
      },
      page: {
        seo: {
          title: 'Статьи и заметки | Byteet Insights',
          description: 'Откройте обширную библиотеку Byteet с ИТ-статьями, техническими плейбуками и стратегическими заметками об облачных решениях, разработке сайтов, управлении устройствами, автоматизации, управлении идентификацией и доступом и лучших практиках современной ИТ-инфраструктуры.',
          keywords: 'Статьи Byteet, ИТ-плейбуки, инсайты автоматизации, стратегия инфраструктуры, руководства по управлению идентификацией и доступом, разработка сайтов Молдова',
          schemaName: 'Статьи и инсайты',
          schemaDescription: 'Статьи, схемы и заметки Byteet об облачных решениях, разработке сайтов, управлении устройствами, автоматизации, управлении идентификацией и доступом и современной ИТ-инфраструктуре.'
        },
        hero: {
          eyebrow: 'Статьи Byteet',
          title: 'Статьи, плейбуки и',
          highlight: 'заметки',
          description: 'Статьи об автоматизации, конечных устройствах, инфраструктуре и веб-разработке.',
          cta: 'Просмотреть статьи'
        },
        stats: {
          averageReadTime: {
            label: 'Среднее время чтения',
            value: '8 мин',
            detail: 'Для тех, кто отвечает за ИТ'
          },
          articlesPublished: {
            label: 'Опубликованные статьи',
            detail: 'Руководства и практические чек-листы'
          },
          categoriesCovered: {
            label: 'Категории',
            detail: 'От управления устройствами до Data Engineering'
          }
        },
        latest: {
          eyebrow: 'Последние выпуски',
          title: 'Новые статьи',
          description: 'Новые руководства и заметки об ИТ для малого и среднего бизнеса.'
        },
        cards: {
          continueReading: 'Продолжить чтение'
        },
        series: {
          eyebrow: 'Серии',
          title: 'Выберите формат',
          description: 'Короткие заметки о стратегии или пошаговые руководства — в зависимости от задачи.',
          cards: {
            fieldNotes: {
              title: 'Заметки',
              summary: 'Короткие заметки из проектов: что мы пробовали и чему научились.'
            },
            playbooks: {
              title: 'Плейбуки',
              summary: 'Пошаговые руководства по онбордингу, управлению и внедрению.'
            },
            strategyCapsules: {
              title: 'Стратегические капсулы',
              summary: 'Краткие объяснения того, когда стоит делать тот или иной выбор в инфраструктуре, автоматизации или UX.'
            }
          }
        }
      }
    },
    hero: {
      titleLead: 'Создание сайтов',
      titleTail: 'и веб-сервисов в Молдове',
      title: 'Создание сайтов и веб-сервисов в Молдове',
      subtitle: 'Мы проектируем и создаём сайты, интернет-магазины и веб-приложения, а та же команда может обслуживать и ИТ за ними: поддержка, облако, безопасность, данные и ИИ.',
      cta: {
        title: 'Нужен новый сайт или помощь с ИТ?',
        consultation: 'Запросите бесплатный ИТ-аудит',
        call: 'Позвонить сейчас'
      }
    },
    home: {
      scroll: 'Листайте',
      statementLabel: 'Что мы делаем',
      statement: 'Byteet проектирует и создаёт сайты, интернет-магазины и веб-приложения для бизнеса в Молдове, от первого дизайна до запуска и поддержки. Кроме того, мы разрабатываем мобильные приложения, CRM и ERP и обслуживаем ИТ за ними: поддержка, облако, безопасность, данные и ИИ.',
      servicesLabel: 'Услуги',
      servicesLead: 'Создаём.',
      servicesTail: 'Обслуживаем.',
      servicesIntro: 'Девять услуг от одной команды, и главная из них — веб-дизайн и разработка: мы создаём то, что нужно вам онлайн, и поддерживаем работу систем за этим.',
      explore: 'Подробнее',
      allServices: 'Все услуги',
      workLabel: 'Избранные работы',
      workLead: 'Запущены',
      workTail: 'и работают',
      workIntro: 'Сайты и платформы, которые мы спроектировали и создали. Сегодня они онлайн.',
      visit: 'Открыть сайт',
      allCases: 'Все проекты',
      engagementsLabel: 'ИТ-проекты',
      engagementsTitle: 'За экраном',
      engagementsIntro: 'Проекты по инфраструктуре, учётным записям и устройствам, которые не покажешь на скриншоте.',
      toolsLabel: 'Инструменты, с которыми мы работаем',
      ctaLabel: 'Контакты',
      ctaLead: 'Давайте обсудим',
      ctaTail: 'ваш проект',
      email: 'Email',
      phone: 'Телефон'
    },
    work: {
      label: 'Портфолио',
      lead: 'Проекты',
      tail: 'в работе',
      intro: 'Сайты и платформы, созданные для клиентов, и ИТ-проекты за кулисами: от парков устройств до управления доступом и миграций в облако.',
      sitesLabel: 'Сайты и платформы',
      stack: 'Технологии',
      delivered: 'Что сделано',
      challenge: 'Задача',
      approach: 'Подход',
      outcome: 'Результат',
      all: 'Все'
    },
    cookieBanner: {
      title: 'Cookie',
      text: 'Мы используем cookie, чтобы улучшать сайт и анализировать трафик. Вы можете принять все cookie, отклонить необязательные или выбрать по категориям. Подробнее см.',
      policy: 'Политику Cookie',
      reject: 'Отклонить все',
      accept: 'Принять все',
      rejectLabel: 'Отклонить все необязательные cookie',
      acceptLabel: 'Принять все cookie',
      manage: 'Управление настройками'
    },
    stats: {
      clients: 'Обслужено клиентов',
      uptime: 'Процент SLA',
      support: 'Поддержка'
    },
    products: {
      title: 'НЕКОТОРЫЕ ИЗ НАШИХ РЕШЕНИЙ',
      subtitle: 'ИТ-услуги для малого и среднего бизнеса.',
      viewAll: 'Посмотреть все услуги'
    },
    partners: {
      title: 'НЕКОТОРЫЕ ИЗ ИНСТРУМЕНТОВ, КОТОРЫЕ МЫ ИСПОЛЬЗУЕМ',
      subtitle: 'Платформы и инструменты, с которыми мы работаем каждый день.'
    },
    services: {
      title: 'НАШИ УСЛУГИ',
      subtitle: 'Полный спектр ИТ-услуг для бизнеса в Кишинёве и Молдове — от поддержки и облака до безопасности, данных, ИИ, разработки сайтов, мобильных приложений, CRM и ERP.',
      learnMore: 'Узнать больше',
      managedItSupport: {
        title: 'ИТ-аутсорсинг и поддержка',
        subtitle: 'Helpdesk, обслуживание и мониторинг',
        description: 'ИТ-аутсорсинг, helpdesk и техподдержка, обслуживание устройств, service desk и мониторинг с абонентским обслуживанием и чётким SLA.',
        features: ['Helpdesk и техподдержка', 'Обслуживание устройств (Intune, Jamf)', 'Настройка service desk', 'Мониторинг и оповещения', 'Ведение базы знаний']
      },
      cloudInfrastructure: {
        title: 'Облачные услуги и инфраструктура',
        subtitle: 'Microsoft 365, серверы и миграция',
        description: 'Облачные услуги и инфраструктура в Молдове: администрирование Microsoft 365 и Google Workspace, серверы и виртуализация, миграция в облако без остановки и оптимизация затрат.',
        features: ['Администрирование Microsoft 365 и Google Workspace', 'Управление серверами и ВМ', 'Миграция в облако (Azure, AWS)', 'Мониторинг и оптимизация затрат', 'Резервное копирование и восстановление']
      },
      cybersecurityIdentity: {
        title: 'Кибербезопасность и идентификация',
        subtitle: 'IAM, защита конечных точек и соответствие Закону 195/2024',
        description: 'Кибербезопасность для бизнеса: управление идентификацией и доступом (MFA/PAM), защита конечных точек, аудит ИБ и соответствие Закону 195/2024.',
        features: ['Single Sign-On и MFA', 'Управление привилегированным доступом (PAM)', 'Обнаружение и реагирование на конечных точках (EDR)', 'Архитектура Zero Trust', 'Соответствие требованиям и аудит']
      },
      dataDatabases: {
        title: 'Базы данных и данные',
        subtitle: 'Администрирование, бэкап и аналитика',
        description: 'Администрирование и оптимизация баз данных (PostgreSQL, MySQL, SQL Server), миграция, автоматический бэкап и восстановление, а также конвейеры и бизнес-аналитика.',
        features: ['Администрирование БД (PostgreSQL, MySQL, SQL Server)', 'Миграция и оптимизация', 'ETL/ELT-конвейеры', 'Хранилища и озёра данных', 'Качество и управление данными']
      },
      aiAutomation: {
        title: 'ИИ и автоматизация',
        subtitle: 'ИИ-агенты, чат-боты и процессы',
        description: 'Автоматизация бизнес-процессов, ИИ-агенты и чат-боты на русском и румынском с интеграцией CRM/1С, обработка документов и ИИ-аналитика.',
        features: ['Автоматизация процессов (n8n, Make, Zapier)', 'ИИ-агенты и чат-боты (RAG)', 'Обработка документов', 'ИИ-аналитика и отчётность', 'Интеграции и CI/CD']
      },
      webSoftwareDevelopment: {
        title: 'Создание сайтов и ПО',
        subtitle: 'Сайты, интернет-магазины и приложения',
        description: 'Создание сайтов, интернет-магазинов и ПО на заказ на React и Next.js — UX-дизайн, производительность, интеграция оплат и поддержка.',
        features: ['Веб-приложения на заказ (React, Next.js)', 'UX/UI-дизайн', 'Производительность и Core Web Vitals', 'Безопасность и SEO', 'Сопровождение и поддержка']
      },
      mobileAppDevelopment: {
        title: 'Разработка мобильных приложений',
        subtitle: 'iOS и Android, бэкенд и публикация',
        description: 'Приложения iOS и Android для клиентов или вашей команды, кроссплатформенные на React Native или Flutter либо нативные, с бэкендом, публикацией в App Store и Google Play и поддержкой.',
        features: [
          'Приложения для iOS и Android',
          'React Native, Flutter, Swift и Kotlin',
          'Бэкенд, API и панель администратора',
          'Публикация в App Store и Google Play',
          'Сопровождение и обновления'
        ]
      },
      crmDevelopment: {
        title: 'CRM-системы',
        subtitle: 'CRM на заказ, настройка и интеграции',
        description: 'CRM на заказ или настроенные и доработанные amoCRM, Bitrix24, HubSpot либо Odoo, связанные с почтой, счетами и сайтом, с переносом данных из таблиц Excel.',
        features: [
          'CRM на заказ',
          'Настройка amoCRM, Bitrix24, HubSpot, Odoo',
          'Интеграция с почтой, счетами и сайтом',
          'Перенос данных из Excel',
          'Автоматизации и напоминания'
        ]
      },
      erpSystems: {
        title: 'ERP-системы',
        subtitle: 'Интеграции, модули на заказ и миграция',
        description: 'Интеграции 1С, Odoo или Microsoft Dynamics 365 Business Central с интернет-магазином, CRM и бухгалтерией, а также модули на заказ и миграция данных.',
        features: [
          'Интеграции с 1С, Odoo и Business Central',
          'Модули и доработки на заказ',
          'Синхронизация заказов, остатков и цен',
          'Миграция данных со сверкой',
          'Мониторинг и поддержка'
        ]
      },
      deviceManagement: {
        title: 'Управление устройствами',
        subtitle: 'Windows, macOS, Linux, ChromeOS, iOS, Android',
        description: 'Полное управление жизненным циклом устройств Windows и macOS: Microsoft Intune и SCCM для Windows, Jamf Pro для macOS.',
        features: [
          'Windows: Microsoft Intune',
          'Windows: SCCM/ConfigMgr',
          'macOS: Jamf Pro',
          'Контроль соответствия и применение политик',
          'Упаковка и развёртывание программного обеспечения'
        ]
      },
      infrastructureManagement: {
        title: 'Управление инфраструктурой',
        subtitle: 'Управление серверами, устройствами и ВМ',
        description: 'Комплексное управление инфраструктурой, включая администрирование серверов, управление устройствами и оптимизацию виртуальных машин.',
        features: ['Администрирование серверов', 'Управление устройствами', 'Оптимизация ВМ', 'Мониторинг производительности', 'Резервное копирование и восстановление']
      },
      databaseManagement: {
        title: 'Управление базами данных',
        subtitle: 'Настройка, миграция и администрирование',
        description: 'Профессиональные услуги по управлению базами данных, включая настройку, миграцию, оптимизацию и постоянное администрирование.',
        features: ['Настройка баз данных', 'Миграция данных', 'Оптимизация производительности', 'Администрирование 24/7', 'Резервное копирование и восстановление']
      },
      cloudWorkspace: {
        title: 'Облачные решения',
        subtitle: 'Microsoft 365 и Google Workspace',
        description: 'Полная настройка и администрирование облачных рабочих пространств Microsoft 365 и Google Workspace.',
        features: ['Настройка M365', 'Администрирование Google Workspace', 'Управление пользователями', 'Настройка безопасности', 'Поддержка миграции']
      },
      identityAccess: {
        title: 'Управление идентификацией и доступом',
        subtitle: 'Active Directory, Okta и CyberArk',
        description: 'Управление идентификацией и доступом на базе Active Directory, Okta и CyberArk.',
        features: ['Active Directory', 'Интеграция Okta', 'CyberArk PAM', 'Внедрение SSO', 'Контроль доступа']
      },
      automationDevops: {
        title: 'Автоматизация ИТ и DevOps',
        subtitle: 'Скриптинг, CI/CD и автоматизация процессов',
        description: 'Автоматизируйте ИТ-процессы и внедряйте практики DevOps для повышения эффективности.',
        features: ['Автоматизация процессов', 'CI/CD-пайплайны', 'Скриптовые решения', 'Оптимизация рабочих процессов', 'Инструменты мониторинга']
      },
      serviceDesk: {
        title: 'Внедрение Service Desk',
        subtitle: 'Настройка Jira, YouTrack и Zammad',
        description: 'Профессиональная настройка service desk для эффективной работы ИТ-поддержки.',
        features: ['Jira Service Desk', 'Jira Service Management', 'Настройка ServiceNow', 'Настройка YouTrack', 'Конфигурация Zammad', 'Проектирование рабочих процессов', 'Поддержка интеграции']
      },
      knowledgeManagement: {
        title: 'Управление знаниями',
        subtitle: 'Confluence и системы базы знаний',
        description: 'Комплексные решения по управлению знаниями для улучшения документации и обмена информацией.',
        features: ['Настройка Confluence', 'Дизайн базы знаний', 'Стандарты документации', 'Оптимизация поиска', 'Управление контентом']
      },
      webDevelopment: {
        title: 'Разработка сайтов',
        subtitle: 'Веб-приложения и сайты на заказ',
        description: 'Профессиональная разработка, обслуживание и оптимизация сайтов. Экспертные решения, адаптированные под задачи бизнеса.',
        features: ['Веб-приложения на заказ', 'Разработка сайтов', 'Обслуживание и обновления', 'Оптимизация производительности', 'Настройка безопасности']
      },
      itSupport: {
        title: 'ИТ-поддержка',
        subtitle: 'Helpdesk и техническая поддержка',
        description: 'Комплексные услуги helpdesk и технической поддержки, обеспечивающие быстрое решение проблем и оптимальную производительность систем.',
        features: ['Техническая поддержка 24/7', 'Услуги helpdesk', 'Реагирование на инциденты', 'Мониторинг системы', 'Поиск и устранение неполадок']
      },
      dataEngineering: {
        title: 'Data Engineering',
        subtitle: 'Пайплайны данных и инфраструктура аналитики',
        description: 'Создавайте надёжные пайплайны данных, процессы ETL и инфраструктуру аналитики, которые превращают сырые данные в полезные выводы для принятия решений.',
        features: ['Разработка пайплайнов данных', 'ETL/ELT-процессы', 'Хранилища и озёра данных', 'Обработка в реальном времени', 'Качество данных и управление']
      }
    },
    serviceOptions: {
      managedItSupport: 'ИТ-аутсорсинг и поддержка',
      cloudInfrastructure: 'Облако и инфраструктура',
      cybersecurityIdentity: 'Кибербезопасность и идентификация',
      dataDatabases: 'Данные и базы данных',
      aiAutomation: 'ИИ и автоматизация',
      webSoftwareDevelopment: 'Создание сайтов и ПО',
      mobileAppDevelopment: 'Разработка мобильных приложений',
      crmDevelopment: 'CRM-системы',
      erpSystems: 'ERP-системы',
      other: 'Другое',
      otherLabel: 'Что ещё вам нужно?',
      otherPlaceholder: 'Кратко опишите, что вам нужно…',
      otherRequired: 'Кратко опишите, что вам нужно',
      otherRequiredDesc: 'Вы выбрали «Другое» — добавьте краткое описание, чтобы мы могли помочь.'
    },
    about: {
      title: 'О BYTEET — ИТ-УСЛУГИ В МОЛДОВЕ',
      subtitle: 'Мы — ИТ-компания, которая обслуживает и модернизирует ИТ малого и среднего бизнеса.',
      description: 'Наша команда сертифицированных профессионалов с более чем десятилетним опытом специализируется на управлении устройствами, облачном администрировании и автоматизации.',
      yearsExperience: 'Лет опыта',
      yearsExperienceSubtitle: 'Опытные инженеры, которые следят за новейшими технологиями',
      projectsCompleted: 'Завершённых проектов',
      excellence: {
        title: 'Качество',
        description: 'Документируем, тестируем и передаём всё, что делаем.'
      },
      partnership: {
        title: 'Партнёрство',
        description: 'Строим долгосрочные отношения на доверии и сотрудничестве.'
      },
      efficiency: {
        title: 'Эффективность',
        description: 'Автоматизируем рутинную работу и держим процессы простыми.'
      },
      security: {
        title: 'Безопасность',
        description: 'Меры безопасности, соответствующие масштабу вашего бизнеса.'
      }
    },
    contact: {
      title: 'СВЯЗАТЬСЯ С НАМИ — ИТ-УСЛУГИ В МОЛДОВЕ',
      subtitle: 'Расскажите, что вам нужно, и мы пришлём предложение.',
      form: {
        name: 'Полное имя',
        email: 'Адрес электронной почты',
        company: 'Название компании',
        phone: 'Номер телефона',
        services: 'Необходимые услуги',
        budget: 'Бюджетный диапазон',
        timeline: 'Сроки проекта',
        teamSize: 'Размер команды',
        message: 'Детали проекта',
        submit: 'Отправить сообщение',
        submitting: 'Отправка…',
        success: 'Сообщение успешно отправлено!',
        error: 'Пожалуйста, заполните все обязательные поля.'
      },
      budgetRanges: {
        under5k: 'До 5K',
        '5k-10k': '5K–10K',
        '10k-20k': '10K–20K',
        '20k-30k': '20K–30K',
        '30k+': '30K+'
      },
      timelines: {
        asap: 'Как можно скорее (в течение 1 месяца)',
        '1-3months': '1–3 месяца',
        '3-6months': '3–6 месяцев',
        '6months+': '6+ месяцев'
      },
      teamSizes: {
        '1-5': '1–5 человек',
        '6-20': '6–20 человек',
        '21-50': '21–50 человек',
        '50+': '50+ человек'
      },
      contactInfo: {
        email: 'Электронная почта',
        phone: 'Телефон',
        location: 'Местоположение'
      }
    },
    footer: {
      description: 'Профессиональные ИТ-услуги в Молдове для современного бизнеса. Мы специализируемся на управлении устройствами, облачном администрировании и автоматизации.',
      services: 'УСЛУГИ',
      pages: 'СТРАНИЦЫ',
      company: 'КОМПАНИЯ',
      copyright: 'Все права защищены.',
      privacyPolicy: 'Политика конфиденциальности',
      termsOfService: 'Условия использования',
      backToTop: 'Наверх'
    },
    forms: {
      alerts: {
        selectService: 'Пожалуйста, выберите хотя бы одну услугу',
        selectServiceDesc: 'Вы должны выбрать хотя бы одну услугу, чтобы продолжить.',
        selectBudget: 'Пожалуйста, выберите бюджетный диапазон',
        selectBudgetDesc: 'Вы должны выбрать бюджетный диапазон, чтобы продолжить.',
        success: 'Запрос на услугу успешно отправлен!',
        successDesc: 'Мы проанализируем ваши требования и свяжемся с вами в течение 24 часов с индивидуальным решением и предложением.',
        errorDesc: 'Что-то пошло не так. Пожалуйста, попробуйте ещё раз или напишите нам на info@byteet.md.'
      },
      serviceInquiry: {
        send: "Отправить",
        sending: "Отправка…",
        steps: {
          need: {
            rail: "Что нужно",
            title: "Что вам нужно?",
            desc: "Выберите всё подходящее.",
          },
          project: {
            rail: "Проект",
            title: "Ваш проект",
            desc: "Достаточно общей идеи. Остальное мы уточним.",
          },
          contact: {
            rail: "Контакты",
            title: "Как с вами связаться?",
            desc: "Мы отвечаем по электронной почте. Телефон указывать необязательно.",
          },
          call: {
            rail: "Звонок",
            title: "Обсудим?",
            desc: "{minutes} минут в Google Meet, бесплатно и без обязательств.",
          },
        },
        projectLabel: "В нескольких предложениях",
        projectPlaceholder: "Что вы хотите создать, исправить или улучшить, и зачем.",
        aiHint: "Не знаете, как сформулировать? Пусть ИИ-ассистент составит описание.",
        aiSteps: "Вставьте это в ИИ-ассистент, ответьте на три вопроса и вставьте результат в поле выше.",
        showPrompt: "Показать промпт",
        hidePrompt: "Скрыть промпт",
        copyPrompt: "Копировать промпт",
        copied: "Скопировано",
        copySelected: "Выделено. Нажмите Ctrl+C (или Cmd+C), чтобы скопировать.",
        budget: "Бюджет",
        timeline: "Сроки",
        callYes: "Да, записаться на звонок",
        callNo: "Нет, просто отправить",
        callUnavailable: "Онлайн-запись сейчас недоступна; мы напишем вам, чтобы договориться о времени.",
        pickTime: "Выберите время для звонка или вариант «Нет, просто отправить».",
        alreadySent: "Ваше сообщение уже у нас.",
        bookingFailed: "Ваше сообщение получено, но записать звонок не удалось. Попробуйте ещё раз или выберите «Нет, просто отправить», и мы напишем вам, чтобы договориться о времени.",
        nameRequired: "Укажите имя.",
        emailInvalid: "Укажите корректный адрес электронной почты.",
        servicesLabel: "Услуги",
        sendFailed: "Не удалось отправить заявку. Попробуйте ещё раз или напишите нам на {email}.",
        received: "Получено.",
        receivedNext: "Мы прочитаем заявку и ответим на {email}.",
        receivedNextCall: "Мы прочитаем заявку до звонка.",
        aiPrompt: "Я хочу обратиться в ИТ-компанию по поводу проекта. Задай мне эти три вопроса по одному и дожидайся каждого ответа:\n1) Что ты хочешь создать, исправить или улучшить?\n2) Чем ты пользуешься сейчас и что не работает?\n3) Как для тебя выглядел бы хороший результат?\nЗатем напиши понятное описание проекта не длиннее 120 слов, от первого лица и простым языком, ничего не добавляя от себя.",
        title: 'Запросить предложение',
        subtitle: 'Получите индивидуальное предложение для вашего проекта',
        thankYou: 'Спасибо!',
        thankYouSubtitle: 'Мы скоро свяжемся с вами!',
        submit: 'Отправить запрос',
        submitting: 'Отправка…',
        previous: 'Назад',
        next: 'Далее',
        nextSteps: 'Следующие шаги:',
        nextStepsDesc: 'Наша команда рассмотрит детали вашего проекта и запланирует консультацию для обсуждения ваших конкретных потребностей.',
        insertOutline: 'Вставить структуру',
        outlineTemplate: 'Что вам нужно?\n- \n\nЧем вы пользуетесь сейчас?\n- \n\nЧто это должно изменить для вас?\n- \n\nЧто ещё нам важно знать (системы для интеграции, сроки, ограничения)?\n- ',
        formLabels: {
          fullName: 'Полное имя',
          emailAddress: 'Адрес электронной почты',
          company: 'Компания',
          phoneNumber: 'Номер телефона',
          servicesOfInterest: 'Интересующие услуги',
          servicesOfInterestDesc: '(выберите все подходящие)',
          budgetRange: 'Бюджетный диапазон',
          projectTimeline: 'Сроки проекта',
          teamSize: 'Размер команды',
          projectDetails: 'Детали проекта и требования'
        },
        placeholders: {
          enterFullName: 'Введите ваше полное имя',
          enterEmail: 'Введите ваш адрес электронной почты',
          enterCompany: 'Введите название вашей компании',
          enterPhone: 'Введите ваш номер телефона',
          selectTimeline: 'Выберите сроки',
          selectTeamSize: 'Выберите размер команды',
          projectDetailsPlaceholder: 'Расскажите нам о вашем проекте, конкретных требованиях, сложностях и других деталях, которые помогут нам подготовить лучшее предложение…'
        },
        stepLabels: {
          step1: 'Ваши данные',
          step2: 'Выберите услуги',
          step3: 'Бюджет и сроки',
          step4: 'Детали проекта'
        },
        stepDescriptions: {
          step1Title: 'Расскажите нам о себе',
          step1Desc: 'Мы используем эту информацию для связи с вами по вашему проекту.',
          step2Title: 'Какие услуги вам нужны?',
          step2Desc: 'Выберите все услуги, которые нужны для вашего проекта.',
          step3Title: 'Бюджет и сроки',
          step3Desc: 'Помогите нам понять масштаб и сроки вашего проекта.',
          step4Title: 'Расскажите нам о вашем проекте',
          step4Desc: 'Поделитесь любыми дополнительными деталями, которые помогут нам подготовить лучшее предложение.'
        }
      }
    },
    contactPage: {
      serviceInquiryForm: 'Индивидуальное предложение',
      serviceInquirySubtitle: 'Получите индивидуальное предложение для вашего ИТ-проекта',
      contactInformation: 'Контактная информация',
      followUs: 'Следите за нами',
      quickContact: 'Быстрая связь',
      quickContactDesc: 'Нужна немедленная помощь? Свяжитесь с нами напрямую.',
      sendEmail: 'Написать письмо',
      selectTimeline: 'Выберите сроки',
      selectTeamSize: 'Выберите размер команды',
      projectDetailsPlaceholder: 'Расскажите нам о вашем проекте, конкретных требованиях, сложностях и других деталях, которые помогут нам подготовить лучшее предложение…',
      privacyConsent: 'Отправляя эту форму, вы соглашаетесь с нашей политикой конфиденциальности и даёте согласие на то, чтобы мы связались с вами по вашему запросу.',
      servicesSelectAll: '(выберите все подходящие)'
    },
    booking: {
      label: 'Запись',
      lead: 'Запишитесь',
      tail: 'на звонок',
      intro: '{minutes} минут в Google Meet о вашей ИТ-инфраструктуре или программном обеспечении, которое вам нужно. Выберите время ниже — приглашение придёт прямо из нашего календаря.',
      expectLabel: 'Чего ожидать',
      lengthTerm: 'Длительность',
      lengthValue: '{minutes} минут',
      whereTerm: 'Где',
      whereValue: 'Google Meet. Ссылка будет в приглашении в календаре.',
      costTerm: 'Стоимость',
      costValue: 'Бесплатно и ни к чему не обязывает.',
      aboutTerm: 'Что обсуждаем',
      aboutValue: 'Вашу текущую инфраструктуру, что вы хотите изменить и подходим ли мы для этой задачи.',
      languageTerm: 'Язык',
      languageValue: 'Румынский или русский.',
      preferContact: 'Удобнее по почте или по телефону?',
      schedulerLabel: 'Выбор времени',
      pickDay: 'Выберите день',
      pickTime: 'Выберите время',
      timezoneNote: 'Время указано по Кишинёву',
      timezoneShort: 'по Кишинёву',
      loading: 'Загружаем свободное время…',
      dayFull: 'Занято',
      noSlotsDay: 'В этот день нет свободного времени. Выберите другой день.',
      noSlotsAll: 'В ближайшие недели нет свободного времени.',
      yourDetails: 'Ваши данные',
      selected: 'Выбранное время',
      changeTime: 'Изменить время',
      name: 'Имя',
      email: 'Эл. почта',
      company: 'Компания',
      topic: 'Что вы хотели бы обсудить?',
      optional: 'необязательно',
      honeypot: 'Оставьте это поле пустым',
      confirm: 'Подтвердить запись',
      submitting: 'Записываем…',
      privacyBefore: 'Ваши данные будут указаны в приглашении на этот звонок. Подробнее — в нашей ',
      privacyLink: 'политике конфиденциальности',
      privacyAfter: '.',
      errors: {
        load: 'Не удалось загрузить календарь.',
        retry: 'Попробовать снова',
        taken: 'Это время только что заняли. Выберите другое.',
        invalid: 'Проверьте имя и адрес эл. почты и не указывайте ссылки в полях компании и темы.',
        unavailable: 'Онлайн-запись сейчас недоступна.',
        rateLimited: 'Слишком много попыток с этого подключения.',
        generic: 'Не удалось записаться.',
        fallbackBefore: 'Напишите нам на ',
        fallbackAfter: ' — и мы подберём время.'
      },
      success: {
        label: 'Подтверждено',
        title: 'Готово.',
        when: 'Когда',
        meet: 'Google Meet',
        meetPending: 'Ссылка на Meet — в приглашении.',
        invite: 'Приглашение в календарь со ссылкой на Meet отправлено на {email}.',
        back: 'На главную'
      }
    },
    floatingHelp: {
      needHelp: 'Нужна помощь?',
      weAreHere: 'Мы готовы помочь!',
      getServiceQuote: 'Получить предложение',
      backToTop: 'Наверх',
      close: 'Закрыть',
      tooltip: 'Нужна помощь? Нажмите здесь!'
    },
    portfolio: {
      title: 'ИЗБРАННЫЕ РАБОТЫ',
      subtitle: 'ИТ- и веб-проекты, выполненные для наших клиентов.',
      jsonLd: {
        name: 'Портфолио',
        description: 'Портфолио Byteet: успешные ИТ-внедрения и кейсы. Реальные примеры облачных решений, разработки сайтов, внедрения управления устройствами и автоматизации.'
      },
      all: 'Все',
      viewAll: 'Посмотреть все проекты',
      technologiesUsed: 'Используемые технологии:',
      keyResults: 'Ключевые результаты:',
      viewProject: 'Посмотреть детали',
      openWebsite: 'Открыть сайт',
      viewDetails: 'Посмотреть детали',
      recentWork: 'ПОСЛЕДНИЕ РАБОТЫ',
      recentWorkSubtitle: 'Обзор наших новейших проектов и успешных внедрений в различных отраслях и технологиях.',
      categories: {
        infrastructure: 'Инфраструктура',
        deviceManagement: 'Управление устройствами',
        security: 'Безопасность',
        automation: 'Автоматизация',
        cloudInfrastructure: 'Облачная инфраструктура',
        devopsAutomation: 'Автоматизация DevOps',
        securityIAM: 'Безопасность и IAM',
        itOperations: 'ИТ-операции',
        documentation: 'Документация',
        webDevelopment: 'Разработка сайтов',
        serviceDesk: 'Service Desk'
      },
      projects: {
        mundusCrasWebsite: {
          title: 'Mundus Cras — консалтинг для высшего руководства',
          description: 'Двуязычный сайт и контент-платформа для Mundus Cras, консалтинговой практики для высшего руководства, работающей в Нидерландах и Объединённых Арабских Эмиратах. Тринадцать страниц на английском и нидерландском, headless CMS с панелью администратора для статей компании, структурированный приём заявок и система согласия на аналитику.',
          results: [
            'Тринадцать страниц на английском и нидерландском',
            'Headless CMS с панелью администратора',
            'Структурированный приём заявок',
            'Управление согласием на аналитику'
          ]
        },
        deHorecaBrigadeWebsite: {
          title: 'De Horeca Brigade — юридические услуги для HoReCa',
          description: 'Фирменный стиль и двуязычный сайт для De Horeca Brigade, нидерландской компании, которая ведёт юридические и регуляторные вопросы предпринимателей в сфере HoReCa, от разрешений до соответствия требованиям. Команда управляет статьями базы знаний, ценами и заявками через собственную панель администратора, а посетители могут записаться на звонок прямо на сайте.',
          results: ['Фирменный стиль и брендбук', 'Двуязычный сайт (NL/EN) с локализованными URL', 'Интерактивный путеводитель, который подводит к нужной услуге', 'Панель администратора для статей, цен и заявок']
        },
        ironLadyWebsite: {
          title: 'The Iron Lady — сайт стейк-хауса, Роттердам',
          description: 'Двуязычный сайт для The Iron Lady, стейк-хауса и коктейль-бара в центре Роттердама. Полное меню блюд и напитков хранится как структурированный контент, который владельцы редактируют сами, а бронирование столиков встроено в сайт.',
          results: ['Двуязычный сайт (NL/EN)', 'Панель администратора для меню, фото и контента', 'Полное меню блюд и напитков', 'Онлайн-бронирование']
        },
        fatFoxWebsite: {
          title: 'The Fat Fox — сайт паба и стейк-хауса, Роттердам',
          description: 'Двуязычный сайт для The Fat Fox, английского паба и стейк-хауса с грилем на углях в районе Witte de With в Роттердаме. Владельцы управляют меню, включая более 150 напитков, из собственной панели администратора, а гости бронируют столик онлайн.',
          results: ['Двуязычный сайт (NL/EN)', 'Панель администратора для меню и контента', 'Меню с более чем 150 напитками', 'Онлайн-бронирование']
        },
        morenaWebsite: {
          title: 'Morena — латиноамериканский ресторан и коктейль-бар, Роттердам',
          description: 'Полная переработка сайта для Morena, латиноамериканского ресторана и коктейль-бара в районе MaHo в Роттердаме. Владельцы сами редактируют меню и выбирают блюда, которые выделяются на главной странице.',
          results: ['Полная переработка morenarotterdam.nl', 'Двуязычный сайт (NL/EN)', 'Панель администратора для меню и избранных блюд', 'Онлайн-бронирование']
        },
        nouraWebsite: {
          title: 'Noura — левантийский ресторан, Роттердам',
          description: 'Двуязычный сайт для Noura, левантийского ресторана в Роттердаме, с дизайном на основе фирменного стиля ресторана. Владельцы управляют часами работы, меню и содержимым страниц из консоли на отдельном поддомене администратора.',
          results: ['Двуязычный сайт (NL/EN)', 'Дизайн на основе фирменного стиля Noura', 'Консоль администратора для часов работы, меню и страниц', 'Меню с арабскими названиями блюд и пометками о диете']
        },
        sportaMdWebsite: {
          title: 'Sporta MD — сайт платформы спортивных бронирований',
          description: 'Сайт для Sporta MD, мобильного приложения для бронирования товарищеских матчей по футболу, баскетболу, волейболу, теннису и паделу в Кишинёве. Трёхъязычный сайт (RO/RU/EN) включает страницы видов спорта, каталог стадионов с картой, юридические документы и публичную документацию API, а также диплинки и подтверждение e-mail, которые передают пользователя в приложение.',
          results: ['Трёхъязычный сайт (RO/RU/EN)', 'Каталог стадионов с Google Maps', 'Документация API на docs.sporta.md', 'Диплинки и перенаправление в магазины приложений']
        },
        jamfDeviceManagement: {
          title: 'Корпоративное управление устройствами',
          description: 'Успешно зарегистрировано и настроено более 150 устройств в Jamf Pro MDM: внедрены комплексное управление устройствами и политики безопасности корпоративного уровня.',
          problem: {
            title: 'Задача',
            description: 'Организация столкнулась с трудностями в управлении растущим парком устройств macOS в нескольких местах:',
            challenges: [
              'Ручная настройка устройств вызывает несоответствия',
              'Нет централизованного способа применения политик безопасности',
              'Трудоёмкие процессы регистрации и настройки устройств',
              'Сложность учёта устройств и управления ими',
              'Отсутствие автоматизированного развёртывания программного обеспечения'
            ]
          },
          solution: {
            title: 'Наше решение',
            description: 'Внедрён Jamf Pro MDM для централизации управления устройствами и автоматизации процессов развёртывания.',
            process: [
              { step: 'Оценка', icon: 'clipboard', description: 'Проведена инвентаризация устройств и оценка требований' },
              { step: 'Настройка Jamf', icon: 'server', description: 'Настроены сервер Jamf Pro и политики' },
              { step: 'Регистрация', icon: 'users', description: 'Автоматизированная регистрация более 150 устройств' },
              { step: 'Внедрение политик', icon: 'shield', description: 'Применены политики безопасности и управления' }
            ]
          },
          results: ['Более 150 устройств зарегистрировано', 'Централизованное управление', 'Политики безопасности применены', 'Решение корпоративного уровня']
        },
        activeDirectoryManagement: {
          title: 'Инфраструктура Active Directory',
          description: 'Внедрено комплексное управление Active Directory, включая настройку групповых политик, управление жизненным циклом пользователей, автоматизированные процессы онбординга и собственные скрипты автоматизации на PowerShell.',
          problem: {
            title: 'Задача',
            description: 'Организация столкнулась с неэффективностью в управлении пользователями и устройствами:',
            challenges: [
              'Ручное создание учётных записей занимает часы на каждого сотрудника',
              'Несогласованные политики безопасности между отделами',
              'Нет автоматизированного способа управления жизненным циклом пользователей',
              'Трудоёмкая настройка групповых политик',
              'Отсутствие централизованного управления идентификацией'
            ]
          },
          solution: {
            title: 'Наше решение',
            description: 'Спроектирована и внедрена комплексная инфраструктура Active Directory с автоматизацией.',
            process: [
              { step: 'Проектирование архитектуры', icon: 'layout', description: 'Спроектирована структура AD и иерархия OU' },
              { step: 'Настройка групповых политик', icon: 'settings', description: 'Настроены политики безопасности и управления' },
              { step: 'Скрипты автоматизации', icon: 'terminal', description: 'Разработаны сценарии автоматизации на PowerShell' },
              { step: 'Жизненный цикл пользователей', icon: 'refresh-cw', description: 'Автоматизированные процессы онбординга/офбординга' }
            ]
          },
          results: ['Внедрение групповых политик', 'Автоматизированный онбординг пользователей', 'Автоматизация PowerShell', 'Оптимизация инфраструктуры']
        },
        googleWorkspaceSetup: {
          title: 'Настройка и управление Google Workspace',
          description: 'Комплексное внедрение Google Workspace для более чем 150 сотрудников, включая организационные единицы, политики безопасности, настройку Google Groups и управление жизненным циклом пользователей с автоматическим созданием учётных записей.',
          problem: {
            title: 'Задача',
            description: 'Организации нужно было перейти на Google Workspace, но она столкнулась с несколькими препятствиями:',
            challenges: [
              'Сложная миграция с устаревших почтовых систем',
              'Необходимость согласования организационной структуры',
              'Требования безопасности и соответствия нормам',
              'Опасения по поводу обучения пользователей и освоения новых инструментов',
              'Интеграция с существующими системами'
            ]
          },
          solution: {
            title: 'Наше решение',
            description: 'Выполнено полное внедрение Google Workspace с автоматическим созданием учётных записей и настройкой безопасности.',
            process: [
              { step: 'Планирование', icon: 'map', description: 'Спроектирована структура OU и план миграции' },
              { step: 'Конфигурация', icon: 'cog', description: 'Настроены политики безопасности и группы' },
              { step: 'Миграция', icon: 'arrow-right', description: 'Более 150 пользователей перенесено без сбоев' },
              { step: 'Автоматизация', icon: 'zap', description: 'Внедрено автоматическое создание учётных записей' }
            ]
          },
          results: ['Учётные записи для более чем 150 сотрудников', 'Структура OU спроектирована', 'Политики безопасности применены', 'Внедрение Google Groups', 'Автоматическое создание учётных записей']
        },
        jiraServiceManagement: {
          title: 'Внедрение Jira Service Management',
          description: 'Внедрён комплексный helpdesk на Atlassian JSM с продвинутой автоматизацией рабочих процессов, настраиваемой маршрутизацией тикетов, управлением SLA и встроенными дашбордами отчётности для эффективной работы ИТ-поддержки.',
          problem: {
            title: 'Задача',
            description: 'Организации нужен был единый service desk, но она столкнулась с операционными трудностями:',
            challenges: [
              'Фрагментированные каналы поддержки вызывают потерю тикетов и задержки',
              'Нет стандартизированного процесса обработки ИТ-запросов',
              'Сложность отслеживания соблюдения SLA и метрик производительности',
              'Отсутствие самообслуживания увеличивает нагрузку на поддержку',
              'Ручная маршрутизация тикетов приводит к неэффективности'
            ]
          },
          solution: {
            title: 'Наше решение',
            description: 'Внедрён Jira Service Management с автоматизацией, порталом самообслуживания и комплексной отчётностью.',
            process: [
              { step: 'Анализ требований', icon: 'clipboard', description: 'Проанализированы процессы поддержки и требования' },
              { step: 'Конфигурация JSM', icon: 'settings', description: 'Настроены мультирегиональный экземпляр JSM и рабочие процессы' },
              { step: 'Настройка автоматизации', icon: 'zap', description: 'Настроены автоматическая маршрутизация и рабочие процессы' },
              { step: 'Портал и обучение', icon: 'users', description: 'Запущен портал самообслуживания и обучены агенты' }
            ]
          },
          results: ['10 агентов ИТ-поддержки', 'Мультирегиональная конфигурация', 'Портал самообслуживания', 'Автоматизированные рабочие процессы', 'Управление SLA', 'Дашборды отчётности']
        },
        zammadServiceDesk: {
          title: 'Zammad Service Desk с интеграцией LDAP',
          description: 'Создано надёжное решение service desk на базе Zammad с интеграцией LDAP, автоматическим созданием учётных записей, ролевой моделью доступа и собственной автоматизацией рабочих процессов для повышения эффективности поддержки.',
          problem: {
            title: 'Задача',
            description: 'Организации нужен был service desk с открытым исходным кодом и интеграцией с каталогом:',
            challenges: [
              'Потребность в экономически эффективном решении service desk',
              'Требование интеграции с LDAP/Active Directory',
              'Ручное управление пользователями отнимает ресурсы ИТ-отдела',
              'Отсутствие ролевого контроля доступа',
              'Нет автоматизации рабочих процессов'
            ]
          },
          solution: {
            title: 'Наше решение',
            description: 'Внедрён Zammad с интеграцией LDAP и автоматическим созданием учётных записей.',
            process: [
              { step: 'Внедрение Zammad', icon: 'server', description: 'Установлена и настроена платформа Zammad' },
              { step: 'Интеграция LDAP', icon: 'link', description: 'Выполнено подключение к Active Directory через LDAP' },
              { step: 'Настройка RBAC', icon: 'shield', description: 'Настроен ролевой контроль доступа' },
              { step: 'Автоматизация', icon: 'zap', description: 'Внедрено автоматическое создание учётных записей' }
            ]
          },
          results: ['Интеграция LDAP', 'Автоматическое создание учётных записей', 'Ролевой контроль доступа', 'Собственная автоматизация рабочих процессов', 'Повышенная эффективность поддержки']
        },
        gravlDocumentation: {
          title: 'Сайт документации Gravl',
          description: 'Разработан современный адаптивный сайт документации на Gravl CMS с расширенным поиском, контролем версий, многоязычной поддержкой и интуитивной навигацией для обширной технической документации.',
          problem: {
            title: 'Задача',
            description: 'Организации нужна была современная платформа документации, но она столкнулась с рядом трудностей:',
            challenges: [
              'Документация разбросана по нескольким местам',
              'Устаревшая система управления контентом',
              'Слабый поиск затрудняет нахождение информации',
              'Нет контроля версий для изменений документации',
              'Ограниченная многоязычная поддержка'
            ]
          },
          solution: {
            title: 'Наше решение',
            description: 'Создан современный сайт документации на Gravl CMS с расширенными функциями.',
            process: [
              { step: 'Аудит контента', icon: 'search', description: 'Проанализирована существующая структура документации' },
              { step: 'Настройка Gravl', icon: 'code', description: 'Настроена платформа Gravl CMS' },
              { step: 'Миграция', icon: 'arrow-right', description: 'Контент перенесён под контроль версий' },
              { step: 'Улучшения', icon: 'rocket', description: 'Добавлены поиск и многоязычная поддержка' }
            ]
          },
          results: ['Современная платформа документации', 'Расширенный поиск', 'Контроль версий', 'Многоязычная поддержка', 'Интуитивная навигация']
        },
        activeDirectoryEnrollment: {
          title: 'Регистрация корпоративных устройств через Active Directory',
          description: 'Успешно присоединено к домену Active Directory и настроено более 80 корпоративных устройств: внедрены комплексные групповые политики, параметры безопасности и централизованное управление ИТ.',
          problem: {
            title: 'Задача',
            description: 'Организации нужно было зарегистрировать устройства в Active Directory, но она столкнулась с рядом трудностей:',
            challenges: [
              'Ручной процесс регистрации устройств занимает слишком много времени',
              'Несогласованные конфигурации безопасности между устройствами',
              'Нет централизованного способа управления политиками устройств',
              'Сложность обеспечения соответствия стандартам',
              'Отсутствие автоматической подготовки устройств'
            ]
          },
          solution: {
            title: 'Наше решение',
            description: 'Автоматизирована регистрация устройств через Active Directory с комплексным управлением политиками.',
            process: [
              { step: 'Подготовка AD', icon: 'server', description: 'Подготовлена среда Active Directory для регистрации устройств' },
              { step: 'Проектирование политик', icon: 'settings', description: 'Спроектированы групповые политики и конфигурации безопасности' },
              { step: 'Регистрация', icon: 'users', description: 'Более 80 устройств зарегистрировано в домене' },
              { step: 'Управление', icon: 'shield', description: 'Применены политики централизованного управления' }
            ]
          },
          results: ['Более 80 устройств зарегистрировано', 'Комплексные групповые политики', 'Параметры безопасности применены', 'Централизованное управление', 'Улучшенное управление ИТ']
        },
        windowsInstallationAutomation: {
          title: 'Автоматизированный процесс установки Windows',
          description: 'Разработана автоматизированная система установки Windows с загрузочными USB-накопителями, собственными скриптами развёртывания, интеграцией драйверов, предустановкой программного обеспечения и автоматической настройкой для быстрой подготовки устройств.',
          problem: {
            title: 'Задача',
            description: 'Организации нужно было оптимизировать установку Windows, но она столкнулась с рядом трудностей:',
            challenges: [
              'Ручная установка Windows занимает часы на устройство',
              'Разный набор программного обеспечения на устройствах',
              'Трудоёмкая установка и настройка драйверов',
              'Нет стандартизированного процесса развёртывания',
              'Сложность управления предустановкой программного обеспечения'
            ]
          },
          solution: {
            title: 'Наше решение',
            description: 'Создана автоматизированная система установки Windows с собственными скриптами развёртывания.',
            process: [
              { step: 'Разработка скриптов', icon: 'terminal', description: 'Разработаны собственные скрипты развёртывания' },
              { step: 'Создание USB', icon: 'server', description: 'Создан загрузочный USB-накопитель с драйверами и программным обеспечением' },
              { step: 'Тестирование', icon: 'settings', description: 'Протестирован процесс автоматической установки' },
              { step: 'Развёртывание', icon: 'rocket', description: 'Внедрена система быстрой подготовки устройств' }
            ]
          },
          results: ['Автоматизированная установка', 'Собственные скрипты развёртывания', 'Интеграция драйверов', 'Предустановка программного обеспечения', 'Быстрая подготовка устройств']
        },
        googleWorkspaceManagement: {
          title: 'Настройка и управление Google Workspace',
          description: 'Комплексное внедрение Google Workspace, включая создание учётных записей, настройку политик безопасности, миграцию данных, интеграцию приложений и постоянное администрирование для высокой продуктивности и удобной совместной работы.',
          problem: {
            title: 'Задача',
            description: 'Организации было нужно комплексное управление Google Workspace, но она столкнулась с рядом операционных трудностей:',
            challenges: [
              'Сложное создание учётных записей и управление их жизненным циклом',
              'Необходимость настройки политик безопасности и соответствия требованиям',
              'Миграция данных с устаревших систем',
              'Требования к интеграции приложений',
              'Потребность в постоянном администрировании и оптимизации'
            ]
          },
          solution: {
            title: 'Наше решение',
            description: 'Выполнено полное внедрение Google Workspace с автоматическим созданием учётных записей и постоянным управлением.',
            process: [
              { step: 'Планирование', icon: 'map', description: 'Разработана стратегия внедрения и миграции' },
              { step: 'Конфигурация', icon: 'cog', description: 'Настроены политики безопасности и интеграции' },
              { step: 'Миграция', icon: 'arrow-right', description: 'Данные и пользователи перенесены без сбоев' },
              { step: 'Управление', icon: 'refresh-cw', description: 'Налажены процессы постоянного администрирования' }
            ]
          },
          results: ['Создание учётных записей', 'Политики безопасности настроены', 'Миграция данных завершена', 'Интеграция приложений', 'Постоянное администрирование']
        },
        wordpressPlatform: {
          title: 'Платформа WordPress',
          description: 'Внедрение высокопроизводительной сети сайтов WordPress Multisite.',
          problem: {
            title: 'Задача',
            description: 'Организации нужна была масштабируемая платформа WordPress, но она столкнулась с инфраструктурными трудностями:',
            challenges: [
              'Потребность в сети из нескольких сайтов',
              'Требования к производительности и масштабируемости',
              'Централизованное управление несколькими сайтами',
              'Оптимизация ресурсов и экономическая эффективность',
              'Опасения по поводу безопасности и обслуживания'
            ]
          },
          solution: {
            title: 'Наше решение',
            description: 'Внедрена высокопроизводительная сеть сайтов WordPress Multisite с оптимизированной инфраструктурой.',
            process: [
              { step: 'Проектирование архитектуры', icon: 'layout', description: 'Спроектирована архитектура сети сайтов' },
              { step: 'Настройка инфраструктуры', icon: 'server', description: 'Настроен высокопроизводительный хостинг' },
              { step: 'Оптимизация', icon: 'zap', description: 'Оптимизированы производительность и ресурсы' },
              { step: 'Внедрение', icon: 'rocket', description: 'Запущена сеть сайтов на WordPress Multisite' }
            ]
          },
          results: ['Сеть сайтов на WordPress Multisite', 'Высокая производительность', 'Масштабируемая инфраструктура', 'Централизованное управление', 'Оптимальное использование ресурсов']
        },
        caseCloudWorkspace: {
          title: 'Облачное рабочее пространство',
          description: 'Совместная работа модернизирована благодаря переходу на Microsoft 365: безопасный обмен файлами, Teams для коммуникаций и детальное управление доступом. Для защиты данных внедрены политики MFA и DLP, для новых пользователей — стандартизированные шаблоны онбординга.',
          problem: {
            title: 'Задача',
            description: 'Организации нужно было модернизировать совместную работу, но она столкнулась с рядом трудностей:',
            challenges: [
              'Устаревшие системы электронной почты и обмена файлами мешают совместной работе',
              'Риски безопасности при обмене данными и управлении доступом',
              'Отсутствие единой платформы для коммуникаций',
              'Разнородная структура файлов и прав доступа',
              'Нет стандартизированного процесса онбординга для новых пользователей'
            ]
          },
          solution: {
            title: 'Наше решение',
            description: 'Выполнен переход на Microsoft 365 с комплексной защитой и инструментами совместной работы.',
            process: [
              { step: 'Планирование миграции', icon: 'map', description: 'Разработана стратегия миграции без простоя' },
              { step: 'Настройка M365', icon: 'server', description: 'Настроен M365 с Teams и SharePoint' },
              { step: 'Настройка безопасности', icon: 'shield', description: 'Внедрены политики MFA и DLP' },
              { step: 'Стандартизация', icon: 'settings', description: 'Созданы стандартизированные шаблоны и процессы' }
            ]
          },
          results: ['Миграция M365 без простоя', '2FA/MFA включена для всех пользователей', 'Стандартизированная структура файлов и прав доступа', 'Объём вложений в электронной почте сокращён на 80%']
        },
        caseDatabaseManagement: {
          title: 'Модернизация управления базами данных',
          description: 'Разрозненные операционные данные консолидированы в управляемый экземпляр Oracle с плановым резервным копированием, мониторингом и ролевым доступом. Созданы лёгкие дашборды для отчётности почти в реальном времени.',
          problem: {
            title: 'Задача',
            description: 'Организация столкнулась с трудностями в управлении базами данных и фрагментацией данных:',
            challenges: [
              'Разрозненные данные в нескольких системах и местах',
              'Медленные запросы мешают работе',
              'Нет автоматизированных процессов резервного копирования и восстановления',
              'Отсутствие ролевого контроля доступа',
              'Сложность построения отчётов и дашбордов в реальном времени'
            ]
          },
          solution: {
            title: 'Наше решение',
            description: 'Данные консолидированы в управляемый Oracle с автоматизацией и мониторингом.',
            process: [
              { step: 'Оценка данных', icon: 'clipboard', description: 'Проанализированы фрагментированные источники данных' },
              { step: 'Настройка Oracle', icon: 'server', description: 'Внедрён управляемый экземпляр Oracle' },
              { step: 'Миграция и оптимизация', icon: 'arrow-right', description: 'Данные перенесены и оптимизированы' },
              { step: 'Мониторинг и дашборды', icon: 'settings', description: 'Настроены мониторинг и дашборды отчётности' }
            ]
          },
          results: ['Oracle в облаке с автоматическим резервным копированием', 'RBAC для менеджеров и операционной команды', 'Время выполнения запросов сокращено с минут до секунд', 'Операционные дашборды для KPI']
        },
        caseDeviceManagement: {
          title: 'Централизованное управление устройствами',
          description: 'Развёрнут Microsoft Intune с базовыми политиками безопасности, шифрованием устройств и каталогами приложений. Внедрены автоматическая регистрация для ускорения подготовки устройств и удалённая очистка потерянных устройств.',
          problem: {
            title: 'Задача',
            description: 'Организации было нужно централизованное управление устройствами, но она столкнулась с рядом трудностей:',
            challenges: [
              'Нет централизованного способа управления корпоративными устройствами',
              'Несогласованные политики безопасности на разных устройствах',
              'Трудоёмкий процесс подготовки устройств',
              'Отсутствие шифрования устройств и средств защиты',
              'Сложность управления одобренным программным обеспечением и приложениями'
            ]
          },
          solution: {
            title: 'Наше решение',
            description: 'Внедрён Microsoft Intune для централизованного управления устройствами и безопасности.',
            process: [
              { step: 'Планирование Intune', icon: 'map', description: 'Разработана стратегия внедрения Intune' },
              { step: 'Настройка политик', icon: 'settings', description: 'Настроены политики безопасности и шифрование' },
              { step: 'Автоматизация регистрации', icon: 'zap', description: 'Настроена автоматическая регистрация устройств' },
              { step: 'Настройка каталога приложений', icon: 'server', description: 'Создан каталог одобренного программного обеспечения' }
            ]
          },
          results: ['Корпоративная регистрация в Intune', 'Полное шифрование диска включено', 'Каталог приложений с одобренным ПО', 'Время онбординга сокращено на 60%']
        },
        caseWindowsAutomatedDeployment: {
          title: 'Автоматизированное развёртывание устройств Windows',
          description: 'Создано решение на базе загрузочного USB-накопителя, которое автоматически устанавливает Windows, присоединяет устройства к домену Active Directory и устанавливает необходимые инструменты и драйверы. Клиент — бухгалтерская фирма с парком из более чем 30 устройств.',
          problem: {
            title: 'Задача',
            description: 'Бухгалтерской фирме нужен был самый простой и дешёвый способ управлять более чем 30 устройствами Windows, которые поступили без предустановленной системы:',
            challenges: [
              'Устройства прибыли без установленной операционной системы Windows',
              'Ручная установка на более чем 30 устройств заняла бы слишком много времени',
              'Необходимость автоматического присоединения устройств к домену Active Directory',
              'Требуется установка необходимых инструментов и драйверов на каждое устройство',
              'Небольшой бухгалтерской фирме нужно экономичное решение'
            ]
          },
          solution: {
            title: 'Наше решение',
            description: 'Разработан загрузочный USB-накопитель, который автоматизирует весь процесс установки и настройки Windows.',
            process: [
              { step: 'Создание USB', icon: 'server', description: 'Создан загрузочный USB-накопитель с установочным носителем Windows' },
              { step: 'Скрипты автоматизации', icon: 'code', description: 'Разработаны скрипты для автоматической установки Windows' },
              { step: 'Интеграция с доменом', icon: 'link', description: 'Настроено автоматическое присоединение к домену Active Directory' },
              { step: 'Настройка драйверов и инструментов', icon: 'settings', description: 'Автоматизирована установка драйверов и необходимых инструментов' }
            ]
          },
          results: ['Автоматизированная установка Windows на более чем 30 устройствах', 'Автоматическое присоединение к домену Active Directory', 'Предварительно настроенные драйверы и инструменты', 'Значительная экономия времени и затрат']
        },
        caseIdentityAccess: {
          title: 'Консолидация идентификации и доступа',
          description: 'Внедрены SSO и MFA на базе Okta с синхронизацией каталога с Azure AD. Запросы доступа стандартизированы с помощью групп и политик жизненного цикла в основных SaaS-приложениях.',
          problem: {
            title: 'Задача',
            description: 'Организации нужно было консолидировать управление идентификацией и доступом:',
            challenges: [
              'Несколько систем аутентификации раздражают пользователей',
              'Нет единого входа (SSO) в бизнес-приложения',
              'Несогласованные процессы управления доступом',
              'Ручное управление жизненным циклом пользователей',
              'Сложность соблюдения требований аудита'
            ]
          },
          solution: {
            title: 'Наше решение',
            description: 'Внедрён Okta с SSO, MFA и автоматизированным управлением жизненным циклом.',
            process: [
              { step: 'Планирование Okta', icon: 'map', description: 'Разработана стратегия консолидации учётных записей' },
              { step: 'Интеграция каталога', icon: 'link', description: 'Okta интегрирован с Azure AD' },
              { step: 'Настройка SSO и MFA', icon: 'shield', description: 'Настроены политики SSO и MFA' },
              { step: 'Автоматизация жизненного цикла', icon: 'zap', description: 'Автоматизированы процессы жизненного цикла пользователей' }
            ]
          },
          results: ['SSO для более чем 12 бизнес-приложений', 'MFA с учётом роли и риска', 'Автоматизированные процессы приёма, перевода и увольнения сотрудников (joiner/mover/leaver)', 'Готовые к аудиту пересмотры прав доступа']
        },
        caseInfrastructure: {
          title: 'Миграция инфраструктуры в облако',
          description: 'Файловые сервисы и отдельные рабочие нагрузки перенесены в AWS (EC2 и S3). Инфраструктура описана в Terraform для воспроизводимости, для проактивного мониторинга настроены оповещения CloudWatch.',
          problem: {
            title: 'Задача',
            description: 'Организации нужно было перенести инфраструктуру в облако, но она столкнулась с рядом трудностей:',
            challenges: [
              'Высокие затраты на локальную инфраструктуру',
              'Отсутствие подхода infrastructure as code для воспроизводимости',
              'Нет автоматизированного мониторинга и оповещений',
              'Сложность масштабирования ресурсов по мере необходимости',
              'Сложные процессы аварийного восстановления и резервного копирования'
            ]
          },
          solution: {
            title: 'Наше решение',
            description: 'Инфраструктура перенесена в AWS с Terraform (IaC) и комплексным мониторингом.',
            process: [
              { step: 'Планирование миграции', icon: 'map', description: 'Разработана стратегия миграции в облако' },
              { step: 'Настройка Terraform', icon: 'code', description: 'Инфраструктура описана как код в Terraform' },
              { step: 'Миграция в AWS', icon: 'arrow-right', description: 'Рабочие нагрузки перенесены в EC2 и S3' },
              { step: 'Настройка мониторинга', icon: 'settings', description: 'Настроены оповещения CloudWatch и мониторинг' }
            ]
          },
          results: ['Затраты на инфраструктуру снижены на 50%', 'Базовые конфигурации Terraform IaC', 'Политики жизненного цикла S3 для контроля затрат', 'Повышена надёжность, улучшены показатели восстановления RTO/RPO']
        },
        caseDevOpsAutomation: {
          title: 'CI/CD и автоматизация',
          description: 'Построен пайплайн GitLab CI со сборками в Docker, автоматическим тестированием и продвижением между средами. Добавлены уведомления в чат и теги релизов для прослеживаемости.',
          problem: {
            title: 'Задача',
            description: 'Организации нужно было автоматизировать процессы разработки и развёртывания:',
            challenges: [
              'Ручные процессы развёртывания вызывают задержки и ошибки',
              'Нет автоматизированных тестов в процессе разработки',
              'Трудоёмкие циклы сборки и развёртывания',
              'Нет возможности отката при развёртывании',
              'Нет информации о статусе развёртываний и уведомлений'
            ]
          },
          solution: {
            title: 'Наше решение',
            description: 'Внедрён пайплайн GitLab CI/CD с Docker, автоматизированными тестами и уведомлениями.',
            process: [
              { step: 'Проектирование пайплайна', icon: 'layout', description: 'Спроектирована архитектура пайплайна CI/CD' },
              { step: 'Настройка GitLab CI', icon: 'code', description: 'Настроен GitLab CI со сборками в Docker' },
              { step: 'Автоматизация тестирования', icon: 'zap', description: 'Встроены автоматизированные тесты для PR' },
              { step: 'Развёртывание и мониторинг', icon: 'rocket', description: 'Настроены автоматическое развёртывание и уведомления' }
            ]
          },
          results: ['Время развёртывания сокращено до 10 минут', 'Автоматизированные тесты для PR', 'Релизы с возможностью отката', 'Меньше простоев при развёртывании']
        },
        caseKnowledgeManagement: {
          title: 'Платформа управления знаниями',
          description: 'Запущена база знаний на Confluence с шаблонами страниц, процессом согласования и структурированными тегами. Интегрирован SSO, команды обучены поддерживать контент в актуальном состоянии.',
          problem: {
            title: 'Задача',
            description: 'Организации нужна была централизованная система управления знаниями, но она столкнулась с рядом трудностей:',
            challenges: [
              'Знания разбросаны по нескольким местам и форматам',
              'Нет стандартизированных шаблонов для документации',
              'Нет процесса согласования для контроля качества контента',
              'Сложность поиска информации из-за плохой организации',
              'Нет структурированной системы тегов или категорий'
            ]
          },
          solution: {
            title: 'Наше решение',
            description: 'Внедрена база знаний Confluence с шаблонами, процессами согласования и чёткой структурой.',
            process: [
              { step: 'Настройка Confluence', icon: 'server', description: 'Настроена платформа Confluence с SSO' },
              { step: 'Создание шаблонов', icon: 'layout', description: 'Созданы стандартизированные шаблоны страниц' },
              { step: 'Проектирование процессов', icon: 'settings', description: 'Настроены процесс согласования и теги' },
              { step: 'Обучение и запуск', icon: 'users', description: 'Обучены команды и запущена база знаний' }
            ]
          },
          results: ['Централизованные политики и регламенты (SOP)', 'Контент на основе шаблонов', 'Теги и метки для удобного поиска', 'Время онбординга значительно сокращено']
        },
        caseServiceDesk: {
          title: 'Внедрение Service Desk',
          description: 'Внедрён единый helpdesk с категориями тикетов, SLA, базой знаний для самообслуживания и правилами автоматической маршрутизации. Добавлены опросы CSAT для оценки удовлетворённости пользователей.',
          problem: {
            title: 'Задача',
            description: 'Организации нужен был единый service desk, но она столкнулась с рядом трудностей в поддержке:',
            challenges: [
              'Несколько каналов поддержки вызывают путаницу и задержки',
              'Нет стандартизированного отслеживания и управления SLA',
              'Отсутствие самообслуживания увеличивает объём тикетов',
              'Ручная маршрутизация тикетов приводит к неэффективности',
              'Нет способа измерять и повышать удовлетворённость пользователей'
            ]
          },
          solution: {
            title: 'Наше решение',
            description: 'Внедрён единый service desk с автоматизацией, самообслуживанием и отслеживанием удовлетворённости.',
            process: [
              { step: 'Настройка Service Desk', icon: 'server', description: 'Настроена единая платформа helpdesk' },
              { step: 'Конфигурация SLA', icon: 'settings', description: 'Настроены отслеживание SLA и категории' },
              { step: 'Автоматизация и самообслуживание', icon: 'zap', description: 'Внедрены автоматизация маршрутизации и база знаний' },
              { step: 'Интеграция CSAT', icon: 'users', description: 'Добавлены опросы удовлетворённости и их отслеживание' }
            ]
          },
          results: ['Соблюдение SLA улучшено', 'Самообслуживание снимает часть типовых обращений', 'Автоматическая маршрутизация сократила очередь тикетов', 'CSAT отслеживается и растёт от квартала к кварталу']
        }
      }
    },
    homepageFeaturedWork: {
      title: 'ИЗБРАННЫЕ РЕШЕНИЯ',
      subtitle: 'Подборка недавних ИТ-проектов.',
      technologiesUsed: 'Используемые технологии:',
      keyResults: 'Ключевые результаты:',
      learnMore: 'Узнать больше',
      viewAllProjects: 'Посмотреть все проекты',
      categories: {
        cloudSolutions: 'Облачные решения',
        securityIAM: 'Безопасность и IAM',
        infrastructure: 'Инфраструктура'
      },
      projects: {
        microsoft365Migration: {
          title: 'Корпоративная миграция на Microsoft 365',
          description: 'Проведена комплексная миграция на Microsoft 365 для организации с более чем 200 сотрудниками, включая перенос электронной почты, настройку SharePoint, внедрение Teams и настройку безопасности, что улучшило совместную работу и продуктивность.',
          problem: {
            title: 'Задача',
            description: 'Организации нужно было перейти на Microsoft 365, но она столкнулась с рядом трудностей:',
            challenges: [
              'Устаревшие почтовые системы мешают совместной работе',
              'Необходимость миграции без простоя для более чем 200 пользователей',
              'Сложная миграция данных из нескольких источников',
              'Требования безопасности и соответствия нормам',
              'Опасения по поводу обучения пользователей и освоения новых инструментов'
            ]
          },
          solution: {
            title: 'Наше решение',
            description: 'Выполнена комплексная миграция на M365 без простоя и с усиленной безопасностью.',
            process: [
              { step: 'Планирование миграции', icon: 'map', description: 'Разработана стратегия миграции без простоя' },
              { step: 'Миграция электронной почты', icon: 'arrow-right', description: 'Более 200 пользователей перенесено без сбоев' },
              { step: 'Настройка платформы', icon: 'server', description: 'Настроены SharePoint, Teams и безопасность' },
              { step: 'Обучение и поддержка', icon: 'users', description: 'Проведено обучение, обеспечена постоянная поддержка' }
            ]
          },
          results: ['Более 200 пользователей перенесено', 'Миграция без простоя', 'Усиленные политики безопасности', 'Улучшенные инструменты совместной работы']
        },
        oktaImplementation: {
          title: 'Внедрение Okta для управления идентификацией',
          description: 'Внедрён Okta как основной провайдер идентификации для мультитенантной организации: единый вход (SSO) в более чем 15 приложений и усиленная защита благодаря многофакторной аутентификации.',
          problem: {
            title: 'Задача',
            description: 'Организации нужно было единое управление идентификацией, но она столкнулась с рядом трудностей с аутентификацией:',
            challenges: [
              'Несколько систем аутентификации раздражают пользователей',
              'Нет единого входа (SSO) в более чем 15 бизнес-приложений',
              'Риски безопасности при аутентификации по паролям',
              'Сложные требования к идентификации в мультитенантной среде',
              'Сложность управления доступом пользователей к приложениям'
            ]
          },
          solution: {
            title: 'Наше решение',
            description: 'Внедрён Okta как основной провайдер идентификации с SSO и MFA во всех приложениях.',
            process: [
              { step: 'Планирование Okta', icon: 'map', description: 'Разработана стратегия управления идентификацией' },
              { step: 'Интеграция приложений', icon: 'link', description: 'Более 15 приложений подключено к SSO' },
              { step: 'Настройка MFA', icon: 'shield', description: 'Настроена многофакторная аутентификация' },
              { step: 'Мультитенантная настройка', icon: 'users', description: 'Настроена мультитенантная архитектура' }
            ]
          },
          results: ['Более 15 приложений интегрировано', 'Внедрение SSO', 'Применение MFA', 'Соответствие требованиям безопасности']
        },
        serverInfrastructure: {
          title: 'Корпоративная серверная инфраструктура',
          description: 'Спроектирована и внедрена полноценная корпоративная серверная инфраструктура: развёртывание Windows Server, виртуализация VMware, настройка Active Directory, автоматическое резервное копирование и комплексный мониторинг для растущей организации.',
          problem: {
            title: 'Задача',
            description: 'Организации нужна была корпоративная серверная инфраструктура, но она столкнулась с рядом трудностей:',
            challenges: [
              'Нет централизованной серверной инфраструктуры для растущей организации',
              'Отсутствие виртуализации снижает эффективность',
              'Нет Active Directory для управления идентификацией',
              'Ручное резервное копирование грозит потерей данных',
              'Нет системы мониторинга состояния инфраструктуры'
            ]
          },
          solution: {
            title: 'Наше решение',
            description: 'Спроектирована и внедрена полноценная корпоративная инфраструктура с виртуализацией и автоматизацией.',
            process: [
              { step: 'Проектирование инфраструктуры', icon: 'layout', description: 'Спроектированы архитектура и топология серверов' },
              { step: 'Внедрение VMware', icon: 'server', description: 'Внедрена платформа виртуализации VMware' },
              { step: 'Настройка AD и сервисов', icon: 'settings', description: 'Настроены Active Directory и сервисы' },
              { step: 'Автоматизация и мониторинг', icon: 'zap', description: 'Внедрены резервное копирование и мониторинг 24/7' }
            ]
          },
          results: ['Полноценная серверная инфраструктура', 'Виртуализация VMware', 'Настройка Active Directory', 'Автоматическое резервное копирование', 'Система мониторинга 24/7']
        }
      }
    },
    solutions: {
      title: 'НАШИ РЕШЕНИЯ',
      subtitle: 'ИТ-поддержка, облако, безопасность, данные, ИИ, разработка сайтов и мобильных приложений, CRM и ERP для бизнеса в Молдове.',
      exploreAllSolutions: 'Смотреть все решения',
      exploreSolution: 'Подробнее о решении',
      technologies: 'Технологии',
      keyBenefits: 'Ключевые преимущества',
      managedItSupport: {
        title: 'ИТ-аутсорсинг и поддержка',
        subtitle: 'Helpdesk, обслуживание и service desk',
        description: 'ИТ-аутсорсинг, helpdesk, обслуживание и мониторинг работают как единая служба — с чётким SLA и базой знаний за каждым решением.',
        benefits: ['Helpdesk с SLA', 'Полный ИТ-аутсорсинг', 'Абонентское обслуживание', 'Решение при первом обращении']
      },
      cloudInfrastructure: {
        title: 'Облако и инфраструктура',
        subtitle: 'Microsoft 365, серверы и миграция',
        description: 'Администрирование Microsoft 365 и Google Workspace, серверы и виртуализация, миграция в облако без остановки, мониторинг и оптимизация затрат.',
        benefits: ['Администрирование Microsoft 365', 'Миграция без остановки', 'Серверы и виртуализация', 'Оптимизация облачных затрат']
      },
      cybersecurityIdentity: {
        title: 'Кибербезопасность и идентификация',
        subtitle: 'IAM, защита конечных точек и Zero Trust',
        description: 'Кибербезопасность для бизнеса: идентификация и доступ (MFA/PAM), защита конечных точек и соответствие требованиям — включая подготовку к Закону 195/2024.',
        benefits: ['MFA и SSO', 'Привилегированный доступ (PAM)', 'Защита конечных точек (EDR)', 'Соответствие Закону 195/2024']
      },
      dataDatabases: {
        title: 'Данные и базы данных',
        subtitle: 'Администрирование, бэкап и аналитика',
        description: 'Администрирование и оптимизация БД, резервное копирование и восстановление, миграция, конвейеры и бизнес-аналитика, превращающая данные в решения.',
        benefits: ['Оптимизированные базы данных', 'Автоматический бэкап', 'Аварийное восстановление', 'Бизнес-аналитика']
      },
      aiAutomation: {
        title: 'ИИ и автоматизация',
        subtitle: 'ИИ-агенты, чат-боты и процессы',
        description: 'Автоматизация бизнес-процессов, ИИ-агенты и чат-боты на русском и румынском с интеграцией CRM/1С, внедрённые с настоящей инженерной проработкой интеграций.',
        benefits: ['Чат-боты на русском и румынском', 'Интеграция CRM/1С', 'Автоматизация процессов', 'ИИ-агенты 24/7']
      },
      webSoftwareDevelopment: {
        title: 'Создание сайтов и ПО',
        subtitle: 'Сайты, интернет-магазины и приложения',
        description: 'Создание сайтов, интернет-магазинов и ПО на заказ на React и Next.js — UX-дизайн, производительность, интеграция оплат (maib, PayNet) и поддержка.',
        benefits: ['Сайты и интернет-магазины', 'Интеграция оплат (maib, PayNet)', 'Производительность и SEO', 'Постоянная поддержка']
      },
      mobileAppDevelopment: {
        title: 'Разработка мобильных приложений',
        subtitle: 'iOS и Android, бэкенд и публикация',
        description: 'Приложения iOS и Android на React Native, Flutter или нативном коде, с бэкендом, публикацией в App Store и Google Play и поддержкой после запуска.',
        benefits: ['iOS и Android от одной команды', 'Бэкенд и API в комплекте', 'Публикация в магазинах приложений', 'Обновления под новые версии ОС']
      },
      crmDevelopment: {
        title: 'CRM-системы',
        subtitle: 'CRM на заказ, настройка и интеграции',
        description: 'CRM на заказ или amoCRM, Bitrix24, HubSpot либо Odoo, настроенные под ваш процесс продаж и связанные с почтой, счетами и сайтом.',
        benefits: ['Воронка под ваш процесс', 'Заявки прямо с сайта', 'Связь со счетами', 'Перенос из Excel']
      },
      erpSystems: {
        title: 'ERP-системы',
        subtitle: 'Интеграции, модули на заказ и миграция',
        description: 'Ваша ERP, будь то 1С, Odoo или Business Central, связанная с интернет-магазином, CRM и бухгалтерией, с модулями на заказ и проверенной миграцией данных.',
        benefits: ['Интеграция с 1С и Odoo', 'Синхронизация заказов и остатков', 'Модули на заказ', 'Миграция со сверкой']
      },
      infrastructureManagement: {
        title: 'Управление инфраструктурой',
        subtitle: 'Управление серверами, устройствами и ВМ',
        description: 'Комплексное управление конечными точками, серверами и ВМ с мониторингом и поддержкой 24/7.',
        benefits: ['Мониторинг 24/7', 'Автоматические обновления', 'Оптимизация производительности', 'Резервное копирование и восстановление']
      },
      cloudSolutions: {
        title: 'Облачные решения',
        subtitle: 'Microsoft 365 и Google Workspace',
        description: 'Экспертное администрирование Microsoft 365 и Google Workspace.',
        benefits: ['Управление пользователями', 'Настройка безопасности', 'Услуги миграции', 'Обучение и поддержка']
      },
      securityIdentity: {
        title: 'Безопасность и идентификация',
        subtitle: 'Active Directory, Okta и CyberArk',
        description: 'Управление идентификацией и доступом корпоративного уровня на базе AD, Okta и CyberArk.',
        benefits: ['Единый вход (SSO)', 'Многофакторная аутентификация', 'Привилегированный доступ', 'Отчётность о соответствии требованиям']
      },
      webDevelopment: {
        title: 'Веб-разработка',
        subtitle: 'Веб-приложения и сайты на заказ',
        description: 'Веб-приложения и сайты на заказ с последующей поддержкой.',
        benefits: ['Разработка на заказ', 'Оптимизация производительности', 'Настройка безопасности', 'Обслуживание и обновления']
      }
    },
    servicePageCommon: {
      backToServices: 'Вернуться к услугам',
      backToAllServices: 'Вернуться ко всем услугам',
      relatedArticles: 'Статьи по этой услуге',
      serviceNotFound: 'Услуга не найдена',
      serviceNotFoundDescription: 'Запрашиваемая страница услуги не найдена.',
      coreCapabilities: 'Основные возможности',
      deliverables: 'Результаты',
      businessImpact: 'Влияние на бизнес',
      coreCapabilitiesDescription: 'Что входит в эту услугу.',
      projectInformation: 'Информация о проекте',
      projectInformationDescription: 'На этой странице описано, что входит в услугу. По вопросам проектов или индивидуальных решений свяжитесь с нами через форму консультации.'
    },
    servicePages: {
      managedItSupport: {
        title: 'ИТ-аутсорсинг и поддержка',
        subtitle: 'Helpdesk, устройства, service desk и мониторинг',
        description: 'Передайте ИТ на аутсорсинг одной команде: helpdesk и техподдержка, обслуживание устройств (Intune, Jamf), service desk (Jira, Zammad) и мониторинг, с абонентским обслуживанием и SLA.',
        heroContent: {
          mainTitle: 'ИТ-аутсорсинг и поддержка',
          subtitle: 'Одна команда для вашего helpdesk, устройств, service desk и мониторинга',
          keyPoints: [
            'Многоуровневый helpdesk с чёткими SLA и путями эскалации',
            'Управление устройствами и конечными точками через Microsoft Intune и Jamf Pro',
            'Настройка service desk в Jira Service Desk, Zammad или ServiceNow',
            'Проактивный мониторинг на основе актуальной базы знаний'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Разрозненные поддержка и устройства',
            description: 'Заявки, ноутбуки и документация живут в разных инструментах, поэтому время реакции растёт, патчи на устройствах установлены вразнобой, а на одни и те же вопросы каждую неделю отвечают с нуля.',
            challenges: [
              'Долгое время реакции, снижающее продуктивность',
              'Неуправляемые устройства с разным уровнем патчей и соответствия требованиям',
              'Нет стандартного процесса заявок или пути эскалации',
              'Знания хранятся в головах сотрудников, а не в документации'
            ]
          },
          solution: {
            title: 'Единая служба поддержки',
            description: 'Мы объединяем helpdesk, управление конечными точками и service desk в единый процесс с мониторингом и документацией, которые ускоряют решение каждой следующей проблемы.',
            benefits: [
              'Быстрое реагирование на инциденты с чёткой эскалацией',
              'Централизованно управляемые устройства на Windows, macOS и мобильных платформах, соответствующие требованиям',
              'Стандартизированная маршрутизация заявок, SLA и отчётность',
              'Документированные решения, которые повышают долю проблем, решённых с первого обращения'
            ]
          }
        },
        features: [
          {
            title: 'Helpdesk и техподдержка',
            description: 'Поддержка пользователей первой и второй линии с отслеживанием заявок, удалённой помощью и экспертным устранением сложных проблем.',
            capabilities: [
              'Управление и отслеживание заявок',
              'Поддержка первой и второй линии',
              'Удалённая помощь и диагностика',
              'Эскалация и маршрутизация к специалистам'
            ]
          },
          {
            title: 'Управление устройствами и конечными точками',
            description: 'Полный жизненный цикл устройств на Windows, macOS, iOS и Android с помощью Microsoft Intune и Jamf Pro — от регистрации до патчей и соответствия требованиям.',
            capabilities: [
              'Регистрация и подготовка по схеме zero-touch',
              'Настройка и применение политик',
              'Развёртывание ПО и управление патчами',
              'Инвентаризация активов и отчётность по соответствию'
            ]
          },
          {
            title: 'Внедрение Service Desk',
            description: 'Настраиваем Jira Service Desk, Zammad или ServiceNow с процессами, SLA и автоматизацией под вашу команду.',
            capabilities: [
              'Настройка платформы и проектирование процессов',
              'Автоматическая маршрутизация заявок и управление SLA',
              'Интеграция с каталогом и существующими системами',
              'Дашборды и отчётность о производительности'
            ]
          },
          {
            title: 'Мониторинг и база знаний',
            description: 'Непрерывный мониторинг выявляет проблемы до того, как пользователи о них сообщат, а актуальная база знаний делает решения единообразными и быстрыми.',
            capabilities: [
              'Мониторинг и оповещения 24/7',
              'Проактивное выявление и предотвращение проблем',
              'Создание и ведение базы знаний',
              'Документированные процедуры и регламенты (runbooks)'
            ]
          }
        ],
        technologies: {
          title: 'Инструменты и платформы поддержки',
          description: 'Опыт работы с платформами управления конечными точками, тикетинга и документации, на которых строится современная ИТ-поддержка.',
          platforms: [
            { name: 'Microsoft Intune', category: 'Управление устройствами' },
            { name: 'Jamf Pro', category: 'Управление macOS' },
            { name: 'Jira Service Desk', category: 'Платформа ITSM' },
            { name: 'Zammad', category: 'Helpdesk с открытым кодом' },
            { name: 'ServiceNow', category: 'Корпоративный ITSM' },
            { name: 'Confluence', category: 'База знаний' }
          ]
        },
        implementation: {
          title: 'Процесс настройки поддержки',
          description: 'Структурированное внедрение, которое одновременно запускает поддержку, управление устройствами и документацию.',
          phases: [
            {
              phase: 'Оценка и планирование',
              duration: '1–2 недели',
              description: 'Анализируем текущую нагрузку поддержки, парк устройств и инструменты, чтобы определить операционную модель.',
              deliverables: ['Оценка поддержки и устройств', 'Операционная модель и SLA', 'Выбор инструментов', 'Дорожная карта внедрения']
            },
            {
              phase: 'Внедрение и настройка',
              duration: '2–3 недели',
              description: 'Настраиваем service desk, регистрируем устройства и создаём начальную базу знаний.',
              deliverables: ['Настройка service desk', 'Регистрация устройств и политики', 'Структура базы знаний', 'Настройка мониторинга и оповещений']
            },
            {
              phase: 'Обучение и запуск',
              duration: '1–2 недели',
              description: 'Обучаем персонал, документируем процедуры и запускаем поддержку.',
              deliverables: ['Обучение команды поддержки', 'Пользовательская документация', 'Поддержка при запуске', 'Настройка отчётности']
            },
            {
              phase: 'Постоянная поддержка',
              duration: 'Постоянно',
              description: 'Обеспечиваем ежедневную поддержку, совершенствуя процессы и документацию.',
              deliverables: ['Предоставление поддержки 24/7', 'Управление патчами и соответствием', 'Оптимизация процессов', 'Ведение базы знаний']
            }
          ]
        },
        benefits: {
          title: 'Результаты поддержки',
          description: 'Измеримый рост скорости решения, соответствия устройств и удовлетворённости пользователей.',
          outcomes: [
            {
              label: 'Более быстрое решение',
              description: 'Стандартные процессы и экспертная поддержка сокращают время решения проблем.'
            },
            {
              label: 'Решение с первого обращения',
              description: 'Актуальная база знаний помогает агентам решать проблемы с первого обращения.'
            },
            {
              label: 'Мониторинг и поддержка',
              description: 'Непрерывный мониторинг выявляет проблемы до того, как они дойдут до пользователей.'
            },
            {
              label: 'Соответствие устройств',
              description: 'Централизованные политики обеспечивают своевременные патчи и соответствие требованиям на всех конечных точках.'
            }
          ]
        }
      },
      cloudInfrastructure: {
        title: 'Облачные услуги и инфраструктура',
        subtitle: 'Microsoft 365, Google Workspace, серверы и виртуализация',
        description: 'Модернизация облачной инфраструктуры: администрирование Microsoft 365 и Google Workspace, серверы, виртуализация и гибридное облако, с миграцией без остановки, мониторингом и контролем затрат.',
        heroContent: {
          mainTitle: 'Облако и инфраструктура',
          subtitle: 'Администрирование рабочих сред, серверы, виртуализация и миграция в облако под одной крышей',
          keyPoints: [
            'Администрирование и безопасность Microsoft 365 и Google Workspace',
            'Управление серверами и виртуальными машинами на VMware и Hyper-V',
            'Миграция в облако и интеграция с Azure и AWS',
            'Мониторинг, планирование ёмкости и оптимизация затрат'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Разрозненные облако и инфраструктура',
            description: 'Тенанты рабочих сред, локальные серверы и облачные аккаунты управляются по отдельности, из-за чего возникают пробелы в контроле, несогласованная безопасность и непредсказуемые затраты.',
            challenges: [
              'Разные инструменты и команды для рабочих сред и инфраструктуры',
              'Несогласованные безопасность и соответствие требованиям на разных платформах',
              'Ручные операции на серверах и ВМ, создающие риск простоя',
              'Затраты на лицензии и облако, которые трудно прогнозировать или контролировать'
            ]
          },
          solution: {
            title: 'Единое управление облаком и инфраструктурой',
            description: 'Мы администрируем ваши рабочие среды и инфраструктуру как единое целое: общий мониторинг, базовые политики безопасности и планирование ёмкости в гибридных средах.',
            benefits: [
              'Централизованное администрирование Microsoft 365 и Google Workspace',
              'Надёжная работа серверов и виртуализации',
              'Плановые миграции с минимальным простоем',
              'Лицензии и облачные расходы по реальным потребностям'
            ]
          }
        },
        features: [
          {
            title: 'Microsoft 365 и Google Workspace',
            description: 'Администрирование тенантов, жизненный цикл пользователей и настройка безопасности в Microsoft 365 и Google Workspace.',
            capabilities: [
              'Настройка и оптимизация тенанта',
              'Управление жизненным циклом пользователей',
              'Политики DLP и условного доступа',
              'Управление лицензиями и оптимизация затрат'
            ]
          },
          {
            title: 'Управление серверами и виртуализацией',
            description: 'Подготовка, установка патчей и оптимизация серверов Windows и Linux, а также виртуальных машин VMware или Hyper-V.',
            capabilities: [
              'Подготовка и настройка серверов',
              'Управление патчами и обновления безопасности',
              'Подготовка ВМ и оптимизация ресурсов',
              'Резервное копирование и аварийное восстановление'
            ]
          },
          {
            title: 'Миграция в облако и интеграция',
            description: 'Плановая миграция почты, файлов и рабочих нагрузок в облако с синхронизацией каталога и интеграцией с существующими системами.',
            capabilities: [
              'Миграция почты и данных',
              'Синхронизация каталога',
              'Миграция рабочих нагрузок в Azure и AWS',
              'Интеграция приложений'
            ]
          },
          {
            title: 'Мониторинг и оптимизация',
            description: 'Непрерывный мониторинг и планирование ёмкости в облаке и локально с оптимизацией производительности и затрат.',
            capabilities: [
              'Мониторинг инфраструктуры в реальном времени',
              'Планирование и прогнозирование ёмкости',
              'Настройка производительности',
              'Оптимизация затрат и лицензий'
            ]
          }
        ],
        technologies: {
          title: 'Платформы, с которыми мы работаем',
          description: 'Глубокий опыт работы с платформами рабочих сред, виртуализации и публичного облака.',
          platforms: [
            { name: 'Microsoft 365', category: 'Офисный пакет' },
            { name: 'Google Workspace', category: 'Платформа для совместной работы' },
            { name: 'Microsoft Azure', category: 'Публичное облако' },
            { name: 'AWS', category: 'Публичное облако' },
            { name: 'VMware vSphere', category: 'Платформа виртуализации' },
            { name: 'Hyper-V', category: 'Гипервизор' }
          ]
        },
        implementation: {
          title: 'Процесс внедрения',
          description: 'Структурированный подход к развёртыванию облака и инфраструктуры, обеспечивающий надёжную работу и оптимизацию.',
          phases: [
            {
              phase: 'Оценка и стратегия',
              duration: '1–2 недели',
              description: 'Оцениваем текущие тенанты рабочих сред, серверы и облачные ресурсы и определяем целевое состояние.',
              deliverables: ['Анализ текущего состояния', 'Стратегия облака и инфраструктуры', 'Дорожная карта миграции', 'Базовые требования безопасности']
            },
            {
              phase: 'Проектирование и настройка',
              duration: '2–3 недели',
              description: 'Проектируем архитектуру и настраиваем рабочие среды, серверы и виртуализацию.',
              deliverables: ['Проектирование архитектуры', 'Настройки безопасности', 'Спецификации интеграции', 'Планы тестирования']
            },
            {
              phase: 'Миграция и развёртывание',
              duration: '3–4 недели',
              description: 'Поэтапная миграция и развёртывание с проверкой и сопровождением переключения.',
              deliverables: ['Пилотная миграция', 'Полное развёртывание', 'Обучение пользователей', 'Поддержка при запуске']
            },
            {
              phase: 'Оптимизация и поддержка',
              duration: 'Постоянно',
              description: 'Непрерывный мониторинг, настройка и оптимизация затрат по всей инфраструктуре.',
              deliverables: ['Оптимизация производительности', 'Планирование ёмкости', 'Поддержка 24/7', 'Регулярный анализ затрат']
            }
          ]
        },
        benefits: {
          title: 'Операционные результаты',
          description: 'Измеримые улучшения по затратам, надёжности и производительности в облаке и локально.',
          outcomes: [
            {
              label: 'Снижение ИТ-затрат',
              description: 'Оптимизированные лицензии и подбор ресурсов снижают расходы на рабочие среды и инфраструктуру.'
            },
            {
              label: 'Доступность инфраструктуры',
              description: 'Проактивный мониторинг и обслуживание обеспечивают доступность систем и бесперебойную работу бизнеса.'
            },
            {
              label: 'Более быстрое решение проблем',
              description: 'Централизованный мониторинг и оповещения ускоряют обнаружение и решение проблем.'
            },
            {
              label: 'Оптимизация облачных затрат',
              description: 'Планирование ёмкости и правильный подбор размеров ресурсов снижают облачные и инфраструктурные затраты.'
            }
          ]
        }
      },
      cybersecurityIdentity: {
        title: 'Кибербезопасность и идентификация',
        subtitle: 'Идентификация, привилегированный доступ, защита конечных точек и Zero Trust',
        description: 'Кибербезопасность для малого и среднего бизнеса в Молдове: SSO и MFA, управление привилегированным доступом (PAM), защита конечных точек (EDR) и подготовка к соответствию Закону 195/2024 о защите персональных данных.',
        heroContent: {
          mainTitle: 'Кибербезопасность и идентификация',
          subtitle: 'Идентификация, доступ и защита конечных точек на принципах Zero Trust',
          keyPoints: [
            'Единый вход (SSO) и MFA в облаке и локально',
            'Управление привилегированным доступом с контролем сессий',
            'Обнаружение угроз и реагирование на всех конечных точках',
            'Архитектура Zero Trust и отчётность о соответствии'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Риски идентификации и конечных точек',
            description: 'Кража учётных данных и неуправляемые конечные точки — основные векторы атак, а разрастание прав доступа и требования аудита перегружают команды безопасности.',
            challenges: [
              'Атаки на основе идентификации и кража учётных данных',
              'Постоянный привилегированный доступ без контроля сессий',
              'Конечные точки без единой системы обнаружения и реагирования',
              'Требования регуляторов и аудита по разным стандартам'
            ]
          },
          solution: {
            title: 'Безопасность на основе идентификации',
            description: 'Мы объединяем идентификацию, привилегированный доступ и защиту конечных точек в модель Zero Trust с непрерывной проверкой и готовой к аудиту отчётностью.',
            benefits: [
              'Единая идентификация с надёжной аутентификацией',
              'Привилегированный доступ по принципу just-in-time с записью сессий',
              'Автоматизированное обнаружение и реагирование на конечных точках',
              'Непрерывный мониторинг и отчётность о соответствии'
            ]
          }
        },
        features: [
          {
            title: 'Управление идентификацией и доступом',
            description: 'SSO, MFA и ролевой доступ в Microsoft Entra ID, Active Directory и Okta с автоматизированными процессами приёма, перевода и увольнения сотрудников.',
            capabilities: [
              'Внедрение единого входа (SSO)',
              'Многофакторная аутентификация (MFA)',
              'Ролевой контроль доступа (RBAC)',
              'Автоматическая подготовка и отзыв доступа'
            ]
          },
          {
            title: 'Управление привилегированным доступом',
            description: 'Контролируем и отслеживаем привилегированный доступ с помощью CyberArk: хранилище учётных данных, повышение прав по принципу just-in-time и запись сессий.',
            capabilities: [
              'Обнаружение и защита привилегированных учётных записей',
              'Предоставление доступа по принципу just-in-time',
              'Мониторинг и запись сессий',
              'Автоматическая ротация учётных данных'
            ]
          },
          {
            title: 'Защита конечных точек',
            description: 'Обнаружение угроз и реагирование на каждой конечной точке с помощью CrowdStrike Falcon и Microsoft Defender, включая поведенческий анализ и автоматическое устранение угроз.',
            capabilities: [
              'Обнаружение и реагирование на конечных точках (EDR)',
              'Поведенческая аналитика и обнаружение аномалий',
              'Автоматическое реагирование на инциденты',
              'Интеграция данных об угрозах'
            ]
          },
          {
            title: 'Zero Trust и соответствие требованиям',
            description: 'Доступ с минимальными привилегиями и непрерывной проверкой, а также журналы аудита и отчётность в соответствии с нормативными стандартами.',
            capabilities: [
              'Условный доступ и доступ на основе рисков',
              'Минимальные привилегии и микросегментация',
              'Журналирование и аудиторский след',
              'Отчётность о соответствии и дашборды'
            ]
          }
        ],
        technologies: {
          title: 'Технологические платформы',
          description: 'Платформы, которые мы используем для идентификации, привилегированного доступа и защиты конечных точек.',
          platforms: [
            { name: 'Microsoft Entra ID', category: 'Облачная идентификация' },
            { name: 'Active Directory', category: 'Службы каталогов' },
            { name: 'Okta', category: 'Провайдер идентификации' },
            { name: 'CyberArk', category: 'Управление привилегированным доступом' },
            { name: 'CrowdStrike Falcon', category: 'Платформа EDR' },
            { name: 'Microsoft Defender', category: 'Защита конечных точек' }
          ]
        },
        implementation: {
          title: 'Подход к внедрению',
          description: 'Структурированная методология развёртывания идентификации, привилегированного доступа и защиты конечных точек.',
          phases: [
            {
              phase: 'Обследование и оценка',
              duration: '1–2 недели',
              description: 'Оцениваем текущую инфраструктуру идентификации, привилегированные учётные записи и состояние конечных точек.',
              deliverables: ['Аудит идентификации и доступа', 'Оценка рисков', 'Анализ пробелов', 'Стратегия внедрения']
            },
            {
              phase: 'Проектирование и архитектура',
              duration: '2–3 недели',
              description: 'Проектируем архитектуру Zero Trust, политики доступа и контроль конечных точек.',
              deliverables: ['Проектирование архитектуры', 'Политики доступа и безопасности', 'Спецификации интеграции', 'Протоколы тестирования']
            },
            {
              phase: 'Развёртывание и интеграция',
              duration: '3–4 недели',
              description: 'Поэтапное развёртывание идентификации, PAM и защиты конечных точек с валидацией.',
              deliverables: ['Пилотное развёртывание', 'Тестирование интеграции', 'Валидация безопасности', 'Обучение пользователей']
            },
            {
              phase: 'Оптимизация и поддержка',
              duration: 'Постоянно',
              description: 'Непрерывный мониторинг, настройка и поддержка для сохранения уровня безопасности.',
              deliverables: ['Мониторинг безопасности', 'Настройка политик', 'Поддержка 24/7', 'Отчётность о соответствии']
            }
          ]
        },
        benefits: {
          title: 'Результаты для безопасности',
          description: 'Значительно повысьте уровень безопасности, сохранив удобство доступа и прозрачность для аудита.',
          outcomes: [
            {
              label: 'Снижение рисков компрометации учётных записей',
              description: 'Надёжная аутентификация и контроль доступа снижают уязвимость к атакам на учётные записи.'
            },
            {
              label: 'Меньше инцидентов безопасности',
              description: 'Обнаружение угроз на конечных точках и принцип минимальных привилегий снижают число инцидентов.'
            },
            {
              label: 'Более быстрое реагирование на инциденты',
              description: 'Автоматическое реагирование и прозрачность сессий ускоряют локализацию инцидентов.'
            },
            {
              label: 'Соответствие требованиям',
              description: 'Журналы аудита и отчётность обеспечивают соответствие доступа нормативным стандартам.'
            }
          ]
        }
      },
      dataDatabases: {
        title: 'Базы данных и данные',
        subtitle: 'Администрирование, миграция, бэкап, конвейеры и аналитика',
        description: 'Администрирование и оптимизация PostgreSQL, MySQL и SQL Server, миграции с минимальным простоем, автоматический бэкап и аварийное восстановление (в том числе после атак шифровальщиков), а также ETL-конвейеры, хранилища и бизнес-аналитика.',
        heroContent: {
          mainTitle: 'Базы данных и данные',
          subtitle: 'Администрирование баз данных и инженерия данных как единая практика',
          keyPoints: [
            'Настройка, миграция и оптимизация производительности баз данных',
            'ETL- и ELT-конвейеры на Apache Airflow',
            'Хранилища и озёра данных для централизованной аналитики',
            'Качество данных, управление и отчётность'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Медленные базы данных и разрозненные данные',
            description: 'Базы данных теряют производительность под нагрузкой, а данные разбросаны по разным системам, что затрудняет надёжную аналитику и отчётность.',
            challenges: [
              'Низкая производительность БД, влияющая на приложения',
              'Рискованные миграции, вызывающие простой',
              'Разрозненные источники данных и изолированные хранилища',
              'Отсутствие управления данными и доверия к цифрам в отчётах'
            ]
          },
          solution: {
            title: 'Надёжные данные на всех этапах',
            description: 'Мы администрируем и настраиваем ваши базы данных и строим конвейеры и хранилища, которые делают данные доступными, точными и готовыми к анализу.',
            benefits: [
              'Настроенные, надёжные базы данных с бэкапами и мониторингом',
              'Миграции с минимальным простоем и валидацией',
              'Данные, консолидированные с помощью управляемых конвейеров',
              'Управляемые, достоверные данные для аналитики'
            ]
          }
        },
        features: [
          {
            title: 'Настройка, миграция и администрирование БД',
            description: 'Установка, настройка и постоянное администрирование PostgreSQL, MySQL, SQL Server и MongoDB, включая миграции с минимальным простоем.',
            capabilities: [
              'Установка, настройка и усиление защиты',
              'Оптимизация производительности и запросов',
              'Стратегии миграции с минимальным простоем',
              'Автоматическое резервное копирование, восстановление и мониторинг'
            ]
          },
          {
            title: 'Конвейеры данных и ETL',
            description: 'Проектируем и эксплуатируем ETL- и ELT-конвейеры на Apache Airflow, которые надёжно принимают, преобразуют и перемещают данные.',
            capabilities: [
              'Архитектура и оркестрация конвейеров',
              'Реализация процессов ETL и ELT',
              'Приём и интеграция данных',
              'Мониторинг конвейеров и оповещения'
            ]
          },
          {
            title: 'Хранилища и озёра данных',
            description: 'Строим и моделируем хранилища и озёра данных для централизованного хранения и быстрых аналитических запросов.',
            capabilities: [
              'Архитектура хранилищ и озёр данных',
              'Моделирование данных и проектирование схем',
              'Оптимизация хранения и партиционирование',
              'Инкрементальная и пакетная загрузка'
            ]
          },
          {
            title: 'Аналитика и управление',
            description: 'Превращаем хранимые данные в отчёты и дашборды с проверками качества данных, отслеживанием происхождения и управлением.',
            capabilities: [
              'Разработка отчётности и дашбордов',
              'Фреймворки качества данных и валидация',
              'Происхождение данных и каталогизация',
              'Управление и контроль доступа'
            ]
          }
        ],
        technologies: {
          title: 'Технологии для данных и баз данных',
          description: 'Опыт работы с реляционными и NoSQL-базами данных, хранилищами и инструментами для конвейеров.',
          platforms: [
            { name: 'PostgreSQL', category: 'Реляционная БД' },
            { name: 'MySQL', category: 'Реляционная БД' },
            { name: 'Microsoft SQL Server', category: 'Корпоративная БД' },
            { name: 'MongoDB', category: 'NoSQL-БД' },
            { name: 'Snowflake', category: 'Хранилище данных' },
            { name: 'Apache Airflow', category: 'Оркестрация процессов' }
          ]
        },
        implementation: {
          title: 'Методология внедрения',
          description: 'Структурированный подход к управлению базами данных и инженерии данных, обеспечивающий надёжные и готовые к анализу данные.',
          phases: [
            {
              phase: 'Оценка и проектирование',
              duration: '2–3 недели',
              description: 'Проводим аудит баз данных и источников, затем проектируем целевую схему и архитектуру конвейеров.',
              deliverables: ['Аудит баз данных и данных', 'Базовые показатели производительности', 'Проектирование архитектуры', 'Дорожная карта внедрения']
            },
            {
              phase: 'Внедрение и настройка',
              duration: '2–3 недели',
              description: 'Настраиваем и оптимизируем базы данных и запускаем первые конвейеры и хранилища.',
              deliverables: ['Установка и настройка БД', 'Стратегия резервного копирования', 'Первые конвейеры', 'Настройка безопасности']
            },
            {
              phase: 'Миграция и построение конвейеров',
              duration: '3–6 недель',
              description: 'Переносим данные и разрабатываем процессы ETL и модели хранилища с валидацией.',
              deliverables: ['Миграция данных', 'Процессы ETL', 'Фреймворки качества данных', 'Настройка мониторинга']
            },
            {
              phase: 'Оптимизация и поддержка',
              duration: 'Постоянно',
              description: 'Непрерывная настройка, мониторинг и поддержка баз данных и конвейеров.',
              deliverables: ['Оптимизация производительности', 'Мониторинг и оповещения', 'Поддержка 24/7', 'Непрерывное улучшение']
            }
          ]
        },
        benefits: {
          title: 'Результаты работы',
          description: 'Измеримые улучшения производительности баз данных, доставки данных и надёжности.',
          outcomes: [
            {
              label: 'Рост производительности',
              description: 'Настройка запросов и индексов сокращает время отклика при критичных нагрузках.'
            },
            {
              label: 'Более быстрая обработка данных',
              description: 'Оркестрированные конвейеры сокращают путь от источника до хранилища.'
            },
            {
              label: 'Более быстрая отчётность',
              description: 'Смоделированные хранилища превращают медленные запросы в быстрые многократно используемые отчёты.'
            },
            {
              label: 'Надёжный бэкап и восстановление',
              description: 'Автоматические бэкапы и протестированное восстановление защищают критичные данные.'
            }
          ]
        }
      },
      aiAutomation: {
        title: 'ИИ и автоматизация',
        subtitle: 'ИИ-агенты, автоматизация процессов и Document AI',
        description: 'Автоматизация бизнес-процессов с ИИ: ИИ-агенты и чат-боты на русском и румынском с поиском по вашим документам и интеграцией с CRM, amoCRM и 1С. Автоматизация процессов на n8n, Make и Zapier и обработка документов.',
        heroContent: {
          mainTitle: 'ИИ и автоматизация',
          subtitle: 'Агенты, автоматизация процессов и Document AI, подключённые к вашим существующим инструментам',
          keyPoints: [
            'Автоматизация процессов в ваших инструментах с помощью n8n, Make и Zapier',
            'ИИ-агенты и чат-боты с поиском по документам компании',
            'Автоматическая обработка, извлечение и классификация документов',
            'Каждое внедрение подкреплено CI/CD и инженерной проработкой интеграций'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Ручная работа и разрозненные инструменты',
            description: 'Команды копируют данные между системами, снова и снова отвечают на одни и те же вопросы и обрабатывают документы вручную, а перспективные ИИ-пилоты так и не доходят до продакшена.',
            challenges: [
              'Повторяющаяся ручная работа в разрозненных инструментах',
              'Вопросы клиентов и сотрудников, на которые каждый раз отвечают с нуля',
              'Документы, обрабатываемые и перенабираемые вручную',
              'ИИ-эксперименты, которые буксуют перед продакшеном'
            ]
          },
          solution: {
            title: 'ИИ, который доходит до продакшена',
            description: 'Мы создаём автоматизации, агентов и документные процессы на проверенных платформах, затем внедряем и поддерживаем их с настоящей инженерной проработкой интеграций и CI/CD.',
            benefits: [
              'Автоматизированные процессы, соединяющие ваши существующие инструменты',
              'Агенты, опирающиеся на ваши собственные документы и данные',
              'Обработка документов и ввод данных без ручного вмешательства',
              'Внедрённые, отслеживаемые и поддерживаемые интеграции'
            ]
          }
        },
        features: [
          {
            title: 'Автоматизация процессов с ИИ',
            description: 'Автоматизируем бизнес-процессы в ваших инструментах с помощью n8n, Make, Zapier и индивидуальных API-интеграций — от маршрутизации лидов до обработки счетов.',
            capabilities: [
              'Картирование процессов и проектирование автоматизации',
              'Процессы n8n, Make и Zapier',
              'Индивидуальные интеграции API и вебхуков',
              'Обработка ошибок и мониторинг'
            ]
          },
          {
            title: 'ИИ-агенты и чат-боты',
            description: 'Ассистенты для клиентской поддержки и внутренних задач на базе Claude и OpenAI, использующие генерацию, дополненную поиском (RAG), по вашим документам.',
            capabilities: [
              'Агенты поддержки и внутренние ассистенты',
              'Генерация, дополненная поиском по документам компании',
              'Интеграция LLM и API (Claude, OpenAI)',
              'Ограничения, оценка и мониторинг'
            ]
          },
          {
            title: 'ИИ для документов и данных',
            description: 'Автоматизируем обработку документов (извлечение, классификацию и ввод данных), чтобы информация поступала в ваши системы без ручного набора.',
            capabilities: [
              'Извлечение и разбор документов',
              'Классификация и маршрутизация',
              'Автоматический ввод данных в системы',
              'Проверка с участием человека'
            ]
          },
          {
            title: 'ИИ-аналитика и инсайты',
            description: 'Отчётность, прогнозирование и поддержка принятия решений с помощью ИИ, превращающие ваши данные в понятные и своевременные ответы.',
            capabilities: [
              'Отчётность и суммаризация на основе ИИ',
              'Прогнозирование и выявление трендов',
              'Поддержка принятия решений и рекомендации',
              'Дашборды и оповещения'
            ]
          }
        ],
        technologies: {
          title: 'Стек ИИ и автоматизации',
          description: 'Модели, платформы автоматизации и инструменты развёртывания, с помощью которых мы создаём и запускаем автоматизации.',
          platforms: [
            { name: 'Claude (Anthropic) API', category: 'Провайдер LLM' },
            { name: 'OpenAI API', category: 'Провайдер LLM' },
            { name: 'n8n', category: 'Автоматизация процессов' },
            { name: 'Make / Zapier', category: 'Платформы автоматизации' },
            { name: 'LangChain', category: 'Фреймворк агентов' },
            { name: 'GitHub Actions', category: 'Платформа CI/CD' }
          ]
        },
        implementation: {
          title: 'Порядок внедрения',
          description: 'От чётко определённого сценария до внедрённой и отслеживаемой автоматизации.',
          phases: [
            {
              phase: 'Обследование и определение сценария',
              duration: '1-2 недели',
              description: 'Определяем процессы с высокой ценностью, изучаем источники данных и задаём метрики успеха.',
              deliverables: ['Оценка процессов и данных', 'Приоритизированные сценарии', 'Метрики успеха', 'Проектирование решения']
            },
            {
              phase: 'Прототип и валидация',
              duration: '2-3 недели',
              description: 'Создаём рабочий прототип и проверяем точность и пригодность на реальных данных.',
              deliverables: ['Рабочий прототип', 'Результаты оценки точности', 'План интеграции', 'Определение ограничений']
            },
            {
              phase: 'Интеграция и развёртывание',
              duration: '2-4 недели',
              description: 'Интегрируем с вашими системами и развёртываем с CI/CD, тестированием и мониторингом.',
              deliverables: ['Системные интеграции', 'Конвейер CI/CD', 'Автоматическое тестирование', 'Мониторинг и оповещения']
            },
            {
              phase: 'Оптимизация и поддержка',
              duration: 'Постоянно',
              description: 'Отслеживаем результаты, дорабатываем промпты и процессы и расширяем охват.',
              deliverables: ['Мониторинг результатов', 'Настройка промптов и процессов', 'Запуск новых автоматизаций', 'Постоянная поддержка']
            }
          ]
        },
        benefits: {
          title: 'Операционный эффект',
          description: 'Конкретная экономия времени и более быстрые ответы благодаря автоматизации и ИИ.',
          outcomes: [
            {
              label: 'Меньше ручной работы',
              description: 'Автоматизированные процессы убирают повторяющееся копирование, маршрутизацию и ввод данных.'
            },
            {
              label: 'Всегда доступные агенты',
              description: 'Ассистенты обрабатывают рутинные вопросы круглосуточно.'
            },
            {
              label: 'Более быстрая обработка документов',
              description: 'Извлечение и классификация заменяют ручной набор.'
            },
            {
              label: 'Сокращение времени ответа',
              description: 'Агенты и автоматизации мгновенно решают типовые запросы.'
            }
          ]
        }
      },
      webSoftwareDevelopment: {
        title: 'Создание сайтов и ПО',
        subtitle: 'Сайты, интернет-магазины, веб- и мобильные приложения',
        description: 'Создание сайтов, интернет-магазинов и ПО на заказ на React, Next.js и TypeScript — от UX-дизайна и производительности (Core Web Vitals) до интеграции оплат (maib, PayNet), безопасности, SEO и поддержки.',
        heroContent: {
          mainTitle: 'Создание сайтов и ПО',
          subtitle: 'Веб-приложения и сайты на заказ: разработка и поддержка',
          keyPoints: [
            'Разработка индивидуальных веб-приложений',
            'Дизайн интерфейса и пользовательского опыта',
            'Производительность, доступность и безопасность',
            'Постоянное сопровождение и поддержка'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Веб-проекты, которые не оправдывают ожиданий',
            description: 'Устаревшие стеки, медленные страницы и неудобные интерфейсы снижают вовлечённость и конверсию, а безопасность и обслуживание откладываются.',
            challenges: [
              'Устаревшие технологии, ограничивающие возможности',
              'Плохой пользовательский опыт, снижающий вовлечённость',
              'Медленная загрузка страниц и низкие показатели Core Web Vitals',
              'Безопасность и обслуживание, оставленные без внимания'
            ]
          },
          solution: {
            title: 'Качественно разработанное веб-ПО',
            description: 'Мы создаём адаптивные и доступные веб-приложения на современном стеке, настроенные под производительность и безопасность и сопровождаемые после запуска.',
            benefits: [
              'Современные адаптивные приложения и сайты',
              'Интерфейсы, спроектированные вокруг реальных задач пользователей',
              'Быстрая загрузка страниц и высокие показатели Core Web Vitals',
              'Поддерживаемые, безопасные и актуальные'
            ]
          }
        },
        features: [
          {
            title: 'Индивидуальные веб-приложения',
            description: 'Приложения, созданные на React, Next.js и Node.js, с хорошо спроектированными API и базами данных.',
            capabilities: [
              'Приложения React и Next.js',
              'Backend-разработка на Node.js',
              'Разработка и интеграция API',
              'Проектирование и оптимизация баз данных'
            ]
          },
          {
            title: 'UX и дизайн интерфейса',
            description: 'Адаптивные и доступные интерфейсы, спроектированные вокруг реальных задач пользователей и протестированные на всех устройствах.',
            capabilities: [
              'Дизайн пользовательского интерфейса',
              'Адаптивный дизайн на всех устройствах',
              'Оптимизация пользовательского опыта',
              'Соответствие доступности (WCAG)'
            ]
          },
          {
            title: 'Производительность и безопасность',
            description: 'Настройка Core Web Vitals и укрепление безопасности для надёжных и быстрых приложений.',
            capabilities: [
              'Оптимизация Core Web Vitals',
              'Укрепление безопасности и лучшие практики',
              'Основы SEO',
              'Поддержка соответствия требованиям и аудитов'
            ]
          },
          {
            title: 'Сопровождение и поддержка',
            description: 'Постоянные обновления, мониторинг и поддержка, чтобы приложения оставались актуальными и безопасными.',
            capabilities: [
              'Регулярные обновления и обслуживание',
              'Мониторинг производительности и доступности',
              'Патчи безопасности',
              'Оперативная техническая поддержка'
            ]
          }
        ],
        technologies: {
          title: 'Технологическая экспертиза',
          description: 'Владение современным стеком веб-разработки.',
          platforms: [
            { name: 'React', category: 'Frontend-фреймворк' },
            { name: 'Next.js', category: 'Full-stack-фреймворк' },
            { name: 'Node.js', category: 'Backend-среда' },
            { name: 'TypeScript', category: 'Язык программирования' },
            { name: 'Tailwind CSS', category: 'Фреймворк стилизации' },
            { name: 'PostgreSQL', category: 'База данных' }
          ]
        },
        implementation: {
          title: 'Процесс разработки',
          description: 'Структурированный подход к веб-разработке, обеспечивающий качество и соблюдение сроков.',
          phases: [
            {
              phase: 'Планирование и дизайн',
              duration: '1-2 недели',
              description: 'Анализ требований, исследование пользователей и проектирование решения.',
              deliverables: ['Спецификация требований', 'Дизайн пользовательского опыта', 'Техническая архитектура', 'График проекта']
            },
            {
              phase: 'Разработка и тестирование',
              duration: '4-8 недель',
              description: 'Разработка приложения с непрерывным тестированием и обеспечением качества.',
              deliverables: ['Frontend-разработка', 'Backend-разработка', 'Интеграционное тестирование', 'Обеспечение качества']
            },
            {
              phase: 'Развёртывание и запуск',
              duration: '1-2 недели',
              description: 'Развёртывание в продакшене, оптимизация производительности и поддержка при запуске.',
              deliverables: ['Развёртывание в продакшене', 'Оптимизация производительности', 'Обучение пользователей', 'Поддержка при запуске']
            },
            {
              phase: 'Сопровождение и поддержка',
              duration: 'Постоянно',
              description: 'Постоянное обслуживание, обновления и поддержка для надёжной работы.',
              deliverables: ['Регулярное обслуживание', 'Обновления функций', 'Мониторинг производительности', 'Техническая поддержка']
            }
          ]
        },
        benefits: {
          title: 'Влияние на бизнес',
          description: 'Измеримые результаты качественно разработанного и хорошо поддерживаемого веб-ПО.',
          outcomes: [
            {
              label: 'Вовлечённость пользователей',
              description: 'Адаптивный дизайн и более понятные интерфейсы повышают вовлечённость и конверсии.'
            },
            {
              label: 'Более быстрая загрузка страниц',
              description: 'Настройка производительности сокращает время загрузки и улучшает Core Web Vitals.'
            },
            {
              label: 'Бюджеты производительности',
              description: 'Перед релизом сборки проверяются в Lighthouse и по Core Web Vitals.'
            },
            {
              label: 'Работа на всех устройствах',
              description: 'Приложения работают на смартфонах, планшетах и десктопах.'
            }
          ]
        }
      },
      deviceManagement: {
        title: 'Управление устройствами',
        subtitle: 'Windows, macOS, Linux, ChromeOS, iOS, Android',
        description: 'Защитите каждое конечное устройство — Windows, macOS, Linux и мобильные — с помощью Intune, Jamf и автоматической проверки соответствия, чтобы инвентарь, политики и патчи оставались синхронизированными.',
        heroContent: {
          mainTitle: 'Управление устройствами',
          subtitle: 'Комплексное управление устройствами Windows и macOS: Microsoft Intune и SCCM для Windows, Jamf Pro для macOS',
          keyPoints: [
            'Продвинутая защита от угроз на всех конечных устройствах',
            'Единое управление устройствами и соответствие требованиям',
            'Внедрение архитектуры безопасности Zero Trust',
            'Автоматическое реагирование на инциденты и устранение угроз'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Сложности защиты конечных устройств',
            description: 'Современные компании сталкиваются с беспрецедентными проблемами безопасности: сотрудники работают распределённо, действуют политики BYOD, а продвинутые киберугрозы нацелены на конечные устройства как на основной вектор атаки.',
            challenges: [
              'Разрозненные инструменты безопасности, оставляющие слепые зоны',
              'Сложные нормативные требования в разных юрисдикциях',
              'Быстро меняющиеся угрозы, опережающие защиту',
              'Нехватка ресурсов, снижающая эффективность команды безопасности'
            ]
          },
          solution: {
            title: 'Наш комплексный подход',
            description: 'Мы предлагаем интегрированные решения для безопасности конечных устройств, обеспечивающие полную прозрачность, контроль и защиту всего парка ваших устройств.',
            benefits: [
              'Унифицированная платформа безопасности, снижающая сложность',
              'Автоматическое обнаружение угроз и реагирование на них',
              'Централизованное управление политиками и их применение',
              'Непрерывный мониторинг соответствия и отчётность'
            ]
          }
        },
        features: [
          {
            title: 'Продвинутая защита от угроз',
            description: 'Многоуровневая защита, включая EDR, анализ поведения и обнаружение угроз на основе ИИ, чтобы выявлять и нейтрализовать сложные атаки до того, как они повлияют на ваш бизнес.',
            capabilities: [
              'Обнаружение и анализ угроз в реальном времени',
              'Анализ поведения и обнаружение аномалий',
              'Автоматизированные сценарии реагирования на инциденты',
              'Интеграция данных киберразведки'
            ]
          },
          {
            title: 'Унифицированное управление устройствами',
            description: 'Централизованный контроль и управление всеми устройствами Windows, macOS, Linux, iOS и Android из одной консоли.',
            capabilities: [
              'Кросс-платформенная регистрация и подготовка устройств',
              'Настройка и применение политик',
              'Развёртывание программного обеспечения и управление патчами',
              'Инвентаризация активов и управление жизненным циклом'
            ]
          },
          {
            title: 'Архитектура Zero Trust',
            description: 'Внедрите принципы безопасности Zero Trust: непрерывную проверку, доступ с минимальными привилегиями и микросегментацию для всех ваших конечных устройств.',
            capabilities: [
              'Контроль доступа на основе идентификации',
              'Сегментация сети и изоляция',
              'Непрерывная аутентификация и авторизация',
              'Решения о доступе с учётом рисков'
            ]
          },
          {
            title: 'Соответствие требованиям и отчётность',
            description: 'Обеспечьте соответствие нормативным требованиям благодаря автоматизированной отчётности, журналам аудита и применению политик в рамках разных нормативов и стандартов.',
            capabilities: [
              'Автоматизированный мониторинг соответствия',
              'Настраиваемые отчёты и дашборды',
              'Ведение журналов аудита',
              'Соответствие нормативным стандартам'
            ]
          }
        ],
        technologies: {
          title: 'Технологический стек',
          description: 'Платформы и инструменты, которые мы используем для защиты конечных устройств.',
          platforms: [
            { name: 'Microsoft Intune', category: 'Управление устройствами' },
            { name: 'Microsoft Defender', category: 'Защита конечных устройств' },
            { name: 'Jamf Pro', category: 'Управление macOS' },
            { name: 'CrowdStrike Falcon', category: 'Платформа EDR' },
            { name: 'SentinelOne', category: 'Автономное реагирование' },
            { name: 'VMware Workspace ONE', category: 'Унифицированное управление конечными устройствами' }
          ]
        },
        implementation: {
          title: 'Методология внедрения',
          description: 'Наш проверенный подход обеспечивает успешное внедрение средств защиты конечных устройств и их принятие пользователями.',
          phases: [
            {
              phase: 'Оценка и планирование',
              duration: '1-2 недели',
              description: 'Комплексная оценка безопасности, анализ пробелов и стратегическое планирование защиты конечных устройств.',
              deliverables: ['Оценка уровня защищённости', 'Отчёт об анализе рисков', 'Дорожная карта внедрения', 'Рекомендации по технологиям']
            },
            {
              phase: 'Проектирование и настройка',
              duration: '2-3 недели',
              description: 'Проектирование архитектуры решения, настройка политик и внедрение стандартов безопасности.',
              deliverables: ['Проектирование архитектуры безопасности', 'Конфигурации политик', 'Спецификации интеграций', 'Протоколы тестирования']
            },
            {
              phase: 'Внедрение и тестирование',
              duration: '2-4 недели',
              description: 'Поэтапное внедрение по средам с комплексными процедурами тестирования и валидации.',
              deliverables: ['Пилотное внедрение', 'Тесты производительности', 'Валидация безопасности', 'Приёмочное тестирование пользователями']
            },
            {
              phase: 'Обучение и оптимизация',
              duration: '1-2 недели',
              description: 'Обучение персонала, предоставление документации и рекомендации по постоянной оптимизации.',
              deliverables: ['Учебные материалы', 'Документация', 'План оптимизации', 'Процедуры поддержки']
            }
          ]
        },
        benefits: {
          title: 'Влияние на бизнес',
          description: 'Повысьте уровень защищённости, одновременно улучшая операционную эффективность и снижая риски.',
          outcomes: [
            {
              label: 'Точность обнаружения угроз',
              description: 'Продвинутое обнаружение на основе ИИ снижает число ложных срабатываний, сохраняя при этом полный охват угроз.'
            },
            {
              label: 'Снижение числа инцидентов безопасности',
              description: 'Проактивное предотвращение угроз и автоматическое реагирование значительно сокращают число инцидентов безопасности.'
            },
            {
              label: 'Более быстрое реагирование на инциденты',
              description: 'Автоматизированные процессы и централизованное управление ускоряют обнаружение и устранение инцидентов.'
            },
            {
              label: 'Соответствие требованиям',
              description: 'Комплексный мониторинг и отчётность обеспечивают непрерывное соответствие всем нормативным стандартам.'
            }
          ]
        }
      },
      infrastructureManagement: {
        title: 'Управление инфраструктурой',
        subtitle: 'Управление серверами, устройствами и VM',
        description: 'Централизуйте управление серверами, сетью и VM с мониторингом, планированием мощностей и автоматическим восстановлением, чтобы гибридные среды были быстрыми, устойчивыми и соответствовали требованиям.',
        heroContent: {
          mainTitle: 'Управление инфраструктурой',
          subtitle: 'Комплексное управление инфраструктурой, включая администрирование серверов, управление устройствами и оптимизацию виртуальных машин',
          keyPoints: [
            'Комплексное администрирование и мониторинг серверов',
            'Оптимизация и управление виртуальными машинами',
            'Автоматизированное резервное копирование и аварийное восстановление',
            'Мониторинг производительности и планирование мощностей'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Сложность инфраструктуры',
            description: 'Современные предприятия сталкиваются со сложной, распределённой инфраструктурой, которая требует постоянного мониторинга, обслуживания и оптимизации для обеспечения непрерывности бизнеса и производительности.',
            challenges: [
              'Разрозненные инструменты мониторинга, оставляющие слепые зоны',
              'Ручные процессы, вызывающие операционную неэффективность',
              'Сложности с планированием мощностей и оптимизацией ресурсов',
              'Сложность резервного копирования и аварийного восстановления'
            ]
          },
          solution: {
            title: 'Единое управление инфраструктурой',
            description: 'Мы предлагаем комплексное управление инфраструктурой, которое централизует контроль, автоматизирует процессы и обеспечивает оптимальную производительность во всей вашей ИТ-среде.',
            benefits: [
              'Централизованная платформа мониторинга и управления',
              'Автоматизированные процессы резервного копирования и восстановления',
              'Проактивная оптимизация производительности',
              'Комплексное планирование мощностей и масштабирование'
            ]
          }
        },
        features: [
          {
            title: 'Администрирование серверов',
            description: 'Комплексное управление жизненным циклом серверов, включая развёртывание, настройку, мониторинг и обслуживание в средах Windows и Linux.',
            capabilities: [
              'Развёртывание и настройка серверов',
              'Мониторинг производительности и оптимизация',
              'Управление патчами и обновлениями безопасности',
              'Планирование мощностей и оптимизация ресурсов'
            ]
          },
          {
            title: 'Управление базами данных',
            description: 'Экспертное администрирование и оптимизация баз данных, обеспечивающие высокую доступность, производительность и безопасность ваших критически важных систем.',
            capabilities: [
              'Установка и конфигурация баз данных',
              'Настройка производительности и оптимизация',
              'Стратегии резервного копирования и восстановления',
              'Усиление безопасности и соответствие требованиям'
            ]
          },
          {
            title: 'Оптимизация виртуальных машин',
            description: 'Управление виртуализацией VMware и Hyper-V с оптимизацией использования ресурсов, производительности и экономической эффективности.',
            capabilities: [
              'Развёртывание виртуальных машин и управление ими',
              'Выделение и оптимизация ресурсов',
              'Миграция и консолидация VM',
              'Мониторинг производительности и настройка'
            ]
          },
          {
            title: 'Мониторинг и аналитика',
            description: 'Комплексный мониторинг инфраструктуры с продвинутой аналитикой, оповещениями и отчётностью для проактивного обнаружения и решения проблем.',
            capabilities: [
              'Мониторинг инфраструктуры в реальном времени',
              'Предиктивная аналитика и оповещения',
              'Настраиваемые дашборды и отчётность',
              'Планирование мощностей и прогнозирование'
            ]
          }
        ],
        technologies: {
          title: 'Технологическая экспертиза',
          description: 'Глубокое знание платформ и инструментов управления инфраструктурой.',
          platforms: [
            { name: 'VMware vSphere', category: 'Платформа виртуализации' },
            { name: 'Microsoft Hyper-V', category: 'Гипервизор' },
            { name: 'Microsoft System Center', category: 'Пакет средств управления' },
            { name: 'Nagios', category: 'Система мониторинга' },
            { name: 'Veeam', category: 'Резервное копирование и восстановление' },
            { name: 'SolarWinds', category: 'Мониторинг инфраструктуры' }
          ]
        },
        implementation: {
          title: 'Методология внедрения',
          description: 'Структурированный подход к внедрению управления инфраструктурой, обеспечивающий оптимальную производительность и надёжность.',
          phases: [
            {
              phase: 'Оценка и обследование',
              duration: '1-2 недели',
              description: 'Комплексная оценка инфраструктуры и анализ текущего состояния.',
              deliverables: ['Отчёт по аудиту инфраструктуры', 'Базовый уровень производительности', 'Анализ мощностей', 'Оценка рисков']
            },
            {
              phase: 'Проектирование и планирование',
              duration: '2-3 недели',
              description: 'Проектирование архитектуры решения и планирование внедрения.',
              deliverables: ['Проектирование архитектуры', 'Дорожная карта внедрения', 'Стратегия миграции', 'Протоколы тестирования']
            },
            {
              phase: 'Внедрение и миграция',
              duration: '3-4 недели',
              description: 'Поэтапное внедрение с комплексным тестированием и валидацией.',
              deliverables: ['Внедрение инфраструктуры', 'Миграция данных', 'Тесты производительности', 'Обучение пользователей']
            },
            {
              phase: 'Оптимизация и поддержка',
              duration: 'Постоянно',
              description: 'Непрерывная оптимизация и постоянная поддержка для оптимальной производительности.',
              deliverables: ['Оптимизация производительности', 'Регулярный мониторинг', 'Поддержка 24/7', 'Непрерывное улучшение']
            }
          ]
        },
        benefits: {
          title: 'Операционный эффект',
          description: 'Обеспечиваем измеримое улучшение производительности, надёжности и операционной эффективности.',
          outcomes: [
            {
              label: 'Выполнение SLA',
              description: 'Проактивный мониторинг и обслуживание обеспечивают максимальную доступность системы и непрерывность бизнеса.'
            },
            {
              label: 'Сокращение простоев',
              description: 'Автоматизированный мониторинг и быстрое реагирование значительно сокращают число незапланированных простоев.'
            },
            {
              label: 'Более быстрое решение проблем',
              description: 'Централизованный мониторинг и автоматизированные оповещения ускоряют обнаружение и решение проблем.'
            },
            {
              label: 'Оптимизация затрат',
              description: 'Оптимизация ресурсов и планирование мощностей снижают затраты на инфраструктуру, одновременно улучшая производительность.'
            }
          ]
        }
      },
      databaseManagement: {
        title: 'Управление базами данных',
        subtitle: 'Настройка, миграция и администрирование',
        description: 'Стабилизируйте критически важные базы данных с помощью миграции, настройки, автоматизированного резервного копирования и мониторинга 24/7, которые отслеживают производительность, время безотказной работы и соответствие требованиям.',
        heroContent: {
          mainTitle: 'Управление базами данных',
          subtitle: 'Экспертное управление базами данных, миграция и оптимизация для максимальной производительности и надёжности',
          keyPoints: [
            'Настройка и конфигурация баз данных',
            'Безопасная миграция данных',
            'Оптимизация производительности и настройка',
            'Мониторинг и поддержка 24/7'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Сложности управления базами данных',
            description: 'Организации сталкиваются с проблемами производительности баз данных, сложными миграциями, уязвимостями безопасности и нехваткой опытных специалистов по базам данных.',
            challenges: [
              'Низкая производительность баз данных, влияющая на работу приложений',
              'Сложные проекты миграции, вызывающие простои',
              'Уязвимости безопасности и проблемы с соответствием требованиям',
              'Нехватка опытных администраторов баз данных'
            ]
          },
          solution: {
            title: 'Комплексные решения для баз данных',
            description: 'Мы предоставляем экспертные услуги по управлению базами данных, которые оптимизируют производительность, обеспечивают безопасную миграцию и надёжную работу баз данных.',
            benefits: [
              'Оптимизированная производительность и надёжность баз данных',
              'Бесперебойная и безопасная миграция данных',
              'Улучшенная безопасность и соответствие требованиям',
              'Экспертное администрирование и поддержка 24/7'
            ]
          }
        },
        features: [
          {
            title: 'Настройка и конфигурация баз данных',
            description: 'Профессиональная установка, конфигурация и настройка баз данных для оптимальной производительности и безопасности.',
            capabilities: [
              'Установка и настройка серверов баз данных',
              'Настройка производительности и оптимизация',
              'Усиление безопасности и конфигурация',
              'Обеспечение высокой доступности'
            ]
          },
          {
            title: 'Миграция баз данных',
            description: 'Безопасная и надёжная миграция баз данных с минимальным простоем и комплексным тестированием.',
            capabilities: [
              'Планирование и выполнение миграции баз данных',
              'Валидация целостности данных и тестирование',
              'Стратегии миграции без простоя',
              'Оптимизация и поддержка после миграции'
            ]
          },
          {
            title: 'Оптимизация производительности',
            description: 'Настройка и оптимизация производительности баз данных, обеспечивающие быстрое выполнение запросов и эффективное использование ресурсов.',
            capabilities: [
              'Оптимизация и настройка запросов',
              'Управление и оптимизация индексов',
              'Мониторинг и анализ баз данных',
              'Планирование мощностей и масштабирование'
            ]
          },
          {
            title: 'Постоянное администрирование',
            description: 'Комплексное администрирование баз данных, включая мониторинг, резервное копирование, безопасность и обслуживание.',
            capabilities: [
              'Мониторинг и поддержка баз данных 24/7',
              'Автоматизированное резервное копирование и восстановление',
              'Обновления безопасности и управление патчами',
              'Мониторинг производительности и отчётность'
            ]
          }
        ],
        technologies: {
          title: 'Экспертиза по базам данных',
          description: 'Опыт работы с платформами и инструментами управления базами данных.',
          platforms: [
            { name: 'PostgreSQL', category: 'База данных с открытым исходным кодом' },
            { name: 'MySQL', category: 'Реляционная база данных' },
            { name: 'Microsoft SQL Server', category: 'Корпоративная база данных' },
            { name: 'Oracle Database', category: 'Корпоративная база данных' },
            { name: 'MongoDB', category: 'NoSQL-база данных' },
            { name: 'Redis', category: 'База данных в оперативной памяти' }
          ]
        },
        implementation: {
          title: 'Процесс внедрения',
          description: 'Структурированный подход к управлению базами данных, обеспечивающий оптимальную производительность и надёжность.',
          phases: [
            {
              phase: 'Оценка и планирование',
              duration: '1-2 недели',
              description: 'Комплексная оценка баз данных и разработка стратегии управления.',
              deliverables: ['Отчёт по аудиту баз данных', 'Базовый уровень производительности', 'Стратегия управления', 'Оценка безопасности']
            },
            {
              phase: 'Настройка и конфигурация',
              duration: '2-3 недели',
              description: 'Настройка, конфигурация и оптимизация баз данных перед вводом в эксплуатацию.',
              deliverables: ['Установка баз данных', 'Настройка производительности', 'Конфигурация безопасности', 'Стратегия резервного копирования']
            },
            {
              phase: 'Миграция и внедрение',
              duration: '2-4 недели',
              description: 'Безопасная миграция и внедрение баз данных с комплексным тестированием.',
              deliverables: ['Миграция данных', 'Тесты производительности', 'Валидация безопасности', 'Приёмка пользователями']
            },
            {
              phase: 'Постоянная поддержка',
              duration: 'Постоянно',
              description: 'Непрерывный мониторинг, оптимизация и поддержка баз данных 24/7.',
              deliverables: ['Мониторинг 24/7', 'Оптимизация производительности', 'Обновления безопасности', 'Постоянная поддержка']
            }
          ]
        },
        benefits: {
          title: 'Влияние на производительность',
          description: 'Обеспечиваем измеримое улучшение производительности, надёжности и безопасности баз данных.',
          outcomes: [
            {
              label: 'Улучшение производительности',
              description: 'Оптимизация значительно повышает производительность запросов и сокращает время отклика.'
            },
            {
              label: 'Гарантия SLA',
              description: 'Надёжная работа баз данных, комплексный мониторинг и поддержка обеспечивают максимальную доступность.'
            },
            {
              label: 'Более быстрое выполнение запросов',
              description: 'Настройка и оптимизация производительности значительно сокращают время выполнения запросов.'
            },
            {
              label: 'Безопасность данных и соответствие требованиям',
              description: 'Усиленные меры безопасности и контроля соответствия обеспечивают защиту данных и соблюдение нормативных требований.'
            }
          ]
        }
      },
      serviceDesk: {
        title: 'Внедрение Service Desk',
        subtitle: 'Настройка Jira, YouTrack и Zammad',
        description: 'Запустите службу поддержки на Jira, ServiceNow или YouTrack с рабочими процессами, SLA и автоматизацией, которые сокращают время решения и дают агентам полный контекст тикетов.',
        heroContent: {
          mainTitle: 'Внедрение Service Desk',
          subtitle: 'Профессиональная настройка и конфигурация service desk для эффективной работы ИТ-поддержки',
          keyPoints: [
            'Внедрение профессиональной платформы service desk',
            'Автоматизированная маршрутизация тикетов и эскалация',
            'Комплексная отчётность и аналитика',
            'Интеграция с существующими ИТ-системами'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Сложности в работе ИТ-поддержки',
            description: 'Организации сталкиваются с неэффективными процессами поддержки, плохим управлением тикетами и отсутствием прозрачности в работе ИТ-сервисов.',
            challenges: [
              'Ручная маршрутизация тикетов, вызывающая задержки',
              'Отсутствие стандартизированных процессов поддержки',
              'Недостаточная прозрачность метрик поддержки',
              'Сложности интеграции с существующими системами'
            ]
          },
          solution: {
            title: 'Комплексные решения Service Desk',
            description: 'Мы внедряем профессиональные платформы service desk, которые автоматизируют процессы, повышают эффективность и обеспечивают полную прозрачность работы ИТ-поддержки.',
            benefits: [
              'Автоматизированная маршрутизация тикетов и эскалация',
              'Стандартизированные процессы и маршруты поддержки',
              'Комплексная отчётность и аналитика',
              'Интеграция с существующими системами'
            ]
          }
        },
        features: [
          {
            title: 'Внедрение платформы',
            description: 'Полная настройка и конфигурация платформы service desk на базе Jira Service Desk, YouTrack или Zammad в зависимости от ваших требований.',
            capabilities: [
              'Выбор и конфигурация платформы',
              'Проектирование и внедрение индивидуальных рабочих процессов',
              'Настройка пользовательского интерфейса',
              'Интеграция с существующими системами'
            ]
          },
          {
            title: 'Автоматизация процессов',
            description: 'Автоматизированные маршрутизация тикетов, эскалация и решение обращений, которые повышают эффективность и сокращают время отклика.',
            capabilities: [
              'Правила автоматизированной маршрутизации тикетов',
              'Эскалация и управление SLA',
              'Процессы согласования и их автоматизация',
              'Автоматизация уведомлений и коммуникаций'
            ]
          },
          {
            title: 'Отчётность и аналитика',
            description: 'Комплексная отчётность и аналитика, дающая представление о работе поддержки, удовлетворённости пользователей и операционной эффективности.',
            capabilities: [
              'Создание настраиваемых дашбордов',
              'Метрики производительности и KPI',
              'Анализ трендов и прогнозирование',
              'Отчёты и аналитика для руководства'
            ]
          },
          {
            title: 'Интеграция и безопасность',
            description: 'Безопасная интеграция с существующими ИТ-системами и внедрение лучших практик безопасности в работе service desk.',
            capabilities: [
              'Интеграция Active Directory',
              'Внедрение единого входа (Single Sign-On)',
              'Применение политик безопасности',
              'Журналы аудита и отчёты о соответствии'
            ]
          }
        ],
        technologies: {
          title: 'Экспертиза по платформам',
          description: 'Опыт работы с платформами service desk и сопутствующими технологиями.',
          platforms: [
            { name: 'Jira Service Desk', category: 'Платформа Atlassian' },
            { name: 'YouTrack', category: 'Продукт JetBrains' },
            { name: 'Zammad', category: 'Платформа с открытым исходным кодом' },
            { name: 'ServiceNow', category: 'Корпоративная платформа' },
            { name: 'Freshservice', category: 'Облачное решение' },
            { name: 'ManageEngine', category: 'Пакет управления ИТ' }
          ]
        },
        implementation: {
          title: 'Процесс внедрения',
          description: 'Структурированный подход к внедрению service desk, обеспечивающий успешное освоение системы и её оптимизацию.',
          phases: [
            {
              phase: 'Требования и планирование',
              duration: '1-2 недели',
              description: 'Комплексный анализ требований и планирование внедрения.',
              deliverables: ['Спецификация требований', 'Выбор платформы', 'План внедрения', 'Сроки и контрольные точки']
            },
            {
              phase: 'Конфигурация и настройка',
              duration: '2-3 недели',
              description: 'Конфигурация платформы, проектирование рабочих процессов и настройка системы.',
              deliverables: ['Конфигурация платформы', 'Внедрение рабочих процессов', 'Настройка пользовательского интерфейса', 'Конфигурация интеграций']
            },
            {
              phase: 'Тестирование и обучение',
              duration: '1-2 недели',
              description: 'Комплексное тестирование и обучение пользователей для успешного освоения системы.',
              deliverables: ['Тестирование системы', 'Учебные материалы для пользователей', 'Обучение администраторов', 'Подготовка к запуску']
            },
            {
              phase: 'Запуск и оптимизация',
              duration: 'Постоянно',
              description: 'Поддержка запуска и непрерывная оптимизация для оптимальной производительности.',
              deliverables: ['Поддержка запуска', 'Мониторинг производительности', 'Оптимизация процессов', 'Постоянное обслуживание']
            }
          ]
        },
        benefits: {
          title: 'Влияние на сервис',
          description: 'Обеспечиваем измеримое улучшение эффективности поддержки и удовлетворённости пользователей.',
          outcomes: [
            {
              label: 'Более быстрое решение тикетов',
              description: 'Автоматизированная маршрутизация и стандартизированные процессы значительно сокращают время решения.'
            },
            {
              label: 'Удовлетворённость пользователей',
              description: 'Более высокое качество сервиса и меньшее время отклика повышают удовлетворённость пользователей.'
            },
            {
              label: 'Сокращение числа эскалаций',
              description: 'Более частое решение вопросов при первом обращении и автоматизированная эскалация сокращают число ненужных эскалаций.'
            },
            {
              label: 'Снижение затрат',
              description: 'Оптимизированные процессы и автоматизация снижают операционные затраты на поддержку.'
            }
          ]
        }
      },
      knowledgeManagement: {
        title: 'Управление знаниями',
        subtitle: 'Confluence и системы баз знаний',
        description: 'Создавайте порталы Confluence и базы знаний с правилами управления, шаблонами и циклами проверки, чтобы знания, которые хранятся в головах сотрудников, превращались в надёжную документацию для повторного использования.',
        heroContent: {
          mainTitle: 'Управление знаниями',
          subtitle: 'Комплексные решения по управлению знаниями для качественной документации и обмена информацией',
          keyPoints: [
            'Внедрение централизованного хранилища знаний',
            'Продвинутый поиск и навигация по контенту',
            'Совместная работа над документацией',
            'Процессы сохранения и передачи знаний'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Сложности управления знаниями',
            description: 'Организации сталкиваются с разрозненной информацией, плохим обменом знаниями и трудностями с поиском нужной информации в нужный момент.',
            challenges: [
              'Информация разбросана по нескольким системам',
              'Недостаточный обмен знаниями и слабое сотрудничество',
              'Трудности с поиском нужной информации',
              'Потеря знаний из-за текучести кадров'
            ]
          },
          solution: {
            title: 'Комплексное управление знаниями',
            description: 'Мы внедряем централизованные системы управления знаниями, которые организуют информацию, способствуют сотрудничеству и обеспечивают сохранение знаний.',
            benefits: [
              'Централизованное хранилище знаний',
              'Продвинутый поиск и навигация по контенту',
              'Совместная работа над документацией',
              'Процессы сохранения и передачи знаний'
            ]
          }
        },
        features: [
          {
            title: 'Внедрение платформы',
            description: 'Полная настройка платформы управления знаниями на базе Confluence, SharePoint или аналогичных решений.',
            capabilities: [
              'Выбор и конфигурация платформы',
              'Структура и организация сайта',
              'Создание и настройка шаблонов',
              'Настройка доступа пользователей и разрешений'
            ]
          },
          {
            title: 'Управление контентом',
            description: 'Структурированные процессы управления контентом, обеспечивающие точность и актуальность информации и удобный поиск.',
            capabilities: [
              'Процессы создания контента',
              'Процессы проверки и утверждения',
              'Контроль версий и управление изменениями',
              'Управление жизненным циклом контента'
            ]
          },
          {
            title: 'Поиск и навигация',
            description: 'Продвинутый поиск и навигация по контенту, которые помогают пользователям быстро находить нужную информацию.',
            capabilities: [
              'Продвинутая конфигурация поиска',
              'Тегирование и категоризация контента',
              'Механизмы рекомендаций',
              'Аналитика и отслеживание использования'
            ]
          },
          {
            title: 'Совместная работа и обмен знаниями',
            description: 'Функции для совместной работы, способствующие обмену знаниями и командному взаимодействию.',
            capabilities: [
              'Совместное редактирование и комментирование',
              'Процессы обмена знаниями',
              'Функции для командной работы',
              'Интеграция с инструментами коммуникации'
            ]
          }
        ],
        technologies: {
          title: 'Экспертиза по платформам',
          description: 'Опыт работы с платформами управления знаниями и сопутствующими технологиями.',
          platforms: [
            { name: 'Confluence', category: 'Платформа Atlassian' },
            { name: 'SharePoint', category: 'Продукт Microsoft' },
            { name: 'Notion', category: 'Современная платформа' },
            { name: 'GitBook', category: 'Платформа для документации' },
            { name: 'Slab', category: 'База знаний для команд' },
            { name: 'Tettra', category: 'Внутренняя база знаний' }
          ]
        },
        implementation: {
          title: 'Методология внедрения',
          description: 'Структурированный подход к внедрению управления знаниями, обеспечивающий успешное освоение и реальную отдачу.',
          phases: [
            {
              phase: 'Оценка и стратегия',
              duration: '1-2 недели',
              description: 'Аудит знаний и разработка стратегии для эффективного управления знаниями.',
              deliverables: ['Отчёт по аудиту знаний', 'Стратегический документ', 'Выбор платформы', 'Дорожная карта внедрения']
            },
            {
              phase: 'Проектирование и настройка',
              duration: '2-3 недели',
              description: 'Проектирование платформы, конфигурация и разработка структуры контента.',
              deliverables: ['Конфигурация платформы', 'Структура контента', 'Создание шаблонов', 'Учебные материалы для пользователей']
            },
            {
              phase: 'Миграция и запуск',
              duration: '2-4 недели',
              description: 'Миграция контента, обучение пользователей и запуск платформы.',
              deliverables: ['Миграция контента', 'Обучение пользователей', 'Поддержка запуска', 'Управление изменениями']
            },
            {
              phase: 'Оптимизация и поддержка',
              duration: 'Постоянно',
              description: 'Непрерывная оптимизация и постоянная поддержка системы управления знаниями.',
              deliverables: ['Оптимизация производительности', 'Обслуживание контента', 'Поддержка пользователей', 'Непрерывное улучшение']
            }
          ]
        },
        benefits: {
          title: 'Эффект от управления знаниями',
          description: 'Обеспечиваем измеримое улучшение обмена знаниями, сотрудничества и принятия решений.',
          outcomes: [
            {
              label: 'Более быстрый доступ к информации',
              description: 'Централизованное хранилище знаний и продвинутый поиск значительно сокращают время поиска информации.'
            },
            {
              label: 'Сокращение дублирования работы',
              description: 'Налаженный обмен знаниями сокращает дублирование работы и повышает эффективность.'
            },
            {
              label: 'Улучшенное сотрудничество',
              description: 'Функции совместной работы и обмен знаниями улучшают взаимодействие и коммуникацию в команде.'
            },
            {
              label: 'Сохранение знаний',
              description: 'Структурированные процессы управления знаниями обеспечивают сохранение и доступность организационных знаний.'
            }
          ]
        }
      },
      cloudWorkspace: {
        title: 'Облачные рабочие пространства',
        subtitle: 'Microsoft 365 и Google Workspace',
        description: 'Модернизируйте M365 и Google Workspace: автоматическое предоставление доступа, онбординг, DLP-ограничения и рабочие процессы помогут сделать совместную работу безопасной, быстрой и соответствующей требованиям.',
        heroContent: {
          mainTitle: 'Облачные рабочие пространства',
          subtitle: 'Полная настройка и администрирование облачных рабочих пространств Microsoft 365 и Google Workspace',
          keyPoints: [
            'Полное администрирование Microsoft 365 и Google Workspace',
            'Продвинутая настройка безопасности и соответствия требованиям',
            'Миграция и интеграция',
            'Непрерывная оптимизация и поддержка'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Сложность облачных рабочих пространств',
            description: 'Организации сталкиваются со сложными облачными средами, непростой настройкой безопасности и трудностями в обеспечении оптимальной производительности для распределённых команд.',
            challenges: [
              'Сложные требования к безопасности и соответствию',
              'Сложности интеграции между платформами',
              'Освоение системы пользователями и управление изменениями',
              'Оптимизация затрат и управление лицензиями'
            ]
          },
          solution: {
            title: 'Комплексное управление облаком',
            description: 'Мы предлагаем комплексные решения для облачных рабочих пространств, которые упрощают управление, одновременно обеспечивая максимальную безопасность и продуктивность.',
            benefits: [
              'Единое администрирование всех платформ',
              'Автоматизированная безопасность и соответствие',
              'Оптимизированное управление пользователями',
              'Экономически эффективная оптимизация лицензий'
            ]
          }
        },
        features: [
          {
            title: 'Администрирование платформы',
            description: 'Полное администрирование сред Microsoft 365 и Google Workspace с продвинутой конфигурацией и оптимизацией.',
            capabilities: [
              'Конфигурация и оптимизация тенанта',
              'Управление жизненным циклом пользователей',
              'Внедрение политик безопасности',
              'Мониторинг производительности и настройка'
            ]
          },
          {
            title: 'Безопасность и соответствие требованиям',
            description: 'Настройки безопасности корпоративного уровня, обеспечивающие защиту данных и соответствие нормативным требованиям во всех облачных сервисах.',
            capabilities: [
              'Политики предотвращения потери данных (DLP)',
              'Политики условного доступа',
              'Отчётность и мониторинг соответствия',
              'Защита от угроз и реагирование'
            ]
          },
          {
            title: 'Миграция и интеграция',
            description: 'Миграция и интеграция, которые связывают ваше облачное рабочее пространство с существующими системами.',
            capabilities: [
              'Миграция электронной почты и данных',
              'Синхронизация каталога',
              'Интеграция приложений',
              'Поддержка управления изменениями'
            ]
          },
          {
            title: 'Оптимизация и поддержка',
            description: 'Непрерывная оптимизация и поддержка 24/7, обеспечивающие работу вашей облачной среды на пике производительности.',
            capabilities: [
              'Мониторинг производительности и оптимизация',
              'Управление лицензиями и оптимизация затрат',
              'Техническая поддержка 24/7',
              'Регулярные проверки состояния и отчётность'
            ]
          }
        ],
        technologies: {
          title: 'Экспертиза по платформам',
          description: 'Глубокое знание платформ облачных рабочих пространств и сопутствующих технологий.',
          platforms: [
            { name: 'Microsoft 365', category: 'Офисный пакет' },
            { name: 'Google Workspace', category: 'Платформа для совместной работы' },
            { name: 'Azure Active Directory', category: 'Управление идентификацией' },
            { name: 'Microsoft Defender', category: 'Платформа безопасности' },
            { name: 'Google Cloud Identity', category: 'Сервисы идентификации' },
            { name: 'Okta', category: 'Провайдер идентификации' }
          ]
        },
        implementation: {
          title: 'Процесс внедрения',
          description: 'Структурированный подход к внедрению облачных рабочих пространств, обеспечивающий успешное освоение и оптимизацию.',
          phases: [
            {
              phase: 'Оценка и стратегия',
              duration: '1-2 недели',
              description: 'Комплексная оценка текущей среды и разработка облачной стратегии.',
              deliverables: ['Анализ текущего состояния', 'Документ облачной стратегии', 'Дорожная карта миграции', 'Модель безопасности']
            },
            {
              phase: 'Проектирование и настройка',
              duration: '2-3 недели',
              description: 'Проектирование решения и настройка облачного рабочего пространства.',
              deliverables: ['Проектирование архитектуры', 'Настройки безопасности', 'Спецификации интеграций', 'Планы тестирования']
            },
            {
              phase: 'Миграция и внедрение',
              duration: '3-4 недели',
              description: 'Поэтапная миграция и внедрение с комплексным тестированием и валидацией.',
              deliverables: ['Пилотная миграция', 'Полное внедрение', 'Обучение пользователей', 'Поддержка запуска']
            },
            {
              phase: 'Оптимизация и поддержка',
              duration: 'Постоянно',
              description: 'Непрерывная оптимизация и постоянная поддержка для оптимальной производительности.',
              deliverables: ['Оптимизация производительности', 'Регулярный мониторинг', 'Поддержка 24/7', 'Непрерывное улучшение']
            }
          ]
        },
        benefits: {
          title: 'Ценность для бизнеса',
          description: 'Обеспечиваем измеримую ценность для бизнеса благодаря оптимизированным облачным рабочим пространствам.',
          outcomes: [
            {
              label: 'Снижение затрат на ИТ',
              description: 'Оптимизация лицензий и упрощённое администрирование снижают общие операционные затраты на ИТ.'
            },
            {
              label: 'Удовлетворённость пользователей',
              description: 'Улучшенный пользовательский опыт и продуктивность благодаря оптимизированной настройке облачного рабочего пространства.'
            },
            {
              label: 'Гарантия SLA',
              description: 'Надёжная облачная инфраструктура с комплексным мониторингом и проактивной поддержкой.'
            },
            {
              label: 'Соответствие требованиям',
              description: 'Комплексная безопасность и контроль соответствия обеспечивают соблюдение нормативных требований.'
            }
          ]
        }
      },
      identityAccess: {
        title: 'Управление идентификацией и доступом',
        subtitle: 'Active Directory, Okta и CyberArk',
        description: 'Внедрите Azure AD, Okta и CyberArk с SSO, MFA, автоматизацией жизненного цикла и политиками PAM, чтобы исключить бесконтрольное накопление прав доступа и успешно проходить аудиты.',
        heroContent: {
          mainTitle: 'Управление идентификацией и доступом',
          subtitle: 'Безопасные решения для управления идентификацией и доступом (IAM)',
          keyPoints: [
            'Продвинутая аутентификация и авторизация',
            'Управление привилегированным доступом (PAM)',
            'Внедрение единого входа (SSO)',
            'Комплексный аудит и соответствие требованиям'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Проблемы безопасности учётных записей',
            description: 'Организации сталкиваются с растущими рисками из-за атак на учётные записи, сложными требованиями к управлению доступом и нормативными требованиями.',
            challenges: [
              'Атаки на учётные записи и кража учётных данных',
              'Сложное управление доступом в разных системах',
              'Пробелы в безопасности привилегированного доступа',
              'Нормативные требования и аудит'
            ]
          },
          solution: {
            title: 'Комплексная защита учётных записей',
            description: 'Мы предлагаем интегрированные решения для управления идентификацией и доступом, которые обеспечивают безопасный, эффективный и соответствующий требованиям контроль доступа.',
            benefits: [
              'Единая платформа управления идентификацией',
              'Продвинутые механизмы аутентификации',
              'Автоматизированное предоставление доступа',
              'Комплексный аудит и соответствие требованиям'
            ]
          }
        },
        features: [
          {
            title: 'Аутентификация и авторизация',
            description: 'Многофакторная аутентификация и контроль доступа на основе ролей, обеспечивающие безопасный доступ к критически важным системам и данным.',
            capabilities: [
              'Многофакторная аутентификация (MFA)',
              'Внедрение единого входа (SSO)',
              'Контроль доступа на основе ролей (RBAC)',
              'Условные политики доступа'
            ]
          },
          {
            title: 'Управление привилегированным доступом',
            description: 'Безопасное управление привилегированными учётными записями и повышенными правами доступа с комплексным мониторингом и контролем.',
            capabilities: [
              'Обнаружение привилегированных учётных записей',
              'Временный доступ по требованию (Just-in-Time)',
              'Мониторинг и запись сессий',
              'Автоматизированная ротация паролей'
            ]
          },
          {
            title: 'Управление жизненным циклом учётных записей',
            description: 'Автоматическое создание и отключение учётных записей и управление доступом на протяжении всего жизненного цикла сотрудника.',
            capabilities: [
              'Автоматическое создание учётных записей пользователей',
              'Процессы запроса доступа',
              'Управление учётными записями и контроль соответствия',
              'Делегированное администрирование'
            ]
          },
          {
            title: 'Аудит и соответствие требованиям',
            description: 'Комплексные журналы аудита, отчёты о соответствии и оценка рисков в сфере управления идентификацией и доступом.',
            capabilities: [
              'Комплексное ведение журналов аудита',
              'Отчёты о соответствии и дашборды',
              'Оценка рисков и аналитика',
              'Соответствие нормативным стандартам'
            ]
          }
        ],
        technologies: {
          title: 'Технологические платформы',
          description: 'Опыт работы с платформами управления идентификацией и доступом.',
          platforms: [
            { name: 'Microsoft Active Directory', category: 'Службы каталогов' },
            { name: 'Azure Active Directory', category: 'Облачная служба идентификации' },
            { name: 'Okta', category: 'Провайдер идентификации' },
            { name: 'CyberArk', category: 'Управление привилегированным доступом' },
            { name: 'BeyondTrust', category: 'Платформа PAM' },
            { name: 'SailPoint', category: 'Управление идентификацией' }
          ]
        },
        implementation: {
          title: 'Подход к внедрению',
          description: 'Структурированная методология успешного внедрения систем управления идентификацией и доступом.',
          phases: [
            {
              phase: 'Обследование и оценка',
              duration: '1-2 недели',
              description: 'Комплексная оценка текущей инфраструктуры идентификации и уровня защищённости.',
              deliverables: ['Отчёт по аудиту учётных записей', 'Оценка рисков', 'Анализ пробелов', 'Стратегия внедрения']
            },
            {
              phase: 'Проектирование и архитектура',
              duration: '2-3 недели',
              description: 'Проектирование архитектуры решения и внедрение стандартов безопасности.',
              deliverables: ['Проектирование архитектуры', 'Политики безопасности', 'Спецификации интеграций', 'Протоколы тестирования']
            },
            {
              phase: 'Внедрение и интеграция',
              duration: '3-4 недели',
              description: 'Поэтапное внедрение с комплексным тестированием и валидацией интеграций.',
              deliverables: ['Пилотное внедрение', 'Тесты интеграций', 'Валидация безопасности', 'Обучение пользователей']
            },
            {
              phase: 'Оптимизация и поддержка',
              duration: 'Постоянно',
              description: 'Непрерывная оптимизация и постоянная поддержка для поддержания высокого уровня защищённости.',
              deliverables: ['Оптимизация производительности', 'Мониторинг безопасности', 'Поддержка 24/7', 'Непрерывное улучшение']
            }
          ]
        },
        benefits: {
          title: 'Влияние на безопасность',
          description: 'Значительно повысьте уровень защищённости, одновременно улучшая операционную эффективность.',
          outcomes: [
            {
              label: 'Снижение рисков, связанных с учётными записями',
              description: 'Комплексная защита учётных записей снижает риск атак с использованием учётных данных и утечек данных.'
            },
            {
              label: 'Более быстрое предоставление доступа',
              description: 'Автоматизированные процессы ускоряют онбординг пользователей и управление доступом.'
            },
            {
              label: 'Соответствие требованиям',
              description: 'Комплексный аудит и отчётность обеспечивают непрерывное соответствие нормативным требованиям.'
            },
            {
              label: 'Снижение административной нагрузки',
              description: 'Автоматизированное управление учётными записями снижает административную нагрузку и операционные затраты.'
            }
          ]
        }
      },
      automationDevops: {
        title: 'ИТ-автоматизация и DevOps',
        subtitle: 'Скриптинг, CI/CD и автоматизация процессов',
        description: 'Проектируйте CI/CD-конвейеры, инфраструктуру как код и самовосстанавливающиеся сценарии (runbooks), чтобы ускорить релизы, сократить рутинную работу и сохранить полную прозрачность сред.',
        heroContent: {
          mainTitle: 'ИТ-автоматизация и DevOps',
          subtitle: 'Автоматизируйте ИТ-процессы и внедряйте практики DevOps для повышения эффективности',
          keyPoints: [
            'Непрерывная интеграция и развёртывание (CI/CD)',
            'Внедрение инфраструктуры как кода (IaC)',
            'Автоматизированное тестирование и обеспечение качества',
            'Решения для мониторинга и наблюдаемости'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Сложности ИТ-эксплуатации',
            description: 'Организации сталкиваются с ручными процессами, медленными развёртываниями и несогласованными средами, которые влияют на продуктивность и надёжность.',
            challenges: [
              'Ручные процессы развёртывания, вызывающие задержки',
              'Несогласованные среды и конфигурации',
              'Недостаточная прозрачность производительности систем',
              'Нехватка ресурсов, сдерживающая инновации'
            ]
          },
          solution: {
            title: 'Операционная эффективность за счёт автоматизации',
            description: 'Мы внедряем комплексную автоматизацию и практики DevOps, которые ускоряют выпуск ПО, одновременно повышая качество и надёжность.',
            benefits: [
              'Автоматизированные конвейеры развёртывания',
              'Единообразное управление средами',
              'Комплексный мониторинг и оповещения',
              'Снижение операционных накладных расходов'
            ]
          }
        },
        features: [
          {
            title: 'Внедрение CI/CD-конвейеров',
            description: 'Автоматизированные конвейеры непрерывной интеграции и развёртывания, обеспечивающие быструю и надёжную поставку программного обеспечения.',
            capabilities: [
              'Автоматизированные процессы сборки и тестирования',
              'Автоматизация развёртывания и отката',
              'Процессы продвижения релизов между средами',
              'Контрольные точки качества и согласования'
            ]
          },
          {
            title: 'Инфраструктура как код (IaC)',
            description: 'Автоматизация инфраструктуры на основе кода для единообразных и воспроизводимых развёртываний.',
            capabilities: [
              'Автоматизация развёртывания инфраструктуры',
              'Управление конфигурацией',
              'Единообразие сред',
              'Контроль версий для инфраструктуры'
            ]
          },
          {
            title: 'Мониторинг и наблюдаемость',
            description: 'Комплексные решения для мониторинга, логирования и наблюдаемости для проактивного обнаружения и решения проблем.',
            capabilities: [
              'Мониторинг производительности приложений',
              'Мониторинг инфраструктуры и оповещения',
              'Централизованное логирование и анализ',
              'Настраиваемые дашборды и отчётность'
            ]
          },
          {
            title: 'Автоматизация процессов',
            description: 'Автоматизация рутинных ИТ-операций и бизнес-процессов для повышения эффективности и сокращения числа ошибок.',
            capabilities: [
              'Автоматизация ИТ-операций',
              'Автоматизация бизнес-процессов',
              'Автоматизация реагирования на инциденты',
              'Автоматизация контроля соответствия и аудита'
            ]
          }
        ],
        technologies: {
          title: 'Технологический стек',
          description: 'Опыт работы с платформами автоматизации и DevOps.',
          platforms: [
            { name: 'GitHub Actions', category: 'Платформа CI/CD' },
            { name: 'Jenkins', category: 'Сервер автоматизации' },
            { name: 'Terraform', category: 'Инфраструктура как код' },
            { name: 'Ansible', category: 'Управление конфигурацией' },
            { name: 'Docker', category: 'Контейнеризация' },
            { name: 'Kubernetes', category: 'Оркестрация контейнеров' }
          ]
        },
        implementation: {
          title: 'Методология внедрения',
          description: 'Проверенный подход к внедрению автоматизации и практик DevOps.',
          phases: [
            {
              phase: 'Оценка и планирование',
              duration: '1-2 недели',
              description: 'Комплексная оценка текущих процессов и разработка стратегии автоматизации.',
              deliverables: ['Оценка процессов', 'Дорожная карта автоматизации', 'Рекомендации по технологиям', 'План внедрения']
            },
            {
              phase: 'Базовая настройка',
              duration: '2-3 недели',
              description: 'Настройка инфраструктуры автоматизации и внедрение базовых практик DevOps.',
              deliverables: ['Настройка CI/CD-конвейера', 'Автоматизация инфраструктуры', 'Внедрение мониторинга', 'Интеграция безопасности']
            },
            {
              phase: 'Внедрение и тестирование',
              duration: '2-4 недели',
              description: 'Внедрение автоматизации с комплексным тестированием и валидацией.',
              deliverables: ['Пилотная автоматизация', 'Тесты производительности', 'Валидация безопасности', 'Обучение пользователей']
            },
            {
              phase: 'Оптимизация и поддержка',
              duration: 'Постоянно',
              description: 'Непрерывная оптимизация и постоянная поддержка для оптимальной производительности.',
              deliverables: ['Оптимизация производительности', 'Улучшение процессов', 'Поддержка 24/7', 'Непрерывное улучшение']
            }
          ]
        },
        benefits: {
          title: 'Операционный эффект',
          description: 'Обеспечиваем измеримое повышение скорости, качества и надёжности.',
          outcomes: [
            {
              label: 'Более быстрое развёртывание',
              description: 'Автоматизированные конвейеры значительно сокращают время развёртывания и объём ручной работы.'
            },
            {
              label: 'Сокращение числа ошибок',
              description: 'Автоматизированные процессы исключают ошибки, связанные с ручной работой, и повышают единообразие.'
            },
            {
              label: 'Сокращение простоев',
              description: 'Проактивный мониторинг и автоматизированное восстановление сокращают простои систем.'
            },
            {
              label: 'Снижение затрат',
              description: 'Автоматизация снижает операционные накладные расходы и требования к ресурсам.'
            }
          ]
        }
      },
      webDevelopment: {
        title: 'Веб-разработка',
        subtitle: 'Веб-приложения и сайты на заказ',
        description: 'Запускайте сверхбыстрые сайты и веб-приложения с дизайн-системами, интеграцией CMS и оптимизацией Core Web Vitals, которые превращают посетителей в квалифицированные лиды.',
        heroContent: {
          mainTitle: 'Веб-разработка',
          subtitle: 'Профессиональная веб-разработка, обслуживание и оптимизация',
          keyPoints: [
            'Разработка веб-приложений на заказ',
            'Современные фреймворки и технологии',
            'Адаптивный дизайн и пользовательский опыт',
            'Оптимизация производительности и безопасность'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Сложности цифровой трансформации',
            description: 'Организациям нужны современные веб-решения, чтобы конкурировать на цифровом рынке, но они сталкиваются с технической сложностью и нехваткой ресурсов.',
            challenges: [
              'Устаревшие веб-технологии, ограничивающие возможности',
              'Плохой пользовательский опыт, снижающий вовлечённость',
              'Уязвимости безопасности и проблемы с соответствием требованиям',
              'Ограничения масштабируемости и производительности'
            ]
          },
          solution: {
            title: 'Комплексные веб-решения',
            description: 'Мы создаём современные веб-приложения, которые обеспечивают исключительный пользовательский опыт, одновременно гарантируя безопасность, производительность и масштабируемость.',
            benefits: [
              'Современные адаптивные веб-приложения',
              'Улучшенный пользовательский опыт и вовлечённость',
              'Надёжная безопасность и соответствие требованиям',
              'Масштабируемая архитектура и производительность'
            ]
          }
        },
        features: [
          {
            title: 'Разработка на заказ',
            description: 'Индивидуальные веб-приложения, созданные на современных фреймворках по лучшим практикам, для оптимальной производительности и удобства сопровождения.',
            capabilities: [
              'Приложения React и Next.js',
              'Backend-разработка на Node.js',
              'Разработка и интеграция API',
              'Проектирование и оптимизация баз данных'
            ]
          },
          {
            title: 'Дизайн пользовательского опыта',
            description: 'Интуитивный адаптивный дизайн, обеспечивающий исключительный пользовательский опыт на всех устройствах и платформах.',
            capabilities: [
              'Дизайн пользовательского интерфейса',
              'Адаптивный веб-дизайн',
              'Оптимизация пользовательского опыта',
              'Соответствие требованиям доступности'
            ]
          },
          {
            title: 'Безопасность и производительность',
            description: 'Надёжные меры безопасности и оптимизация производительности для стабильных и быстрых веб-приложений.',
            capabilities: [
              'Внедрение лучших практик безопасности',
              'Оптимизация производительности',
              'SEO-оптимизация',
              'Поддержка соответствия требованиям и аудитов'
            ]
          },
          {
            title: 'Обслуживание и поддержка',
            description: 'Постоянное обслуживание, обновления и поддержка, обеспечивающие актуальность и безопасность ваших веб-приложений.',
            capabilities: [
              'Регулярные обновления и обслуживание',
              'Мониторинг производительности',
              'Обновления безопасности и патчи',
              'Техническая поддержка 24/7'
            ]
          }
        ],
        technologies: {
          title: 'Технологическая экспертиза',
          description: 'Владение современными технологиями и фреймворками веб-разработки.',
          platforms: [
            { name: 'React', category: 'Frontend-фреймворк' },
            { name: 'Next.js', category: 'Full-stack-фреймворк' },
            { name: 'Node.js', category: 'Backend-среда' },
            { name: 'TypeScript', category: 'Язык программирования' },
            { name: 'Tailwind CSS', category: 'Фреймворк стилизации' },
            { name: 'PostgreSQL', category: 'База данных' }
          ]
        },
        implementation: {
          title: 'Процесс разработки',
          description: 'Структурированный подход к веб-разработке, обеспечивающий качество и соблюдение сроков.',
          phases: [
            {
              phase: 'Планирование и дизайн',
              duration: '1-2 недели',
              description: 'Анализ требований, исследование пользователей и проектирование решения.',
              deliverables: ['Спецификация требований', 'Дизайн пользовательского опыта', 'Техническая архитектура', 'График проекта']
            },
            {
              phase: 'Разработка и тестирование',
              duration: '4-8 недель',
              description: 'Разработка приложения с непрерывным тестированием и обеспечением качества.',
              deliverables: ['Frontend-разработка', 'Backend-разработка', 'Тесты интеграций', 'Обеспечение качества']
            },
            {
              phase: 'Развёртывание и запуск',
              duration: '1-2 недели',
              description: 'Развёртывание в продакшене, оптимизация производительности и поддержка при запуске.',
              deliverables: ['Развёртывание в продакшене', 'Оптимизация производительности', 'Обучение пользователей', 'Поддержка запуска']
            },
            {
              phase: 'Обслуживание и поддержка',
              duration: 'Постоянно',
              description: 'Постоянное обслуживание, обновления и поддержка для оптимальной производительности.',
              deliverables: ['Регулярное обслуживание', 'Обновления функций', 'Мониторинг производительности', 'Поддержка 24/7']
            }
          ]
        },
        benefits: {
          title: 'Влияние на бизнес',
          description: 'Обеспечиваем измеримую ценность для бизнеса с помощью современных веб-решений.',
          outcomes: [
            {
              label: 'Рост вовлечённости пользователей',
              description: 'Современный адаптивный дизайн значительно повышает вовлечённость пользователей и конверсию.'
            },
            {
              label: 'Более быстрая загрузка страниц',
              description: 'Оптимизация производительности сокращает время загрузки страниц и улучшает пользовательский опыт.'
            },
            {
              label: 'Соответствие требованиям безопасности',
              description: 'Надёжные меры безопасности обеспечивают соответствие отраслевым стандартам и нормативным требованиям.'
            },
            {
              label: 'Рост мобильного трафика',
              description: 'Адаптивный дизайн и мобильная оптимизация стимулируют значительное увеличение мобильного трафика.'
            }
          ]
        }
      },
      mobileAppDevelopment: {
        title: 'Разработка мобильных приложений',
        subtitle: 'Приложения iOS и Android, бэкенд и публикация в магазинах',
        description: 'Проектируем и разрабатываем приложения iOS и Android для ваших клиентов или вашей команды, нативные или кроссплатформенные на React Native либо Flutter, вместе с бэкендом и API, публикацией в App Store и Google Play и поддержкой после запуска.',
        heroContent: {
          mainTitle: 'Разработка мобильных приложений',
          subtitle: 'Приложения для iOS и Android, от первого прототипа до публикации в магазинах и дальше',
          keyPoints: [
            'Приложения, которые выглядят и работают как родные на iOS и Android',
            'Кроссплатформенная разработка на React Native или Flutter либо нативная на Swift и Kotlin, где это нужно',
            'Бэкенд, API и панель администратора, созданные вместе с приложением',
            'Публикация в App Store и Google Play и регулярные обновления'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Идея приложения без понятного пути в магазины',
            description: 'Приложение для клиентов или для выездных сотрудников часто застревает между идеей и релизом: две платформы, бэкенд, который никто не запланировал, проверка в магазинах, и нет никого, кто будет поддерживать его после следующего обновления iOS или Android.',
            challenges: [
              'Непонятно, разрабатывать нативно или кроссплатформенно',
              'Нет бэкенда или API, с которым приложение могло бы работать',
              'Публикация, подпись и декларации конфиденциальности откладываются на конец',
              'Приложения ломаются после обновлений ОС, потому что их никто не сопровождает'
            ]
          },
          solution: {
            title: 'Одна команда от прототипа до магазинов и обновлений',
            description: 'Мы проектируем приложение под задачи, которые реально решают ваши пользователи, выбираем подходящий платформенный подход, разрабатываем приложение и бэкенд вместе, проводим его через проверку магазинов и поддерживаем в актуальном состоянии после запуска.',
            benefits: [
              'Выбор платформы объяснён и согласован до начала разработки',
              'Приложение и бэкенд спроектированы как единая система',
              'Публикация готовится с первого спринта, а не в последнюю неделю',
              'План сопровождения для обновлений ОС, библиотек и исправления ошибок'
            ]
          }
        },
        features: [
          {
            title: 'Приложения iOS и Android',
            description: 'Приложения, которые выглядят и ведут себя так, как пользователи ожидают на каждой платформе: кроссплатформенные на React Native или Flutter либо нативные на Swift и Kotlin, когда нужен глубокий доступ к устройству.',
            capabilities: [
              'Кроссплатформенная разработка на React Native или Flutter',
              'Нативная разработка для iOS (Swift) и Android (Kotlin)',
              'Работа офлайн, камера, геолокация и push-уведомления',
              'Доступные интерфейсы на русском и румынском для телефонов и планшетов'
            ]
          },
          {
            title: 'Бэкенд и API',
            description: 'Серверная часть, от которой зависит приложение: API, учётные записи пользователей, базы данных и панель администратора для вашей команды или подключение к системам, которые у вас уже работают. Персональные данные обрабатываются с учётом их защиты.',
            capabilities: [
              'Разработка REST или GraphQL API',
              'Аутентификация и управление пользователями',
              'Панель администратора для контента и пользователей',
              'Интеграция с существующими бизнес-системами'
            ]
          },
          {
            title: 'Публикация в App Store и Google Play',
            description: 'Мы готовим и отправляем релиз: аккаунты разработчика, подпись, страницы в магазинах и сведения о конфиденциальности и разрешениях, которые требуют оба магазина.',
            capabilities: [
              'Настройка аккаунтов разработчика и подписи',
              'Страницы в магазинах, скриншоты и описания',
              'Декларации конфиденциальности и разрешений',
              'Тестовые сборки через TestFlight и тестовые треки Google Play'
            ]
          },
          {
            title: 'Сопровождение и обновления',
            description: 'Приложения требуют регулярного сопровождения, чтобы продолжать работать на новых версиях iOS и Android. Мы берём на себя обновления, мониторинг и новые функции после запуска.',
            capabilities: [
              'Обновления под новые версии операционных систем',
              'Обновления зависимостей и безопасности',
              'Отчёты о сбоях и мониторинг',
              'Плановые релизы новых функций'
            ]
          }
        ],
        technologies: {
          title: 'Мобильные технологии',
          description: 'Фреймворки и языки, на которых мы создаём и сопровождаем мобильные приложения.',
          platforms: [
            { name: 'React Native', category: 'Кроссплатформенный фреймворк' },
            { name: 'Flutter', category: 'Кроссплатформенный фреймворк' },
            { name: 'Swift', category: 'Нативная разработка iOS' },
            { name: 'Kotlin', category: 'Нативная разработка Android' },
            { name: 'Node.js', category: 'Бэкенд и API' },
            { name: 'Firebase', category: 'Push-уведомления и аутентификация' }
          ]
        },
        implementation: {
          title: 'Процесс разработки приложения',
          description: 'От чётко описанной идеи до опубликованного приложения, короткими итерациями и с тестовыми сборками, которые можно установить на свой телефон.',
          phases: [
            {
              phase: 'Исследование и прототип',
              duration: '2-3 недели',
              description: 'Определяем пользователей, основные задачи и платформенный подход и проверяем ключевые сценарии в кликабельном прототипе.',
              deliverables: [
                'Функции и пользовательские сценарии',
                'Рекомендация: нативно или кроссплатформенно',
                'Кликабельный прототип',
                'Техническая архитектура'
              ]
            },
            {
              phase: 'Разработка и тестирование',
              duration: '6-12 недель',
              description: 'Разрабатываем приложение и бэкенд короткими итерациями, с тестовой сборкой на реальных устройствах после каждой.',
              deliverables: [
                'Сборки для iOS и Android',
                'Бэкенд и API',
                'Тестовые сборки через TestFlight и Google Play',
                'Автоматическое тестирование и тесты на устройствах'
              ]
            },
            {
              phase: 'Публикация в магазинах',
              duration: '1-2 недели',
              description: 'Готовим страницы в магазинах, сведения о конфиденциальности и релизные сборки и проводим приложение через проверку App Store и Google Play.',
              deliverables: [
                'Страницы в магазинах и скриншоты',
                'Декларации конфиденциальности и разрешений',
                'Подписанные релизные сборки',
                'Настройка отчётов о сбоях'
              ]
            },
            {
              phase: 'Сопровождение и обновления',
              duration: 'Постоянно',
              description: 'Поддерживаем работу приложения на новых версиях ОС и выпускаем улучшения плановыми релизами.',
              deliverables: ['Обновления ОС и зависимостей', 'Исправления и мониторинг', 'Релизы новых функций', 'Обновление страниц в магазинах']
            }
          ]
        },
        benefits: {
          title: 'Влияние на бизнес',
          description: 'Что даёт вашему бизнесу хорошо сделанное и поддерживаемое приложение.',
          outcomes: [
            {
              label: 'Один код, две платформы',
              description: 'При кроссплатформенном подходе iOS и Android используют большую часть общего кода, поэтому новые функции появляются на обеих одновременно.'
            },
            {
              label: 'Исходный код принадлежит вам',
              description: 'Вы получаете исходный код приложения и бэкенда и не зависите от одного подрядчика.'
            },
            {
              label: 'Меньше сюрпризов при публикации',
              description: 'Требования магазинов учитываются во время разработки, поэтому проблемы с проверкой выявляются рано.'
            },
            {
              label: 'Всегда актуально',
              description: 'Регулярное сопровождение сохраняет работоспособность приложения по мере изменений iOS и Android.'
            }
          ]
        }
      },
      crmDevelopment: {
        title: 'CRM-системы',
        subtitle: 'CRM на заказ, настройка CRM и интеграции',
        description: 'CRM, которая повторяет то, как ваша команда продаёт и обслуживает клиентов: CRM на заказ или настроенные и доработанные amoCRM, Bitrix24, HubSpot либо Odoo, связанные с почтой, счетами и сайтом, с переносом данных из таблиц Excel.',
        heroContent: {
          mainTitle: 'CRM-системы',
          subtitle: 'Данные клиентов, воронка и контроль задач в одной системе, подходящей вашему процессу',
          keyPoints: [
            'CRM на заказ под ваш процесс продаж и обслуживания',
            'Настройка и доработка существующей CRM',
            'Интеграции с почтой, счетами и сайтом',
            'Перенос данных из таблиц Excel и старых инструментов'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Данные клиентов разбросаны по таблицам и почтовым ящикам',
            description: 'Заявки приходят по почте, через форму на сайте, по телефону и в мессенджерах, предложения ведутся в таблице, а счета хранятся в другой системе. Повторные контакты теряются, и ни у кого нет полной картины по клиенту.',
            challenges: [
              'Заявки и сделки ведутся в таблицах или в личной почте',
              'Лицензия CRM, которой команда не пользуется, потому что она не подходит процессу',
              'Двойной ввод данных между CRM, счетами и сайтом',
              'Нет надёжной картины воронки и открытых задач'
            ]
          },
          solution: {
            title: 'CRM под ваш процесс',
            description: 'Мы описываем путь клиента в вашем бизнесе, затем либо создаём CRM под этот процесс, либо настраиваем и дорабатываем ту, что у вас уже есть, и связываем её с инструментами, которыми команда уже пользуется.',
            benefits: [
              'Воронки, поля и этапы, которые повторяют ваш процесс продаж',
              'Формы с сайта и письма попадают прямо в CRM',
              'Данные о клиентах и счетах синхронизированы',
              'Существующие данные очищены и импортированы, а не перепечатаны вручную'
            ]
          }
        },
        features: [
          {
            title: 'CRM на заказ',
            description: 'CRM, созданная под ваш процесс, когда готовые решения не подходят: с теми экранами, полями и правами, которые нужны команде, и ничего лишнего.',
            capabilities: [
              'Собственная модель данных для клиентов, сделок и проектов',
              'Доступ по ролям и правила хранения данных',
              'Дашборды и отчёты по воронке',
              'Интерфейс на русском и румынском, в браузере и на мобильном'
            ]
          },
          {
            title: 'Настройка и доработка CRM',
            description: 'Настройка и доработка amoCRM, Bitrix24, HubSpot или Odoo: воронки, пользовательские поля, автоматизации и расширения там, где стандартной настройки не хватает.',
            capabilities: [
              'Проектирование воронки и этапов',
              'Пользовательские поля, объекты и представления',
              'Автоматизации и напоминания',
              'Расширения через API платформы'
            ]
          },
          {
            title: 'Интеграции',
            description: 'Связи между CRM и остальными вашими инструментами, чтобы данные вводились один раз и появлялись там, где они нужны.',
            capabilities: [
              'Интеграция с почтой и календарём',
              'Связь со счетами и бухгалтерией, в том числе с 1С',
              'Приём заявок с сайта и веб-форм',
              'Двусторонняя синхронизация с другими бизнес-системами'
            ]
          },
          {
            title: 'Перенос из таблиц',
            description: 'Существующие данные о клиентах переносятся в CRM: очищенные, без дублей, сопоставленные с новой структурой и проверенные до запуска.',
            capabilities: [
              'Инвентаризация таблиц и инструментов',
              'Очистка и удаление дублей',
              'Сопоставление полей и пробные импорты',
              'Проверка вместе с вашей командой до запуска'
            ]
          }
        ],
        technologies: {
          title: 'CRM-платформы и инструменты',
          description: 'Платформы, которые мы настраиваем и дорабатываем, и инструменты для разработки на заказ и интеграций.',
          platforms: [
            { name: 'amoCRM', category: 'CRM-платформа' },
            { name: 'Bitrix24', category: 'CRM и совместная работа' },
            { name: 'HubSpot', category: 'CRM-платформа' },
            { name: 'Odoo', category: 'CRM и ERP с открытым кодом' },
            { name: 'PostgreSQL', category: 'База данных для CRM на заказ' },
            { name: 'n8n', category: 'Интеграционные процессы' }
          ]
        },
        implementation: {
          title: 'Процесс внедрения CRM',
          description: 'Пошаговый путь от разрозненных данных о клиентах к CRM, которой команда действительно пользуется.',
          phases: [
            {
              phase: 'Описание процесса',
              duration: '1-2 недели',
              description: 'Описываем, как сегодня заявки, сделки и клиенты проходят через ваш бизнес, и решаем, создавать CRM или настраивать готовую.',
              deliverables: [
                'Карта процесса продаж и обслуживания',
                'Инвентаризация текущих данных и инструментов',
                'Рекомендация: создать или настроить',
                'Объём работ и план'
              ]
            },
            {
              phase: 'Разработка и настройка',
              duration: '3-8 недель',
              description: 'Настраиваем или разрабатываем CRM, затем связываем её с почтой, счетами и сайтом.',
              deliverables: ['Воронки, поля и роли', 'Экраны или расширения на заказ', 'Интеграции', 'Автоматизации и напоминания']
            },
            {
              phase: 'Перенос данных и обучение',
              duration: '1-3 недели',
              description: 'Импортируем очищенные данные, проверяем их вместе с вашей командой и обучаем каждую роль ежедневной работе.',
              deliverables: ['Импорт очищенных данных без дублей', 'Пробный перенос и согласование', 'Обучение по ролям', 'Поддержка при запуске']
            },
            {
              phase: 'Поддержка и развитие',
              duration: 'Постоянно',
              description: 'Корректируем воронки, отчёты и интеграции по мере изменения вашего процесса.',
              deliverables: ['Поддержка пользователей', 'Изменения полей и процессов', 'Мониторинг интеграций', 'Новые отчёты и автоматизации']
            }
          ]
        },
        benefits: {
          title: 'Влияние на бизнес',
          description: 'Что даёт вашей команде CRM, подходящая вашему процессу.',
          outcomes: [
            {
              label: 'Полная картина по каждому клиенту',
              description: 'Контакты, сделки, письма и счета клиента собраны в одном месте.'
            },
            {
              label: 'Меньше потерянных контактов',
              description: 'Напоминания и этапы воронки делают открытые задачи видимыми.'
            },
            {
              label: 'Меньше двойного ввода',
              description: 'Интеграции переносят данные между системами, и сотрудникам не нужно перепечатывать их вручную.'
            },
            {
              label: 'Удобно для ежедневной работы',
              description: 'Экраны и поля повторяют ваш процесс, поэтому CRM проще поддерживать в актуальном состоянии.'
            }
          ]
        }
      },
      erpSystems: {
        title: 'ERP-системы',
        subtitle: 'Интеграции ERP, модули на заказ и миграция данных',
        description: 'Связываем и дорабатываем ERP, на которой работает ваш бизнес, например 1С, Odoo или Microsoft Dynamics 365 Business Central: модули на заказ, интеграции с интернет-магазином, CRM и бухгалтерией и миграция данных, проверенная шаг за шагом.',
        heroContent: {
          mainTitle: 'ERP-системы',
          subtitle: 'Ваша ERP, связанная с остальным бизнесом и доработанная там, где стандартных возможностей не хватает',
          keyPoints: [
            'Интеграции ERP с интернет-магазином, CRM и бухгалтерией',
            'Модули и доработки на заказ для процессов, которые не покрывает стандартная конфигурация',
            'Миграция данных из старых систем со сверкой',
            'Поддержка при изменении версий ERP и API'
          ]
        },
        problemSolution: {
          problem: {
            title: 'ERP, которая работает сама по себе',
            description: 'Заказы из интернет-магазина переносятся вручную, остатки в системах расходятся, а процессы, которые отличают ваш бизнес, ведутся в таблицах Excel рядом с ERP.',
            challenges: [
              'Ручной перенос заказов, клиентов и счетов между системами',
              'Расхождения остатков и цен между ERP и интернет-магазином',
              'Процессы, которые стандартная ERP не поддерживает, ведутся в таблицах',
              'Запланированный переход на другую ERP с данными за несколько лет'
            ]
          },
          solution: {
            title: 'ERP, связанная с остальным бизнесом',
            description: 'Мы описываем, как данные движутся между вашими системами, создаём интеграции и модули, которые закрывают пробелы, и переносим данные с пробными прогонами и проверками до запуска.',
            benefits: [
              'Заказы, клиенты и остатки синхронизируются автоматически',
              'Модули на заказ повторяют ваши процессы',
              'Интеграции с журналированием и оповещениями об ошибках, чтобы сбои были заметны',
              'Миграция данных проверена до переключения'
            ]
          }
        },
        features: [
          {
            title: 'Подключение и доработка ERP',
            description: 'Мы работаем с ERP, которой вы уже пользуетесь, например 1С, Odoo или Business Central, через её API, механизмы обмена данными и возможности расширения.',
            capabilities: [
              'Анализ текущей настройки ERP',
              'Использование стандартных API и коннекторов',
              'Настройка существующих модулей',
              'Документирование каждого изменения'
            ]
          },
          {
            title: 'Модули на заказ',
            description: 'Модули или сопутствующие приложения для процессов, которые ваша ERP не покрывает, например планирование, этапы производства, сервисные выезды или клиентские порталы, на тех же данных.',
            capabilities: [
              'Модули на заказ для Odoo или Business Central',
              'Сопутствующие веб-приложения на данных ERP, включая 1С',
              'Порталы для клиентов и поставщиков',
              'Отчёты и дашборды на данных ERP'
            ]
          },
          {
            title: 'Интеграции',
            description: 'Связи ERP с интернет-магазином, CRM, бухгалтерией и логистическими инструментами, с журналированием и оповещениями, чтобы неудачная синхронизация не осталась незамеченной.',
            capabilities: [
              'Интеграция с интернет-магазином: заказы, остатки и цены',
              'Синхронизация клиентов и заказов между CRM и ERP',
              'Связь с бухгалтерией и выставлением счетов',
              'Мониторинг, журналирование и оповещения об ошибках'
            ]
          },
          {
            title: 'Миграция данных',
            description: 'Клиенты, номенклатура, открытые остатки и история переносятся из старой системы в новую ERP, с пробными миграциями и сверкой до запуска.',
            capabilities: [
              'Инвентаризация данных и оценка их качества',
              'Сопоставление и скрипты конвертации',
              'Пробные миграции в тестовой среде',
              'Сверка итогов со старой системой'
            ]
          }
        ],
        technologies: {
          title: 'ERP-платформы и инструменты интеграции',
          description: 'ERP-системы, которые мы связываем и дорабатываем, и инструменты, с помощью которых мы их интегрируем.',
          platforms: [
            { name: '1C:Enterprise', category: 'Учёт и ERP' },
            { name: 'Odoo', category: 'Модульная ERP' },
            { name: 'Microsoft Dynamics 365 Business Central', category: 'ERP' },
            { name: 'n8n', category: 'Интеграционные процессы' },
            { name: 'REST и OData API', category: 'Интерфейсы интеграции' },
            { name: 'PostgreSQL', category: 'Промежуточная база и отчётность' }
          ]
        },
        implementation: {
          title: 'Процесс интеграции ERP',
          description: 'Аккуратная последовательность шагов для изменения системы, от которой зависят ваши финансы и операции.',
          phases: [
            {
              phase: 'Анализ',
              duration: '2-3 недели',
              description: 'Описываем системы, потоки данных и процессы, которые ERP сегодня не покрывает.',
              deliverables: ['Карта систем и потоков данных', 'Требования к интеграциям и модулям', 'Оценка качества данных', 'План внедрения']
            },
            {
              phase: 'Разработка и интеграция',
              duration: '4-10 недель',
              description: 'Разрабатываем интеграции и модули на заказ и проверяем их в тестовой среде, а не в рабочей базе.',
              deliverables: [
                'Интеграции через API',
                'Модули или доработки на заказ',
                'Журналирование и обработка ошибок',
                'Тестовые прогоны на реальных сценариях'
              ]
            },
            {
              phase: 'Миграция и запуск',
              duration: '2-4 недели',
              description: 'Проводим пробные миграции, сверяем результаты со старой системой и планируем переключение вместе с вашей командой.',
              deliverables: ['Скрипты миграции и пробные прогоны', 'Отчёты сверки', 'План переключения', 'Поддержка при запуске']
            },
            {
              phase: 'Поддержка и сопровождение',
              duration: 'Постоянно',
              description: 'Следим за интеграциями и обновляем их, когда меняются ERP или подключённые системы.',
              deliverables: ['Мониторинг интеграций', 'Обновления при изменениях ERP и API', 'Исправления и доработки', 'Актуальная документация']
            }
          ]
        },
        benefits: {
          title: 'Влияние на бизнес',
          description: 'Что даёт вашему бизнесу связанная ERP, подходящая вашим процессам.',
          outcomes: [
            {
              label: 'Меньше ручного ввода',
              description: 'Заказы, клиенты и счета автоматически передаются между системами.'
            },
            {
              label: 'Согласованные остатки и цены',
              description: 'Интернет-магазин и ERP работают с одними и теми же цифрами.'
            },
            {
              label: 'Процессы под ваш бизнес',
              description: 'Модули на заказ покрывают шаги, которые отличают ваш бизнес.'
            },
            {
              label: 'Контролируемая миграция',
              description: 'Пробные прогоны и сверка выявляют проблемы с данными до запуска.'
            }
          ]
        }
      },
      itSupport: {
        title: 'ИТ-поддержка',
        subtitle: 'Helpdesk и техническая поддержка',
        description: 'Комплексные услуги helpdesk и технической поддержки, обеспечивающие быстрое решение проблем и оптимальную производительность систем.',
        heroContent: {
          mainTitle: 'ИТ-поддержка',
          subtitle: 'Профессиональный ИТ-хелпдеск и техническая поддержка для стабильной работы и быстрого решения проблем',
          keyPoints: [
            'Техническая поддержка и услуги helpdesk 24/7',
            'Быстрое реагирование на инциденты и их устранение',
            'Проактивный мониторинг системы и обслуживание',
            'Экспертное устранение неполадок и решение проблем'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Сложности ИТ-поддержки',
            description: 'Организации сталкиваются с ИТ-проблемами, которые вызывают простои, потерю продуктивности и недовольство пользователей из-за долгого времени отклика и нехватки квалифицированной поддержки.',
            challenges: [
              'Долгое время отклика, снижающее продуктивность',
              'Нехватка квалифицированных специалистов технической поддержки',
              'Отсутствие единых процессов решения проблем',
              'Недостаточная прозрачность состояния ИТ-систем'
            ]
          },
          solution: {
            title: 'Комплексная ИТ-поддержка',
            description: 'Мы предоставляем профессиональные услуги ИТ-поддержки, которые обеспечивают быстрое решение проблем, проактивный мониторинг и экспертную техническую помощь.',
            benefits: [
              'Быстрое реагирование на инциденты и их устранение',
              'Экспертная техническая поддержка и устранение неполадок',
              'Проактивный мониторинг системы и обслуживание',
              'Комплексная документация поддержки и база знаний'
            ]
          }
        },
        features: [
          {
            title: 'Услуги helpdesk',
            description: 'Профессиональный helpdesk: поддержка первой линии при ИТ-проблемах, ответы на вопросы пользователей и техническая помощь.',
            capabilities: [
              'Управление и отслеживание тикетов',
              'Техническая поддержка первой линии',
              'Помощь и консультации для пользователей',
              'Эскалация и маршрутизация проблем'
            ]
          },
          {
            title: 'Техническая поддержка',
            description: 'Экспертная техническая поддержка для решения сложных ИТ-проблем и устранения неполадок в системах.',
            capabilities: [
              'Продвинутое устранение неполадок и диагностика',
              'Конфигурация и оптимизация системы',
              'Поддержка оборудования и программного обеспечения',
              'Удалённая помощь и поддержка'
            ]
          },
          {
            title: 'Проактивный мониторинг',
            description: 'Непрерывный мониторинг систем и проактивное обслуживание, чтобы предотвращать проблемы до того, как они затронут пользователей.',
            capabilities: [
              'Мониторинг системы и оповещения 24/7',
              'Проактивное обнаружение и предотвращение проблем',
              'Мониторинг производительности и оптимизация',
              'Проверки состояния и обслуживание'
            ]
          },
          {
            title: 'Управление знаниями',
            description: 'Комплексная база знаний и документация, обеспечивающие стабильное качество поддержки и сокращение времени решения.',
            capabilities: [
              'Разработка и обслуживание базы знаний',
              'Документация и процедуры поддержки',
              'Обучение и передача знаний',
              'Лучшие практики и руководящие принципы'
            ]
          }
        ],
        technologies: {
          title: 'Инструменты и платформы поддержки',
          description: 'Опыт работы с платформами и инструментами ИТ-поддержки.',
          platforms: [
            { name: 'Zammad', category: 'Платформа helpdesk' },
            { name: 'Jira Service Desk', category: 'Платформа ITSM' },
            { name: 'ServiceNow', category: 'Корпоративная ITSM-система' },
            { name: 'Freshservice', category: 'Облачный helpdesk' },
            { name: 'ManageEngine', category: 'Управление ИТ' },
            { name: 'TeamViewer', category: 'Удалённая поддержка' }
          ]
        },
        implementation: {
          title: 'Процесс настройки поддержки',
          description: 'Структурированный подход к настройке комплексных услуг ИТ-поддержки.',
          phases: [
            {
              phase: 'Оценка и планирование',
              duration: '1-2 недели',
              description: 'Комплексная оценка текущих потребностей в ИТ-поддержке и разработка стратегии поддержки.',
              deliverables: ['Анализ требований к поддержке', 'Документ стратегии поддержки', 'Выбор инструментов и планирование', 'Дорожная карта внедрения']
            },
            {
              phase: 'Настройка и конфигурация',
              duration: '2-3 недели',
              description: 'Настройка платформы helpdesk, конфигурация рабочих процессов и внедрение процессов поддержки.',
              deliverables: ['Конфигурация платформы', 'Настройка рабочих процессов', 'Структура базы знаний', 'Процедуры поддержки']
            },
            {
              phase: 'Обучение и запуск',
              duration: '1-2 недели',
              description: 'Обучение персонала, документирование процессов и сопровождение запуска ИТ-поддержки.',
              deliverables: ['Обучение команды поддержки', 'Документация для пользователей', 'Поддержка запуска', 'Настройка мониторинга производительности']
            },
            {
              phase: 'Постоянная поддержка',
              duration: 'Постоянно',
              description: 'Непрерывное оказание поддержки, оптимизация процессов и улучшение сервиса.',
              deliverables: ['Поддержка 24/7', 'Мониторинг производительности', 'Оптимизация процессов', 'Непрерывное улучшение']
            }
          ]
        },
        benefits: {
          title: 'Эффект от поддержки',
          description: 'Обеспечиваем измеримое улучшение качества поддержки и удовлетворённости пользователей.',
          outcomes: [
            {
              label: 'Более быстрое решение проблем',
              description: 'Экспертная поддержка и эффективные процессы значительно сокращают время решения проблем.'
            },
            {
              label: 'Удовлетворённость пользователей',
              description: 'Профессиональная поддержка и короткое время отклика повышают удовлетворённость пользователей.'
            },
            {
              label: 'Сокращение простоев',
              description: 'Проактивный мониторинг и быстрое реагирование сокращают простои систем и потери продуктивности.'
            },
            {
              label: 'Решение при первом обращении',
              description: 'Экспертная поддержка и комплексная база знаний обеспечивают высокую долю решений при первом обращении.'
            }
          ]
        }
      },
      dataEngineering: {
        title: 'Инженерия данных',
        subtitle: 'Конвейеры данных и инфраструктура аналитики',
        description: 'Создавайте надёжные конвейеры данных, процессы ETL и инфраструктуру аналитики, которые превращают сырые данные в практически полезные выводы для принятия решений.',
        heroContent: {
          mainTitle: 'Инженерия данных',
          subtitle: 'Комплексные услуги по инженерии данных: масштабируемые конвейеры данных, процессы ETL и инфраструктура аналитики',
          keyPoints: [
            'Разработка масштабируемых конвейеров данных',
            'Проектирование и внедрение процессов ETL/ELT',
            'Архитектура хранилищ и озёр данных',
            'Обработка данных в реальном времени и аналитика'
          ]
        },
        problemSolution: {
          problem: {
            title: 'Сложности инфраструктуры данных',
            description: 'Организации сталкиваются с фрагментированными источниками данных, неэффективной обработкой данных и отсутствием масштабируемой инфраструктуры для поддержки аналитики и бизнес-аналитики.',
            challenges: [
              'Разрозненные источники данных и изолированные хранилища',
              'Неэффективная обработка и трансформация данных',
              'Отсутствие масштабируемой инфраструктуры данных',
              'Ограниченные возможности обработки данных в реальном времени'
            ]
          },
          solution: {
            title: 'Комплексные решения в области инженерии данных',
            description: 'Мы предлагаем масштабируемые решения в области инженерии данных, которые обеспечивают эффективную обработку и трансформацию данных и инфраструктуру для аналитики.',
            benefits: [
              'Масштабируемая архитектура конвейеров данных',
              'Эффективные процессы ETL/ELT',
              'Единая инфраструктура данных',
              'Возможности обработки данных в реальном времени'
            ]
          }
        },
        features: [
          {
            title: 'Разработка конвейеров данных',
            description: 'Проектируйте и внедряйте масштабируемые конвейеры данных для эффективного приёма, трансформации и обработки данных.',
            capabilities: [
              'Проектирование архитектуры конвейеров данных',
              'Внедрение процессов ETL/ELT',
              'Приём и интеграция данных',
              'Мониторинг и оптимизация конвейеров'
            ]
          },
          {
            title: 'Хранилища и озёра данных',
            description: 'Создавайте и оптимизируйте хранилища данных (data warehouse) и озёра данных (data lake) для централизованного хранения и аналитики.',
            capabilities: [
              'Проектирование архитектуры хранилища данных',
              'Внедрение и оптимизация озера данных',
              'Моделирование данных и проектирование схем',
              'Оптимизация хранения и партиционирование'
            ]
          },
          {
            title: 'Обработка в реальном времени',
            description: 'Внедряйте обработку данных в реальном времени и потоковую аналитику для мгновенного получения выводов и принятия решений.',
            capabilities: [
              'Архитектура потоковой обработки',
              'Трансформация данных в реальном времени',
              'Событийная обработка данных',
              'Потоковая аналитика и мониторинг'
            ]
          },
          {
            title: 'Качество данных и управление ими',
            description: 'Внедряйте стандарты качества данных, политики управления и мониторинг, чтобы данные были надёжными и заслуживали доверия.',
            capabilities: [
              'Стандарты качества данных и валидация',
              'Управление данными и соответствие требованиям',
              'Происхождение данных и каталогизация',
              'Мониторинг качества данных и отчётность'
            ]
          }
        ],
        technologies: {
          title: 'Технологический стек',
          description: 'Опыт работы с платформами и инструментами инженерии данных.',
          platforms: [
            { name: 'Apache Airflow', category: 'Оркестрация процессов' },
            { name: 'Apache Spark', category: 'Обработка данных' },
            { name: 'Snowflake', category: 'Хранилище данных' },
            { name: 'AWS Glue', category: 'ETL-сервис' },
            { name: 'Apache Kafka', category: 'Потоковая обработка' },
            { name: 'dbt', category: 'Трансформация данных' }
          ]
        },
        implementation: {
          title: 'Методология внедрения',
          description: 'Структурированный подход к инженерии данных, обеспечивающий масштабируемую и надёжную инфраструктуру данных.',
          phases: [
            {
              phase: 'Оценка и проектирование',
              duration: '2-3 недели',
              description: 'Комплексная оценка данных, проектирование архитектуры и планирование внедрения.',
              deliverables: ['Отчёт по оценке данных', 'Проектирование архитектуры', 'Рекомендации по технологиям', 'Дорожная карта внедрения']
            },
            {
              phase: 'Настройка инфраструктуры',
              duration: '2-4 недели',
              description: 'Настройка инфраструктуры данных, конфигурация платформы и разработка первых конвейеров.',
              deliverables: ['Внедрение инфраструктуры', 'Конфигурация платформы', 'Первые конвейеры', 'Настройка безопасности']
            },
            {
              phase: 'Разработка конвейеров',
              duration: '3-6 недель',
              description: 'Разработка конвейеров данных и процессов ETL, внедрение трансформации данных.',
              deliverables: ['Конвейеры данных', 'Процессы ETL', 'Стандарты качества данных', 'Настройка мониторинга']
            },
            {
              phase: 'Оптимизация и поддержка',
              duration: 'Постоянно',
              description: 'Непрерывная оптимизация, настройка производительности и постоянная поддержка инфраструктуры данных.',
              deliverables: ['Оптимизация производительности', 'Мониторинг и оповещения', 'Поддержка 24/7', 'Непрерывное улучшение']
            }
          ]
        },
        benefits: {
          title: 'Влияние на бизнес',
          description: 'Обеспечиваем измеримое повышение эффективности обработки данных и расширение возможностей аналитики.',
          outcomes: [
            {
              label: 'Более быстрая обработка данных',
              description: 'Оптимизированные конвейеры и инфраструктура значительно сокращают время обработки данных.'
            },
            {
              label: 'Снижение затрат',
              description: 'Эффективная инфраструктура данных и оптимизация снижают затраты на обработку и хранение данных.'
            },
            {
              label: 'Улучшение качества данных',
              description: 'Комплексные стандарты качества данных обеспечивают надёжные и заслуживающие доверия данные для аналитики.'
            },
            {
              label: 'Быстрее от данных к выводам',
              description: 'Оптимизированные конвейеры данных и обработка в реальном времени сокращают путь от данных к практическим выводам.'
            }
          ]
        }
      }
    },
    legal: {
      label: 'Правовая информация'
    },
    privacyPolicy: {
      title: 'Политика конфиденциальности',
      lastUpdated: 'Последнее обновление',
      sections: {
        introduction: {
          title: '1. Введение',
          paragraph1: 'Byteet («мы», «наш» или «наше») обязуется защищать вашу конфиденциальность и персональные данные. Эта Политика конфиденциальности объясняет, как мы собираем, используем, раскрываем и защищаем вашу информацию при посещении нашего веб-сайта <a href="https://byteet.md" className="text-blue-600 hover:underline">https://byteet.md</a> или использовании наших услуг.',
          paragraph2: 'Эта Политика конфиденциальности соответствует Общему регламенту по защите данных (GDPR) (ЕС) 2016/679 и применимым правилам защиты данных в Молдове. Используя наш веб-сайт и услуги, вы соглашаетесь с практиками обработки данных, описанными в этой политике.'
        },
        dataController: {
          title: '2. Контролёр данных',
          paragraph: 'Byteet является контроллером данных, ответственным за ваши персональные данные. Наша контактная информация:',
          companyName: 'Название компании',
          address: 'Адрес',
          email: 'Email',
          phone: 'Телефон'
        },
        informationWeCollect: {
          title: '3. Информация, которую мы собираем',
          personalDataTitle: '3.1 Персональные данные, которые вы предоставляете',
          paragraph: 'Мы можем собирать следующие персональные данные, когда вы:',
          contactUs: 'Связываетесь с нами:',
          contactUsItems: 'Имя, адрес электронной почты, номер телефона, название компании и любая информация, которую вы предоставляете в своём сообщении',
          requestQuote: 'Запрашиваете предложение:',
          requestQuoteItems: 'Имя, адрес электронной почты, номер телефона, название компании, интересующие услуги и детали проекта',
          subscribeNewsletter: 'Подписываетесь на нашу рассылку:',
          subscribeNewsletterItems: 'Адрес электронной почты и имя (если предоставлено)',
          automaticallyCollectedTitle: '3.2 Автоматически собираемая информация',
          automaticallyCollectedParagraph: 'При посещении нашего веб-сайта мы автоматически собираем определённую информацию, включая:',
          technicalData: 'Технические данные:',
          technicalDataItems: 'IP-адрес, тип и версия браузера, тип устройства, операционная система, часовой пояс и данные о местоположении',
          usageData: 'Данные об использовании:',
          usageDataItems: 'Посещённые страницы, время, проведённое на страницах, паттерны кликов, источники перехода и пути навигации',
          cookiesTracking: 'Файлы cookie и технологии отслеживания:',
          cookiesTrackingItems: 'Мы используем файлы cookie и аналогичные технологии отслеживания. Подробная информация приведена в разделе нашей Политики использования файлов cookie ниже.'
        },
        legalBasis: {
          title: '4. Правовая основа для обработки',
          paragraph: 'Мы обрабатываем ваши персональные данные на основе следующих правовых оснований в соответствии с GDPR:',
          consent: 'Согласие:',
          consentItems: 'Когда вы предоставляете явное согласие на конкретные виды обработки (например, маркетинговые коммуникации)',
          contractualNecessity: 'Договорная необходимость:',
          contractualNecessityItems: 'Для предоставления наших услуг и выполнения наших договорных обязательств',
          legitimateInterests: 'Законные интересы:',
          legitimateInterestsItems: 'Для веб-аналитики, безопасности, предотвращения мошенничества и ведения бизнеса (за исключением случаев, когда над этими интересами преобладают ваши интересы или основные права и свободы)',
          legalObligations: 'Правовые обязательства:',
          legalObligationsItems: 'Для соблюдения применимых законов и правил'
        },
        howWeUse: {
          title: '5. Как мы используем вашу информацию',
          paragraph: 'Мы используем собранную информацию для следующих целей:',
          items: [
            'Для ответа на ваши запросы и предоставления поддержки клиентам',
            'Для обработки запросов на услуги и предложения и управления ими',
            'Для предоставления наших ИТ-услуг (управление устройствами, облачные решения, веб-разработка и т. д.)',
            'Для отправки вам маркетинговых коммуникаций (с вашего согласия)',
            'Для улучшения нашего веб-сайта, услуг и пользовательского опыта',
            'Для анализа использования веб-сайта и тенденций',
            'Для обеспечения безопасности веб-сайта и предотвращения мошенничества',
            'Для соблюдения правовых обязательств и обеспечения соблюдения наших условий'
          ]
        },
        cookies: {
          title: '6. Файлы cookie и технологии отслеживания',
          paragraph1: 'Мы используем файлы cookie и аналогичные технологии отслеживания для улучшения вашего опыта просмотра, анализа веб-трафика и персонализации контента. Вы можете контролировать настройки файлов cookie через наш баннер согласия на использование файлов cookie или настройки вашего браузера.',
          typesTitle: 'Типы файлов cookie, которые мы используем:',
          essentialCookies: 'Необходимые файлы cookie:',
          essentialCookiesItems: 'Требуются для функциональности веб-сайта и не могут быть отключены',
          analyticsCookies: 'Аналитические файлы cookie:',
          analyticsCookiesItems: 'Помогают нам понять, как посетители взаимодействуют с нашим веб-сайтом (например, Google Analytics)',
          marketingCookies: 'Маркетинговые файлы cookie:',
          marketingCookiesItems: 'Используются для показа релевантной рекламы и отслеживания эффективности кампаний',
          paragraph2: 'Для получения дополнительной информации о нашей практике использования файлов cookie, пожалуйста, обратитесь к настройкам файлов cookie, доступным на нашем веб-сайте.'
        },
        dataSharing: {
          title: '7. Обмен и раскрытие данных',
          paragraph1: 'Мы можем делиться вашими персональными данными с:',
          serviceProviders: 'Поставщиками услуг:',
          serviceProvidersItems: 'Сторонними поставщиками, которые помогают нам в работе веб-сайта, ведении бизнеса или обслуживании пользователей (например, хостинг-провайдеры, аналитические сервисы, сервисы электронной почты)',
          businessPartners: 'Деловыми партнёрами:',
          businessPartnersItems: 'Надёжными партнёрами, которые помогают нам предоставлять услуги (только при необходимости и с соответствующими гарантиями)',
          legalRequirements: 'В силу требований закона:',
          legalRequirementsItems: 'Когда этого требуют закон, судебный приказ или государственное регулирование',
          businessTransfers: 'При передаче бизнеса:',
          businessTransfersItems: 'В связи со слиянием, поглощением или продажей активов (с уведомлением затронутых пользователей)',
          paragraph2: 'Мы не продаём ваши персональные данные третьим лицам. Все третьи стороны обязаны по договору защищать ваши данные и использовать их только для указанных целей.'
        },
        internationalTransfers: {
          title: '8. Международная передача данных',
          paragraph: 'Ваши персональные данные могут быть переданы и обработаны в странах за пределами Европейской экономической зоны (ЕЭЗ). При передаче данных за пределы ЕЭЗ мы обеспечиваем наличие соответствующих гарантий, таких как:',
          items: [
            'Стандартные договорные положения, утверждённые Европейской комиссией',
            'Решения об адекватности Европейской комиссии',
            'Другие юридически признанные механизмы передачи'
          ]
        },
        dataRetention: {
          title: '9. Хранение данных',
          paragraph1: 'Мы храним ваши персональные данные только в течение времени, необходимого для выполнения целей, изложенных в этой Политике конфиденциальности, если более длительный период хранения не требуется или не разрешён законом. Периоды хранения различаются в зависимости от:',
          items: [
            'Характера данных и цели обработки',
            'Правовых и нормативных требований',
            'Договорных обязательств',
            'Законных деловых интересов'
          ],
          paragraph2: 'Когда персональные данные больше не нужны, мы безопасно удаляем или анонимизируем их в соответствии с нашими политиками хранения данных.'
        },
        yourRights: {
          title: '10. Ваши права в соответствии с GDPR',
          paragraph: 'Как субъект данных, вы имеете следующие права:',
          rightOfAccess: 'Право доступа:',
          rightOfAccessItems: 'Запросить копию ваших персональных данных, которые мы храним',
          rightToRectification: 'Право на исправление:',
          rightToRectificationItems: 'Запросить исправление неточных или неполных данных',
          rightToErasure: 'Право на удаление («право быть забытым»):',
          rightToErasureItems: 'Запросить удаление ваших персональных данных при определённых обстоятельствах',
          rightToRestrict: 'Право на ограничение обработки:',
          rightToRestrictItems: 'Запросить ограничение того, как мы обрабатываем ваши данные',
          rightToPortability: 'Право на переносимость данных:',
          rightToPortabilityItems: 'Получить ваши данные в структурированном, широко используемом формате',
          rightToObject: 'Право на возражение:',
          rightToObjectItems: 'Возразить против обработки на основе законных интересов или для прямого маркетинга',
          rightToWithdraw: 'Право на отзыв согласия:',
          rightToWithdrawItems: 'Отозвать согласие в любое время, когда обработка основана на согласии',
          paragraph2: 'Для осуществления этих прав, пожалуйста, свяжитесь с нами по адресу <a href="mailto:info@byteet.md" className="text-blue-600 hover:underline">info@byteet.md</a>. Мы ответим на ваш запрос в течение одного месяца (срок может быть продлён на два месяца для сложных запросов).'
        },
        dataSecurity: {
          title: '11. Безопасность данных',
          paragraph1: 'Мы применяем соответствующие технические и организационные меры для защиты ваших персональных данных от несанкционированного доступа, изменения, раскрытия или уничтожения. Эти меры включают:',
          items: [
            'Шифрование данных при передаче и при хранении',
            'Регулярные оценки безопасности и обновления',
            'Контроль доступа и механизмы аутентификации',
            'Безопасное хранение данных и процедуры резервного копирования',
            'Обучение сотрудников защите данных'
          ],
          paragraph2: 'Однако ни один метод передачи через Интернет или электронного хранения не является на 100% безопасным. Хотя мы стремимся защитить ваши данные, мы не можем гарантировать абсолютную безопасность.'
        },
        childrenPrivacy: {
          title: '12. Конфиденциальность детей',
          paragraph: 'Наши услуги не предназначены для лиц младше 16 лет. Мы не собираем намеренно персональные данные от детей. Если вы считаете, что мы собрали данные от ребёнка, пожалуйста, немедленно свяжитесь с нами, и мы примем меры для удаления такой информации.'
        },
        changes: {
          title: '13. Изменения в этой Политике конфиденциальности',
          paragraph1: 'Мы можем время от времени обновлять эту Политику конфиденциальности, чтобы отражать изменения в наших практиках или правовых требованиях. Мы уведомим вас о любых существенных изменениях путём:',
          items: [
            'Размещения обновлённой политики на этой странице с новой датой «Последнее обновление»',
            'Отправки уведомления по электронной почте (для значительных изменений)',
            'Отображения уведомления на нашем веб-сайте'
          ],
          paragraph2: 'Дальнейшее использование вами нашего веб-сайта после вступления изменений в силу означает принятие обновлённой Политики конфиденциальности.'
        },
        complaints: {
          title: '14. Жалобы',
          paragraph1: 'Если у вас есть опасения по поводу того, как мы обрабатываем ваши персональные данные, вы имеете право подать жалобу в Национальный центр защиты персональных данных Республики Молдова:',
          website: 'Веб-сайт:',
          phone: 'Телефон:',
          paragraph2: 'Мы рекомендуем вам сначала связаться с нами по адресу <a href="mailto:info@byteet.md" className="text-blue-600 hover:underline">info@byteet.md</a>, чтобы решить любые проблемы.'
        },
        contactUs: {
          title: '15. Свяжитесь с нами',
          paragraph: 'Если у вас есть вопросы, опасения или запросы относительно этой Политики конфиденциальности или наших практик обработки данных, пожалуйста, свяжитесь с нами:',
          email: 'Email:',
          phone: 'Телефон:',
          address: 'Адрес:'
        }
      }
    },
    termsOfService: {
      title: 'Условия использования',
      lastUpdated: 'Последнее обновление',
      sections: {
        acceptance: {
          title: '1. Принятие условий',
          paragraph1: 'Получая доступ к веб-сайту <a href="https://byteet.md" className="text-blue-600 hover:underline">https://byteet.md</a> («Веб-сайт») и используя услуги, предоставляемые Byteet («мы», «наш» или «наше»), вы соглашаетесь с тем, что эти Условия использования («Условия») являются для вас обязательными. Если вы не согласны с этими Условиями, пожалуйста, не используйте наш Веб-сайт или услуги.',
          paragraph2: 'Эти Условия составляют юридически обязательное соглашение между вами и Byteet. Мы оставляем за собой право изменять эти Условия в любое время. Дальнейшее использование вами нашего Веб-сайта или услуг после вступления изменений в силу означает принятие обновлённых Условий.'
        },
        companyInfo: {
          title: '2. Информация о компании',
          paragraph: 'Byteet работает как поставщик ИТ-услуг. Наша контактная информация:',
          companyName: 'Название компании',
          address: 'Адрес',
          email: 'Email',
          phone: 'Телефон',
          website: 'Веб-сайт'
        },
        servicesDescription: {
          title: '3. Описание услуг',
          paragraph1: 'Byteet предоставляет профессиональные ИТ-услуги, включая, но не ограничиваясь перечисленным:',
          items: [
            'Управление устройствами (Microsoft Intune, SCCM, Jamf Pro, Active Directory)',
            'Облачные решения и администрирование (Microsoft 365, Google Workspace)',
            'Управление идентификацией и доступом (Okta, CyberArk, Active Directory)',
            'ИТ-автоматизация и DevOps',
            'Веб-разработка и веб-приложения на заказ',
            'Управление базами данных',
            'Инженерия данных',
            'ИТ-поддержка и Service Desk',
            'Управление инфраструктурой',
            'Управление знаниями'
          ],
          paragraph2: 'Описания услуг, цены и доступность могут быть изменены без предварительного уведомления. Мы оставляем за собой право изменять, приостанавливать или прекращать любую услугу в любое время.'
        },
        useOfWebsite: {
          title: '4. Использование веб-сайта',
          permittedUseTitle: '4.1 Разрешённое использование',
          permittedUseParagraph: 'Вы можете использовать наш Веб-сайт только в законных целях. Вы соглашаетесь:',
          permittedUseItems: [
            'Предоставлять точную и полную информацию при обращении к нам или запросе услуг',
            'Использовать Веб-сайт в соответствии со всеми применимыми законами и правилами',
            'Уважать права интеллектуальной собственности',
            'Не вмешиваться в работу Веб-сайта и не нарушать её'
          ],
          prohibitedTitle: '4.2 Запрещённые действия',
          prohibitedParagraph: 'Вы соглашаетесь, что не будете:',
          prohibitedItems: [
            'Использовать Веб-сайт в любых незаконных или несанкционированных целях',
            'Пытаться получить несанкционированный доступ к нашим системам или сетям',
            'Передавать вирусы, вредоносное ПО или любой вредоносный код',
            'Собирать данные с Веб-сайта методами скрейпинга или краулинга либо использовать автоматизированные инструменты для доступа к нему без разрешения',
            'Выдавать себя за любое лицо или организацию',
            'Нарушать любые применимые законы или правила'
          ]
        },
        serviceAgreements: {
          title: '5. Соглашения об услугах',
          paragraph1: 'Когда вы обращаетесь к Byteet за ИТ-услугами, будет заключено отдельное соглашение об услугах или договор. Условия этого соглашения будут регулировать предоставление конкретных услуг. В случае противоречия между этими Условиями и соглашением об услугах соглашение об услугах будет иметь приоритет для этих конкретных услуг.',
          paragraph2: 'Соглашения об услугах будут включать, помимо прочего:',
          items: [
            'Объём услуг',
            'Цены и условия оплаты',
            'Соглашения об уровне обслуживания (SLA)',
            'Сроки проекта и результаты',
            'Права интеллектуальной собственности',
            'Обязательства по конфиденциальности',
            'Условия расторжения'
          ]
        },
        pricing: {
          title: '6. Цены и оплата',
          paragraph1: 'Цены на наши услуги будут указаны в предложениях или соглашениях об услугах. Все цены указаны в евро (EUR), если не указано иное, и не включают НДС (если применимо).',
          paragraph2: 'Условия оплаты будут указаны в индивидуальных соглашениях об услугах. Как правило:',
          items: [
            'Оплата производится в соответствии с условиями, указанными в соглашении об услугах',
            'На просроченные платежи могут начисляться проценты в пределах, разрешённых законом',
            'Мы оставляем за собой право приостановить услуги за неуплату',
            'Все платежи не подлежат возврату, если иное не указано или не предусмотрено законом'
          ]
        },
        rightOfWithdrawal: {
          title: '7. Право на отказ от договора (права потребителей ЕС)',
          paragraph1: 'Если вы являетесь потребителем (не действуете в коммерческих целях) в Европейском Союзе, вы имеете право отказаться от договора об услугах в течение 14 дней с момента заключения договора, за исключением случаев, когда:',
          items: [
            'Услуга была полностью выполнена с вашего явного согласия и с признанием того, что вы утратите право на отказ после завершения услуги',
            'Услуга настроена или персонализирована в соответствии с вашими спецификациями',
            'Услуга является срочным ремонтом или техническим обслуживанием'
          ],
          paragraph2: 'Для осуществления права на отказ от договора, пожалуйста, свяжитесь с нами по адресу <a href="mailto:info@byteet.md" className="text-blue-600 hover:underline">info@byteet.md</a> в течение срока для отказа. Если вы уже получили услуги, вам может потребоваться оплатить услуги, предоставленные до момента отказа.'
        },
        intellectualProperty: {
          title: '8. Интеллектуальная собственность',
          websiteContentTitle: '8.1 Контент веб-сайта',
          websiteContentParagraph: 'Весь контент на этом Веб-сайте, включая текст, графику, логотипы, изображения, программное обеспечение и дизайн, является собственностью Byteet или его лицензиаров и защищён законами об авторском праве, о товарных знаках и другими законами об интеллектуальной собственности.',
          deliverablesTitle: '8.2 Результаты услуг',
          deliverablesParagraph: 'Права интеллектуальной собственности на результаты услуг будут указаны в индивидуальных соглашениях об услугах. Как правило:',
          deliverablesItems: [
            'Существующая интеллектуальная собственность остаётся у первоначального владельца',
            'Решения, разработанные на заказ, могут быть переданы клиенту, как указано в соглашении',
            'Byteet может сохранить права на использование общих методологий, инструментов и ноу-хау'
          ]
        },
        confidentiality: {
          title: '9. Конфиденциальность',
          paragraph1: 'Мы понимаем чувствительный характер ИТ-услуг и информации о клиентах. Мы обязуемся:',
          items: [
            'Соблюдать строгую конфиденциальность в отношении информации и данных клиентов',
            'Не раскрывать конфиденциальную информацию третьим лицам без разрешения',
            'Применять соответствующие меры безопасности для защиты конфиденциальной информации',
            'Соблюдать применимые законы о защите данных (см. нашу Политику конфиденциальности)'
          ],
          paragraph2: 'Подробные обязательства по конфиденциальности будут указаны в индивидуальных соглашениях об услугах.'
        },
        warranties: {
          title: '10. Гарантии и отказы от ответственности',
          serviceWarrantiesTitle: '10.1 Гарантии услуг',
          serviceWarrantiesParagraph: 'Мы гарантируем, что услуги будут выполнены с разумным мастерством и осторожностью в соответствии со стандартами отрасли. Конкретные гарантии, если таковые имеются, будут указаны в индивидуальных соглашениях об услугах.',
          disclaimersTitle: '10.2 Отказ от ответственности в отношении веб-сайта',
          disclaimersParagraph: 'ВЕБ-САЙТ И ЕГО КОНТЕНТ ПРЕДОСТАВЛЯЮТСЯ «КАК ЕСТЬ» И «КАК ДОСТУПНО» БЕЗ ГАРАНТИЙ ЛЮБОГО РОДА, ЯВНЫХ ИЛИ ПОДРАЗУМЕВАЕМЫХ, ВКЛЮЧАЯ, НО НЕ ОГРАНИЧИВАЯСЬ:',
          disclaimersItems: [
            'Гарантиями товарности или пригодности для определённой цели',
            'Гарантиями того, что Веб-сайт будет бесперебойным, безопасным или безошибочным',
            'Гарантиями относительно точности, полноты или надёжности контента'
          ]
        },
        limitationOfLiability: {
          title: '11. Ограничение ответственности',
          paragraph1: 'В максимальной степени, разрешённой применимым законодательством:',
          items: [
            'Общая ответственность Byteet за любые претензии, возникающие из этих Условий или наших услуг, не должна превышать общую сумму, уплаченную вами за конкретные услуги, вызвавшие претензию, в течение 12 месяцев, предшествующих претензии',
            'Мы не несём ответственности за косвенный, случайный, особый, последующий или штрафной ущерб, включая потерю прибыли, данных или деловых возможностей',
            'Мы не несём ответственности за ущерб, возникший в результате услуг, программного обеспечения или платформ третьих сторон, используемых в связи с нашими услугами'
          ],
          paragraph2: 'Ничто в этих Условиях не исключает и не ограничивает нашу ответственность за:',
          exceptions: [
            'Смерть или телесные повреждения, вызванные нашей небрежностью',
            'Мошенничество или мошенническое введение в заблуждение',
            'Любую ответственность, которая не может быть исключена или ограничена в соответствии с применимым законодательством'
          ]
        },
        indemnification: {
          title: '12. Возмещение ущерба',
          paragraph: 'Вы соглашаетесь возмещать ущерб, защищать и ограждать Byteet, его должностных лиц, директоров, сотрудников и агентов от любых претензий, ущерба, потерь, обязательств, расходов и затрат (включая разумные гонорары адвокатов), возникающих в результате:',
          items: [
            'Вашего использования Веб-сайта или услуг',
            'Вашего нарушения этих Условий',
            'Вашего нарушения любых прав третьих лиц',
            'Любого контента или любой информации, которые вы предоставляете'
          ]
        },
        termination: {
          title: '13. Расторжение',
          paragraph1: 'Мы оставляем за собой право немедленно прекратить или приостановить ваш доступ к Веб-сайту или услугам без предварительного уведомления за:',
          items: [
            'Нарушение этих Условий',
            'Мошенническую или незаконную деятельность',
            'Неуплату сборов',
            'Любую другую причину, которую мы считаем необходимой для защиты наших интересов'
          ],
          paragraph2: 'Расторжение соглашений об услугах будет регулироваться условиями, указанными в этих соглашениях.'
        },
        disputeResolution: {
          title: '14. Разрешение споров',
          odrTitle: '14.1 Онлайн-разрешение споров ЕС',
          odrParagraph: 'Если вы являетесь потребителем в Европейском Союзе, вы можете использовать платформу онлайн-разрешения споров Европейской комиссии по адресу <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">https://ec.europa.eu/consumers/odr</a> для разрешения споров.',
          governingLawTitle: '14.2 Применимое право и юрисдикция',
          governingLawParagraph: 'Эти Условия регулируются законами Молдовы. Любые споры, возникающие из этих Условий или наших услуг, подлежат исключительной юрисдикции судов Кишинёва, Молдова, за исключением случаев, когда обязательные законы о защите потребителей требуют иного.'
        },
        forceMajeure: {
          title: '15. Форс-мажор',
          paragraph: 'Мы не несём ответственности за любой сбой или задержку в выполнении этих Условий из-за обстоятельств, находящихся вне нашего разумного контроля, включая, но не ограничиваясь:',
          items: [
            'Стихийными бедствиями',
            'Войной, терроризмом или гражданскими беспорядками',
            'Пандемиями или чрезвычайными ситуациями в области общественного здравоохранения',
            'Действиями или правилами правительства',
            'Сбоями в работе интернета или телекоммуникаций',
            'Сбоями поставщиков услуг третьих сторон'
          ]
        },
        severability: {
          title: '16. Разделимость',
          paragraph: 'Если какое-либо положение этих Условий признано недействительным, незаконным или неисполнимым, оставшиеся положения продолжают действовать в полной мере. Недействительное положение будет заменено действительным положением, которое наиболее близко отражает намерение первоначального положения.'
        },
        entireAgreement: {
          title: '17. Полное соглашение',
          paragraph: 'Эти Условия вместе с нашей Политикой конфиденциальности и любыми применимыми соглашениями об услугах составляют полное соглашение между вами и Byteet относительно использования нашего Веб-сайта и услуг, заменяя все предыдущие соглашения и договорённости.'
        },
        changesToTerms: {
          title: '18. Изменения в Условиях',
          paragraph1: 'Мы оставляем за собой право изменять эти Условия в любое время. Существенные изменения будут сообщены путём:',
          items: [
            'Размещения обновлённых Условий на этой странице с новой датой «Последнее обновление»',
            'Отправки уведомления по электронной почте (для значительных изменений)',
            'Отображения уведомления на нашем Веб-сайте'
          ],
          paragraph2: 'Дальнейшее использование вами нашего Веб-сайта или услуг после вступления изменений в силу означает принятие обновлённых Условий.'
        },
        contactInfo: {
          title: '19. Контактная информация',
          paragraph: 'Если у вас есть вопросы об этих Условиях, пожалуйста, свяжитесь с нами:',
          email: 'Email:',
          phone: 'Телефон:',
          address: 'Адрес:'
        }
      }
    }
  }
}
